// AUTO-GENERATED from SMAART Role & Skills Reference
// 1001 roles across 55 job families
// Generated: 2026-07-27T08:34:29.679Z

export const SMAART_ROLE_LIBRARY = [
  {
    "roleId": "JF01-001",
    "roleName": "Software Engineer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Data Structures and Algorithms",
      "Java",
      "Git",
      "SQL",
      "System Design"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Relational Database Management",
      "Object-Oriented Programming Principles",
      "Software Development Life Cycle (SDLC)",
      "Database Administration",
      "Design Patterns"
    ]
  },
  {
    "roleId": "JF01-002",
    "roleName": "Frontend Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "JavaScript",
      "React",
      "HTML",
      "CSS",
      "TypeScript"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Cursor AI",
      "ChatGPT",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "DOM and Browser Rendering",
      "Responsive Web Design",
      "Component-Based Architecture",
      "State Management Concepts",
      "Web Performance Optimization"
    ]
  },
  {
    "roleId": "JF01-003",
    "roleName": "Backend Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Node.js",
      "SQL",
      "REST API",
      "Git",
      "Docker"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Database Administration",
      "Relational Database Management",
      "API Design Principles",
      "Microservices Architecture",
      "Authentication and Authorization"
    ]
  },
  {
    "roleId": "JF01-004",
    "roleName": "Full Stack Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "JavaScript",
      "React",
      "Node.js",
      "MongoDB",
      "SQL"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "Database Administration",
      "Object-Oriented Programming Principles",
      "Component-Based Architecture",
      "Relational Database Management",
      "API Design Principles"
    ]
  },
  {
    "roleId": "JF01-005",
    "roleName": "Mobile App Developer - Android",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Kotlin",
      "Android SDK",
      "Java",
      "Jetpack Compose",
      "SQLite"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Google Gemini",
      "Claude Code",
      "Cursor AI",
      "TensorFlow Lite"
    ],
    "domainSkills": [
      "Android Application Lifecycle",
      "Mobile UI/UX Principles",
      "Object-Oriented Programming Principles",
      "Mobile Performance Optimization",
      "Mobile Security Principles"
    ]
  },
  {
    "roleId": "JF01-006",
    "roleName": "Mobile App Developer - iOS",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Swift",
      "SwiftUI",
      "Xcode",
      "Objective-C",
      "UIKit"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "Core ML"
    ],
    "domainSkills": [
      "iOS Application Lifecycle",
      "Mobile UI/UX Principles",
      "Object-Oriented Programming Principles",
      "Mobile Performance Optimization",
      "Mobile Security Principles"
    ]
  },
  {
    "roleId": "JF01-007",
    "roleName": "React Native Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "React Native",
      "JavaScript",
      "React",
      "TypeScript",
      "Redux"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "Cross-Platform Development Principles",
      "Component-Based Architecture",
      "State Management Concepts",
      "Mobile Performance Optimization",
      "Mobile UI/UX Principles"
    ]
  },
  {
    "roleId": "JF01-008",
    "roleName": "Flutter Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Flutter",
      "Dart",
      "Firebase",
      "REST API",
      "Git"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Perplexity AI",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Cross-Platform Development Principles",
      "Component-Based Architecture",
      "State Management Concepts",
      "Mobile Performance Optimization",
      "Mobile UI/UX Principles"
    ]
  },
  {
    "roleId": "JF01-009",
    "roleName": "Embedded Systems Engineer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Embedded C",
      "Microcontrollers",
      "RTOS",
      "C++",
      "ARM"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "TensorFlow Lite",
      "Claude Code"
    ],
    "domainSkills": [
      "Embedded Systems Architecture",
      "Microcontroller Architecture",
      "Real-Time Operating System (RTOS) Concepts",
      "Interrupt Handling",
      "Hardware Communication Protocols"
    ]
  },
  {
    "roleId": "JF01-010",
    "roleName": "Game Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Unity",
      "C#",
      "C++",
      "Unreal Engine",
      "Game Physics"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Stable Diffusion",
      "Cursor AI",
      "Unity ML-Agents"
    ],
    "domainSkills": [
      "Game Design Principles",
      "Unity Game Development Principles",
      "3D Mathematics",
      "Rendering Pipeline",
      "Artificial Intelligence for Games"
    ]
  },
  {
    "roleId": "JF01-011",
    "roleName": "Blockchain Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Solidity",
      "Ethereum",
      "Smart Contracts",
      "Web3.js",
      "JavaScript"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Blockchain Technology Fundamentals",
      "Smart Contract Development",
      "Cryptography Principles",
      "Decentralized Application (DApp) Architecture",
      "Consensus Mechanisms"
    ]
  },
  {
    "roleId": "JF01-012",
    "roleName": "AR/VR Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Unity",
      "C#",
      "ARKit",
      "ARCore",
      "Unreal Engine"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "Stable Diffusion",
      "Claude Code"
    ],
    "domainSkills": [
      "3D Spatial Computing",
      "3D Mathematics",
      "Computer Vision Principles",
      "Human-Computer Interaction (HCI)",
      "3D Modeling and Animation Concepts"
    ]
  },
  {
    "roleId": "JF01-013",
    "roleName": "Integration Engineer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "REST API",
      "SOAP",
      "SQL",
      "Apache Kafka",
      "MuleSoft"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Enterprise Application Integration (EAI)",
      "Service-Oriented Architecture (SOA)",
      "Event-Driven Architecture",
      "Data Transformation and Mapping",
      "API Management"
    ]
  },
  {
    "roleId": "JF01-014",
    "roleName": "Firmware Engineer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Embedded C",
      "C++",
      "RTOS",
      "Microcontrollers",
      "Device Drivers"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "TensorFlow Lite",
      "Claude Code"
    ],
    "domainSkills": [
      "Embedded Systems Architecture",
      "Microcontroller Architecture",
      "Real-Time Operating System (RTOS) Concepts",
      "Interrupt Handling",
      "Hardware Communication Protocols"
    ]
  },
  {
    "roleId": "JF01-015",
    "roleName": "Python Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Python",
      "Django",
      "Flask",
      "SQL",
      "REST API"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "Object-Oriented Programming Principles",
      "Software Development Life Cycle (SDLC)",
      "Relational Database Management",
      "API Design Principles",
      "Caching Strategies"
    ]
  },
  {
    "roleId": "JF01-016",
    "roleName": "Java Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Java",
      "Spring Boot",
      "Hibernate",
      "SQL",
      "Microservices"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Object-Oriented Programming Principles",
      "Software Development Life Cycle (SDLC)",
      "Relational Database Management",
      "Microservices Architecture",
      "Authentication and Authorization"
    ]
  },
  {
    "roleId": "JF01-017",
    "roleName": "Node.js Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Node.js",
      "JavaScript",
      "Express.js",
      "MongoDB",
      "REST API"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Concurrency and Multithreading",
      "API Design Principles",
      "Relational Database Management",
      "Message Queue Architecture",
      "Authentication and Authorization"
    ]
  },
  {
    "roleId": "JF01-018",
    "roleName": "PHP Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "PHP",
      "Laravel",
      "MySQL",
      "JavaScript",
      "REST API"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Software Development Life Cycle (SDLC)",
      "Object-Oriented Programming Principles",
      "Relational Database Management",
      "API Design Principles",
      "Authentication and Authorization"
    ]
  },
  {
    "roleId": "JF01-019",
    "roleName": ".NET Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "C#",
      "ASP.NET Core",
      "SQL Server",
      "Entity Framework",
      "LINQ"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Semantic Kernel",
      "Cursor AI"
    ],
    "domainSkills": [
      "Object-Oriented Programming Principles",
      "Software Development Life Cycle (SDLC)",
      "Relational Database Management",
      "Microservices Architecture",
      "Authentication and Authorization"
    ]
  },
  {
    "roleId": "JF01-020",
    "roleName": "Go Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Golang",
      "Goroutines",
      "REST API",
      "Docker",
      "Microservices"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Concurrency and Multithreading",
      "Microservices Architecture",
      "API Design Principles",
      "Component-Based Architecture",
      "Low-Level Memory Management"
    ]
  },
  {
    "roleId": "JF01-021",
    "roleName": "Angular Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Angular",
      "TypeScript",
      "RxJS",
      "HTML",
      "CSS"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Component-Based Architecture",
      "State Management Concepts",
      "Software Development Life Cycle (SDLC)",
      "Responsive Web Design",
      "Web Performance Optimization"
    ]
  },
  {
    "roleId": "JF01-022",
    "roleName": "Vue.js Developer",
    "jobFamily": "Software Engineering",
    "technicalSkills": [
      "Vue.js",
      "JavaScript",
      "Vuex",
      "TypeScript",
      "CSS"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "Component-Based Architecture",
      "State Management Concepts",
      "Responsive Web Design",
      "DOM and Browser Rendering",
      "Web Performance Optimization"
    ]
  },
  {
    "roleId": "JF02-001",
    "roleName": "QA Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Manual Testing",
      "Test Case Design",
      "Selenium",
      "SQL",
      "JIRA"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Software Testing Life Cycle (STLC)",
      "Test Case Design Techniques",
      "Defect Life Cycle",
      "Test Automation Principles",
      "Agile Testing Methodology"
    ]
  },
  {
    "roleId": "JF02-002",
    "roleName": "Test Automation Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Selenium",
      "Java",
      "TestNG",
      "Cucumber",
      "Jenkins"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Test Automation Principles",
      "Software Testing Life Cycle (STLC)",
      "Object-Oriented Programming Principles",
      "Test Case Design Techniques",
      "Agile Testing Methodology"
    ]
  },
  {
    "roleId": "JF02-003",
    "roleName": "Performance Test Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "JMeter",
      "LoadRunner",
      "Performance Testing",
      "Grafana",
      "SQL"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Claude Code",
      "Cursor AI"
    ],
    "domainSkills": [
      "Performance Testing Concepts",
      "Load Testing Concepts",
      "Relational Database Management",
      "Observability and Monitoring Concepts",
      "Caching Strategies"
    ]
  },
  {
    "roleId": "JF02-004",
    "roleName": "Mobile QA Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Appium",
      "Manual Testing",
      "Test Case Design",
      "Android SDK",
      "JIRA"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "Core ML"
    ],
    "domainSkills": [
      "Mobile Testing Concepts",
      "Software Testing Life Cycle (STLC)",
      "Test Case Design Techniques",
      "Mobile UI/UX Principles",
      "Mobile Performance Optimization"
    ]
  },
  {
    "roleId": "JF02-005",
    "roleName": "QA Lead",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Test Management",
      "Test Strategy",
      "Selenium",
      "JIRA",
      "Agile"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Defect Life Cycle",
      "Software Testing Life Cycle (STLC)",
      "Agile Testing Methodology",
      "Test Automation Principles",
      "Test Case Design Techniques"
    ]
  },
  {
    "roleId": "JF02-006",
    "roleName": "Manual QA Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Manual Testing",
      "Test Case Design",
      "SQL",
      "JIRA",
      "Agile"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Software Testing Life Cycle (STLC)",
      "Test Case Design Techniques",
      "Defect Life Cycle",
      "Agile Testing Methodology",
      "API Testing Concepts"
    ]
  },
  {
    "roleId": "JF02-007",
    "roleName": "Security Test Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Penetration Testing",
      "OWASP",
      "Burp Suite",
      "Vulnerability Assessment",
      "Kali Linux"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Security Testing Concepts",
      "Authentication and Authorization",
      "Network Security Principles",
      "OWASP Application Security Concepts",
      "Software Testing Life Cycle (STLC)"
    ]
  },
  {
    "roleId": "JF02-008",
    "roleName": "API Test Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Postman",
      "REST API",
      "API Testing",
      "Rest Assured",
      "SQL"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "API Testing Concepts",
      "API Design Principles",
      "Software Testing Life Cycle (STLC)",
      "Test Automation Principles",
      "Defect Life Cycle"
    ]
  },
  {
    "roleId": "JF02-009",
    "roleName": "UAT Analyst",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "User Acceptance Testing",
      "Test Case Design",
      "SQL",
      "JIRA",
      "Agile"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Claude Code",
      "Cursor AI"
    ],
    "domainSkills": [
      "User Acceptance Testing (UAT)",
      "Software Testing Life Cycle (STLC)",
      "Test Case Design Techniques",
      "Defect Life Cycle",
      "Agile Testing Methodology"
    ]
  },
  {
    "roleId": "JF02-010",
    "roleName": "Automation QA Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Selenium",
      "Python",
      "Pytest",
      "Git",
      "Jenkins"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Test Automation Principles",
      "Object-Oriented Programming Principles",
      "Software Testing Life Cycle (STLC)",
      "Test Case Design Techniques",
      "Continuous Integration and Continuous Delivery (CI/CD)"
    ]
  },
  {
    "roleId": "JF02-011",
    "roleName": "Load Test Engineer",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "JMeter",
      "LoadRunner",
      "Performance Testing",
      "Gatling",
      "SQL"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Claude Code",
      "Cursor AI"
    ],
    "domainSkills": [
      "Load Testing Concepts",
      "Performance Testing Concepts",
      "Caching Strategies",
      "Relational Database Management",
      "Observability and Monitoring Concepts"
    ]
  },
  {
    "roleId": "JF02-012",
    "roleName": "QA Analyst",
    "jobFamily": "Quality Assurance & Testing",
    "technicalSkills": [
      "Manual Testing",
      "Test Case Design",
      "SQL",
      "Selenium",
      "JIRA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Software Testing Life Cycle (STLC)",
      "Test Case Design Techniques",
      "Defect Life Cycle",
      "Agile Testing Methodology",
      "API Testing Concepts"
    ]
  },
  {
    "roleId": "JF03-001",
    "roleName": "Cloud Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "AWS",
      "Docker",
      "Kubernetes",
      "Terraform",
      "Linux"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Amazon Q Developer",
      "GitHub Copilot Enterprise",
      "Cursor AI"
    ],
    "domainSkills": [
      "Cloud Computing Fundamentals",
      "Containerization Concepts",
      "Infrastructure as Code (IaC)",
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Cloud Security Principles"
    ]
  },
  {
    "roleId": "JF03-002",
    "roleName": "Cloud Architect",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "AWS",
      "Azure",
      "Terraform",
      "Kubernetes",
      "System Design"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Amazon Q Developer",
      "GitHub Copilot Enterprise",
      "Cursor AI"
    ],
    "domainSkills": [
      "Cloud Architecture Patterns",
      "Cloud Computing Fundamentals",
      "Cloud Security Principles",
      "Disaster Recovery and Business Continuity",
      "Cloud Cost Optimization"
    ]
  },
  {
    "roleId": "JF03-003",
    "roleName": "DevOps Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Docker",
      "Kubernetes",
      "Jenkins",
      "AWS",
      "Ansible"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "AIOps",
      "Amazon Q Developer"
    ],
    "domainSkills": [
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Containerization Concepts",
      "Infrastructure as Code (IaC)",
      "Cloud Computing Fundamentals",
      "Configuration Management Principles"
    ]
  },
  {
    "roleId": "JF03-004",
    "roleName": "Site Reliability Engineer (SRE)",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Kubernetes",
      "Prometheus",
      "Linux",
      "Terraform",
      "Datadog"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "AIOps",
      "Cursor AI",
      "Amazon Q Developer"
    ],
    "domainSkills": [
      "Site Reliability Engineering (SRE) Principles",
      "Observability and Monitoring Concepts",
      "Cloud Computing Fundamentals",
      "Containerization Concepts",
      "Disaster Recovery and Business Continuity"
    ]
  },
  {
    "roleId": "JF03-005",
    "roleName": "Systems Administrator",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Linux",
      "Windows Server",
      "Shell Scripting",
      "Active Directory",
      "VMware"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Linux Systems Administration",
      "Windows Server Administration",
      "Networking Fundamentals",
      "Disaster Recovery and Business Continuity",
      "Configuration Management Principles"
    ]
  },
  {
    "roleId": "JF03-006",
    "roleName": "Network Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "CCNA",
      "Routing and Switching",
      "TCP/IP",
      "Firewall",
      "Network Security"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Routing and Switching Concepts",
      "TCP/IP Networking",
      "Networking Fundamentals",
      "Network Security Principles",
      "Firewall and Network Security Design"
    ]
  },
  {
    "roleId": "JF03-007",
    "roleName": "Database Administrator (DBA)",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Oracle Database",
      "SQL",
      "Database Performance Tuning",
      "Backup and Recovery",
      "High Availability"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "AI-Powered SIEM",
      "ChatGPT",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Database Administration",
      "Relational Database Querying Concepts",
      "Query Optimization Concepts",
      "Database Design Principles",
      "Relational Database Management"
    ]
  },
  {
    "roleId": "JF03-008",
    "roleName": "Storage Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "SAN/NAS",
      "Storage Administration",
      "NetApp",
      "Storage Capacity Planning",
      "Linux"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Storage Architecture",
      "Storage Protocols",
      "Cloud Computing Fundamentals",
      "Disaster Recovery and Business Continuity",
      "Networking Fundamentals"
    ]
  },
  {
    "roleId": "JF03-009",
    "roleName": "Linux Administrator",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Linux System Administration",
      "Bash Scripting",
      "Ansible",
      "SELinux",
      "VMware"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Linux Systems Administration",
      "Networking Fundamentals",
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Configuration Management Principles",
      "Network Security Principles"
    ]
  },
  {
    "roleId": "JF03-010",
    "roleName": "Platform Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Platform Engineering",
      "Kubernetes",
      "Internal Developer Platform",
      "Terraform",
      "Helm"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "AIOps",
      "Amazon Q Developer"
    ],
    "domainSkills": [
      "Platform Engineering Concepts",
      "Containerization Concepts",
      "Infrastructure as Code (IaC)",
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Cloud Computing Fundamentals"
    ]
  },
  {
    "roleId": "JF03-011",
    "roleName": "AWS Solutions Architect",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "AWS Solutions Architect",
      "AWS",
      "VPC",
      "AWS IAM",
      "CloudFormation"
    ],
    "aiToolSkills": [
      "Amazon Q Developer",
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "AWS Well-Architected Framework",
      "Cloud Architecture Patterns",
      "Cloud Security Principles",
      "Disaster Recovery and Business Continuity",
      "Cloud Cost Optimization"
    ]
  },
  {
    "roleId": "JF03-012",
    "roleName": "Azure Administrator",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Azure",
      "Azure Active Directory",
      "Azure Virtual Machines",
      "Azure Networking",
      "Azure Monitor"
    ],
    "aiToolSkills": [
      "GitHub Copilot Enterprise",
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Azure Architecture Fundamentals",
      "Identity and Access Management (IAM)",
      "Linux Systems Administration",
      "Disaster Recovery and Business Continuity",
      "Cloud Cost Optimization"
    ]
  },
  {
    "roleId": "JF03-013",
    "roleName": "Google Cloud Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Google Cloud Platform",
      "Google Kubernetes Engine",
      "BigQuery",
      "Terraform",
      "Cloud IAM"
    ],
    "aiToolSkills": [
      "Gemini Code Assist",
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Google Cloud Platform Architecture",
      "Containerization Concepts",
      "Infrastructure as Code (IaC)",
      "Cloud Security Principles",
      "Continuous Integration and Continuous Delivery (CI/CD)"
    ]
  },
  {
    "roleId": "JF03-014",
    "roleName": "Kubernetes Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Kubernetes",
      "Kubernetes Administration",
      "Kubernetes Networking",
      "Kubernetes Security",
      "Helm"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "AIOps",
      "Amazon Q Developer"
    ],
    "domainSkills": [
      "Container Orchestration Concepts",
      "Containerization Concepts",
      "Networking Fundamentals",
      "Observability and Monitoring Concepts",
      "Cloud Security Principles"
    ]
  },
  {
    "roleId": "JF03-015",
    "roleName": "CI/CD Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "CI/CD Pipelines",
      "Jenkins",
      "GitHub Actions",
      "ArgoCD",
      "Docker"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Containerization Concepts",
      "Configuration Management Principles",
      "Infrastructure as Code (IaC)",
      "Cloud Computing Fundamentals"
    ]
  },
  {
    "roleId": "JF03-016",
    "roleName": "Infrastructure Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Infrastructure as Code",
      "Terraform",
      "AWS",
      "Docker",
      "Linux"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "AIOps",
      "Amazon Q Developer"
    ],
    "domainSkills": [
      "Cloud Computing Fundamentals",
      "Infrastructure as Code (IaC)",
      "Networking Fundamentals",
      "Disaster Recovery and Business Continuity",
      "Cloud Security Principles"
    ]
  },
  {
    "roleId": "JF03-017",
    "roleName": "Container Platform Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Docker",
      "Kubernetes",
      "Helm",
      "Ansible",
      "Linux"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Container Orchestration Concepts",
      "Containerization Concepts",
      "Platform Engineering Concepts",
      "Networking Fundamentals",
      "Cloud Security Principles"
    ]
  },
  {
    "roleId": "JF03-018",
    "roleName": "Infrastructure Automation Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Terraform",
      "Ansible",
      "Bash Scripting",
      "Packer",
      "Jenkins"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Infrastructure as Code (IaC)",
      "Configuration Management Principles",
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Cloud Computing Fundamentals",
      "Linux Systems Administration"
    ]
  },
  {
    "roleId": "JF03-019",
    "roleName": "Configuration Management Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Ansible",
      "Puppet",
      "Chef",
      "Linux",
      "Git"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Configuration Management Principles",
      "Linux Systems Administration",
      "Infrastructure as Code (IaC)",
      "Cloud Computing Fundamentals",
      "Continuous Integration and Continuous Delivery (CI/CD)"
    ]
  },
  {
    "roleId": "JF03-020",
    "roleName": "Cloud Security Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Cloud Security",
      "AWS",
      "Terraform",
      "Zero Trust Security",
      "SIEM"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "AIOps",
      "OpenAI API"
    ],
    "domainSkills": [
      "Cloud Security Principles",
      "Identity and Access Management (IAM)",
      "Network Security Principles",
      "Security Testing Concepts",
      "Disaster Recovery and Business Continuity"
    ]
  },
  {
    "roleId": "JF03-021",
    "roleName": "Observability Engineer",
    "jobFamily": "DevOps & Cloud Engineering",
    "technicalSkills": [
      "Prometheus",
      "Grafana",
      "OpenTelemetry",
      "Distributed Tracing",
      "Log Management"
    ],
    "aiToolSkills": [
      "AIOps",
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Observability and Monitoring Concepts",
      "Site Reliability Engineering (SRE) Principles",
      "Log Analysis and Correlation",
      "Continuous Integration and Continuous Delivery (CI/CD)",
      "Networking Fundamentals"
    ]
  },
  {
    "roleId": "JF04-001",
    "roleName": "IT Project Manager",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Project Management",
      "MS Project",
      "Risk Management",
      "Stakeholder Management",
      "PMP"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Zapier",
      "Power BI Copilot",
      "Gamma"
    ],
    "domainSkills": [
      "IT Project Management",
      "Agile Methodology",
      "Scrum Framework",
      "Project Cycle Management",
      "Budgeting and Resource Management"
    ]
  },
  {
    "roleId": "JF04-002",
    "roleName": "IT Manager",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "IT Governance",
      "Project Management",
      "Vendor Management",
      "IT Budgeting",
      "Agile"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Zapier",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Team Leadership and People Management",
      "ITIL Framework",
      "IT Service Management (ITSM)",
      "Budgeting and Resource Management",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF04-003",
    "roleName": "Scrum Master",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Scrum",
      "Agile",
      "JIRA",
      "Agile Coaching",
      "SAFe"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Zapier",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Scrum Framework",
      "Agile Methodology",
      "Agile Testing Methodology",
      "IT Project Management",
      "Budgeting and Resource Management"
    ]
  },
  {
    "roleId": "JF04-004",
    "roleName": "Agile Coach",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Agile Coaching",
      "Agile Transformation",
      "SAFe",
      "Scrum",
      "Agile"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Zapier",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Agile Testing Methodology",
      "Agile Methodology",
      "Scrum Framework",
      "Software Testing Life Cycle (STLC)",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF04-005",
    "roleName": "Technical Support Engineer",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Technical Troubleshooting",
      "ITIL",
      "ServiceNow",
      "Active Directory Administration",
      "PostgreSQL"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Claude",
      "AIOps",
      "Gamma"
    ],
    "domainSkills": [
      "ITIL Framework",
      "Relational Database Management",
      "Troubleshooting Methodology",
      "Networking Fundamentals",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF04-006",
    "roleName": "Help Desk Technician",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Hardware Troubleshooting",
      "Windows OS",
      "ServiceNow",
      "Remote Desktop Support",
      "ITIL"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Microsoft 365 Copilot",
      "AIOps",
      "Gamma"
    ],
    "domainSkills": [
      "IT Hardware and Software Fundamentals",
      "Network Troubleshooting Concepts",
      "Operating System Concepts",
      "ITIL Framework",
      "End-User Support Principles"
    ]
  },
  {
    "roleId": "JF04-007",
    "roleName": "IT Service Desk Analyst",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Incident Management",
      "ServiceNow",
      "ITIL",
      "Customer Service",
      "Windows OS"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Microsoft 365 Copilot",
      "AIOps",
      "Gamma"
    ],
    "domainSkills": [
      "ITIL Framework",
      "Customer Experience Design",
      "IT Hardware and Software Fundamentals",
      "End-User Support Principles",
      "Troubleshooting Methodology"
    ]
  },
  {
    "roleId": "JF04-008",
    "roleName": "Desktop Support Engineer",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Desktop Support",
      "Windows OS",
      "Software Installation and Configuration",
      "Active Directory Administration",
      "Network Troubleshooting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Claude",
      "Gamma",
      "AIOps"
    ],
    "domainSkills": [
      "Desktop and Endpoint Management",
      "IT Hardware and Software Fundamentals",
      "Operating System Concepts",
      "Network Troubleshooting Concepts",
      "ITIL Framework"
    ]
  },
  {
    "roleId": "JF04-009",
    "roleName": "IT Consultant",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "IT Consulting",
      "Solution Architecture",
      "Business Process Analysis",
      "System Design",
      "Change Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "AIOps",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "IT Consulting Methodology",
      "Gap Analysis",
      "Business Analysis Methodology",
      "IT Strategy and Planning",
      "Requirements Engineering"
    ]
  },
  {
    "roleId": "JF04-010",
    "roleName": "SAP Consultant",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "SAP",
      "SAP S/4HANA",
      "SAP FICO",
      "SAP ABAP",
      "SAP Basis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "SAP Joule",
      "Claude",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "SAP Functional Knowledge",
      "SAP Implementation Methodology",
      "Enterprise Resource Planning (ERP) Concepts",
      "ERP Implementation Methodology",
      "SAP ABAP Development Concepts"
    ]
  },
  {
    "roleId": "JF04-011",
    "roleName": "Salesforce Consultant",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Salesforce",
      "Salesforce Administration",
      "Salesforce CPQ",
      "Apex",
      "Salesforce Lightning"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Claude",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "Salesforce CRM Concepts",
      "Salesforce Platform Architecture",
      "Networking Fundamentals",
      "Salesforce Development Principles",
      "Software Testing Life Cycle (STLC)"
    ]
  },
  {
    "roleId": "JF04-012",
    "roleName": "ERP Consultant",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "ERP Implementation",
      "SAP",
      "Business Process Mapping",
      "Change Management",
      "SQL"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "SAP Joule",
      "Claude",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "Enterprise Resource Planning (ERP) Concepts",
      "ERP Implementation Methodology",
      "Business Analysis Methodology",
      "ERP Integration Concepts",
      "Gap Analysis"
    ]
  },
  {
    "roleId": "JF04-013",
    "roleName": "IT Business Analyst",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Business Analysis",
      "Requirements Gathering",
      "Use Case Documentation",
      "JIRA",
      "Agile Business Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AIOps",
      "Microsoft 365 Copilot",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "Business Analysis Methodology",
      "Requirements Engineering",
      "Process Modeling and Mapping",
      "Use Case and User Story Design",
      "Agile Methodology"
    ]
  },
  {
    "roleId": "JF04-014",
    "roleName": "IT Strategy Consultant",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "IT Strategy",
      "Enterprise Architecture",
      "Digital Strategy",
      "IT Consulting",
      "Change Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "AIOps",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "IT Strategy and Planning",
      "IT Governance Frameworks",
      "IT Consulting Methodology",
      "Technology Roadmap Development",
      "Vendor and Third-Party Management"
    ]
  },
  {
    "roleId": "JF04-015",
    "roleName": "Digital Transformation Consultant",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Digital Transformation",
      "Cloud Migration",
      "Change Management",
      "Digital Strategy",
      "Innovation Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft 365 Copilot",
      "AIOps",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "Digital Transformation Strategy",
      "Change Management for Digital Initiatives",
      "Change Management Methodology",
      "Emerging Technology Trends",
      "IT Consulting Methodology"
    ]
  },
  {
    "roleId": "JF04-016",
    "roleName": "Technology Advisor",
    "jobFamily": "IT Support & Management",
    "technicalSkills": [
      "Technology Roadmap",
      "IT Strategy",
      "Enterprise Architecture",
      "IT Due Diligence",
      "Solution Architecture"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AIOps",
      "Microsoft 365 Copilot",
      "Gamma",
      "Zapier"
    ],
    "domainSkills": [
      "Emerging Technology Trends",
      "IT Strategy and Planning",
      "IT Consulting Methodology",
      "Technology Roadmap Development",
      "Vendor and Third-Party Management"
    ]
  },
  {
    "roleId": "JF05-001",
    "roleName": "Data Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Data Analysis",
      "SQL",
      "Microsoft Excel",
      "Power BI",
      "Python for Data Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Data Storytelling",
      "Data Wrangling and Cleaning",
      "Data Visualization Principles",
      "Exploratory Data Analysis (EDA)",
      "Relational Database Querying Concepts"
    ]
  },
  {
    "roleId": "JF05-002",
    "roleName": "Data Engineer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Apache Spark",
      "SQL",
      "Data Pipeline",
      "ETL",
      "Apache Kafka"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "Julius AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "ETL (Extract, Transform, Load) Principles",
      "Data Pipeline Design",
      "Data Warehousing Concepts",
      "Relational Database Management",
      "ETL Architecture and Design"
    ]
  },
  {
    "roleId": "JF05-003",
    "roleName": "Business Intelligence Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Business Intelligence",
      "Tableau",
      "SQL",
      "Data Warehousing",
      "Looker"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "GitHub Copilot",
      "Cursor AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Business Intelligence Concepts",
      "Data Warehousing Concepts",
      "Data Visualization Principles",
      "Dimensional Modeling",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF05-004",
    "roleName": "Big Data Engineer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Hadoop",
      "Apache Spark",
      "Hive",
      "HBase",
      "AWS Glue"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "Julius AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Big Data Architecture",
      "Distributed Computing Concepts",
      "ETL (Extract, Transform, Load) Principles",
      "Data Pipeline Design",
      "ETL Architecture and Design"
    ]
  },
  {
    "roleId": "JF05-005",
    "roleName": "Analytics Consultant",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Analytics Consulting",
      "Data Analysis",
      "Statistical Analysis",
      "SQL",
      "Data Visualization"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Analytics Consulting Methodology",
      "Data-Driven Decision Making",
      "Data Wrangling and Cleaning",
      "Data Visualization Principles",
      "Exploratory Data Analysis (EDA)"
    ]
  },
  {
    "roleId": "JF05-006",
    "roleName": "Quantitative Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Quantitative Analysis",
      "R Programming",
      "NumPy",
      "Financial Modeling",
      "Machine Learning"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Cursor AI",
      "ChatGPT",
      "Julius AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Quantitative Methods",
      "Statistical Modelling",
      "Financial Mathematics",
      "Risk Modeling",
      "Data-Driven Decision Making"
    ]
  },
  {
    "roleId": "JF05-007",
    "roleName": "Data Architect",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Data Architecture",
      "Data Modeling",
      "Data Warehousing",
      "Data Governance",
      "Cloud Data Architecture"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Julius AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Data Architecture and Modeling",
      "Master Data Management (MDM)",
      "Data Wrangling and Cleaning",
      "Data Warehousing Concepts",
      "ETL (Extract, Transform, Load) Principles"
    ]
  },
  {
    "roleId": "JF05-008",
    "roleName": "SQL Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Advanced SQL",
      "Query Optimization",
      "SQL Server",
      "PostgreSQL",
      "Power BI"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Relational Database Querying Concepts",
      "Query Optimization Concepts",
      "Database Design Principles",
      "Data Storytelling",
      "Data Visualization Principles"
    ]
  },
  {
    "roleId": "JF05-009",
    "roleName": "Tableau Developer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Tableau Desktop",
      "SQL",
      "Tableau Server",
      "Tableau",
      "Tableau Prep"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Tableau Pulse",
      "Julius AI"
    ],
    "domainSkills": [
      "Data Visualization Principles",
      "Dashboard and Report Design Principles",
      "Business Intelligence Concepts",
      "Data Storytelling",
      "Relational Database Querying Concepts"
    ]
  },
  {
    "roleId": "JF05-010",
    "roleName": "Power BI Developer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Power BI Desktop",
      "DAX",
      "Power Query",
      "Power BI Service",
      "SQL"
    ],
    "aiToolSkills": [
      "Power BI Copilot",
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Business Intelligence Concepts",
      "Self-Service BI Principles",
      "KPI Design and Metrics Framework",
      "Dashboard and Report Design Principles",
      "Semantic Layer Design"
    ]
  },
  {
    "roleId": "JF05-011",
    "roleName": "Data Quality Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Data Quality Management",
      "SQL",
      "Data Profiling",
      "Great Expectations",
      "Data Lineage"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Julius AI",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Data Quality Management Concepts",
      "Data Profiling Concepts",
      "Data Quality Rules and Validation",
      "Root Cause Analysis for Data Issues",
      "Master Data Management (MDM)"
    ]
  },
  {
    "roleId": "JF05-012",
    "roleName": "ETL Developer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "ETL",
      "SSIS",
      "Informatica PowerCenter",
      "Talend",
      "Data Integration"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "dbt (data build tool)",
      "Julius AI"
    ],
    "domainSkills": [
      "ETL Architecture and Design",
      "Data Transformation Logic",
      "Incremental Load Design",
      "ETL (Extract, Transform, Load) Principles",
      "Data Quality Management Concepts"
    ]
  },
  {
    "roleId": "JF05-013",
    "roleName": "Reporting Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Report Development",
      "SQL",
      "Power BI",
      "SSRS",
      "Business Reporting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Power BI Copilot",
      "Tableau Pulse"
    ],
    "domainSkills": [
      "Reporting Design Principles",
      "Business Intelligence Concepts",
      "Data Storytelling",
      "Dashboard and Report Design Principles",
      "Report Performance Optimization"
    ]
  },
  {
    "roleId": "JF05-014",
    "roleName": "Analytics Engineer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "dbt",
      "Analytics Engineering",
      "SQL",
      "Snowflake",
      "Data Build Tool"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "dbt (data build tool)",
      "Cursor AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Analytics Engineering Concepts",
      "Data Modeling for Analytics",
      "Semantic Layer Design",
      "ETL (Extract, Transform, Load) Principles",
      "Data Pipeline Design"
    ]
  },
  {
    "roleId": "JF05-015",
    "roleName": "Data Pipeline Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Apache Airflow",
      "Data Pipeline",
      "SQL",
      "Pipeline Monitoring",
      "Data Orchestration"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Julius AI",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Data Pipeline Monitoring and Observability",
      "Batch vs Streaming Processing Concepts",
      "ETL (Extract, Transform, Load) Principles",
      "Root Cause Analysis for Data Issues",
      "Data Pipeline Design"
    ]
  },
  {
    "roleId": "JF05-016",
    "roleName": "Database Developer",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Stored Procedures",
      "SQL",
      "Database Design",
      "PL/SQL",
      "T-SQL"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "OpenAI API",
      "Julius AI",
      "Cursor AI"
    ],
    "domainSkills": [
      "Database Development Concepts",
      "Stored Procedures and Functions",
      "Database Indexing and Query Tuning",
      "Relational Database Management",
      "Query Optimization Concepts"
    ]
  },
  {
    "roleId": "JF05-017",
    "roleName": "Data Visualization Analyst",
    "jobFamily": "Data Engineering & Analytics",
    "technicalSkills": [
      "Data Visualization",
      "Tableau",
      "Power BI",
      "D3.js",
      "Visual Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Power BI Copilot",
      "Tableau Pulse"
    ],
    "domainSkills": [
      "Data Visualization Principles",
      "Data Storytelling",
      "Dashboard and Report Design Principles",
      "Exploratory Data Analysis (EDA)",
      "KPI Design and Metrics Framework"
    ]
  },
  {
    "roleId": "JF06-001",
    "roleName": "Data Scientist",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Data Science",
      "Python",
      "pandas",
      "scikit-learn",
      "Statistics"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Claude",
      "OpenAI API",
      "Claude Code",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Machine Learning Fundamentals",
      "ML System Design",
      "Data-Driven Decision Making",
      "Model Selection and Evaluation",
      "Exploratory Data Analysis (EDA)"
    ]
  },
  {
    "roleId": "JF06-002",
    "roleName": "Machine Learning Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Machine Learning Engineering",
      "TensorFlow",
      "PyTorch",
      "Feature Engineering",
      "Model Deployment"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Machine Learning Fundamentals",
      "ML System Design",
      "MLOps Principles",
      "Model Deployment and Serving Concepts",
      "ML Experiment Tracking"
    ]
  },
  {
    "roleId": "JF06-003",
    "roleName": "AI Research Scientist",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "AI Research",
      "PyTorch",
      "Deep Learning",
      "Research Paper Writing",
      "Reinforcement Learning"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Hugging Face",
      "OpenAI API"
    ],
    "domainSkills": [
      "AI Research Methodology",
      "Deep Learning Principles",
      "Statistical Learning Theory",
      "Scientific Writing and Publication",
      "AI Ethics and Responsible AI"
    ]
  },
  {
    "roleId": "JF06-004",
    "roleName": "NLP Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Natural Language Processing",
      "Hugging Face Transformers",
      "Text Classification",
      "BERT",
      "spaCy"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Hugging Face",
      "ChatGPT",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "Natural Language Processing (NLP) Fundamentals",
      "Text Representation and Embeddings",
      "Neural Network Architecture",
      "Sequence Modeling",
      "Information Extraction"
    ]
  },
  {
    "roleId": "JF06-005",
    "roleName": "Computer Vision Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Computer Vision",
      "OpenCV",
      "Image Classification",
      "Convolutional Neural Networks",
      "Object Detection"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Computer Vision Fundamentals",
      "Convolutional Neural Network Principles",
      "Image Feature Extraction",
      "Object Detection and Segmentation",
      "Deep Learning Principles"
    ]
  },
  {
    "roleId": "JF06-006",
    "roleName": "MLOps Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "MLOps",
      "Kubernetes",
      "MLflow",
      "Kubeflow",
      "Model Monitoring"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "MLOps Principles",
      "Model Deployment and Serving Concepts",
      "ML Experiment Tracking",
      "ML System Design",
      "Continuous Integration and Continuous Delivery (CI/CD)"
    ]
  },
  {
    "roleId": "JF06-007",
    "roleName": "AI Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "AI Engineering",
      "LLM Integration",
      "Vector Databases",
      "LangChain",
      "PyTorch"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "OpenAI API",
      "ChatGPT",
      "Claude Code",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Machine Learning Fundamentals",
      "ML System Design",
      "Generative AI Concepts",
      "MLOps Principles",
      "AI Ethics and Responsible AI"
    ]
  },
  {
    "roleId": "JF06-008",
    "roleName": "Deep Learning Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Deep Learning Engineering",
      "PyTorch",
      "Neural Networks",
      "CUDA",
      "Model Architecture Design"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Deep Learning Principles",
      "Neural Network Architecture",
      "Backpropagation and Optimization Theory",
      "Machine Learning Fundamentals",
      "Model Selection and Evaluation"
    ]
  },
  {
    "roleId": "JF06-009",
    "roleName": "Generative AI Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Generative AI",
      "Large Language Models",
      "RAG",
      "LangChain",
      "Fine-tuning"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "OpenAI API",
      "Hugging Face",
      "ChatGPT",
      "Claude Code"
    ],
    "domainSkills": [
      "Generative AI Concepts",
      "Large Language Model (LLM) Architecture",
      "Retrieval-Augmented Generation (RAG)",
      "Prompt Engineering Principles",
      "LLM Evaluation and Safety"
    ]
  },
  {
    "roleId": "JF06-010",
    "roleName": "Prompt Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Prompt Engineering",
      "GPT API",
      "Large Language Models",
      "AI Evaluation",
      "Chain-of-Thought Prompting"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "OpenAI API",
      "Hugging Face"
    ],
    "domainSkills": [
      "Prompt Engineering Principles",
      "Prompt Design Patterns",
      "Large Language Model (LLM) Architecture",
      "LLM Evaluation and Safety",
      "Natural Language Processing (NLP) Fundamentals"
    ]
  },
  {
    "roleId": "JF06-011",
    "roleName": "ML Research Engineer",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "ML Research",
      "PyTorch",
      "Deep Learning",
      "Experiment Tracking",
      "Bayesian Optimization"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Claude Code",
      "Hugging Face",
      "OpenAI API"
    ],
    "domainSkills": [
      "Machine Learning Fundamentals",
      "Deep Learning Principles",
      "AI Research Methodology",
      "Backpropagation and Optimization Theory",
      "ML System Design"
    ]
  },
  {
    "roleId": "JF06-012",
    "roleName": "AI Product Analyst",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "AI Product Analysis",
      "Data Analysis",
      "Product Analytics",
      "A/B Testing",
      "AI Literacy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "OpenAI API",
      "GitHub Copilot",
      "Claude Code",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "AI Product Analytics",
      "Machine Learning Fundamentals",
      "Exploratory Data Analysis (EDA)",
      "AI Ethics and Responsible AI",
      "Model Selection and Evaluation"
    ]
  },
  {
    "roleId": "JF06-013",
    "roleName": "Generative AI Specialist",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "Generative AI",
      "Generative AI Applications",
      "Diffusion Models",
      "Multimodal AI",
      "AI Safety"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "OpenAI API",
      "Hugging Face",
      "Claude Code",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Generative AI Concepts",
      "Generative AI System Design",
      "Foundation Model Fine-Tuning Concepts",
      "Retrieval-Augmented Generation (RAG)",
      "Agentic AI Architecture"
    ]
  },
  {
    "roleId": "JF06-014",
    "roleName": "AI Analyst",
    "jobFamily": "Data Science & Machine Learning",
    "technicalSkills": [
      "AI Analytics",
      "Data Analysis",
      "Model Performance Evaluation",
      "A/B Testing",
      "AI Use Case Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "OpenAI API",
      "GitHub Copilot",
      "Power BI Copilot",
      "Claude Code"
    ],
    "domainSkills": [
      "AI Use Case Identification",
      "AI Product Analytics",
      "Machine Learning Fundamentals",
      "AI Ethics and Responsible AI",
      "Exploratory Data Analysis (EDA)"
    ]
  },
  {
    "roleId": "JF07-001",
    "roleName": "Cybersecurity Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Cybersecurity",
      "Network Security Monitoring",
      "Security Information and Event Management",
      "Threat Detection",
      "Incident Response"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI-Powered SIEM",
      "GitHub Copilot",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Cybersecurity Fundamentals",
      "Threat Modeling",
      "Security Operations Concepts",
      "MITRE ATT&CK Framework",
      "Network Security Principles"
    ]
  },
  {
    "roleId": "JF07-002",
    "roleName": "Ethical Hacker / Penetration Tester",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Ethical Hacking",
      "Exploitation Techniques",
      "Metasploit",
      "Burp Suite",
      "Nmap"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Microsoft Security Copilot",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Penetration Testing Methodology",
      "Offensive Security Methodology",
      "Cybersecurity Fundamentals",
      "MITRE ATT&CK Framework",
      "Social Engineering Concepts"
    ]
  },
  {
    "roleId": "JF07-003",
    "roleName": "SOC Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "SOC Operations",
      "Security Information and Event Management",
      "Log Analysis",
      "Security Monitoring",
      "Malware Analysis"
    ],
    "aiToolSkills": [
      "AI-Powered SIEM",
      "ChatGPT",
      "AIOps",
      "Cursor AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Security Operations Concepts",
      "Security Information and Event Management (SIEM) Concepts",
      "Log Analysis and Correlation",
      "MITRE ATT&CK Framework",
      "Cyber Kill Chain"
    ]
  },
  {
    "roleId": "JF07-004",
    "roleName": "Information Security Manager",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Information Security Management",
      "ISO 27001",
      "Security Policy",
      "Risk Assessment",
      "CISSP"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Claude Code",
      "GitHub Copilot",
      "Microsoft Security Copilot",
      "AI-Powered SIEM"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Risk Assessment Methodology",
      "Compliance Frameworks",
      "Threat Modeling"
    ]
  },
  {
    "roleId": "JF07-005",
    "roleName": "Cyber Forensics Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Digital Forensics",
      "Forensic Investigation",
      "EnCase",
      "FTK",
      "Chain of Custody"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Microsoft Security Copilot",
      "AI-Powered SIEM"
    ],
    "domainSkills": [
      "Digital Forensics Principles",
      "Cybersecurity Fundamentals",
      "Malware Analysis Concepts",
      "Memory Forensics Concepts",
      "Incident Response Methodology"
    ]
  },
  {
    "roleId": "JF07-006",
    "roleName": "Vulnerability Assessment Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Vulnerability Assessment",
      "Nessus",
      "OpenVAS",
      "CVE",
      "Vulnerability Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Microsoft Security Copilot",
      "AI-Powered SIEM",
      "Cursor AI"
    ],
    "domainSkills": [
      "Cybersecurity Fundamentals",
      "Vulnerability Scanning Concepts",
      "Common Vulnerabilities and Exposures (CVE) Framework",
      "Threat Modeling",
      "MITRE ATT&CK Framework"
    ]
  },
  {
    "roleId": "JF07-007",
    "roleName": "GRC Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Governance Risk and Compliance",
      "NIST Framework",
      "SOC 2",
      "Compliance Management",
      "Audit Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Cursor AI",
      "Claude Code",
      "Microsoft Security Copilot",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Compliance Frameworks",
      "Risk Assessment Methodology",
      "Information Security Policies and Standards",
      "IT Governance Frameworks"
    ]
  },
  {
    "roleId": "JF07-008",
    "roleName": "Threat Intelligence Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Threat Intelligence",
      "MITRE ATT&CK",
      "Threat Hunting",
      "OSINT",
      "Indicator of Compromise"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI-Powered SIEM",
      "Cursor AI",
      "Microsoft Security Copilot",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Threat Intelligence Principles",
      "MITRE ATT&CK Framework",
      "Threat Actor Profiling",
      "Indicators of Compromise (IoC)",
      "Cyber Kill Chain"
    ]
  },
  {
    "roleId": "JF07-009",
    "roleName": "Application Security Engineer",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Application Security",
      "OWASP",
      "SAST",
      "DAST",
      "Secure Code Review"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Microsoft Security Copilot",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Application Security Principles",
      "Secure Software Development Life Cycle (SSDLC)",
      "OWASP Application Security Concepts",
      "Code Review for Security",
      "Threat Modeling"
    ]
  },
  {
    "roleId": "JF07-010",
    "roleName": "Cloud Security Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Cloud Security Analysis",
      "AWS",
      "AWS Security",
      "Cloud Compliance",
      "CSPM"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI-Powered SIEM",
      "GitHub Copilot",
      "Cursor AI",
      "AIOps"
    ],
    "domainSkills": [
      "Cloud Security Architecture",
      "Cloud Security Principles",
      "Cloud Threat Landscape",
      "Threat Modeling",
      "MITRE ATT&CK Framework"
    ]
  },
  {
    "roleId": "JF07-011",
    "roleName": "Identity & Access Management Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Identity and Access Management",
      "Active Directory Security",
      "Single Sign-On",
      "Multi-Factor Authentication",
      "Privileged Access Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "AI-Powered SIEM",
      "Microsoft Security Copilot"
    ],
    "domainSkills": [
      "Identity and Access Management Principles",
      "Federation and Single Sign-On Concepts",
      "Cybersecurity Fundamentals",
      "Directory Services Concepts",
      "Identity and Access Management (IAM)"
    ]
  },
  {
    "roleId": "JF07-012",
    "roleName": "Security Operations Engineer",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Security Operations",
      "Splunk",
      "Security Information and Event Management",
      "SOAR",
      "Security Automation"
    ],
    "aiToolSkills": [
      "AI-Powered SIEM",
      "GitHub Copilot",
      "ChatGPT",
      "AIOps",
      "Cursor AI"
    ],
    "domainSkills": [
      "Security Engineering Principles",
      "Security Monitoring and Detection",
      "Security Operations Concepts",
      "Security Information and Event Management (SIEM) Concepts",
      "MITRE ATT&CK Framework"
    ]
  },
  {
    "roleId": "JF07-013",
    "roleName": "Incident Response Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Incident Response Analysis",
      "Threat Intelligence",
      "Digital Forensics and Incident Response",
      "Threat Containment",
      "Post-Incident Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI-Powered SIEM",
      "AIOps",
      "Cursor AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Incident Response Methodology",
      "Security Operations Concepts",
      "Digital Evidence Handling",
      "MITRE ATT&CK Framework",
      "Recovery and Remediation Planning"
    ]
  },
  {
    "roleId": "JF07-014",
    "roleName": "Network Security Engineer",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Network Security Engineering",
      "Firewall",
      "IDS/IPS",
      "VPN",
      "Zero Trust Architecture"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "AIOps",
      "AI-Powered SIEM"
    ],
    "domainSkills": [
      "Cybersecurity Fundamentals",
      "Network Security Principles",
      "Intrusion Detection and Prevention Concepts",
      "Network Traffic Analysis",
      "Firewall and Network Security Design"
    ]
  },
  {
    "roleId": "JF07-015",
    "roleName": "Network Security Analyst",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Network Security Analysis",
      "Packet Analysis",
      "Wireshark",
      "Network Security Monitoring",
      "IDS/IPS"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI-Powered SIEM",
      "Cursor AI",
      "AIOps",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Cybersecurity Fundamentals",
      "Network Traffic Analysis",
      "Intrusion Detection and Prevention Concepts",
      "Protocol Security Analysis",
      "Log Analysis and Correlation"
    ]
  },
  {
    "roleId": "JF07-016",
    "roleName": "DevSecOps Engineer",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "DevSecOps Engineering",
      "Secrets Management",
      "SAST/DAST Integration",
      "Container Security",
      "Security as Code"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Cursor AI",
      "AI-Powered SIEM",
      "AIOps"
    ],
    "domainSkills": [
      "DevSecOps Principles",
      "Shift-Left Security",
      "Secure Software Development Life Cycle (SSDLC)",
      "Application Security Principles",
      "Continuous Integration and Continuous Delivery (CI/CD)"
    ]
  },
  {
    "roleId": "JF07-017",
    "roleName": "Cloud Penetration Tester",
    "jobFamily": "Cybersecurity",
    "technicalSkills": [
      "Cloud Penetration Testing",
      "Penetration Testing",
      "AWS",
      "AWS Exploitation",
      "Cloud Attack Surface"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ChatGPT",
      "Microsoft Security Copilot",
      "Cursor AI",
      "OpenAI API"
    ],
    "domainSkills": [
      "Cloud Penetration Testing Methodology",
      "Cloud Misconfiguration Analysis",
      "Penetration Testing Methodology",
      "Cloud Security Architecture",
      "Cloud Threat Landscape"
    ]
  },
  {
    "roleId": "JF08-001",
    "roleName": "Product Manager",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Product Management",
      "Product Roadmap",
      "Product Analytics Tools",
      "User Story Writing",
      "Stakeholder Communication"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Replit Agent",
      "Power BI Copilot",
      "Figma AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Product Management Fundamentals",
      "Product Strategy",
      "Product Roadmap Development",
      "User Story and Requirements Definition",
      "Product Metrics and KPIs"
    ]
  },
  {
    "roleId": "JF08-002",
    "roleName": "UX Designer",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "UX Design",
      "Figma",
      "User Research",
      "Wireframing",
      "Prototyping"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Adobe Firefly",
      "Figma AI"
    ],
    "domainSkills": [
      "User-Centred Design Principles",
      "Design Thinking Methodology",
      "Persona Development",
      "Journey Mapping",
      "User Research Methodology"
    ]
  },
  {
    "roleId": "JF08-003",
    "roleName": "UI Designer",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "UI Design",
      "Figma",
      "Visual Design",
      "Design Systems",
      "Adobe XD"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Adobe Firefly",
      "Figma AI"
    ],
    "domainSkills": [
      "Visual Design Principles",
      "Design Systems Concepts",
      "Typography Principles",
      "Colour Theory",
      "Accessibility Standards (WCAG)"
    ]
  },
  {
    "roleId": "JF08-004",
    "roleName": "UX Researcher",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "UX Research",
      "Usability Testing",
      "User Interviews",
      "Qualitative Research",
      "Research Synthesis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Figma AI",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "User Research Methodology",
      "API Design Principles",
      "Quantitative Research Methods",
      "Software Development Life Cycle (SDLC)",
      "Persona Development"
    ]
  },
  {
    "roleId": "JF08-005",
    "roleName": "Interaction Designer",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Interaction Design",
      "Figma",
      "Micro-interactions",
      "Motion Design",
      "Information Architecture"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Adobe Firefly",
      "Figma AI"
    ],
    "domainSkills": [
      "Interaction Design Principles",
      "User-Centred Design Principles",
      "Prototyping Principles",
      "Usability Principles",
      "Journey Mapping"
    ]
  },
  {
    "roleId": "JF08-006",
    "roleName": "Product Analyst",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Product Analysis",
      "SQL",
      "A/B Testing",
      "Funnel Analysis",
      "Cohort Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Power BI Copilot",
      "Figma AI"
    ],
    "domainSkills": [
      "Product Analytics Concepts",
      "Product Metrics and KPIs",
      "Data-Driven Decision Making",
      "Design Thinking Methodology",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF08-007",
    "roleName": "Associate Product Manager",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Product Management",
      "Product Discovery",
      "JIRA",
      "Backlog Management",
      "User Story Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Replit Agent",
      "Power BI Copilot",
      "Figma AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Associate Product Manager Fundamentals",
      "Product Management Fundamentals",
      "Agile Methodology",
      "Use Case and User Story Design",
      "User-Centred Design Principles"
    ]
  },
  {
    "roleId": "JF08-008",
    "roleName": "Product Operations Analyst",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Product Operations",
      "Process Improvement",
      "SQL",
      "KPI Tracking",
      "JIRA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Figma AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Product Operations Concepts",
      "Product Management Fundamentals",
      "Product Analytics Concepts",
      "Product Metrics and KPIs",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF08-009",
    "roleName": "Growth Product Manager",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Growth Hacking",
      "A/B Testing",
      "Conversion Rate Optimization",
      "Retention Analysis",
      "Experimentation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Replit Agent",
      "Figma AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Growth Frameworks",
      "Product Analytics Concepts",
      "Product Management Fundamentals",
      "Data-Driven Decision Making",
      "Product Metrics and KPIs"
    ]
  },
  {
    "roleId": "JF08-010",
    "roleName": "User Research Analyst",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "User Research",
      "Usability Testing",
      "Survey Design",
      "Quantitative User Research",
      "Research Synthesis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Figma AI",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "User Research Methodology",
      "Quantitative Research Methods",
      "API Design Principles",
      "Software Development Life Cycle (SDLC)",
      "Persona Development"
    ]
  },
  {
    "roleId": "JF08-011",
    "roleName": "Service Designer",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Service Design",
      "Service Blueprint",
      "Customer Journey Mapping",
      "UX Design",
      "Systems Thinking"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Figma AI",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Service Design Principles",
      "Service Blueprint Design",
      "Journey Mapping",
      "Design Thinking Methodology",
      "User-Centred Design Principles"
    ]
  },
  {
    "roleId": "JF08-012",
    "roleName": "Content Designer",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Content Design",
      "Content Strategy",
      "UX Design",
      "Information Design",
      "Plain Language Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Figma AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "API Design Principles",
      "User-Centred Design Principles",
      "UX Writing Principles",
      "Software Development Life Cycle (SDLC)",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF08-013",
    "roleName": "UX Writer",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "UX Writing",
      "Microcopy",
      "UX Design",
      "Voice and Tone Guidelines",
      "Content Audit"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Perplexity AI",
      "Figma AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "UX Writing Principles",
      "Microcopy Design",
      "Inclusive Design Principles",
      "User-Centred Design Principles",
      "Accessibility Standards (WCAG)"
    ]
  },
  {
    "roleId": "JF08-014",
    "roleName": "Technical Product Manager",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Technical Product Management",
      "Product Management",
      "System Design",
      "API Product Management",
      "Technical Documentation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Replit Agent",
      "Power BI Copilot",
      "GitHub Copilot",
      "Figma AI"
    ],
    "domainSkills": [
      "Technical Product Management Concepts",
      "Product Management Fundamentals",
      "Software Development Life Cycle (SDLC)",
      "User Story and Requirements Definition",
      "API Design Principles"
    ]
  },
  {
    "roleId": "JF08-015",
    "roleName": "Platform Product Manager",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Platform Product Management",
      "Product Management",
      "Developer Experience",
      "System Design",
      "Platform Strategy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Replit Agent",
      "Power BI Copilot",
      "Figma AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Platform Product Management Concepts",
      "Product Management Fundamentals",
      "Product Roadmap Development",
      "Product Strategy",
      "Product Metrics and KPIs"
    ]
  },
  {
    "roleId": "JF08-016",
    "roleName": "Accessibility Specialist",
    "jobFamily": "Product Management & Design",
    "technicalSkills": [
      "Web Accessibility",
      "WCAG",
      "Assistive Technology Testing",
      "Accessibility Audit",
      "ARIA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Figma AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Accessibility Standards (WCAG)",
      "Inclusive Design Principles",
      "User-Centred Design Principles",
      "Usability Principles",
      "UX Writing Principles"
    ]
  },
  {
    "roleId": "JF09-001",
    "roleName": "Chartered Accountant (CA)",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Financial Accounting",
      "Taxation",
      "Auditing",
      "IFRS",
      "Tally"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Financial Accounting Principles",
      "Double-Entry Bookkeeping",
      "Auditing Principles",
      "Taxation Concepts",
      "Corporate Law and Company Regulations"
    ]
  },
  {
    "roleId": "JF09-002",
    "roleName": "Financial Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Financial Analysis",
      "Microsoft Excel",
      "Financial Modeling",
      "Valuation",
      "DCF Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "BlackLine",
      "Datarails",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Financial Accounting Principles",
      "Financial Modelling",
      "Corporate Finance Principles",
      "Cost-Benefit Analysis",
      "Governance, Risk, and Compliance (GRC)"
    ]
  },
  {
    "roleId": "JF09-003",
    "roleName": "Investment Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Investment Analysis",
      "Equity Research",
      "Microsoft Excel",
      "Bloomberg Terminal",
      "Portfolio Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "BlackLine",
      "Datarails"
    ],
    "domainSkills": [
      "Cost-Benefit Analysis",
      "Equity Valuation",
      "Financial Modelling",
      "Governance, Risk, and Compliance (GRC)",
      "Capital Markets Knowledge"
    ]
  },
  {
    "roleId": "JF09-004",
    "roleName": "Portfolio Manager",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Portfolio Management",
      "Asset Allocation",
      "Risk Management in Finance",
      "Microsoft Excel",
      "CFA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "Julius AI",
      "Datarails"
    ],
    "domainSkills": [
      "Portfolio Theory",
      "Financial Accounting Principles",
      "Risk-Adjusted Performance Measurement",
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF09-005",
    "roleName": "Treasury Manager",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Treasury Management",
      "Cash Flow Management",
      "FX Risk Management",
      "Liquidity Management",
      "SAP Treasury"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "BlackLine",
      "Power BI Copilot",
      "Datarails"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Foreign Exchange Risk Management",
      "Derivatives and Hedging Concepts",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF09-006",
    "roleName": "Accounts Manager",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Accounts Management",
      "Financial Accounting",
      "Financial Statements Preparation",
      "Tally",
      "Bank Reconciliation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Financial Accounting Principles",
      "Accounts Closure and Period-End Processes",
      "Accounts Reconciliation Concepts",
      "Financial Reporting Standards",
      "Auditing Principles"
    ]
  },
  {
    "roleId": "JF09-007",
    "roleName": "Tax Consultant",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Tax Consulting",
      "Income Tax",
      "GST",
      "Tax Planning",
      "Tax Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "Datarails",
      "BlackLine"
    ],
    "domainSkills": [
      "Direct Taxation Principles",
      "GST and Indirect Tax Law",
      "Tax Filing and Compliance Procedures",
      "Tax Audit Concepts",
      "Taxation Concepts"
    ]
  },
  {
    "roleId": "JF09-008",
    "roleName": "Cost Accountant (CMA)",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Cost Accounting",
      "Cost Analysis",
      "Standard Costing",
      "Variance Analysis",
      "CMA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "BlackLine",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Cost Accounting Principles",
      "Standard Costing and Cost Variance",
      "Activity-Based Costing",
      "Financial Modelling",
      "Cost-Benefit Analysis"
    ]
  },
  {
    "roleId": "JF09-009",
    "roleName": "Financial Controller",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Financial Control",
      "Financial Accounting",
      "Management Reporting",
      "Month End Closing",
      "Internal Controls"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Financial Accounting Principles",
      "Internal Controls Framework",
      "Financial Reporting Standards",
      "Financial Planning and Analysis (FP&A)",
      "Auditing Principles"
    ]
  },
  {
    "roleId": "JF09-010",
    "roleName": "Accounts Payable Executive",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Accounts Payable",
      "Invoice Processing",
      "Vendor Payment",
      "Three-Way Matching",
      "Purchase Order Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Accounts Payable Management",
      "Double-Entry Bookkeeping",
      "Statutory Compliance (PF, ESI, TDS)",
      "Accounts Reconciliation Concepts",
      "Financial Accounting Principles"
    ]
  },
  {
    "roleId": "JF09-011",
    "roleName": "Accounts Receivable Executive",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Accounts Receivable",
      "Collections Management",
      "Credit Control",
      "Billing and Invoicing",
      "Tally"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Accounts Receivable Management",
      "Credit Control Principles",
      "Double-Entry Bookkeeping",
      "Accounts Reconciliation Concepts",
      "GST and Indirect Tax Law"
    ]
  },
  {
    "roleId": "JF09-012",
    "roleName": "GST Consultant",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "GST Compliance",
      "GST Return Filing",
      "GST",
      "GST Audit",
      "Input Tax Credit"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "Julius AI",
      "Datarails"
    ],
    "domainSkills": [
      "GST and Indirect Tax Law",
      "Tax Filing and Compliance Procedures",
      "Direct Taxation Principles",
      "Financial Accounting Principles",
      "Internal Controls Framework"
    ]
  },
  {
    "roleId": "JF09-013",
    "roleName": "Financial Reporting Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Financial Reporting",
      "IFRS",
      "GAAP",
      "Consolidation Reporting",
      "Disclosure Requirements"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "BlackLine",
      "Datarails"
    ],
    "domainSkills": [
      "Financial Reporting Standards",
      "Financial Accounting Principles",
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Auditing Principles"
    ]
  },
  {
    "roleId": "JF09-014",
    "roleName": "FP&A Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Financial Planning and Analysis",
      "Budgeting",
      "Forecasting",
      "Microsoft Excel",
      "Business Partnering"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "BlackLine",
      "Datarails"
    ],
    "domainSkills": [
      "Financial Planning and Analysis (FP&A)",
      "Zero-Based Budgeting",
      "Financial Modelling",
      "Budget Preparation and Control",
      "Cost-Benefit Analysis"
    ]
  },
  {
    "roleId": "JF09-015",
    "roleName": "Management Accountant",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Management Accounting",
      "Variance Analysis",
      "Management Reporting",
      "Decision Support Analysis",
      "CIMA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Standard Costing and Cost Variance",
      "Activity-Based Costing",
      "Cost Accounting Principles",
      "Financial Planning and Analysis (FP&A)",
      "Internal Controls Framework"
    ]
  },
  {
    "roleId": "JF09-016",
    "roleName": "Internal Auditor",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Internal Audit",
      "Audit Planning",
      "Control Testing",
      "CIA",
      "Audit Report Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "Datarails",
      "BlackLine"
    ],
    "domainSkills": [
      "Internal Audit Methodology",
      "Internal Controls Framework",
      "Risk Assessment Methodology",
      "Financial Accounting Principles",
      "Compliance Frameworks"
    ]
  },
  {
    "roleId": "JF09-017",
    "roleName": "Cost Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Cost Analysis",
      "Cost Accounting",
      "Cost Benefit Analysis",
      "Product Costing",
      "Overhead Allocation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "BlackLine",
      "Datarails"
    ],
    "domainSkills": [
      "Cost Accounting Principles",
      "Cost-Benefit Analysis",
      "Standard Costing and Cost Variance",
      "Activity-Based Costing",
      "Financial Modelling"
    ]
  },
  {
    "roleId": "JF09-018",
    "roleName": "Budget Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Budget Preparation",
      "Budgeting",
      "Budget Monitoring",
      "Microsoft Excel",
      "Expenditure Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "BlackLine",
      "Datarails"
    ],
    "domainSkills": [
      "Budget Preparation and Control",
      "Zero-Based Budgeting",
      "Governance, Risk, and Compliance (GRC)",
      "Financial Planning and Analysis (FP&A)",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF09-019",
    "roleName": "Accounts Executive",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Day-to-Day Accounting",
      "Tally",
      "Ledger Maintenance",
      "Journal Entries",
      "Bank Reconciliation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Double-Entry Bookkeeping",
      "Financial Accounting Principles",
      "Accounts Closure and Period-End Processes",
      "Statutory Compliance (PF, ESI, TDS)",
      "Accounts Reconciliation Concepts"
    ]
  },
  {
    "roleId": "JF09-020",
    "roleName": "Tax Associate",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Tax Return Preparation",
      "Income Tax",
      "Tax Compliance",
      "Tax Research",
      "E-filing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "Datarails",
      "BlackLine"
    ],
    "domainSkills": [
      "Direct Taxation Principles",
      "Tax Filing and Compliance Procedures",
      "GST and Indirect Tax Law",
      "Tax Audit Concepts",
      "Financial Accounting Principles"
    ]
  },
  {
    "roleId": "JF09-021",
    "roleName": "Accounts Reconciliation Analyst",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Account Reconciliation",
      "Bank Reconciliation",
      "Intercompany Reconciliation",
      "SQL",
      "Reconciliation Reporting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Datarails",
      "Power BI Copilot",
      "BlackLine"
    ],
    "domainSkills": [
      "Accounts Reconciliation Concepts",
      "Auditing Principles",
      "Double-Entry Bookkeeping",
      "Accounts Closure and Period-End Processes",
      "Financial Accounting Principles"
    ]
  },
  {
    "roleId": "JF09-022",
    "roleName": "Payroll Executive",
    "jobFamily": "Finance & Accounting",
    "technicalSkills": [
      "Payroll Processing",
      "Payroll Compliance",
      "Employee Benefits Administration",
      "Statutory Compliance",
      "Tally"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Julius AI",
      "Power BI Copilot",
      "Datarails"
    ],
    "domainSkills": [
      "Payroll Compliance and Processing",
      "Statutory Compliance (PF, ESI, TDS)",
      "Double-Entry Bookkeeping",
      "Accounts Closure and Period-End Processes",
      "Accounts Reconciliation Concepts"
    ]
  },
  {
    "roleId": "JF10-001",
    "roleName": "Bank Clerk",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Banking Operations",
      "Cash Handling",
      "KYC",
      "Core Banking System",
      "Teller Operations"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot",
      "Microsoft Copilot for Finance",
      "Datarails"
    ],
    "domainSkills": [
      "Banking Operations Fundamentals",
      "Banking Products and Services",
      "Customer Due Diligence (KYC/AML)",
      "Double-Entry Bookkeeping",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF10-002",
    "roleName": "Bank Probationary Officer (PO)",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Banking and Finance",
      "Credit Appraisal",
      "Loan Processing",
      "Regulatory Compliance",
      "Customer Relationship Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot",
      "Microsoft Copilot for Finance",
      "Datarails"
    ],
    "domainSkills": [
      "Retail Banking Concepts",
      "Credit Appraisal and Lending Principles",
      "Banking Regulations and Compliance",
      "Customer Due Diligence (KYC/AML)",
      "Banking Products and Services"
    ]
  },
  {
    "roleId": "JF10-003",
    "roleName": "Branch Manager",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Branch Management",
      "Team Management",
      "Business Development",
      "Regulatory Compliance",
      "P&L Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot",
      "Datarails",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Branch Management Principles",
      "Business Development and Sales in Banking",
      "Credit Appraisal and Lending Principles",
      "Banking Regulations and Compliance",
      "Banking Products and Services"
    ]
  },
  {
    "roleId": "JF10-004",
    "roleName": "Relationship Manager",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Relationship Management",
      "Customer Relationship Management",
      "Cross-selling",
      "Customer Acquisition",
      "Portfolio Growth"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot",
      "Datarails",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Relationship Banking Principles",
      "Business Development and Sales in Banking",
      "Retail Banking Concepts",
      "Credit Appraisal and Lending Principles",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF10-005",
    "roleName": "Loan Officer",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Loan Origination",
      "Credit Assessment",
      "Credit Appraisal",
      "Loan Documentation",
      "Debt Service Coverage Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Julius AI",
      "Power BI Copilot",
      "Datarails"
    ],
    "domainSkills": [
      "Credit Appraisal and Lending Principles",
      "Banking Products and Services",
      "Banking Regulations and Compliance",
      "Customer Due Diligence (KYC/AML)",
      "Credit Control Principles"
    ]
  },
  {
    "roleId": "JF10-006",
    "roleName": "Credit Analyst",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Credit Analysis",
      "Financial Statement Analysis",
      "Credit Rating",
      "Lending Risk Assessment",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "BlackLine",
      "Datarails",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Credit Appraisal and Lending Principles",
      "Double-Entry Bookkeeping",
      "Financial Modelling",
      "Banking Products and Services",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF10-007",
    "roleName": "KYC Analyst",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "KYC Compliance",
      "AML",
      "Customer Due Diligence",
      "Sanctions Screening",
      "FATF Guidelines"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "BlackLine",
      "Power BI Copilot",
      "Microsoft Copilot for Finance",
      "Datarails"
    ],
    "domainSkills": [
      "KYC and AML Compliance Framework",
      "Customer Due Diligence (KYC/AML)",
      "Enhanced Due Diligence (EDD)",
      "Sanctions Screening Concepts",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF10-008",
    "roleName": "Trade Finance Officer",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Trade Finance",
      "Letter of Credit",
      "Bank Guarantee",
      "Export/Import Documentation",
      "SWIFT Messaging"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Julius AI",
      "Power BI Copilot",
      "Datarails"
    ],
    "domainSkills": [
      "Trade Finance Concepts",
      "Letter of Credit and Documentary Collections",
      "Banking Regulations and Compliance",
      "Foreign Exchange Risk Management",
      "Customer Due Diligence (KYC/AML)"
    ]
  },
  {
    "roleId": "JF10-009",
    "roleName": "Cash Management Executive",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "Cash Management",
      "Cash Flow Management",
      "Liquidity Forecasting",
      "Payment Systems",
      "Working Capital Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Julius AI",
      "Power BI Copilot",
      "Datarails"
    ],
    "domainSkills": [
      "Cash Management and Liquidity Solutions",
      "Customer Due Diligence (KYC/AML)",
      "Banking Products and Services",
      "Banking Regulations and Compliance",
      "Business Development and Sales in Banking"
    ]
  },
  {
    "roleId": "JF10-010",
    "roleName": "NRI Relationship Manager",
    "jobFamily": "Banking Operations",
    "technicalSkills": [
      "NRI Banking",
      "Relationship Management",
      "Foreign Exchange Services",
      "NRI Investment Products",
      "FEMA Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot",
      "Datarails",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "NRI Banking and FEMA Regulations",
      "Relationship Banking Principles",
      "Cross-Border Wealth Management",
      "Wealth Management Principles",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF11-001",
    "roleName": "Equity Research Analyst",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Equity Research",
      "Fundamental Analysis",
      "Financial Modeling",
      "Industry Analysis",
      "Investment Recommendation"
    ],
    "aiToolSkills": [
      "Bloomberg Terminal AI",
      "ChatGPT",
      "AlphaSense",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Equity Research Methodology",
      "Equity Valuation",
      "Financial Modelling",
      "Industry and Sector Analysis",
      "Capital Markets Knowledge"
    ]
  },
  {
    "roleId": "JF11-002",
    "roleName": "Stock Broker",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Stock Broking",
      "Technical Analysis",
      "Order Execution",
      "Trading Terminal",
      "SEBI Regulations"
    ],
    "aiToolSkills": [
      "Bloomberg Terminal AI",
      "ChatGPT",
      "AlphaSense",
      "Google NotebookLM",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Stock Broking and Trading Concepts",
      "Capital Markets Knowledge",
      "Order Types and Market Microstructure",
      "Customer Due Diligence (KYC/AML)",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF11-003",
    "roleName": "Derivatives Trader",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Derivatives Trading",
      "Options Pricing",
      "Futures and Options",
      "Hedging Strategies",
      "Risk Management in Trading"
    ],
    "aiToolSkills": [
      "Bloomberg Terminal AI",
      "Claude",
      "ChatGPT",
      "Google NotebookLM",
      "AlphaSense"
    ],
    "domainSkills": [
      "Derivatives Concepts",
      "Options Pricing Theory",
      "Trading Strategy and Risk Management",
      "Capital Markets Knowledge",
      "Quantitative Methods"
    ]
  },
  {
    "roleId": "JF11-004",
    "roleName": "Investment Banker",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Investment Banking",
      "Mergers and Acquisitions",
      "Deal Structuring",
      "Pitch Book Preparation",
      "Capital Markets"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Bloomberg Terminal AI",
      "AlphaSense",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Investment Banking Concepts",
      "Capital Raising and IPO Process",
      "Financial Modelling",
      "Corporate Finance Principles",
      "Mergers and Acquisitions Methodology"
    ]
  },
  {
    "roleId": "JF11-005",
    "roleName": "Wealth Manager",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Wealth Management",
      "Financial Planning",
      "Asset Management",
      "HNI Client Management",
      "CFA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Bloomberg Terminal AI",
      "AlphaSense",
      "Google NotebookLM",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Wealth Management Principles",
      "Financial Planning for Clients",
      "Portfolio Theory",
      "Capital Markets Knowledge",
      "Risk-Adjusted Performance Measurement"
    ]
  },
  {
    "roleId": "JF11-006",
    "roleName": "Fund Manager",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Fund Management",
      "Portfolio Construction",
      "Asset Allocation",
      "Mutual Funds",
      "Performance Attribution"
    ],
    "aiToolSkills": [
      "Bloomberg Terminal AI",
      "AlphaSense",
      "ChatGPT",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Fund Management Principles",
      "Active vs Passive Investment Strategies",
      "Portfolio Theory",
      "Capital Markets Knowledge",
      "Risk-Adjusted Performance Measurement"
    ]
  },
  {
    "roleId": "JF11-007",
    "roleName": "Mergers & Acquisitions Analyst",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "M&A Analysis",
      "Due Diligence",
      "Transaction Advisory",
      "Financial Modeling",
      "Accretion/Dilution Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Bloomberg Terminal AI",
      "AlphaSense",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Mergers and Acquisitions Methodology",
      "Deal Structuring and Valuation",
      "Financial Modelling",
      "Equity Valuation",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF11-008",
    "roleName": "Private Equity Analyst",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Private Equity",
      "LBO Modeling",
      "Due Diligence",
      "Portfolio Company Monitoring",
      "Deal Sourcing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Bloomberg Terminal AI",
      "AlphaSense",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Private Equity Concepts",
      "LBO Modelling Concepts",
      "Capital Markets Knowledge",
      "Financial Modelling",
      "Deal Structuring and Valuation"
    ]
  },
  {
    "roleId": "JF11-009",
    "roleName": "Venture Capital Analyst",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Venture Capital",
      "Startup Evaluation",
      "Term Sheet Analysis",
      "Market Sizing",
      "Due Diligence"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AlphaSense",
      "Bloomberg Terminal AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Venture Capital Investment Principles",
      "Startup Valuation Concepts",
      "Industry and Sector Analysis",
      "Capital Markets Knowledge",
      "Deal Structuring and Valuation"
    ]
  },
  {
    "roleId": "JF11-010",
    "roleName": "Fixed Income Analyst",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Fixed Income Analysis",
      "Bond Valuation",
      "Interest Rate Analysis",
      "Credit Spread Analysis",
      "Duration and Convexity"
    ],
    "aiToolSkills": [
      "Bloomberg Terminal AI",
      "ChatGPT",
      "AlphaSense",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Fixed Income Concepts",
      "Bond Valuation and Duration",
      "Financial Modelling",
      "Quantitative Methods",
      "Capital Markets Knowledge"
    ]
  },
  {
    "roleId": "JF11-011",
    "roleName": "Portfolio Analyst",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Portfolio Performance Analysis",
      "Portfolio Analysis",
      "Benchmark Analysis",
      "Risk-Return Analysis",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Bloomberg Terminal AI",
      "Power BI Copilot",
      "AlphaSense",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Portfolio Analytics",
      "Capital Markets Knowledge",
      "Portfolio Theory",
      "Risk-Adjusted Performance Measurement",
      "Quantitative Methods"
    ]
  },
  {
    "roleId": "JF11-012",
    "roleName": "Research Associate - Equity",
    "jobFamily": "Capital Markets & Investments",
    "technicalSkills": [
      "Equity Analysis",
      "Fundamental Analysis",
      "Company Profiling",
      "Financial Modeling",
      "Sector Research"
    ],
    "aiToolSkills": [
      "Bloomberg Terminal AI",
      "ChatGPT",
      "AlphaSense",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Equity Research Methodology",
      "Capital Markets Knowledge",
      "Financial Modelling",
      "Industry and Sector Analysis",
      "Equity Valuation"
    ]
  },
  {
    "roleId": "JF12-001",
    "roleName": "Insurance Agent",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Insurance Sales",
      "Life Insurance",
      "General Insurance",
      "Policy Servicing",
      "IRDA Regulations"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot",
      "AlphaSense",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Insurance Principles and Concepts",
      "Life Insurance Products",
      "Insurance Sales and Advisory Methodology",
      "Insurance Regulatory Framework (IRDAI)",
      "Underwriting Principles"
    ]
  },
  {
    "roleId": "JF12-002",
    "roleName": "Underwriter",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Underwriting",
      "Risk Underwriting",
      "Policy Pricing",
      "Underwriting Guidelines",
      "Reinsurance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Power BI Copilot",
      "Google NotebookLM",
      "AlphaSense"
    ],
    "domainSkills": [
      "Underwriting Principles",
      "Risk Selection and Rating",
      "Insurance Principles and Concepts",
      "Risk Management Framework",
      "Insurance Regulatory Framework (IRDAI)"
    ]
  },
  {
    "roleId": "JF12-003",
    "roleName": "Actuary",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Actuarial Science",
      "Actuarial Modeling",
      "R Programming",
      "Mortality and Morbidity Analysis",
      "Reserve Estimation (Insurance)"
    ],
    "aiToolSkills": [
      "Python for AI",
      "Claude",
      "Google NotebookLM",
      "AlphaSense",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Actuarial Science Fundamentals",
      "Actuarial Modelling and Reserving",
      "Probability and Life Table Analysis",
      "Risk Modeling",
      "Financial Mathematics"
    ]
  },
  {
    "roleId": "JF12-004",
    "roleName": "Claims Adjuster",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Claims Processing",
      "Claims Investigation",
      "Loss Assessment",
      "Claims Settlement",
      "Policy Interpretation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot",
      "Microsoft Copilot for Finance",
      "AlphaSense"
    ],
    "domainSkills": [
      "Claims Management Principles",
      "Claims Investigation and Settlement",
      "Insurance Principles and Concepts",
      "Underwriting Principles",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF12-005",
    "roleName": "Insurance Sales Manager",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Insurance Sales Management",
      "Sales Team Management",
      "Agency Development",
      "Channel Management",
      "Agency Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot",
      "AlphaSense",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Insurance Principles and Concepts",
      "Insurance Sales and Advisory Methodology",
      "Life Insurance Products",
      "Insurance Regulatory Framework (IRDAI)",
      "Quantitative Methods"
    ]
  },
  {
    "roleId": "JF12-006",
    "roleName": "Reinsurance Analyst",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Reinsurance Analysis",
      "Treaty Reinsurance",
      "Facultative Reinsurance",
      "Catastrophe Modeling",
      "Retrocession"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Bloomberg Terminal AI",
      "Power BI Copilot",
      "AlphaSense",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Reinsurance Concepts",
      "Treaty and Facultative Reinsurance",
      "Underwriting Principles",
      "Risk Management Framework",
      "Insurance Principles and Concepts"
    ]
  },
  {
    "roleId": "JF12-007",
    "roleName": "Claims Surveyor",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Claims Survey",
      "Site Inspection",
      "Damage Assessment",
      "Loss Assessment",
      "Survey Report Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot",
      "AlphaSense",
      "Microsoft Copilot for Finance"
    ],
    "domainSkills": [
      "Loss Assessment and Surveying",
      "Engineering and Property Risk Survey",
      "Claims Management Principles",
      "Insurance Principles and Concepts",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF12-008",
    "roleName": "Risk Analyst",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Risk Analysis",
      "Quantitative Risk Modeling",
      "Risk Assessment",
      "Risk Reporting",
      "Enterprise Risk Management"
    ],
    "aiToolSkills": [
      "Claude",
      "Google NotebookLM",
      "AlphaSense",
      "Microsoft Copilot for Finance",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Risk Management Framework",
      "Risk Assessment Methodology",
      "Cybersecurity Fundamentals",
      "Compliance Frameworks",
      "Governance, Risk, and Compliance (GRC)"
    ]
  },
  {
    "roleId": "JF12-009",
    "roleName": "Compliance Officer",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Compliance Management",
      "Governance Risk and Compliance",
      "Regulatory Reporting",
      "Policy and Procedure Development",
      "Compliance Monitoring"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Regulatory AI",
      "Power BI Copilot",
      "Google NotebookLM",
      "AlphaSense"
    ],
    "domainSkills": [
      "Regulatory Compliance Management",
      "Regulatory Reporting Concepts",
      "Compliance Frameworks",
      "Governance, Risk, and Compliance (GRC)",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF12-010",
    "roleName": "AML Analyst",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "AML Analysis",
      "Sanctions Screening",
      "Transaction Monitoring",
      "Suspicious Activity Reporting",
      "Financial Crime Investigation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Regulatory AI",
      "Google NotebookLM",
      "Power BI Copilot",
      "AlphaSense"
    ],
    "domainSkills": [
      "AML Investigation Methodology",
      "KYC and AML Compliance Framework",
      "Suspicious Transaction Reporting",
      "Customer Due Diligence (KYC/AML)",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF12-011",
    "roleName": "Credit Risk Manager",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Credit Risk Management",
      "Credit Portfolio Management",
      "Basel III",
      "IFRS 9",
      "Stress Testing"
    ],
    "aiToolSkills": [
      "Claude",
      "Google NotebookLM",
      "AlphaSense",
      "Microsoft Copilot for Finance",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Credit Risk Concepts",
      "Credit Risk Measurement and Modelling",
      "Credit Appraisal and Lending Principles",
      "Risk Assessment Methodology",
      "Risk Management Framework"
    ]
  },
  {
    "roleId": "JF12-012",
    "roleName": "Operational Risk Analyst",
    "jobFamily": "Insurance & Risk",
    "technicalSkills": [
      "Operational Risk",
      "RCSA",
      "Key Risk Indicators",
      "Enterprise Risk Management",
      "Loss Event Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Google NotebookLM",
      "Regulatory AI",
      "AlphaSense"
    ],
    "domainSkills": [
      "Operational Risk Framework",
      "Operational Risk Assessment",
      "Risk Management Framework",
      "Risk Assessment Methodology",
      "Governance, Risk, and Compliance (GRC)"
    ]
  },
  {
    "roleId": "JF13-001",
    "roleName": "Fintech Product Manager",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Fintech Product Management",
      "Payment Products",
      "Product Management",
      "API Integration",
      "Regulatory Technology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Replit Agent",
      "GitHub Copilot",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "Fintech Business Models",
      "Product Management Fundamentals",
      "Banking Regulations and Compliance",
      "Payment Systems Architecture",
      "Governance, Risk, and Compliance (GRC)"
    ]
  },
  {
    "roleId": "JF13-002",
    "roleName": "Payment Solutions Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Payment Systems Analysis",
      "Digital Payments",
      "Payment Gateway",
      "PCI DSS",
      "Payment Reconciliation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "Payment Systems Architecture",
      "Payment Regulations and Compliance",
      "UPI and Instant Payment Systems",
      "Customer Due Diligence (KYC/AML)",
      "Fintech Business Models"
    ]
  },
  {
    "roleId": "JF13-003",
    "roleName": "Lending Technology Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Lending Technology",
      "Credit Decisioning Systems",
      "Credit Analysis",
      "Loan Management System",
      "Alternative Credit Scoring"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "Digital Lending Concepts",
      "Credit Underwriting in Fintech",
      "Credit Appraisal and Lending Principles",
      "Banking Regulations and Compliance",
      "Fintech Business Models"
    ]
  },
  {
    "roleId": "JF13-004",
    "roleName": "Digital Banking Specialist",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Digital Banking",
      "Mobile Banking",
      "Internet Banking",
      "KYC",
      "Customer Onboarding Technology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Replit Agent",
      "GitHub Copilot",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "Digital Banking Concepts",
      "Customer Onboarding in Digital Channels",
      "Retail Banking Concepts",
      "Banking Regulations and Compliance",
      "Payment Systems Architecture"
    ]
  },
  {
    "roleId": "JF13-005",
    "roleName": "Blockchain Finance Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Blockchain in Finance",
      "Solidity",
      "DeFi",
      "Cryptocurrency",
      "Tokenization"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Claude Code",
      "OpenAI API",
      "Cursor AI"
    ],
    "domainSkills": [
      "Blockchain in Finance Concepts",
      "Decentralised Finance (DeFi) Concepts",
      "Blockchain Technology Fundamentals",
      "Banking Regulations and Compliance",
      "Fintech Business Models"
    ]
  },
  {
    "roleId": "JF13-006",
    "roleName": "UPI Payments Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "UPI",
      "NPCI Guidelines",
      "Digital Payments",
      "Real-Time Payments",
      "Payment Fraud Prevention"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "UPI and Instant Payment Systems",
      "Payment Network Architecture",
      "Payment Regulations and Compliance",
      "Fintech Business Models",
      "Customer Due Diligence (KYC/AML)"
    ]
  },
  {
    "roleId": "JF13-007",
    "roleName": "RegTech Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "RegTech",
      "Regulatory Automation",
      "Regulatory Technology",
      "Compliance Technology",
      "Financial Regulation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Regulatory AI",
      "GitHub Copilot",
      "Replit Agent",
      "Claude Code"
    ],
    "domainSkills": [
      "RegTech Concepts",
      "Regulatory Automation Principles",
      "Customer Due Diligence (KYC/AML)",
      "Regulatory Reporting Concepts",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF13-008",
    "roleName": "Open Banking Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Open Banking",
      "API Banking",
      "REST API",
      "Account Aggregation",
      "Data Sharing Frameworks"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "OpenAI API",
      "Cursor AI",
      "Claude Code"
    ],
    "domainSkills": [
      "Open Banking Principles",
      "API Economy and Open Finance",
      "Banking Regulations and Compliance",
      "Retail Banking Concepts",
      "Fintech Business Models"
    ]
  },
  {
    "roleId": "JF13-009",
    "roleName": "InsurTech Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "InsurTech",
      "Digital Insurance Products",
      "Underwriting",
      "Telematics",
      "Insurance Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "InsurTech Concepts",
      "Digital Insurance Distribution",
      "Insurance Principles and Concepts",
      "Insurance Regulatory Framework (IRDAI)",
      "Fintech Business Models"
    ]
  },
  {
    "roleId": "JF13-010",
    "roleName": "WealthTech Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "WealthTech",
      "Robo-Advisory",
      "Wealth Management",
      "Digital Wealth Management",
      "Portfolio Technology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "WealthTech Concepts",
      "Robo-Advisory Principles",
      "Wealth Management Principles",
      "Fintech Business Models",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF13-011",
    "roleName": "Digital Assets Compliance Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Digital Assets Compliance",
      "Crypto Regulation",
      "AML",
      "Digital Asset AML",
      "Travel Rule Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Regulatory AI",
      "GitHub Copilot",
      "Replit Agent",
      "Claude Code"
    ],
    "domainSkills": [
      "Digital Assets Regulatory Framework",
      "Virtual Asset Service Provider (VASP) Compliance",
      "Digital Assets and Cryptocurrency Concepts",
      "AML Investigation Methodology",
      "KYC and AML Compliance Framework"
    ]
  },
  {
    "roleId": "JF13-012",
    "roleName": "Digital Lending Analyst",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Digital Lending",
      "Lending Technology",
      "Credit Underwriting Technology",
      "BNPL",
      "Embedded Finance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "OpenAI API",
      "Claude Code"
    ],
    "domainSkills": [
      "Digital Lending Concepts",
      "Lending Operations and Servicing",
      "Loan Portfolio Monitoring",
      "Credit Underwriting in Fintech",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF13-013",
    "roleName": "Payments Operations Executive",
    "jobFamily": "Fintech & Digital Finance",
    "technicalSkills": [
      "Payments Operations",
      "Digital Payments",
      "Settlement Operations",
      "Dispute Management",
      "Chargeback Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "GitHub Copilot",
      "Cursor AI",
      "Claude Code",
      "OpenAI API"
    ],
    "domainSkills": [
      "Payment Operations Concepts",
      "Reconciliation in Payment Systems",
      "Payment Systems Architecture",
      "Payment Regulations and Compliance",
      "Banking Regulations and Compliance"
    ]
  },
  {
    "roleId": "JF14-001",
    "roleName": "Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Sales",
      "Prospecting",
      "Sales Pitch",
      "Cold Calling",
      "CRM Software"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Sales Fundamentals",
      "Sales Process and Methodology",
      "Customer Relationship Management Concepts",
      "Negotiation Principles",
      "Market and Competitive Intelligence"
    ]
  },
  {
    "roleId": "JF14-002",
    "roleName": "Business Development Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Business Development",
      "Lead Generation",
      "Market Research",
      "Prospecting",
      "Partnership Development"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Business Development Principles",
      "Sales Process and Methodology",
      "Market and Competitive Intelligence",
      "Negotiation Principles",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF14-003",
    "roleName": "Key Account Manager",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Key Account Management",
      "Account Planning",
      "Upselling",
      "Client Retention",
      "CRM Software"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "HubSpot AI",
      "Gamma",
      "Gong"
    ],
    "domainSkills": [
      "Account Management Principles",
      "Customer Relationship Management Strategy",
      "Customer Relationship Management Concepts",
      "Negotiation Principles",
      "Customer Success Principles"
    ]
  },
  {
    "roleId": "JF14-004",
    "roleName": "Sales Manager",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Sales Management",
      "Sales Forecasting",
      "Sales Team Leadership",
      "Revenue Target Management",
      "CRM Software"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Sales Management and Leadership",
      "Sales Planning and Forecasting",
      "Sales Process and Methodology",
      "Market and Competitive Intelligence",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF14-005",
    "roleName": "Zonal Sales Manager",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Zonal Sales Management",
      "Territory Planning",
      "Sales Team Leadership",
      "Distributor Management",
      "Market Expansion"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Sales Management and Leadership",
      "Sales Planning and Forecasting",
      "Market Intelligence Principles",
      "Market and Competitive Intelligence",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF14-006",
    "roleName": "Inside Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Inside Sales",
      "Inbound Sales",
      "Sales Qualification",
      "Pipeline Management",
      "CRM Software"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Gamma",
      "Salesforce Einstein",
      "Gong"
    ],
    "domainSkills": [
      "Inside Sales Methodology",
      "Sales Process and Methodology",
      "Sales Development Methodology",
      "Customer Relationship Management Concepts",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF14-007",
    "roleName": "Channel Sales Manager",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Channel Sales Management",
      "Partner Relationship Management",
      "Reseller Management",
      "Channel Strategy",
      "CRM Software"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Market Intelligence Principles",
      "Sales Management and Leadership",
      "Sales Planning and Forecasting",
      "Market and Competitive Intelligence",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF14-008",
    "roleName": "Pre-Sales Consultant",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Pre-Sales",
      "Solution Demonstration",
      "RFP/RFI Response",
      "Proof of Concept",
      "Technical Sales Support"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Gamma",
      "HubSpot AI",
      "Gong",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Pre-Sales Methodology",
      "Market Intelligence Principles",
      "Competitive Intelligence Analysis",
      "Market and Competitive Intelligence",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF14-009",
    "roleName": "Territory Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Territory Sales Management",
      "Field Sales",
      "Route-to-Market Planning",
      "Distributor Management",
      "Prospecting"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Territory Management",
      "Sales Process and Methodology",
      "Sales Fundamentals",
      "Customer Relationship Management Concepts",
      "Market and Competitive Intelligence"
    ]
  },
  {
    "roleId": "JF14-010",
    "roleName": "B2B Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "B2B Sales",
      "Solution Selling",
      "Account-Based Selling",
      "Contract Negotiation",
      "Procurement Navigation"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "HubSpot AI",
      "Gamma",
      "Gong"
    ],
    "domainSkills": [
      "B2B Sales Principles",
      "Customer Relationship Management Strategy",
      "Sales Process and Methodology",
      "Negotiation Principles",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF14-011",
    "roleName": "B2C Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "B2C Sales",
      "Retail Sales",
      "Sales Pitch",
      "Consumer Behaviour",
      "Promotional Sales"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Gamma",
      "Gong",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "B2C Sales Principles",
      "Sales Fundamentals",
      "Negotiation Principles",
      "Sales Process and Methodology",
      "Market and Competitive Intelligence"
    ]
  },
  {
    "roleId": "JF14-012",
    "roleName": "Account Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Account Management",
      "Client Retention",
      "Contract Negotiation",
      "Renewal Management",
      "CRM Software"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Gamma",
      "Gong",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Sales Process and Methodology",
      "Account Management Principles",
      "Customer Success Methodology",
      "Negotiation Principles",
      "Customer Success Principles"
    ]
  },
  {
    "roleId": "JF14-013",
    "roleName": "Sales Development Representative",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Sales Development",
      "Outbound Prospecting",
      "Sales Cadence",
      "Lead Qualification",
      "CRM Software"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Gamma",
      "Salesforce Einstein",
      "Gong"
    ],
    "domainSkills": [
      "Sales Development Methodology",
      "Sales Fundamentals",
      "Customer Relationship Management Concepts",
      "Market and Competitive Intelligence",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF14-014",
    "roleName": "Corporate Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Corporate Sales",
      "B2B Sales",
      "Executive Stakeholder Engagement",
      "Large Deal Management",
      "Contract Negotiation"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "HubSpot AI",
      "Gamma",
      "Gong"
    ],
    "domainSkills": [
      "Corporate Sales Principles",
      "B2B Sales Principles",
      "Sales Fundamentals",
      "Negotiation Principles",
      "Account Management Principles"
    ]
  },
  {
    "roleId": "JF14-015",
    "roleName": "Enterprise Account Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Enterprise Sales",
      "Multi-Stakeholder Selling",
      "Enterprise Account Planning",
      "Strategic Account Management",
      "Solution Selling"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "HubSpot AI",
      "Gamma",
      "Gong"
    ],
    "domainSkills": [
      "Enterprise Sales Methodology",
      "Sales Fundamentals",
      "Account Management Principles",
      "Negotiation Principles",
      "B2B Sales Principles"
    ]
  },
  {
    "roleId": "JF14-016",
    "roleName": "Solution Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Solution Sales",
      "Consultative Selling",
      "Value Proposition Development",
      "Needs Assessment",
      "Pre-Sales"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "HubSpot AI",
      "Gamma",
      "Gong"
    ],
    "domainSkills": [
      "Market Intelligence Principles",
      "Pre-Sales Methodology",
      "Competitive Intelligence Analysis",
      "Market and Competitive Intelligence",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF14-017",
    "roleName": "Retail Sales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Retail Sales",
      "Product Knowledge",
      "Visual Merchandising",
      "Stock Management",
      "Point of Sale Systems"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Gamma",
      "Gong",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Retail Sales Principles",
      "Visual Merchandising Concepts",
      "Sales Fundamentals",
      "Sales Process and Methodology",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF14-018",
    "roleName": "Telesales Executive",
    "jobFamily": "Sales & Business Development",
    "technicalSkills": [
      "Telesales",
      "Cold Calling",
      "Objection Handling",
      "Call Script Development",
      "Dialer Software"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Gamma",
      "Salesforce Einstein",
      "Gong"
    ],
    "domainSkills": [
      "Telesales Methodology",
      "Call Script and Pitch Design",
      "Sales Fundamentals",
      "Customer Relationship Management Concepts",
      "Customer Relationship Management Strategy"
    ]
  },
  {
    "roleId": "JF15-001",
    "roleName": "Marketing Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Marketing",
      "Campaign Management",
      "Event Marketing",
      "Marketing Communications",
      "Marketing Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "HeyGen",
      "Google Analytics 4 AI",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Marketing Fundamentals",
      "Marketing Mix (4Ps / 7Ps)",
      "Marketing Funnel Concepts",
      "Digital Marketing Principles",
      "Digital Transformation Strategy"
    ]
  },
  {
    "roleId": "JF15-002",
    "roleName": "Digital Marketing Manager",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Digital Marketing",
      "Paid Media",
      "SEO",
      "Social Media Marketing",
      "Marketing Automation"
    ],
    "aiToolSkills": [
      "Google Analytics 4 AI",
      "HubSpot AI",
      "ChatGPT",
      "HeyGen",
      "Surfer SEO"
    ],
    "domainSkills": [
      "Digital Marketing Principles",
      "Marketing Funnel Concepts",
      "Market and Competitive Intelligence",
      "Performance Marketing Concepts",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF15-003",
    "roleName": "SEO Specialist",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Search Engine Optimization",
      "On-Page SEO",
      "Technical SEO",
      "Link Building",
      "Google Search Console"
    ],
    "aiToolSkills": [
      "Surfer SEO",
      "ChatGPT",
      "HeyGen",
      "Google Analytics 4 AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "Search Engine Optimisation (SEO) Principles",
      "Search Engine Marketing (SEM) Concepts",
      "Content Marketing Principles",
      "Editorial Planning and Content Calendar",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF15-004",
    "roleName": "Performance Marketing Analyst",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Performance Marketing",
      "Google Ads",
      "Meta Ads",
      "ROAS Optimization",
      "Attribution Modeling"
    ],
    "aiToolSkills": [
      "Google Analytics 4 AI",
      "ChatGPT",
      "HeyGen",
      "Power BI Copilot",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Performance Marketing Concepts",
      "Marketing Attribution Models",
      "Marketing Fundamentals",
      "A/B Testing Methodology",
      "Marketing Funnel Concepts"
    ]
  },
  {
    "roleId": "JF15-005",
    "roleName": "Product Marketing Manager",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Product Marketing",
      "Go-to-Market Strategy",
      "Positioning and Messaging",
      "Competitive Intelligence",
      "Sales Enablement"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Canva Magic Studio",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Product Marketing Principles",
      "Market Intelligence Principles",
      "Product Strategy",
      "Competitive Intelligence Analysis",
      "Market and Competitive Intelligence"
    ]
  },
  {
    "roleId": "JF15-006",
    "roleName": "Growth Analyst",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Growth Analysis",
      "A/B Testing",
      "SQL",
      "Acquisition Analytics",
      "Engagement Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google Analytics 4 AI",
      "Canva Magic Studio",
      "HeyGen",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Growth Marketing Methodology",
      "A/B Testing Methodology",
      "Data-Driven Decision Making",
      "Conversion Rate Optimisation (CRO) Concepts",
      "Marketing Funnel Concepts"
    ]
  },
  {
    "roleId": "JF15-007",
    "roleName": "Email Marketing Specialist",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Email Marketing",
      "Email Automation",
      "List Segmentation",
      "Email Deliverability",
      "Mailchimp"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "Jasper AI",
      "Claude",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Email Marketing Principles",
      "Email Deliverability Concepts",
      "Lifecycle Marketing",
      "Customer Segmentation and Targeting",
      "A/B Testing Methodology"
    ]
  },
  {
    "roleId": "JF15-008",
    "roleName": "Marketing Analyst",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Marketing Analysis",
      "Marketing Analytics",
      "Campaign Analytics",
      "SQL",
      "Marketing Mix Modeling"
    ],
    "aiToolSkills": [
      "Google Analytics 4 AI",
      "ChatGPT",
      "Canva Magic Studio",
      "HeyGen",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Customer Segmentation and Targeting",
      "A/B Testing Methodology",
      "Marketing Attribution Models",
      "Brand Management Principles",
      "Marketing Funnel Concepts"
    ]
  },
  {
    "roleId": "JF15-009",
    "roleName": "Social Media Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Social Media Management",
      "Content Creation",
      "Social Media Marketing",
      "Community Engagement",
      "Social Media Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "HeyGen",
      "Google Analytics 4 AI",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Social Media Marketing Principles",
      "Social Media Content Strategy",
      "Brand Identity and Positioning",
      "Brand Management Principles",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF15-010",
    "roleName": "Content Marketing Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Content Marketing",
      "Content Writing",
      "SEO Content",
      "SEO",
      "Editorial Calendar Management"
    ],
    "aiToolSkills": [
      "Jasper AI",
      "ChatGPT",
      "HeyGen",
      "Google Analytics 4 AI",
      "Surfer SEO"
    ],
    "domainSkills": [
      "Content Marketing Principles",
      "Editorial Planning and Content Calendar",
      "Market and Competitive Intelligence",
      "Search Engine Optimisation (SEO) Principles",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF15-011",
    "roleName": "Brand Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Brand Management",
      "Brand Identity",
      "Brand Guidelines",
      "Positioning and Messaging",
      "Brand Activation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Canva Magic Studio",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Brand Management Principles",
      "Brand Identity and Positioning",
      "Marketing Fundamentals",
      "Integrated Marketing Communications (IMC)",
      "Brand Communications Principles"
    ]
  },
  {
    "roleId": "JF15-012",
    "roleName": "CRM Analyst",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "CRM Analysis",
      "Customer Segmentation",
      "Customer Lifetime Value",
      "Churn Analysis",
      "SQL"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Google Analytics 4 AI",
      "HeyGen"
    ],
    "domainSkills": [
      "CRM Marketing Concepts",
      "Customer Segmentation and Targeting",
      "Lifecycle Marketing",
      "Marketing Funnel Concepts",
      "A/B Testing Methodology"
    ]
  },
  {
    "roleId": "JF15-013",
    "roleName": "Affiliate Marketing Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Affiliate Marketing",
      "Affiliate Network Management",
      "Commission Structure",
      "Performance Tracking",
      "Paid Media"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google Analytics 4 AI",
      "HeyGen",
      "HubSpot AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "Affiliate Marketing Principles",
      "Partnership and Performance Marketing",
      "Performance Marketing Concepts",
      "Marketing Attribution Models",
      "Marketing Funnel Concepts"
    ]
  },
  {
    "roleId": "JF15-014",
    "roleName": "Market Research Analyst",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Market Research",
      "Consumer Insights",
      "Statistical Analysis",
      "Focus Group Facilitation",
      "Competitive Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "HeyGen",
      "Power BI Copilot",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Market Research Methodology",
      "Primary and Secondary Research Methods",
      "Data-Driven Decision Making",
      "Lifecycle Marketing",
      "Customer Segmentation and Targeting"
    ]
  },
  {
    "roleId": "JF15-015",
    "roleName": "Brand Communications Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Brand Communications",
      "Public Relations",
      "Press Release Writing",
      "Media Relations",
      "Marketing Communications"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Power BI Copilot",
      "Canva Magic Studio",
      "HeyGen"
    ],
    "domainSkills": [
      "Brand Communications Principles",
      "Integrated Marketing Communications (IMC)",
      "Brand Management Principles",
      "Brand Identity and Positioning",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF15-016",
    "roleName": "CRM Marketing Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "CRM Marketing",
      "Customer Engagement Strategy",
      "Customer Segmentation",
      "Loyalty Programme Management",
      "Personalisation"
    ],
    "aiToolSkills": [
      "HubSpot AI",
      "ChatGPT",
      "Jasper AI",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "CRM Marketing Concepts",
      "Lifecycle Marketing",
      "Customer Segmentation and Targeting",
      "Email Marketing Principles",
      "Email Deliverability Concepts"
    ]
  },
  {
    "roleId": "JF15-017",
    "roleName": "Community Manager",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Community Management",
      "Online Community Building",
      "Community Engagement",
      "Moderation",
      "Community Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Canva Magic Studio",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Community Management Principles",
      "Online Community Engagement Strategy",
      "Social Media Marketing Principles",
      "Marketing Fundamentals",
      "Social Media Content Strategy"
    ]
  },
  {
    "roleId": "JF15-018",
    "roleName": "Influencer Relations Executive",
    "jobFamily": "Marketing & Growth",
    "technicalSkills": [
      "Influencer Marketing",
      "Influencer Identification",
      "Creator Partnership Management",
      "Social Media Marketing",
      "Influencer Campaign Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "HeyGen",
      "Jasper AI",
      "Google Analytics 4 AI",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Influencer Marketing Principles",
      "Influencer Identification and Relations",
      "Social Media Marketing Principles",
      "Brand Management Principles",
      "Brand Identity and Positioning"
    ]
  },
  {
    "roleId": "JF16-001",
    "roleName": "Copywriter",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Copywriting",
      "Advertising Copy",
      "Creative Brief Interpretation",
      "Direct Response Writing",
      "Brand Voice"
    ],
    "aiToolSkills": [
      "Jasper AI",
      "ChatGPT",
      "Canva Magic Studio",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Copywriting Principles",
      "Persuasive Writing and Rhetoric",
      "Advertising Account Management",
      "Advertising Copywriting",
      "Brand Identity and Positioning"
    ]
  },
  {
    "roleId": "JF16-002",
    "roleName": "Brand Manager",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Brand Management",
      "Brand Strategy",
      "Brand Equity Management",
      "Brand P&L Management",
      "Consumer Research"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Synthesia",
      "HeyGen",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Brand Management Principles",
      "Brand Identity and Positioning",
      "Campaign Planning and Management",
      "Marketing Fundamentals",
      "Brand Monitoring and Analytics"
    ]
  },
  {
    "roleId": "JF16-003",
    "roleName": "PR Manager",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "PR Management",
      "Reputation Management",
      "Crisis Communications",
      "PR Strategy",
      "Spokesperson Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "HeyGen",
      "Jasper AI"
    ],
    "domainSkills": [
      "Public Relations Principles",
      "Media Relations Concepts",
      "Marketing Fundamentals",
      "Corporate Communications Principles",
      "PR Measurement and Evaluation"
    ]
  },
  {
    "roleId": "JF16-004",
    "roleName": "Media Planner",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Media Planning",
      "Media Buying",
      "Audience Planning",
      "GRP and TRP Calculation",
      "Cross-Channel Media Planning"
    ],
    "aiToolSkills": [
      "Google Analytics 4 AI",
      "ChatGPT",
      "Synthesia",
      "HubSpot AI",
      "HeyGen"
    ],
    "domainSkills": [
      "Media Planning Concepts",
      "Audience Research and Media Measurement",
      "Marketing Fundamentals",
      "Campaign Planning and Management",
      "Search Engine Optimisation (SEO) Principles"
    ]
  },
  {
    "roleId": "JF16-005",
    "roleName": "Account Manager - Ad Agency",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Ad Agency Account Management",
      "Client Servicing",
      "Campaign Briefing",
      "Creative Project Management",
      "Campaign Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "HeyGen",
      "Google Analytics 4 AI",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Advertising Account Management",
      "Campaign Planning and Management",
      "Advertising Copywriting",
      "Marketing Fundamentals",
      "Account Management Principles"
    ]
  },
  {
    "roleId": "JF16-006",
    "roleName": "Influencer Marketing Manager",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Influencer Marketing Management",
      "Campaign Analytics",
      "Influencer Strategy",
      "Budget Management",
      "Creator Economy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "HeyGen",
      "Jasper AI",
      "Google Analytics 4 AI",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Influencer Marketing Principles",
      "Influencer Identification and Relations",
      "Campaign Planning and Management",
      "Brand Management Principles",
      "Brand Monitoring and Analytics"
    ]
  },
  {
    "roleId": "JF16-007",
    "roleName": "Public Relations Executive",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Public Relations Execution",
      "Crisis Communications",
      "Press Release Writing",
      "Press Coverage Tracking",
      "Stakeholder Communication"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "Jasper AI",
      "HeyGen"
    ],
    "domainSkills": [
      "Public Relations Principles",
      "Media Relations Concepts",
      "Brand Communications Principles",
      "Integrated Marketing Communications (IMC)",
      "PR Measurement and Evaluation"
    ]
  },
  {
    "roleId": "JF16-008",
    "roleName": "Corporate Communications Executive",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Corporate Communications",
      "Brand Communications",
      "Internal Communications",
      "Executive Communication",
      "Reputation Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "HeyGen",
      "Jasper AI"
    ],
    "domainSkills": [
      "Corporate Communications Principles",
      "Public Relations Principles",
      "Integrated Marketing Communications (IMC)",
      "Brand Communications Principles",
      "Internal Communications Principles"
    ]
  },
  {
    "roleId": "JF16-009",
    "roleName": "Media Relations Executive",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Media Relations Execution",
      "Press Release Writing",
      "Journalist Outreach",
      "Media List Management",
      "News Monitoring"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "HeyGen",
      "Jasper AI"
    ],
    "domainSkills": [
      "Media Relations Concepts",
      "Public Relations Principles",
      "Integrated Marketing Communications (IMC)",
      "Brand Communications Principles",
      "PR Measurement and Evaluation"
    ]
  },
  {
    "roleId": "JF16-010",
    "roleName": "Internal Communications Executive",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Internal Communications Execution",
      "Email Newsletter Management",
      "Employee Engagement Communication",
      "Intranet Management",
      "Leadership Messaging"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "HeyGen",
      "Jasper AI"
    ],
    "domainSkills": [
      "Internal Communications Principles",
      "Corporate Communications Principles",
      "Campaign Planning and Management",
      "Brand Communications Principles",
      "Integrated Marketing Communications (IMC)"
    ]
  },
  {
    "roleId": "JF16-011",
    "roleName": "Campaign Manager",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Integrated Campaign Management",
      "Campaign Planning",
      "Campaign Management",
      "Campaign Optimization",
      "Cross-functional Coordination"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "HubSpot AI",
      "HeyGen",
      "Google Analytics 4 AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "Campaign Planning and Management",
      "Marketing Fundamentals",
      "Brand Communications Principles",
      "Marketing Funnel Concepts",
      "Integrated Marketing Communications (IMC)"
    ]
  },
  {
    "roleId": "JF16-012",
    "roleName": "Brand Analyst",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Brand Analysis",
      "Brand Management",
      "Brand Health Tracking",
      "Brand Sentiment Analysis",
      "Share of Voice Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Google Analytics 4 AI",
      "Synthesia",
      "Power BI Copilot",
      "HeyGen"
    ],
    "domainSkills": [
      "Brand Monitoring and Analytics",
      "Brand Management Principles",
      "Brand Communications Principles",
      "Primary and Secondary Research Methods",
      "Integrated Marketing Communications (IMC)"
    ]
  },
  {
    "roleId": "JF16-013",
    "roleName": "Media Buying Executive",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Media Buying Execution",
      "Audience Targeting",
      "Programmatic Advertising",
      "Ad Inventory Management",
      "Vendor Negotiation"
    ],
    "aiToolSkills": [
      "Google Analytics 4 AI",
      "ChatGPT",
      "Synthesia",
      "HubSpot AI",
      "HeyGen"
    ],
    "domainSkills": [
      "Media Buying Principles",
      "Media Planning Concepts",
      "Audience Research and Media Measurement",
      "Marketing Fundamentals",
      "Performance Marketing Concepts"
    ]
  },
  {
    "roleId": "JF16-014",
    "roleName": "Events Executive",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "Event Management",
      "Event Logistics",
      "Event Marketing",
      "Venue Management",
      "Event Sponsorship"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "Jasper AI",
      "HeyGen"
    ],
    "domainSkills": [
      "Event Management Principles",
      "Experiential Marketing Concepts",
      "Campaign Planning and Management",
      "Marketing Fundamentals",
      "Brand Communications Principles"
    ]
  },
  {
    "roleId": "JF16-015",
    "roleName": "PR Analyst",
    "jobFamily": "Advertising, PR & Communications",
    "technicalSkills": [
      "PR Analysis",
      "Media Monitoring",
      "PR Reporting",
      "Sentiment Tracking",
      "Public Relations"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Synthesia",
      "HeyGen",
      "Jasper AI"
    ],
    "domainSkills": [
      "PR Measurement and Evaluation",
      "Public Relations Principles",
      "Brand Monitoring and Analytics",
      "Primary and Secondary Research Methods",
      "Market Research Methodology"
    ]
  },
  {
    "roleId": "JF17-001",
    "roleName": "Content Writer",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Content Writing",
      "SEO Writing",
      "Research and Writing",
      "Long-Form Content",
      "Editing and Proofreading"
    ],
    "aiToolSkills": [
      "Jasper AI",
      "ChatGPT",
      "Stable Diffusion",
      "Grammarly",
      "Surfer SEO"
    ],
    "domainSkills": [
      "Content Writing Principles",
      "Long-Form Content Creation",
      "Search Engine Optimisation (SEO) Principles",
      "Content Marketing Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF17-002",
    "roleName": "Content Strategist",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Content Strategy",
      "Content Marketing",
      "Content Audit",
      "Content Architecture",
      "Audience Research"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Stable Diffusion",
      "Runway",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Editorial Planning and Content Calendar",
      "Content Governance",
      "Content Marketing Principles",
      "Search Engine Optimisation (SEO) Principles",
      "Data Visualization Principles"
    ]
  },
  {
    "roleId": "JF17-003",
    "roleName": "Social Media Manager",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Social Media Strategy",
      "Social Media Management",
      "Social Media Content Planning",
      "Paid Social Advertising",
      "Influencer Collaboration"
    ],
    "aiToolSkills": [
      "Jasper AI",
      "ChatGPT",
      "Runway",
      "Google Analytics 4 AI",
      "HubSpot AI"
    ],
    "domainSkills": [
      "Social Media Management Principles",
      "Platform-Specific Content Strategy",
      "Brand Management Principles",
      "Campaign Planning and Management",
      "Brand Identity and Positioning"
    ]
  },
  {
    "roleId": "JF17-004",
    "roleName": "Content Creator",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Content Creation",
      "Engagement Analytics",
      "Video Production",
      "Short-Form Video",
      "Audience Growth"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Stable Diffusion",
      "Runway",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Content Creator Methodology",
      "Multi-Format Content Production",
      "Short-Form Video Concepts",
      "Social Media Content Strategy",
      "Search Engine Optimisation (SEO) Principles"
    ]
  },
  {
    "roleId": "JF17-005",
    "roleName": "Podcast Producer",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Podcast Production",
      "Audio Editing",
      "Podcast Distribution",
      "Interview Techniques",
      "Podcast Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "ElevenLabs",
      "Jasper AI",
      "Runway"
    ],
    "domainSkills": [
      "Podcasting Principles",
      "Audio Production Concepts",
      "Podcast Audience Development",
      "Long-Form Content Creation",
      "Content Writing Principles"
    ]
  },
  {
    "roleId": "JF17-006",
    "roleName": "SEO Content Writer",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "SEO Writing",
      "Keyword Research",
      "On-Page SEO",
      "Search Intent Optimization",
      "On-Page Content Optimization"
    ],
    "aiToolSkills": [
      "Surfer SEO",
      "Jasper AI",
      "ChatGPT",
      "Grammarly",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "SEO Content Writing Principles",
      "Search Engine Optimisation (SEO) Principles",
      "Content Writing Principles",
      "Long-Form Content Creation",
      "Editorial Planning and Content Calendar"
    ]
  },
  {
    "roleId": "JF17-007",
    "roleName": "Video Content Creator",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Video Content Creation",
      "Video Editing",
      "Thumbnail Design",
      "YouTube Strategy",
      "Scriptwriting"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "Runway",
      "Jasper AI",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Video Content Strategy",
      "Video Storytelling and Script Writing",
      "Short-Form Video Concepts",
      "Multi-Format Content Production",
      "Search Engine Optimisation (SEO) Principles"
    ]
  },
  {
    "roleId": "JF17-008",
    "roleName": "Reporter - Print",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Print Journalism",
      "News Reporting",
      "Source Development",
      "AP Style Writing",
      "Beat Reporting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Grammarly",
      "Runway",
      "Jasper AI"
    ],
    "domainSkills": [
      "Journalism Principles and Ethics",
      "News Writing and Reporting",
      "Long-Form Content Creation",
      "Source Development and Protection",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF17-009",
    "roleName": "Reporter - TV",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "TV Reporting",
      "On-Camera Presentation",
      "Field Reporting",
      "News Reporting",
      "Video Journalism"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Adobe Firefly",
      "Grammarly",
      "Runway"
    ],
    "domainSkills": [
      "Journalism Principles and Ethics",
      "Broadcast Journalism Principles",
      "News Writing and Reporting",
      "Television Presenting and Anchoring",
      "Source Development and Protection"
    ]
  },
  {
    "roleId": "JF17-010",
    "roleName": "Reporter - Digital",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Digital Journalism",
      "Online News Writing",
      "News Reporting",
      "Multimedia Storytelling",
      "Social Media Journalism"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Surfer SEO",
      "Runway",
      "Jasper AI",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Journalism Principles and Ethics",
      "News Writing and Reporting",
      "SEO Content Writing Principles",
      "Multi-Format Content Production",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF17-011",
    "roleName": "Editor - News",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "News Editing",
      "Copy Editing",
      "Editorial Judgment",
      "Headline Writing",
      "Story Assignment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Google NotebookLM",
      "Grammarly",
      "Jasper AI"
    ],
    "domainSkills": [
      "Editorial Management Principles",
      "Journalism Principles and Ethics",
      "News Writing and Reporting",
      "Proofreading and Copy Editing Principles",
      "Source Development and Protection"
    ]
  },
  {
    "roleId": "JF17-012",
    "roleName": "News Anchor",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "News Anchoring",
      "Teleprompter Reading",
      "Live Broadcasting",
      "News Script Writing",
      "On-Camera Presentation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Adobe Firefly",
      "Grammarly",
      "Runway"
    ],
    "domainSkills": [
      "Television Presenting and Anchoring",
      "Broadcast Journalism Principles",
      "Journalism Principles and Ethics",
      "Source Development and Protection",
      "News Writing and Reporting"
    ]
  },
  {
    "roleId": "JF17-013",
    "roleName": "Photojournalist",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Photojournalism",
      "News Photography",
      "Photo Editing",
      "Visual Storytelling",
      "Adobe Lightroom"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "Google NotebookLM",
      "Stable Diffusion",
      "Grammarly"
    ],
    "domainSkills": [
      "Photojournalism Principles",
      "Cinematography Principles",
      "Journalism Principles and Ethics",
      "Visual Composition and Framing",
      "Source Development and Protection"
    ]
  },
  {
    "roleId": "JF17-014",
    "roleName": "Investigative Journalist",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Investigative Journalism",
      "Data Journalism",
      "FOIA and RTI Filing",
      "Document Analysis",
      "Confidential Source Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Google NotebookLM",
      "Grammarly",
      "Jasper AI"
    ],
    "domainSkills": [
      "Investigative Journalism Methodology",
      "Source Development and Protection",
      "Journalism Principles and Ethics",
      "News Writing and Reporting",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF17-015",
    "roleName": "Sports Journalist",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Sports Journalism",
      "Sports Reporting",
      "News Reporting",
      "Match Analysis Writing",
      "Athlete Interviewing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Jasper AI",
      "Grammarly",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "Sports Journalism Principles",
      "Journalism Principles and Ethics",
      "News Writing and Reporting",
      "Investigative Journalism Methodology",
      "Source Development and Protection"
    ]
  },
  {
    "roleId": "JF17-016",
    "roleName": "Business Journalist",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Business Journalism",
      "Financial News Writing",
      "News Reporting",
      "Corporate Reporting",
      "Economic Analysis Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Google NotebookLM",
      "Grammarly",
      "Jasper AI"
    ],
    "domainSkills": [
      "Financial and Business Journalism",
      "Economic Concepts for Journalists",
      "Journalism Principles and Ethics",
      "News Writing and Reporting",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF17-017",
    "roleName": "Editor - Publishing",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Publishing Editorial",
      "Manuscript Editing",
      "Developmental Editing",
      "Style Guide Application",
      "Publishing Workflow Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Google NotebookLM",
      "Grammarly",
      "Jasper AI"
    ],
    "domainSkills": [
      "Editorial Management Principles",
      "Publishing Industry Concepts",
      "Proofreading and Copy Editing Principles",
      "Long-Form Content Creation",
      "Audience-Appropriate Writing"
    ]
  },
  {
    "roleId": "JF17-018",
    "roleName": "Proofreader",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Proofreading",
      "Grammar and Punctuation",
      "Style Guide Application",
      "Consistency Checking",
      "Typesetting Review"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Grammarly",
      "Runway",
      "Jasper AI"
    ],
    "domainSkills": [
      "Proofreading and Copy Editing Principles",
      "Grammar, Style, and Usage Standards",
      "Audience-Appropriate Writing",
      "Content Writing Principles",
      "Publishing Industry Concepts"
    ]
  },
  {
    "roleId": "JF17-019",
    "roleName": "Technical Writer",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Technical Writing",
      "API Documentation",
      "User Manual Writing",
      "MadCap Flare",
      "DITA"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Google NotebookLM",
      "Jasper AI",
      "Grammarly"
    ],
    "domainSkills": [
      "Technical Writing Principles",
      "Documentation Design and Structure",
      "Audience-Appropriate Writing",
      "Content Writing Principles",
      "Search Engine Optimisation (SEO) Principles"
    ]
  },
  {
    "roleId": "JF17-020",
    "roleName": "Ghost Writer",
    "jobFamily": "Content, Media & Journalism",
    "technicalSkills": [
      "Ghost Writing",
      "Voice Matching",
      "Thought Leadership Writing",
      "Long-Form Content",
      "Executive Ghost Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Google NotebookLM",
      "Jasper AI",
      "Grammarly"
    ],
    "domainSkills": [
      "Ghost Writing and Collaborative Writing",
      "Voice Adaptation in Writing",
      "Long-Form Content Creation",
      "Persuasive Writing and Rhetoric",
      "Content Writing Principles"
    ]
  },
  {
    "roleId": "JF18-001",
    "roleName": "Screenplay Writer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Screenplay Writing",
      "Story Structure",
      "Dialogue Writing",
      "Final Draft",
      "Scene Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "ElevenLabs",
      "Jasper AI",
      "Runway"
    ],
    "domainSkills": [
      "Screenwriting Principles",
      "Story Structure and Narrative Theory",
      "Screenplay Format and Industry Standards",
      "Video Storytelling and Script Writing",
      "Persuasive Writing and Rhetoric"
    ]
  },
  {
    "roleId": "JF18-002",
    "roleName": "Film Editor",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Film Editing",
      "Adobe Premiere Pro",
      "DaVinci Resolve",
      "Narrative Editing",
      "Colour Grading"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "ElevenLabs",
      "Stable Diffusion",
      "Runway"
    ],
    "domainSkills": [
      "Film Editing Principles",
      "Narrative Editing Concepts",
      "Film Production Process",
      "Story Structure and Narrative Theory",
      "Sound Design Principles"
    ]
  },
  {
    "roleId": "JF18-003",
    "roleName": "Cinematographer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Cinematography",
      "Camera Operation",
      "Lighting Design",
      "Composition and Framing",
      "Digital Cinema Cameras"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "ElevenLabs",
      "Stable Diffusion",
      "Runway"
    ],
    "domainSkills": [
      "Cinematography Principles",
      "Visual Composition and Framing",
      "Lighting Design Concepts",
      "Film Production Process",
      "Story Structure and Narrative Theory"
    ]
  },
  {
    "roleId": "JF18-004",
    "roleName": "Sound Designer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Sound Design",
      "Audio Post-Production",
      "Foley",
      "Pro Tools",
      "Sound Mixing"
    ],
    "aiToolSkills": [
      "Suno AI",
      "ChatGPT",
      "Stable Diffusion",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Sound Design Principles",
      "Audio Post-Production Concepts",
      "Audio Production Concepts",
      "Film Production Process",
      "Story Structure and Narrative Theory"
    ]
  },
  {
    "roleId": "JF18-005",
    "roleName": "Production Designer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Production Design",
      "Set Design",
      "Art Direction",
      "Budget Management in Production",
      "Visual Concept Development"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "ElevenLabs",
      "Stable Diffusion",
      "Runway"
    ],
    "domainSkills": [
      "Production Design Principles",
      "Set Design and Art Direction",
      "Film Production Process",
      "Story Structure and Narrative Theory",
      "Cinematography Principles"
    ]
  },
  {
    "roleId": "JF18-006",
    "roleName": "Lyricist",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Lyric Writing",
      "Song Structure",
      "Rhyme and Meter",
      "Music Theory",
      "Collaboration with Composers"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Suno AI",
      "Stable Diffusion",
      "Runway",
      "Jasper AI"
    ],
    "domainSkills": [
      "Lyric Writing Principles",
      "Song Structure and Composition",
      "Music Theory Fundamentals",
      "Persuasive Writing and Rhetoric",
      "Story Structure and Narrative Theory"
    ]
  },
  {
    "roleId": "JF18-007",
    "roleName": "Animator - 2D",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "2D Animation",
      "Adobe Animate",
      "Toon Boom Harmony",
      "Frame-by-Frame Animation",
      "Character Animation"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Midjourney"
    ],
    "domainSkills": [
      "2D Animation Principles",
      "Frame-by-Frame and Tweening Animation",
      "Typography Principles",
      "Colour Theory",
      "Visual Design Principles"
    ]
  },
  {
    "roleId": "JF18-008",
    "roleName": "Animator - 3D",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "3D Animation",
      "Maya",
      "Rigging",
      "Keyframe Animation",
      "Motion Capture"
    ],
    "aiToolSkills": [
      "Blender AI",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "3D Animation Principles",
      "Character Animation Concepts",
      "Rigging Concepts",
      "3D Mathematics",
      "Game Design Principles"
    ]
  },
  {
    "roleId": "JF18-009",
    "roleName": "VFX Artist",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Visual Effects",
      "Nuke",
      "Compositing",
      "CGI",
      "Rotoscoping"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Blender AI"
    ],
    "domainSkills": [
      "Visual Effects (VFX) Principles",
      "Compositing Concepts",
      "Motion Tracking and Matchmoving",
      "Rendering Pipeline",
      "Sound Design Principles"
    ]
  },
  {
    "roleId": "JF18-010",
    "roleName": "Game Designer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Game Design",
      "Game Mechanics Design",
      "Level Design",
      "Game Balancing",
      "Game Design Document"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "ElevenLabs",
      "Midjourney",
      "Runway"
    ],
    "domainSkills": [
      "Game Design Methodology",
      "Level Design Principles",
      "Game Design Principles",
      "Game Economy and Balance Design",
      "Artificial Intelligence for Games"
    ]
  },
  {
    "roleId": "JF18-011",
    "roleName": "3D Modeller",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "3D Modelling",
      "Blender",
      "Texturing",
      "ZBrush",
      "UV Mapping"
    ],
    "aiToolSkills": [
      "Blender AI",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Midjourney"
    ],
    "domainSkills": [
      "3D Modelling Principles",
      "Polygon and Subdivision Modelling",
      "UV Mapping and Texturing",
      "PBR (Physically Based Rendering) Concepts",
      "3D Modeling and Animation Concepts"
    ]
  },
  {
    "roleId": "JF18-012",
    "roleName": "Game Developer - Unity",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Unity",
      "C#",
      "Unity Game Development",
      "Unity Scripting",
      "Physics Simulation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Stable Diffusion",
      "Runway",
      "Blender AI",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Unity Game Development Principles",
      "Game Design Principles",
      "3D Mathematics",
      "Rendering Pipeline",
      "Artificial Intelligence for Games"
    ]
  },
  {
    "roleId": "JF18-013",
    "roleName": "Motion Graphics Designer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Motion Graphics",
      "Adobe After Effects",
      "Kinetic Typography",
      "Animation Principles",
      "Graphic Design"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Midjourney"
    ],
    "domainSkills": [
      "Motion Graphics Principles",
      "Typography in Motion",
      "Animation Timing and Easing",
      "Visual Design Principles",
      "Video Storytelling and Script Writing"
    ]
  },
  {
    "roleId": "JF18-014",
    "roleName": "Storyboard Artist",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Storyboarding",
      "Visual Narrative",
      "Shot Composition",
      "Storyboard Pro",
      "Visual Storytelling"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Storyboarding Principles",
      "Visual Narrative Planning",
      "Cinematography Principles",
      "Visual Composition and Framing",
      "Story Structure and Narrative Theory"
    ]
  },
  {
    "roleId": "JF18-015",
    "roleName": "Colour Grading Artist",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Colour Grading",
      "DaVinci Resolve Colour",
      "LUT Creation",
      "Colour Science",
      "Colour Correction"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "ElevenLabs",
      "Stable Diffusion",
      "Runway"
    ],
    "domainSkills": [
      "Colour Grading Principles",
      "Colour Science Fundamentals",
      "Cinematography Principles",
      "Colour Theory",
      "Film Production Process"
    ]
  },
  {
    "roleId": "JF18-016",
    "roleName": "Sound Engineer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Sound Engineering",
      "Acoustic Treatment",
      "Live Sound",
      "Recording Studio",
      "Signal Processing (Media & Film)"
    ],
    "aiToolSkills": [
      "Suno AI",
      "ChatGPT",
      "Stable Diffusion",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Sound Engineering Principles",
      "Live Sound and Studio Recording Concepts",
      "Signal Chain and Acoustics",
      "Audio Production Concepts",
      "Audio Post-Production Concepts"
    ]
  },
  {
    "roleId": "JF18-017",
    "roleName": "Game Artist",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Game Art",
      "Sprite Design",
      "Environment Art",
      "Blender",
      "Concept Art for Games"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Game Art Principles",
      "Asset Creation for Real-Time Environments",
      "3D Modelling Principles",
      "PBR (Physically Based Rendering) Concepts",
      "Visual Design Principles"
    ]
  },
  {
    "roleId": "JF18-018",
    "roleName": "Immersive Experience Designer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Immersive Experience Design",
      "Spatial Design",
      "Interactive Storytelling",
      "Mixed Reality Design",
      "Unity"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ElevenLabs",
      "Runway",
      "Stable Diffusion",
      "Midjourney"
    ],
    "domainSkills": [
      "Immersive Experience Design Principles",
      "Spatial Interaction Design",
      "3D Spatial Computing",
      "Experiential Marketing Concepts",
      "Story Structure and Narrative Theory"
    ]
  },
  {
    "roleId": "JF18-019",
    "roleName": "Concept Artist",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Concept Art",
      "Digital Painting",
      "Procreate",
      "Adobe Photoshop",
      "Ideation Sketching"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Concept Art Principles",
      "Visual Development Methodology",
      "Illustration Principles",
      "Visual Design Principles",
      "Drawing and Sketching Fundamentals"
    ]
  },
  {
    "roleId": "JF18-020",
    "roleName": "Character Designer",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "Character Design",
      "Character Sheet Creation",
      "Style Development",
      "Digital Painting",
      "Turn-Around Drawing"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Character Design Principles",
      "Visual Development Methodology",
      "Character Animation Concepts",
      "3D Animation Principles",
      "Drawing and Sketching Fundamentals"
    ]
  },
  {
    "roleId": "JF18-021",
    "roleName": "AR/VR Content Creator",
    "jobFamily": "Film, Animation & Gaming",
    "technicalSkills": [
      "AR/VR Content Creation",
      "Unity",
      "WebXR",
      "360 Video Production",
      "Spatial Audio"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ElevenLabs",
      "Runway",
      "Stable Diffusion",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "AR/VR Content Creation Principles",
      "Real-Time 3D Content for XR",
      "3D Spatial Computing",
      "Immersive Experience Design Principles",
      "Multi-Format Content Production"
    ]
  },
  {
    "roleId": "JF19-001",
    "roleName": "Graphic Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Graphic Design",
      "Adobe Illustrator",
      "Adobe InDesign",
      "Typography",
      "Layout Design"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Graphic Design Principles",
      "Visual Communication Theory",
      "Layout and Composition Design",
      "Visual Design Principles",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF19-002",
    "roleName": "Brand Identity Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Brand Identity Design",
      "Logo Design",
      "Adobe Illustrator",
      "Design System Creation",
      "Brand Style Guide"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Brand Identity Design Principles",
      "Logo Design Methodology",
      "Brand Identity and Positioning",
      "Graphic Design Principles",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF19-003",
    "roleName": "Packaging Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Packaging Design",
      "Dieline Creation",
      "Adobe Illustrator",
      "Print Production",
      "3D Packaging Mockup"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Packaging Design Principles",
      "Brand Management Principles",
      "Graphic Design Principles",
      "Brand Identity and Positioning",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF19-004",
    "roleName": "Illustrator",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Illustration",
      "Digital Painting",
      "Digital Illustration",
      "Editorial Illustration",
      "Children's Book Illustration"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Stable Diffusion",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Illustration Principles",
      "Drawing and Sketching Fundamentals",
      "Typography Principles",
      "Visual Design Principles",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF19-005",
    "roleName": "Type Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Type Design",
      "Font Development",
      "Glyph Design",
      "FontLab",
      "Kerning and Spacing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Runway",
      "Stable Diffusion",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Type Design Principles",
      "Typeface Anatomy and Classification",
      "Lettering and Calligraphy Fundamentals",
      "Typography Principles",
      "Visual Design Principles"
    ]
  },
  {
    "roleId": "JF19-006",
    "roleName": "Photographer - Commercial",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Commercial Photography",
      "Studio Photography",
      "Product Photography",
      "Photo Retouching",
      "Adobe Photoshop for Photography"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Photography Principles",
      "Commercial Photography Concepts",
      "Lighting Design Concepts",
      "Visual Composition and Framing",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF19-007",
    "roleName": "Photographer - Wedding",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Wedding Photography",
      "Candid Photography",
      "Photo Retouching",
      "Outdoor Lighting",
      "Wedding Album Design"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Photography Principles",
      "Wedding and Event Photography Principles",
      "Portrait and Lifestyle Photography",
      "Commercial Photography Concepts",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF19-008",
    "roleName": "Videographer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Videography",
      "Camera Work",
      "Video Editing",
      "Video Post-Production",
      "On-Location Filming"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "Runway",
      "Suno AI",
      "Midjourney"
    ],
    "domainSkills": [
      "Videography Principles",
      "Cinematography Principles",
      "Lighting Design Concepts",
      "Video Storytelling and Script Writing",
      "Sound Design Principles"
    ]
  },
  {
    "roleId": "JF19-009",
    "roleName": "Video Editor",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Video Editing Skills",
      "Adobe Premiere Pro",
      "Export and Delivery",
      "Colour Correction",
      "Sound Sync"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "ChatGPT",
      "Runway",
      "Stable Diffusion",
      "Midjourney"
    ],
    "domainSkills": [
      "Video Editing Principles",
      "Film Editing Principles",
      "Colour Grading for Video",
      "Audio for Video Concepts",
      "Video Storytelling and Script Writing"
    ]
  },
  {
    "roleId": "JF19-010",
    "roleName": "Documentary Filmmaker",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Documentary Filmmaking",
      "Investigative Research",
      "Interview Direction",
      "Narrative Documentary Structure",
      "Archival Research"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Adobe Firefly",
      "Stable Diffusion",
      "Runway",
      "Midjourney"
    ],
    "domainSkills": [
      "Documentary Filmmaking Methodology",
      "Film Production Process",
      "Colour Theory",
      "Investigative Journalism Methodology",
      "Source Development and Protection"
    ]
  },
  {
    "roleId": "JF19-011",
    "roleName": "Visual Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Visual Design",
      "UI Visual Design",
      "Figma",
      "Iconography",
      "Design Tokens"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Visual Design Methodology",
      "Graphic Design Principles",
      "Visual Design Principles",
      "Visual Communication Theory",
      "Layout and Composition Design"
    ]
  },
  {
    "roleId": "JF19-012",
    "roleName": "Social Media Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Social Media Design",
      "Graphic Design",
      "Template Design",
      "Canva",
      "Content Visual Production"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Social Media Design Principles",
      "Visual Design Principles",
      "Social Media Content Strategy",
      "Colour Theory",
      "Brand Management Principles"
    ]
  },
  {
    "roleId": "JF19-013",
    "roleName": "Print Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Print Design",
      "Adobe InDesign",
      "Pre-press Production",
      "Brochure Design",
      "CMYK Colour Management"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Print Design Principles",
      "Pre-Press and Print Production Concepts",
      "Graphic Design Principles",
      "Colour Theory",
      "Layout and Composition Design"
    ]
  },
  {
    "roleId": "JF19-014",
    "roleName": "Exhibition Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Exhibition Design",
      "Spatial Exhibition Planning",
      "Wayfinding Design",
      "3D Exhibition Rendering",
      "Set Design"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Firefly",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Exhibition Design Principles",
      "Wayfinding and Environmental Graphics",
      "Production Design Principles",
      "Set Design and Art Direction",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF19-015",
    "roleName": "Infographic Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Infographic Design",
      "Data Visualisation Design",
      "Adobe Illustrator",
      "Information Hierarchy",
      "Chart and Graph Design"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Infographic Design Principles",
      "Data Visualisation for Design",
      "Graphic Design Principles",
      "Visual Communication Theory",
      "Layout and Composition Design"
    ]
  },
  {
    "roleId": "JF19-016",
    "roleName": "Digital Designer",
    "jobFamily": "Graphic & Visual Design",
    "technicalSkills": [
      "Digital Design",
      "Web Design",
      "Figma",
      "Responsive Design",
      "Design-to-Development Handoff"
    ],
    "aiToolSkills": [
      "Adobe Firefly",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Digital Design Principles",
      "Responsive and Adaptive Design Concepts",
      "Graphic Design Principles",
      "Visual Design Principles",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF20-001",
    "roleName": "Fashion Designer",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Fashion Design",
      "Garment Construction",
      "Fashion Illustration",
      "Trend Forecasting",
      "Adobe Illustrator for Fashion"
    ],
    "aiToolSkills": [
      "CLO 3D AI",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Fashion Design Principles",
      "Textile Design Principles",
      "Garment Construction Concepts",
      "Fashion Trend Forecasting",
      "Fibre and Fabric Knowledge"
    ]
  },
  {
    "roleId": "JF20-002",
    "roleName": "Textile Designer",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Textile Design",
      "Surface Pattern Design",
      "Fabric Knowledge",
      "CAD for Textiles",
      "Print and Weave Design"
    ],
    "aiToolSkills": [
      "CLO 3D AI",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Textile Design Principles",
      "Fashion Design Principles",
      "Fibre and Fabric Knowledge",
      "Colour Theory",
      "Fashion Trend Forecasting"
    ]
  },
  {
    "roleId": "JF20-003",
    "roleName": "Fashion Stylist",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Fashion Styling",
      "Wardrobe Curation",
      "Editorial Styling",
      "Trend Awareness",
      "Client Style Consultation"
    ],
    "aiToolSkills": [
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Fashion Styling Principles",
      "Wardrobe Curation and Concept",
      "Fashion Design Principles",
      "Fashion Trend Forecasting",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF20-004",
    "roleName": "Costume Designer",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Costume Design",
      "Period Costume Research",
      "Fabric Sourcing",
      "Costume Construction",
      "Costume Budget Management"
    ],
    "aiToolSkills": [
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Stable Diffusion",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Costume Design Principles",
      "Historical and Period Costume Research",
      "Garment Construction Concepts",
      "Film Production Process",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF20-005",
    "roleName": "Apparel Merchandiser",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Apparel Merchandising",
      "Merchandise Planning",
      "Range Building",
      "Retail Buying",
      "OTB Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "CLO 3D AI",
      "Stable Diffusion",
      "Canva Magic Studio",
      "Runway"
    ],
    "domainSkills": [
      "Apparel Merchandising Principles",
      "Buying and Range Planning",
      "Fashion Trend Forecasting",
      "Fibre and Fabric Knowledge",
      "Fashion Design Principles"
    ]
  },
  {
    "roleId": "JF20-006",
    "roleName": "Pattern Maker",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Pattern Making",
      "Flat Pattern Drafting",
      "Draping",
      "Grading",
      "Gerber CAD"
    ],
    "aiToolSkills": [
      "Gerber AccuMark AI",
      "ChatGPT",
      "Canva Magic Studio",
      "CLO 3D AI",
      "Runway"
    ],
    "domainSkills": [
      "Pattern Making Principles",
      "Grading and Sizing Concepts",
      "Garment Construction Concepts",
      "Fibre and Fabric Knowledge",
      "Fashion Design Principles"
    ]
  },
  {
    "roleId": "JF20-007",
    "roleName": "Textile Engineer",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Textile Engineering",
      "Yarn and Fibre Technology",
      "Fabric Testing",
      "Textile Quality Control",
      "Loom Technology"
    ],
    "aiToolSkills": [
      "Gerber AccuMark AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Textile Engineering Principles",
      "Yarn and Fabric Production Concepts",
      "Quality Control in Textiles",
      "Fibre and Fabric Knowledge",
      "Weaving Technology Concepts"
    ]
  },
  {
    "roleId": "JF20-008",
    "roleName": "Weaving Technician",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Weaving",
      "Loom Operation",
      "Loom Technology",
      "Warp and Weft Calculation",
      "Handloom Techniques"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Gerber AccuMark AI",
      "Canva Magic Studio",
      "Stable Diffusion",
      "Runway"
    ],
    "domainSkills": [
      "Weaving Technology Concepts",
      "Loom Mechanics and Fabric Structure",
      "Quality Control in Textiles",
      "Fibre and Fabric Knowledge",
      "Textile Engineering Principles"
    ]
  },
  {
    "roleId": "JF20-009",
    "roleName": "Dyeing & Printing Technician",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Dyeing Technology",
      "Screen Printing",
      "Reactive and Acid Dyes",
      "Colour Matching",
      "Finishing Processes"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Gerber AccuMark AI",
      "Canva Magic Studio",
      "Stable Diffusion",
      "Runway"
    ],
    "domainSkills": [
      "Dyeing and Printing Technology",
      "Colour Fastness and Testing Concepts",
      "Quality Control in Textiles",
      "Fibre and Fabric Knowledge",
      "Textile Engineering Principles"
    ]
  },
  {
    "roleId": "JF20-010",
    "roleName": "Spinning Engineer",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Spinning Technology",
      "Ring Spinning",
      "Rotor Spinning",
      "Yarn Count Calculation",
      "Spinning Machine Maintenance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Gerber AccuMark AI",
      "Canva Magic Studio",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Spinning Technology Concepts",
      "Fibre-to-Yarn Processing",
      "Quality Control in Textiles",
      "Yarn and Fabric Production Concepts",
      "Textile Engineering Principles"
    ]
  },
  {
    "roleId": "JF20-011",
    "roleName": "Textile Quality Inspector",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Textile Quality Inspection",
      "AQL Sampling",
      "Defect Classification",
      "Textile Quality Control",
      "Inspection Report Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Runway",
      "Gerber AccuMark AI",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Textile Quality Inspection Methodology",
      "Defect Classification in Textiles",
      "Quality Control in Textiles",
      "Fibre and Fabric Knowledge",
      "Export Documentation and Compliance"
    ]
  },
  {
    "roleId": "JF20-012",
    "roleName": "Production Manager - Apparel",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Apparel Production Management",
      "Production Planning",
      "Line Balancing",
      "Efficiency and Productivity Management",
      "SAM Calculation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Stable Diffusion",
      "Runway",
      "Gerber AccuMark AI"
    ],
    "domainSkills": [
      "Supply Chain Management Principles",
      "Garment Manufacturing Process",
      "Quality Control in Textiles",
      "Supply Chain Management in Apparel",
      "Export Documentation and Compliance"
    ]
  },
  {
    "roleId": "JF20-013",
    "roleName": "Garment Technologist",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Garment Technology",
      "Fit Assessment",
      "Tech Pack Development",
      "Pattern Making",
      "Wash and Care Development"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Gerber AccuMark AI",
      "CLO 3D AI",
      "Runway",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Garment Technology Principles",
      "Fit Assessment and Specification Writing",
      "Garment Construction Concepts",
      "Grading and Sizing Concepts",
      "Fibre and Fabric Knowledge"
    ]
  },
  {
    "roleId": "JF20-014",
    "roleName": "Pattern Grader",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Pattern Grading",
      "Grading",
      "Size Specification Development",
      "Marker Making",
      "Gerber CAD"
    ],
    "aiToolSkills": [
      "Gerber AccuMark AI",
      "ChatGPT",
      "Runway",
      "CLO 3D AI",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Grading and Sizing Concepts",
      "Pattern Making Principles",
      "Garment Construction Concepts",
      "Fit Assessment and Specification Writing",
      "Fibre and Fabric Knowledge"
    ]
  },
  {
    "roleId": "JF20-015",
    "roleName": "Merchandiser - Apparel Export",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Apparel Export Merchandising",
      "Export Order Follow-up",
      "Buyer Communication",
      "Critical Path Management",
      "Tech Pack Development"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Stable Diffusion",
      "CLO 3D AI",
      "Runway"
    ],
    "domainSkills": [
      "Buying and Range Planning",
      "Export Documentation and Compliance",
      "Apparel Merchandising Principles",
      "Supply Chain Management in Apparel",
      "Quality Control in Textiles"
    ]
  },
  {
    "roleId": "JF20-016",
    "roleName": "Buyer - Fashion Retail",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Fashion Buying",
      "Range Planning",
      "Supplier Negotiation",
      "Open to Buy Planning",
      "Trend Forecasting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Stable Diffusion",
      "CLO 3D AI",
      "Runway"
    ],
    "domainSkills": [
      "Fashion Retail Buying Principles",
      "Buying and Range Planning",
      "Fashion Trend Forecasting",
      "Vendor Development and Evaluation",
      "Fibre and Fabric Knowledge"
    ]
  },
  {
    "roleId": "JF20-017",
    "roleName": "Sourcing Manager - Apparel",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Apparel Sourcing",
      "Vendor Development",
      "Cost Negotiation",
      "Compliance and Audit",
      "Buyer Communication"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Stable Diffusion",
      "Power BI Copilot",
      "Runway"
    ],
    "domainSkills": [
      "Apparel Sourcing Principles",
      "Supply Chain Management in Apparel",
      "Vendor Development and Evaluation",
      "Export Documentation and Compliance",
      "Quality Control in Textiles"
    ]
  },
  {
    "roleId": "JF20-018",
    "roleName": "Export Coordinator - Garments",
    "jobFamily": "Fashion, Textile & Apparel",
    "technicalSkills": [
      "Garment Export Coordination",
      "Shipping Documentation",
      "Letter of Credit for Exports",
      "Customs and Compliance",
      "Critical Path Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Stable Diffusion",
      "Runway",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Garment Export Operations",
      "International Trade Documentation",
      "Export Documentation and Compliance",
      "Supply Chain Management Principles",
      "Supply Chain Management in Apparel"
    ]
  },
  {
    "roleId": "JF21-001",
    "roleName": "Store Manager",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Store Management",
      "Retail Operations",
      "Team Management",
      "Staff Scheduling",
      "Store P&L Management"
    ],
    "aiToolSkills": [
      "Retail AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Retail Management Principles",
      "Store Operations Management",
      "Retail Visual Merchandising Principles",
      "Retail Sales Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF21-002",
    "roleName": "Visual Merchandiser",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Visual Merchandising",
      "Planogram Execution",
      "Merchandising Execution",
      "Window Display Design",
      "In-Store Navigation Design"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Firefly",
      "ChatGPT",
      "Canva Magic Studio",
      "Stable Diffusion"
    ],
    "domainSkills": [
      "Retail Visual Merchandising Principles",
      "Visual Merchandising Concepts",
      "Visual Design Principles",
      "Brand Management Principles",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF21-003",
    "roleName": "Retail Sales Associate",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Retail Customer Service",
      "Retail Sales",
      "Product Knowledge",
      "Point of Sale Systems",
      "Sales Target Achievement"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Salesforce Einstein",
      "Canva Magic Studio",
      "Jasper AI"
    ],
    "domainSkills": [
      "Retail Sales Principles",
      "Sales Fundamentals",
      "Sales Process and Methodology",
      "Visual Merchandising Concepts",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF21-004",
    "roleName": "Category Manager",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Category Management",
      "Assortment Planning",
      "Category P&L",
      "Pricing Strategy",
      "SQL"
    ],
    "aiToolSkills": [
      "Retail AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Category Management Principles",
      "Retail Management Principles",
      "Buying and Range Planning",
      "Apparel Merchandising Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF21-005",
    "roleName": "Retail Area Manager",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Retail Area Management",
      "Multi-Store Management",
      "Store Management",
      "Retail KPI Management",
      "Sales Team Leadership"
    ],
    "aiToolSkills": [
      "Retail AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Visual Merchandising Concepts",
      "Multi-Store Operations",
      "Retail Management Principles",
      "Revenue Management Concepts",
      "Retail Sales Principles"
    ]
  },
  {
    "roleId": "JF21-006",
    "roleName": "Loss Prevention Officer",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Loss Prevention",
      "Shrinkage Control",
      "CCTV Surveillance",
      "Security Audit",
      "Security Incident Reporting"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Perplexity AI",
      "Retail AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Loss Prevention and Shrinkage Control",
      "Retail Security Principles",
      "Retail Management Principles",
      "Store Operations Management",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF21-007",
    "roleName": "E-Commerce Manager",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "E-Commerce Management",
      "Online Marketplace Management",
      "Digital Marketing",
      "E-Commerce Analytics",
      "Conversion Rate Optimization"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Google Analytics 4 AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "E-Commerce Management Principles",
      "Digital Customer Experience",
      "Digital Marketing Principles",
      "Category Management Principles",
      "Growth Frameworks"
    ]
  },
  {
    "roleId": "JF21-008",
    "roleName": "Marketplace Analyst",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Marketplace Analysis",
      "Amazon Seller Central",
      "Flipkart Seller Hub",
      "Listing Optimization",
      "Marketplace Advertising"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Online Marketplace Concepts",
      "Marketplace Analytics",
      "Search Engine Optimisation (SEO) Principles",
      "Apparel Merchandising Principles",
      "Buying and Range Planning"
    ]
  },
  {
    "roleId": "JF21-009",
    "roleName": "Catalogue Manager",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Catalogue Management",
      "Product Data Management",
      "Product Content Writing",
      "Listing Optimization",
      "Image Asset Management"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Jasper AI",
      "Canva Magic Studio",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Product Catalogue Management",
      "Product Information Management (PIM) Concepts",
      "Digital Customer Experience",
      "Search Engine Optimisation (SEO) Principles",
      "Apparel Merchandising Principles"
    ]
  },
  {
    "roleId": "JF21-010",
    "roleName": "D2C Marketing Manager",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "D2C Marketing",
      "Customer Acquisition Strategy",
      "Performance Marketing",
      "D2C Analytics",
      "Retention Marketing"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "Google Analytics 4 AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Jasper AI"
    ],
    "domainSkills": [
      "Direct-to-Consumer (D2C) Marketing Principles",
      "Customer Acquisition and Retention in D2C",
      "Digital Marketing Principles",
      "Marketing Fundamentals",
      "Marketing Mix (4Ps / 7Ps)"
    ]
  },
  {
    "roleId": "JF21-011",
    "roleName": "Retail Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Retail Sales Execution",
      "Upselling",
      "Retail Customer Service",
      "Store Replenishment",
      "Customer Floor Assistance"
    ],
    "aiToolSkills": [
      "Retail AI",
      "ChatGPT",
      "Perplexity AI",
      "Salesforce Einstein",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Retail Operations Principles",
      "Retail Sales Principles",
      "Customer Service Principles",
      "Visual Merchandising Concepts",
      "Retail Management Principles"
    ]
  },
  {
    "roleId": "JF21-012",
    "roleName": "Merchandising Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Merchandising Execution",
      "Visual Merchandising",
      "Space Management",
      "SKU Management",
      "Promotional Display Execution"
    ],
    "aiToolSkills": [
      "Retail AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Midjourney"
    ],
    "domainSkills": [
      "Retail Merchandising Execution",
      "Visual Merchandising Concepts",
      "Apparel Merchandising Principles",
      "Retail Visual Merchandising Principles",
      "Retail Management Principles"
    ]
  },
  {
    "roleId": "JF21-013",
    "roleName": "E-Commerce Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "E-Commerce Operations",
      "Product Listing Management",
      "Order Fulfilment",
      "Listing Optimization",
      "E-Commerce Customer Support"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Jasper AI",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "E-Commerce Operations Concepts",
      "Order Fulfilment and Logistics",
      "Digital Customer Experience",
      "Online Marketplace Concepts",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF21-014",
    "roleName": "Marketplace Operations Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Marketplace Operations",
      "Amazon Seller Central",
      "Seller Account Management",
      "Marketplace SLA Management",
      "Inventory Reconciliation"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Marketplace Operations Management",
      "Online Marketplace Concepts",
      "Marketplace Analytics",
      "Order Fulfilment and Logistics",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF21-015",
    "roleName": "Retail Buyer",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Retail Buying Execution",
      "Open-to-Buy Planning",
      "Supplier Negotiation",
      "Purchase Order Management",
      "Vendor Relationship Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Retail AI",
      "Stable Diffusion",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Fashion and Retail Buying Fundamentals",
      "Buying and Range Planning",
      "Apparel Merchandising Principles",
      "Vendor Development and Evaluation",
      "Fashion Trend Forecasting"
    ]
  },
  {
    "roleId": "JF21-016",
    "roleName": "E-Commerce Operations Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "E-Commerce Order Management",
      "Order Fulfilment",
      "Returns Management",
      "Warehouse Coordination",
      "COD Reconciliation"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Stable Diffusion",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "E-Commerce Operations Concepts",
      "Order Fulfilment and Logistics",
      "Reverse Logistics Concepts",
      "Digital Customer Experience",
      "Marketplace Operations Management"
    ]
  },
  {
    "roleId": "JF21-017",
    "roleName": "D2C Brand Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "D2C Brand Management",
      "D2C Marketing",
      "Direct Consumer Engagement",
      "Content Creation",
      "D2C Content Execution"
    ],
    "aiToolSkills": [
      "E-Commerce AI",
      "ChatGPT",
      "Jasper AI",
      "Canva Magic Studio",
      "Google Analytics 4 AI"
    ],
    "domainSkills": [
      "D2C Brand Building Principles",
      "Customer Acquisition and Retention in D2C",
      "Direct-to-Consumer (D2C) Marketing Principles",
      "Digital Customer Experience",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF21-018",
    "roleName": "Retail Operations Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Retail Operations Execution",
      "Loss Prevention",
      "SOP Compliance",
      "Stock Management",
      "Retail Audit Compliance"
    ],
    "aiToolSkills": [
      "Retail AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Retail Operations Principles",
      "Store Operations Management",
      "Retail Management Principles",
      "Loss Prevention and Shrinkage Control",
      "Retail Sales Principles"
    ]
  },
  {
    "roleId": "JF21-019",
    "roleName": "Reverse Logistics Executive",
    "jobFamily": "Retail & E-Commerce",
    "technicalSkills": [
      "Reverse Logistics",
      "Return Processing",
      "Returns Management",
      "Refund and Credit Management",
      "Damage Assessment for Returns"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Stable Diffusion",
      "Retail AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Reverse Logistics Concepts",
      "E-Commerce Operations Concepts",
      "Order Fulfilment and Logistics",
      "Store Operations Management",
      "Retail Operations Principles"
    ]
  },
  {
    "roleId": "JF22-001",
    "roleName": "Customer Success Manager",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Success Management",
      "Onboarding Management",
      "Churn Prevention",
      "NPS and CSAT Management",
      "Account Health Monitoring"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Power BI Copilot",
      "Zapier",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Customer Success Methodology",
      "Account Health Management",
      "Customer Success Principles",
      "Customer Relationship Management Concepts",
      "Account Management Principles"
    ]
  },
  {
    "roleId": "JF22-002",
    "roleName": "Customer Support Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Support",
      "Ticket Resolution",
      "Escalation Management",
      "Customer Service",
      "Help Desk Management"
    ],
    "aiToolSkills": [
      "Zendesk AI",
      "ChatGPT",
      "Perplexity AI",
      "Conversational AI",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Customer Support Operations",
      "Customer Service Principles",
      "Customer Experience Design",
      "Service Quality and SLA Management",
      "End-User Support Principles"
    ]
  },
  {
    "roleId": "JF22-003",
    "roleName": "CRM Manager",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "CRM Management",
      "CRM Platform Administration",
      "CRM Software",
      "Customer Data Management",
      "Customer Lifecycle Management"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "HubSpot AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Customer Relationship Management Strategy",
      "CRM Programme Design",
      "CRM Marketing Concepts",
      "Customer Segmentation and Targeting",
      "Customer Insights and Research"
    ]
  },
  {
    "roleId": "JF22-004",
    "roleName": "Customer Insights Analyst",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Insights Analysis",
      "Voice of Customer",
      "Customer Feedback Analysis",
      "SQL",
      "Customer Journey Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Salesforce Einstein",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Customer Insights and Research",
      "Voice of Customer Methodology",
      "Customer Segmentation and Targeting",
      "Lifecycle Marketing",
      "Customer Experience Design"
    ]
  },
  {
    "roleId": "JF22-005",
    "roleName": "Customer Service Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Service",
      "CRM Management",
      "Query Resolution",
      "Help Desk Management",
      "Service Quality Management"
    ],
    "aiToolSkills": [
      "Zendesk AI",
      "ChatGPT",
      "Perplexity AI",
      "Conversational AI",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Customer Service Principles",
      "Customer Support Operations",
      "Service Quality and SLA Management",
      "Customer Relationship Management Strategy",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF22-006",
    "roleName": "Client Servicing Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Client Servicing",
      "Customer Relationship Management Execution",
      "Account Servicing",
      "Client Communication Management",
      "Client Retention"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Zapier",
      "Perplexity AI",
      "Zendesk AI"
    ],
    "domainSkills": [
      "Client Servicing Principles",
      "Customer Service Principles",
      "Account Management Principles",
      "Customer Relationship Management Strategy",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF22-007",
    "roleName": "Technical Support Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Technical Support",
      "Technical Troubleshooting",
      "Remote Troubleshooting",
      "Product Technical Knowledge",
      "Support Ticket Management"
    ],
    "aiToolSkills": [
      "Zendesk AI",
      "ChatGPT",
      "Zapier",
      "Conversational AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Technical Support Methodology",
      "End-User Support Principles",
      "Customer Experience Design",
      "Service Quality and SLA Management",
      "Customer Support Operations"
    ]
  },
  {
    "roleId": "JF22-008",
    "roleName": "Customer Relationship Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Relationship Management Execution",
      "Customer Service",
      "Proactive Customer Outreach",
      "CRM Software",
      "Customer Satisfaction Monitoring"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Zapier",
      "Zendesk AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Customer Relationship Management Concepts",
      "Customer Service Principles",
      "Customer Success Methodology",
      "Customer Relationship Management Strategy",
      "Service Quality and SLA Management"
    ]
  },
  {
    "roleId": "JF22-009",
    "roleName": "Contact Centre Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Contact Centre Operations",
      "Inbound Call Handling",
      "Customer Support",
      "Outbound Call Management",
      "Call Quality Monitoring"
    ],
    "aiToolSkills": [
      "Conversational AI",
      "Zendesk AI",
      "ChatGPT",
      "Perplexity AI",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Account Management Principles",
      "Customer Service Principles",
      "Service Quality and SLA Management",
      "Customer Relationship Management Strategy",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF22-010",
    "roleName": "Customer Experience Analyst",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Experience Analysis",
      "Experience Mapping",
      "Customer Insights Analysis",
      "CX Metrics Reporting",
      "Pain Point Identification"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Salesforce Einstein",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Customer Experience Design",
      "Text Analytics for Customer Insights",
      "Customer Insights and Research",
      "Voice of Customer Methodology",
      "Troubleshooting Methodology"
    ]
  },
  {
    "roleId": "JF22-011",
    "roleName": "Customer Onboarding Specialist",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Onboarding",
      "Onboarding Programme Design",
      "Product Training Delivery",
      "Onboarding Management",
      "Time-to-Value Optimization"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Zapier",
      "Zendesk AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Customer Onboarding Methodology",
      "Customer Education and Enablement",
      "Customer Success Principles",
      "Customer Success Methodology",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF22-012",
    "roleName": "Customer Feedback Analyst",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Feedback Management",
      "Customer Feedback Analysis",
      "Survey Design and Analysis",
      "Text Analytics",
      "Feedback Loop Implementation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Zapier",
      "Salesforce Einstein",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Customer Experience Design",
      "Text Analytics for Customer Insights",
      "Voice of Customer Methodology",
      "Troubleshooting Methodology",
      "Customer Insights and Research"
    ]
  },
  {
    "roleId": "JF22-013",
    "roleName": "Customer Retention Executive",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Customer Retention",
      "Churn Prevention",
      "Win-Back Campaigns",
      "Renewal Tracking",
      "Loyalty Programme Execution"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Perplexity AI",
      "Conversational AI",
      "Zendesk AI"
    ],
    "domainSkills": [
      "Customer Retention Methodology",
      "Churn Analysis and Prevention",
      "Customer Success Methodology",
      "Customer Segmentation and Targeting",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF22-014",
    "roleName": "Helpdesk Analyst",
    "jobFamily": "Customer Success & Support",
    "technicalSkills": [
      "Helpdesk Analysis",
      "Help Desk Management",
      "Incident Tracking",
      "Knowledge Base Management",
      "SLA Compliance Monitoring"
    ],
    "aiToolSkills": [
      "Zendesk AI",
      "ChatGPT",
      "Zapier",
      "Conversational AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Helpdesk Operations",
      "IT Incident Classification",
      "End-User Support Principles",
      "Service Quality and SLA Management",
      "Customer Experience Design"
    ]
  },
  {
    "roleId": "JF23-001",
    "roleName": "HR Executive",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Human Resources",
      "HR Operations",
      "Employee Records Management",
      "Payroll Processing",
      "HR Compliance"
    ],
    "aiToolSkills": [
      "AI Recruiting",
      "ChatGPT",
      "Power BI Copilot",
      "Fireflies.ai",
      "Eightfold AI"
    ],
    "domainSkills": [
      "Human Resource Management Principles",
      "HR Policy and Compliance",
      "Payroll Compliance and Processing",
      "Talent Acquisition Methodology",
      "Employee Relations Principles"
    ]
  },
  {
    "roleId": "JF23-002",
    "roleName": "HR Manager",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "HR Management",
      "HR Strategy",
      "Workforce Planning",
      "HR Policy Development",
      "Human Resources"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Recruiting",
      "Fireflies.ai",
      "Eightfold AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Human Resource Management Principles",
      "HR Policy and Compliance",
      "Disciplinary and Grievance Procedures",
      "Employee Relations Principles",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF23-003",
    "roleName": "HR Business Partner (HRBP)",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "HR Business Partnering",
      "HR Strategy",
      "Organisational Development",
      "People Analytics",
      "Change Management in HR"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Fireflies.ai",
      "Eightfold AI",
      "AI Recruiting"
    ],
    "domainSkills": [
      "Data Visualization Principles",
      "Organisational Diagnosis",
      "Human Resource Management Principles",
      "Data Storytelling",
      "Dashboard and Report Design Principles"
    ]
  },
  {
    "roleId": "JF23-004",
    "roleName": "Recruiter - Non-Tech",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Recruitment",
      "Sourcing",
      "Interview Coordination",
      "ATS Management",
      "Offer Management"
    ],
    "aiToolSkills": [
      "AI Recruiting",
      "ChatGPT",
      "Power BI Copilot",
      "Eightfold AI",
      "Paradox (Olivia)"
    ],
    "domainSkills": [
      "Talent Acquisition Methodology",
      "Sourcing and Headhunting",
      "Candidate Assessment and Selection",
      "Interview Design and Assessment",
      "Human Resource Management Principles"
    ]
  },
  {
    "roleId": "JF23-005",
    "roleName": "Technical Recruiter",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Technical Recruitment",
      "Boolean Search",
      "LinkedIn Recruiter",
      "Tech Stack Assessment",
      "ATS Management"
    ],
    "aiToolSkills": [
      "AI Recruiting",
      "ChatGPT",
      "Power BI Copilot",
      "Eightfold AI",
      "Paradox (Olivia)"
    ],
    "domainSkills": [
      "Technical Recruiting",
      "Talent Acquisition Methodology",
      "Sourcing and Headhunting",
      "Candidate Assessment and Selection",
      "Interview Design and Assessment"
    ]
  },
  {
    "roleId": "JF23-006",
    "roleName": "Talent Acquisition Specialist",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Talent Acquisition",
      "Employer Branding",
      "Talent Pipeline Building",
      "ATS Management",
      "LinkedIn Recruiter"
    ],
    "aiToolSkills": [
      "AI Recruiting",
      "ChatGPT",
      "Power BI Copilot",
      "Eightfold AI",
      "Paradox (Olivia)"
    ],
    "domainSkills": [
      "Talent Acquisition Methodology",
      "Sourcing and Headhunting",
      "Candidate Assessment and Selection",
      "Human Resource Management Principles",
      "Interview Design and Assessment"
    ]
  },
  {
    "roleId": "JF23-007",
    "roleName": "Headhunter - Executive Search",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Executive Search",
      "C-Suite Headhunting",
      "Candidate Assessment",
      "Search Research",
      "Boolean Search"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Recruiting",
      "Power BI Copilot",
      "Fireflies.ai",
      "Eightfold AI"
    ],
    "domainSkills": [
      "Executive Search Methodology",
      "Sourcing and Headhunting",
      "Interview Design and Assessment",
      "Data Visualization Principles",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF23-008",
    "roleName": "Campus Recruiter",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Campus Recruitment",
      "College Relationship Management",
      "Pre-Placement Talk",
      "ATS Management",
      "Internship Programme Management"
    ],
    "aiToolSkills": [
      "AI Recruiting",
      "ChatGPT",
      "Power BI Copilot",
      "Eightfold AI",
      "Paradox (Olivia)"
    ],
    "domainSkills": [
      "Campus Recruiting",
      "Talent Acquisition Methodology",
      "Sourcing and Headhunting",
      "Candidate Assessment and Selection",
      "Interview Design and Assessment"
    ]
  },
  {
    "roleId": "JF23-009",
    "roleName": "RPO Recruiter",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "RPO Recruitment",
      "Volume Hiring",
      "SLA-Based Recruiting",
      "ATS Management",
      "Recruitment Process Management"
    ],
    "aiToolSkills": [
      "AI Recruiting",
      "ChatGPT",
      "Power BI Copilot",
      "Eightfold AI",
      "Paradox (Olivia)"
    ],
    "domainSkills": [
      "RPO Operations",
      "Talent Acquisition Methodology",
      "Sourcing and Headhunting",
      "Service Quality and SLA Management",
      "Candidate Assessment and Selection"
    ]
  },
  {
    "roleId": "JF23-010",
    "roleName": "L&D Manager",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Learning and Development Management",
      "Training Needs Analysis",
      "L&D Strategy",
      "Learning Management System",
      "Workforce Planning"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "HeyGen",
      "Synthesia",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Learning and Development Strategy",
      "Data Visualization Principles",
      "Training Delivery and Facilitation",
      "Data Storytelling",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF23-011",
    "roleName": "Training Coordinator",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Training Coordination",
      "Training Scheduling",
      "Learning Management System",
      "Trainer Liaison",
      "Training Effectiveness Tracking"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "Power BI Copilot",
      "HeyGen",
      "Synthesia"
    ],
    "domainSkills": [
      "Training Delivery and Facilitation",
      "Learning Experience Design",
      "Human Resource Management Principles",
      "Instructional Design Principles",
      "Learning and Development Strategy"
    ]
  },
  {
    "roleId": "JF23-012",
    "roleName": "Instructional Designer",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Instructional Design",
      "eLearning Development",
      "Articulate Storyline",
      "ADDIE Model",
      "Storyboard Development"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "Power BI Copilot",
      "HeyGen",
      "Synthesia"
    ],
    "domainSkills": [
      "Instructional Design Principles",
      "Learning Experience Design",
      "Adult Learning Theory",
      "Learning and Development Strategy",
      "Training Delivery and Facilitation"
    ]
  },
  {
    "roleId": "JF23-013",
    "roleName": "Leadership Development Specialist",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Leadership Development",
      "Executive Coaching",
      "Succession Planning",
      "High Potential Programme Management",
      "Organisational Development"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Learning Management System",
      "Power BI Copilot",
      "HeyGen",
      "Synthesia"
    ],
    "domainSkills": [
      "Leadership Development Principles",
      "Coaching and Mentoring",
      "Learning and Development Strategy",
      "Adult Learning Theory",
      "Organisational Diagnosis"
    ]
  },
  {
    "roleId": "JF23-014",
    "roleName": "Compensation & Benefits Manager",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Compensation and Benefits Management",
      "Compensation Benchmarking",
      "Benefits Administration",
      "Job Evaluation",
      "Total Rewards Strategy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Fireflies.ai",
      "Eightfold AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Compensation and Benefits Strategy",
      "Job Evaluation and Grading",
      "Salary Benchmarking and Market Pricing",
      "Variable Pay and Incentive Design",
      "Labour Law and Employment Legislation"
    ]
  },
  {
    "roleId": "JF23-015",
    "roleName": "Payroll Specialist",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Payroll Administration",
      "Payroll Processing",
      "Payroll Software",
      "Tax Deductions at Source",
      "Payroll Reconciliation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Fireflies.ai",
      "Power BI Copilot",
      "Eightfold AI"
    ],
    "domainSkills": [
      "Payroll Management Principles",
      "Payroll Legislation and Statutory Compliance",
      "Payroll Compliance and Processing",
      "Labour Law and Employment Legislation",
      "Total Rewards Framework"
    ]
  },
  {
    "roleId": "JF23-016",
    "roleName": "Rewards Analyst",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Rewards Analysis",
      "Salary Benchmarking",
      "Compensation Benchmarking",
      "Incentive Programme Design",
      "Market Pay Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Fireflies.ai",
      "Microsoft Copilot for Finance",
      "Eightfold AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Total Rewards Framework",
      "Salary Benchmarking and Market Pricing",
      "Benefits Programme Design",
      "Variable Pay and Incentive Design",
      "Job Evaluation and Grading"
    ]
  },
  {
    "roleId": "JF23-017",
    "roleName": "Employee Relations Manager",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Employee Relations",
      "Grievance Management",
      "Disciplinary Procedures",
      "Labour Law",
      "Workplace Investigations"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Fireflies.ai",
      "Eightfold AI",
      "AI Recruiting"
    ],
    "domainSkills": [
      "Employee Relations Principles",
      "Labour Law and Employment Legislation",
      "Disciplinary and Grievance Procedures",
      "Collective Bargaining and Industrial Relations",
      "Industrial Relations Management"
    ]
  },
  {
    "roleId": "JF23-018",
    "roleName": "Industrial Relations Officer",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Industrial Relations",
      "Union Negotiation",
      "Collective Bargaining",
      "Labour Law",
      "Labour Dispute Resolution"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Fireflies.ai",
      "Eightfold AI",
      "AI Recruiting"
    ],
    "domainSkills": [
      "Industrial Relations Management",
      "Labour Law and Employment Legislation",
      "Collective Bargaining and Industrial Relations",
      "Disciplinary and Grievance Procedures",
      "Employee Relations Principles"
    ]
  },
  {
    "roleId": "JF23-019",
    "roleName": "POSH Compliance Officer",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "POSH Compliance",
      "Internal Committee Management",
      "POSH Investigation",
      "Labour Law",
      "Workplace Sensitisation Training"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Fireflies.ai",
      "Eightfold AI",
      "AI Recruiting"
    ],
    "domainSkills": [
      "Prevention of Sexual Harassment (POSH) Compliance",
      "Internal Complaints Committee Procedures",
      "HR Policy and Compliance",
      "Labour Law and Employment Legislation",
      "Labour Law Advisory and Compliance"
    ]
  },
  {
    "roleId": "JF23-020",
    "roleName": "HR Analyst",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "HR Analytics",
      "HR Metrics Reporting",
      "HRIS Reporting",
      "SQL",
      "Attrition Analysis"
    ],
    "aiToolSkills": [
      "People Analytics AI",
      "ChatGPT",
      "Fireflies.ai",
      "Power BI Copilot",
      "Eightfold AI"
    ],
    "domainSkills": [
      "HR Analytics Principles",
      "HR Metrics and Reporting",
      "Data Storytelling",
      "Data Visualization Principles",
      "Human Resource Management Principles"
    ]
  },
  {
    "roleId": "JF23-021",
    "roleName": "Workforce Planning Analyst",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "Workforce Analytics",
      "Workforce Planning",
      "Headcount Planning",
      "Capacity Planning",
      "Workforce Forecasting"
    ],
    "aiToolSkills": [
      "People Analytics AI",
      "ChatGPT",
      "Fireflies.ai",
      "Eightfold AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Data Visualization Principles",
      "Dashboard and Report Design Principles",
      "Reporting Design Principles",
      "HR Analytics Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF23-022",
    "roleName": "People Analytics Manager",
    "jobFamily": "Human Resources",
    "technicalSkills": [
      "People Analytics Management",
      "Python",
      "Predictive HR Analytics",
      "HR Data Visualisation",
      "Analytics Strategy"
    ],
    "aiToolSkills": [
      "People Analytics AI",
      "Claude",
      "Fireflies.ai",
      "Eightfold AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "People Analytics Strategy",
      "Predictive Workforce Modelling",
      "Data Visualization Principles",
      "Data Storytelling",
      "Dashboard and Report Design Principles"
    ]
  },
  {
    "roleId": "JF24-001",
    "roleName": "Advocate - District Court",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Litigation",
      "Legal Drafting",
      "Court Procedure",
      "Legal Research",
      "Case Management"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Legal Practice and Procedure",
      "Civil Procedure and Litigation",
      "Governance, Risk, and Compliance (GRC)",
      "Criminal Law and Procedure",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF24-002",
    "roleName": "Advocate - High Court",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "High Court Litigation",
      "Writ Petition Drafting",
      "Appellate Advocacy",
      "Constitutional Law",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Legal Practice and Procedure",
      "Governance, Risk, and Compliance (GRC)",
      "Civil Procedure and Litigation",
      "Information Security Policies and Standards",
      "Criminal Law and Procedure"
    ]
  },
  {
    "roleId": "JF24-003",
    "roleName": "Advocate - Supreme Court",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Supreme Court Practice",
      "Special Leave Petition",
      "Constitutional Litigation",
      "Appellate Advocacy",
      "Legal Precedent Analysis"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Legal Practice and Procedure",
      "Information Security Policies and Standards",
      "Civil Procedure and Litigation",
      "Criminal Law and Procedure"
    ]
  },
  {
    "roleId": "JF24-004",
    "roleName": "Senior Advocate",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Senior Advocacy",
      "Oral Argument",
      "Complex Litigation Strategy",
      "Legal Opinion",
      "Legal Precedent Analysis"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Legal Practice and Procedure",
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Civil Procedure and Litigation",
      "Criminal Law and Procedure"
    ]
  },
  {
    "roleId": "JF24-005",
    "roleName": "Criminal Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Criminal Law",
      "Criminal Defence",
      "Cross-Examination",
      "Evidence Law",
      "Bail Application"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Criminal Law and Procedure",
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Legal Practice and Procedure",
      "Civil Procedure and Litigation"
    ]
  },
  {
    "roleId": "JF24-006",
    "roleName": "Civil Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Civil Law",
      "Civil Litigation",
      "Suit Drafting",
      "Property Law",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Civil Procedure and Litigation",
      "Governance, Risk, and Compliance (GRC)",
      "Legal Practice and Procedure",
      "Contract Law and Drafting",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF24-007",
    "roleName": "Family Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Family Law",
      "Matrimonial Disputes",
      "Child Custody",
      "Mediation",
      "Legal Drafting"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Civil Procedure and Litigation",
      "Information Security Policies and Standards",
      "Legal Practice and Procedure",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF24-008",
    "roleName": "Company Secretary (CS)",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Company Secretarial Practice",
      "Corporate Governance",
      "Companies Act Compliance",
      "Board Meeting Management",
      "ROC Filings"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Ironclad",
      "Spellbook"
    ],
    "domainSkills": [
      "Company Law and Secretarial Practice",
      "Corporate Law and Company Regulations",
      "Securities Law and SEBI Regulations",
      "Corporate Governance and Board Advisory",
      "Compliance Frameworks"
    ]
  },
  {
    "roleId": "JF24-009",
    "roleName": "Legal Counsel",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Legal Advisory",
      "Contract Review",
      "Regulatory Compliance",
      "Risk Advisory",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Corporate Legal Counsel Principles",
      "Contract Law and Drafting",
      "Legal Risk Assessment",
      "Governance, Risk, and Compliance (GRC)",
      "Banking Products and Services"
    ]
  },
  {
    "roleId": "JF24-010",
    "roleName": "Corporate Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Corporate Law",
      "Commercial Contracts",
      "Corporate Transactions",
      "Due Diligence - Legal",
      "Corporate Governance"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Ironclad",
      "Spellbook"
    ],
    "domainSkills": [
      "Corporate Law and Company Regulations",
      "Contract Law and Drafting",
      "Company Law and Secretarial Practice",
      "Corporate Finance Principles",
      "Securities Law and SEBI Regulations"
    ]
  },
  {
    "roleId": "JF24-011",
    "roleName": "Contract Manager",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Contract Management",
      "Contract Drafting",
      "Contract Negotiation - Legal",
      "Contract Review",
      "Contract Lifecycle Management"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Ironclad",
      "Spellbook"
    ],
    "domainSkills": [
      "Contract Law and Drafting",
      "Governance, Risk, and Compliance (GRC)",
      "Legal Risk Assessment",
      "Information Security Policies and Standards",
      "Risk Assessment Methodology"
    ]
  },
  {
    "roleId": "JF24-012",
    "roleName": "Compliance Manager",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Compliance Programme Management",
      "Regulatory Affairs (Legal)",
      "Regulatory Compliance",
      "Compliance Auditing",
      "Policy Implementation"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Ironclad",
      "Spellbook"
    ],
    "domainSkills": [
      "Regulatory Compliance Management",
      "Banking Products and Services",
      "Compliance Frameworks",
      "Legal Risk Assessment",
      "Governance, Risk, and Compliance (GRC)"
    ]
  },
  {
    "roleId": "JF24-013",
    "roleName": "In-house Counsel",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "In-house Legal Practice",
      "Business Legal Support",
      "Contract Review",
      "Litigation Management",
      "Legal Risk Management"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Corporate Legal Counsel Principles",
      "Contract Law and Drafting",
      "Legal Risk Assessment",
      "HR Policy and Compliance",
      "Governance, Risk, and Compliance (GRC)"
    ]
  },
  {
    "roleId": "JF24-014",
    "roleName": "M&A Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Mergers and Acquisitions Law",
      "Transaction Structuring",
      "M&A Due Diligence",
      "Share Purchase Agreement",
      "Due Diligence - Legal"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "M&A Legal Due Diligence",
      "Transaction Structuring and Closing",
      "Mergers and Acquisitions Methodology",
      "Contract Law and Drafting",
      "Corporate Law and Company Regulations"
    ]
  },
  {
    "roleId": "JF24-015",
    "roleName": "Arbitrator",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Arbitration",
      "Alternative Dispute Resolution",
      "Arbitration Procedure",
      "Arbitral Award Writing",
      "Legal Opinion"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Arbitration Law and Practice",
      "Dispute Resolution Methodology",
      "Corporate Law and Company Regulations",
      "Contract Law and Drafting",
      "Civil Procedure and Litigation"
    ]
  },
  {
    "roleId": "JF24-016",
    "roleName": "Mediator",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Mediation Practice",
      "Alternative Dispute Resolution",
      "Conflict Resolution",
      "Negotiation Facilitation",
      "Mediation Agreement Drafting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI",
      "AI Legal Research"
    ],
    "domainSkills": [
      "Mediation Principles and Practice",
      "Alternative Dispute Resolution (ADR) Framework",
      "Dispute Resolution Methodology",
      "Corporate Law and Company Regulations",
      "Civil Procedure and Litigation"
    ]
  },
  {
    "roleId": "JF24-017",
    "roleName": "Conciliator",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Conciliation",
      "Alternative Dispute Resolution",
      "Industrial Conciliation",
      "Conflict Resolution",
      "Settlement Facilitation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI",
      "AI Legal Research"
    ],
    "domainSkills": [
      "Conciliation Methodology",
      "Alternative Dispute Resolution (ADR) Framework",
      "Dispute Resolution Methodology",
      "Labour Law and Employment Legislation",
      "Arbitration Law and Practice"
    ]
  },
  {
    "roleId": "JF24-018",
    "roleName": "Patent Attorney",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Patent Law",
      "Patent Drafting",
      "Patent Prosecution",
      "Prior Art Search",
      "Patent Portfolio Management"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Patent Law and Prosecution",
      "Patent Drafting and Claims",
      "Legal Practice and Procedure",
      "IP Portfolio Management",
      "Copyright Registration and Enforcement"
    ]
  },
  {
    "roleId": "JF24-019",
    "roleName": "Trademark Analyst",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Trademark Analysis",
      "Trademark Search",
      "Trademark Registration",
      "Trademark Watch",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Trademark Law and Practice",
      "Trademark Prosecution and Portfolio Management",
      "IP Portfolio Management",
      "Legal Practice and Procedure",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF24-020",
    "roleName": "IP Paralegal",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "IP Paralegal Support",
      "IP Docketing",
      "IP Filing Administration",
      "IP Deadlines Management",
      "Case Management"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "IP Paralegal Practice",
      "IP Portfolio Management",
      "Patent Law and Prosecution",
      "Trademark Law and Practice",
      "Patent Drafting and Claims"
    ]
  },
  {
    "roleId": "JF24-021",
    "roleName": "Copyright Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Copyright Law",
      "Copyright Registration",
      "Copyright Infringement Analysis",
      "Content Licensing",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Copyright Registration and Enforcement",
      "Legal Practice and Procedure",
      "Trademark Law and Practice",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF24-022",
    "roleName": "Tax Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Tax Law",
      "Direct Tax Litigation",
      "Tax Planning and Advisory",
      "Income Tax Act",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Tax Law Principles",
      "Tax Litigation and Appeals",
      "Direct Taxation Principles",
      "GST and Indirect Tax Law",
      "Tax Filing and Compliance Procedures"
    ]
  },
  {
    "roleId": "JF24-023",
    "roleName": "GST Litigation Specialist",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "GST Law",
      "GST Litigation",
      "GST Appeal Drafting",
      "GST Audit Defence",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "GST Litigation and Dispute Resolution",
      "Indirect Tax Law",
      "GST and Indirect Tax Law",
      "Legal Practice and Procedure",
      "Tax Litigation and Appeals"
    ]
  },
  {
    "roleId": "JF24-024",
    "roleName": "Labour Law Consultant",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Labour Law Consulting",
      "Labour Law",
      "Employment Contract Advisory",
      "Statutory Compliance Advisory",
      "Retrenchment and VRS Advisory"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Labour Law Advisory and Compliance",
      "Labour Law and Employment Legislation",
      "HR Policy and Compliance",
      "Disciplinary and Grievance Procedures",
      "Industrial Relations Management"
    ]
  },
  {
    "roleId": "JF24-025",
    "roleName": "Industrial Relations Advisor",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Industrial Relations Advisory",
      "Industrial Relations",
      "Trade Union Law",
      "Standing Orders",
      "Labour Tribunal Representation"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Industrial Dispute Advisory",
      "Industrial Relations Management",
      "Collective Bargaining and Industrial Relations",
      "Labour Law and Employment Legislation",
      "Labour Law Advisory and Compliance"
    ]
  },
  {
    "roleId": "JF24-026",
    "roleName": "Property Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Property Law Practice",
      "Title Verification",
      "Sale Deed Drafting",
      "Property Law",
      "Land Acquisition Law"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Property Law Principles",
      "Transfer of Property Act and Conveyancing",
      "Civil Procedure and Litigation",
      "Corporate Law and Company Regulations",
      "Contract Law and Drafting"
    ]
  },
  {
    "roleId": "JF24-027",
    "roleName": "RERA Consultant",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "RERA Compliance",
      "Real Estate Regulatory Advisory",
      "RERA Project Registration",
      "Homebuyer Dispute Advisory",
      "Property Law Practice"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "RERA Compliance and Advisory",
      "Real Estate Regulatory Framework",
      "Property Law Principles",
      "Legal Practice and Procedure",
      "Transfer of Property Act and Conveyancing"
    ]
  },
  {
    "roleId": "JF24-028",
    "roleName": "Environmental Lawyer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Environmental Law",
      "Environmental Compliance",
      "NGT Practice",
      "Environmental Clearance Advisory",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Environmental Law and Regulations",
      "Environmental Compliance and Litigation",
      "Governance, Risk, and Compliance (GRC)",
      "Legal Practice and Procedure",
      "Compliance Frameworks"
    ]
  },
  {
    "roleId": "JF24-029",
    "roleName": "Cyber Law Attorney",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Cyber Law",
      "IT Act Advisory",
      "Data Protection Law",
      "Cybercrime Litigation",
      "Legal Research"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Cyber Law and IT Act",
      "Data Privacy and Digital Rights Law",
      "Criminal Law and Procedure",
      "Legal Practice and Procedure",
      "Data Wrangling and Cleaning"
    ]
  },
  {
    "roleId": "JF24-030",
    "roleName": "Civil Judge",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Judicial Decision Making",
      "Judgment Writing",
      "Evidence Evaluation",
      "Case Adjudication",
      "Court Procedure"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Judicial Decision-Making Principles",
      "Civil Procedure and Litigation",
      "Corporate Law and Company Regulations",
      "Judicial Inquiry and Fact-Finding",
      "Contract Law and Drafting"
    ]
  },
  {
    "roleId": "JF24-031",
    "roleName": "Public Prosecutor",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Public Prosecution",
      "Criminal Law",
      "Charge Sheet Analysis",
      "Prosecution Witness Management",
      "Sentencing Advocacy"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Everlaw",
      "Thomson Reuters CoCounsel"
    ],
    "domainSkills": [
      "Prosecution Law and Practice",
      "Criminal Law and Procedure",
      "Criminal Investigation and Evidence Management",
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF24-032",
    "roleName": "Law Officer",
    "jobFamily": "Legal Practice & Corporate Law",
    "technicalSkills": [
      "Government Legal Advisory",
      "Legislative Drafting",
      "Departmental Inquiry",
      "Statutory Interpretation",
      "Litigation"
    ],
    "aiToolSkills": [
      "AI Legal Research",
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Thomson Reuters CoCounsel",
      "Harvey AI"
    ],
    "domainSkills": [
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Legal Practice and Procedure",
      "Risk Assessment Methodology",
      "Civil Procedure and Litigation"
    ]
  },
  {
    "roleId": "JF25-001",
    "roleName": "Supply Chain Manager",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Supply Chain Management",
      "Supply Chain Planning",
      "Logistics Management",
      "Inventory Management",
      "Supply Chain Analytics"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Supply Chain Management Principles",
      "Supply Chain Strategy and Design",
      "Procurement Management Principles",
      "Supplier Risk Assessment",
      "Global Sourcing Principles"
    ]
  },
  {
    "roleId": "JF25-002",
    "roleName": "Procurement Manager",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Procurement Management",
      "Strategic Sourcing",
      "Supplier Relationship Management",
      "Category Management - Procurement",
      "Spend Analysis"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Procurement Management Principles",
      "Vendor and Third-Party Management",
      "Procurement Negotiation",
      "Vendor Management Principles",
      "Legal Risk Assessment"
    ]
  },
  {
    "roleId": "JF25-003",
    "roleName": "Vendor Manager",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Vendor Management",
      "Vendor Evaluation",
      "Supplier Relationship Management",
      "Vendor Performance Management",
      "Contract Governance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Supply Chain",
      "Power BI Copilot",
      "Julius AI",
      "Zapier"
    ],
    "domainSkills": [
      "Vendor Management Principles",
      "Supplier Performance Management",
      "Supplier Risk Assessment",
      "Procurement Negotiation",
      "Procurement Management Principles"
    ]
  },
  {
    "roleId": "JF25-004",
    "roleName": "Inventory Manager",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Inventory Management",
      "Inventory Control",
      "Stock Optimisation",
      "ABC Analysis",
      "Dead Stock Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "Claude",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Inventory Management Principles",
      "Inventory Optimisation Concepts",
      "Demand Planning Methodology",
      "Supply Chain Management Principles",
      "Sales and Operations Planning (S&OP)"
    ]
  },
  {
    "roleId": "JF25-005",
    "roleName": "Demand Planner",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Demand Planning",
      "Sales Forecasting - Ops",
      "Statistical Forecasting",
      "Demand Sensing",
      "Forecast Accuracy Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "Claude",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Demand Planning Methodology",
      "Forecasting Methods and Models",
      "Sales and Operations Planning (S&OP)",
      "Inventory Management Principles",
      "Inventory Optimisation Concepts"
    ]
  },
  {
    "roleId": "JF25-006",
    "roleName": "Category Buyer",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Category Buying",
      "Strategic Sourcing",
      "RFQ Management",
      "Supplier Benchmarking",
      "Purchase Negotiation"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Category Buying Principles",
      "Procurement Management Principles",
      "Procurement Negotiation",
      "Category Management Principles",
      "Vendor Management Principles"
    ]
  },
  {
    "roleId": "JF25-007",
    "roleName": "Global Sourcing Manager",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Global Sourcing",
      "Strategic Sourcing",
      "Cross-Border Procurement",
      "International Supplier Management",
      "Trade Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Supply Chain",
      "Power BI Copilot",
      "Julius AI",
      "Zapier"
    ],
    "domainSkills": [
      "Global Sourcing Principles",
      "International Procurement Concepts",
      "Customs and Trade Compliance",
      "Import and Export Regulations",
      "Supplier Risk Assessment"
    ]
  },
  {
    "roleId": "JF25-008",
    "roleName": "Supply Chain Analyst",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Supply Chain Analysis",
      "Supply Chain Analytics",
      "KPI Dashboard Management",
      "Supply Chain Modelling",
      "Root Cause Analysis - Ops"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "Claude",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Category Management Principles",
      "Supply Chain Management Principles",
      "Forecasting Methods and Models",
      "Inventory Management Principles",
      "Export Documentation and Compliance"
    ]
  },
  {
    "roleId": "JF25-009",
    "roleName": "Procurement Executive",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Procurement Execution",
      "Purchase Order Processing",
      "Procurement Management",
      "Vendor Invoice Management",
      "Three-Way Matching"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Zapier"
    ],
    "domainSkills": [
      "Procurement Operations",
      "Procurement Management Principles",
      "Vendor and Third-Party Management",
      "Vendor Management Principles",
      "Procurement Negotiation"
    ]
  },
  {
    "roleId": "JF25-010",
    "roleName": "Purchase Executive",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Purchasing",
      "Indent Management",
      "Material Requisition",
      "Purchase Order Processing",
      "GRN Processing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Supply Chain",
      "Power BI Copilot",
      "Julius AI",
      "Zapier"
    ],
    "domainSkills": [
      "Inventory Optimisation Concepts",
      "Procurement Operations",
      "Inventory Management Principles",
      "Vendor Management Principles",
      "Procurement Management Principles"
    ]
  },
  {
    "roleId": "JF25-011",
    "roleName": "Logistics Coordinator",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Logistics Coordination",
      "Shipment Tracking",
      "Carrier Management",
      "Logistics Management",
      "Freight Documentation"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Zapier"
    ],
    "domainSkills": [
      "Logistics Coordination Principles",
      "Logistics Management Principles",
      "Order Fulfilment and Logistics",
      "EXIM Documentation and Procedures",
      "Import and Export Regulations"
    ]
  },
  {
    "roleId": "JF25-012",
    "roleName": "Import-Export Executive",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Import-Export Management",
      "Customs Clearance",
      "Export Documentation",
      "EXIM Compliance",
      "Incoterms"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot",
      "AI Supply Chain",
      "Zapier"
    ],
    "domainSkills": [
      "EXIM Documentation and Procedures",
      "Import and Export Regulations",
      "Customs and Trade Compliance",
      "Logistics Coordination Principles",
      "Export Documentation and Compliance"
    ]
  },
  {
    "roleId": "JF25-013",
    "roleName": "Strategic Sourcing Analyst",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Strategic Sourcing Analysis",
      "Spend Analysis",
      "Market Intelligence - Procurement",
      "TCO Analysis",
      "Sourcing Strategy Development"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Category Management Principles",
      "Export Documentation and Compliance",
      "Category Buying Principles",
      "Supplier Risk Assessment",
      "Procurement Negotiation"
    ]
  },
  {
    "roleId": "JF25-014",
    "roleName": "Supplier Relations Executive",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Supplier Relations",
      "Supplier Relationship Management",
      "Supplier Onboarding",
      "Supplier Development",
      "Supplier Risk Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Supply Chain",
      "Power BI Copilot",
      "Julius AI",
      "Zapier"
    ],
    "domainSkills": [
      "Vendor Management Principles",
      "Supplier Performance Management",
      "Supplier Risk Assessment",
      "Procurement Negotiation",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF25-015",
    "roleName": "Materials Planner",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Materials Planning",
      "MRP",
      "Bill of Materials Management",
      "Inventory Management",
      "Material Availability Planning"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "Claude",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Materials Management Principles",
      "Materials Requirements Planning (MRP) Concepts",
      "Demand Planning Methodology",
      "Inventory Management Principles",
      "Sales and Operations Planning (S&OP)"
    ]
  },
  {
    "roleId": "JF25-016",
    "roleName": "S&OP Analyst",
    "jobFamily": "Supply Chain & Procurement",
    "technicalSkills": [
      "Sales and Operations Planning",
      "S&OP Process Management",
      "Demand Planning",
      "Integrated Business Planning",
      "Cross-functional S&OP Coordination"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "Claude",
      "Julius AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Sales and Operations Planning (S&OP)",
      "Category Management Principles",
      "Demand Planning Methodology",
      "Export Documentation and Compliance",
      "Inventory Management Principles"
    ]
  },
  {
    "roleId": "JF26-001",
    "roleName": "Logistics Manager",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Logistics Operations Management",
      "Logistics Management",
      "Transportation Management",
      "Freight Cost Management",
      "3PL Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Notion AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Logistics Management Principles",
      "Transportation and Distribution Concepts",
      "Supply Chain Management Principles",
      "Warehouse Management Principles",
      "Customs and Trade Compliance"
    ]
  },
  {
    "roleId": "JF26-002",
    "roleName": "Warehouse Manager",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Warehouse Management",
      "Warehouse Operations",
      "Warehouse Management System",
      "Inventory Management",
      "Picking and Packing"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Warehouse Management Principles",
      "Warehouse Operations and Layout Design",
      "Inventory Management Principles",
      "Order Fulfilment and Logistics",
      "Last Mile Delivery Concepts"
    ]
  },
  {
    "roleId": "JF26-003",
    "roleName": "Freight & Shipping Manager",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Freight Management",
      "Shipping Operations",
      "Ocean Freight",
      "Air Freight",
      "Freight Rate Negotiation"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Freight Management Principles",
      "Shipping and Ocean Freight Concepts",
      "Multimodal Logistics Concepts",
      "Customs and Trade Compliance",
      "Import and Export Regulations"
    ]
  },
  {
    "roleId": "JF26-004",
    "roleName": "Fleet Manager",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Fleet Management",
      "Vehicle Maintenance Management",
      "Driver Management",
      "Fleet GPS Tracking",
      "Transportation Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Notion AI",
      "Power BI Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Fleet Management Principles",
      "Vehicle Routing and Scheduling",
      "Transportation and Distribution Concepts",
      "Last Mile Delivery Concepts",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF26-005",
    "roleName": "Last Mile Delivery Manager",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Last Mile Delivery Management",
      "Delivery Route Optimisation",
      "Delivery Partner Management",
      "On-Time Delivery Management",
      "Logistics Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Last Mile Delivery Concepts",
      "Delivery Operations Management",
      "Vehicle Routing and Scheduling",
      "Transportation and Distribution Concepts",
      "Digital Customer Experience"
    ]
  },
  {
    "roleId": "JF26-006",
    "roleName": "Customs & Exim Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Customs Management",
      "Customs Clearance",
      "HS Code Classification",
      "DGFT Compliance",
      "Duty Drawback"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Notion AI",
      "Power BI Copilot",
      "AI Supply Chain",
      "Zapier"
    ],
    "domainSkills": [
      "Customs and Trade Compliance",
      "Import and Export Regulations",
      "EXIM Documentation and Procedures",
      "Logistics Coordination Principles",
      "Export Documentation and Compliance"
    ]
  },
  {
    "roleId": "JF26-007",
    "roleName": "3PL Coordinator",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "3PL Coordination",
      "Third-Party Logistics Operations",
      "3PL Management",
      "SLA Monitoring - Logistics",
      "Logistics Partner Performance"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Third-Party Logistics (3PL) Management",
      "Logistics Coordination Principles",
      "Logistics Management Principles",
      "Freight Forwarding Concepts",
      "Customs and Trade Compliance"
    ]
  },
  {
    "roleId": "JF26-008",
    "roleName": "Warehouse Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Warehouse Operations Execution",
      "Warehouse Management System",
      "Goods Receipt",
      "Putaway Management",
      "Dispatch Operations"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Warehouse Executive Operations",
      "Warehouse Management Principles",
      "Warehouse Operations and Layout Design",
      "Inventory Management Principles",
      "Order Fulfilment and Logistics"
    ]
  },
  {
    "roleId": "JF26-009",
    "roleName": "Distribution Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Distribution Operations",
      "Distribution Centre Management",
      "Warehouse Operations",
      "Order Dispatch",
      "Distribution SLA Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Distribution Operations Concepts",
      "Transportation and Distribution Concepts",
      "Warehouse Management Principles",
      "Inventory Management Principles",
      "Delivery Operations Management"
    ]
  },
  {
    "roleId": "JF26-010",
    "roleName": "Logistics Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Logistics Execution",
      "Logistics Coordination",
      "Freight Booking",
      "Proof of Delivery Management",
      "Transport Documentation"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Logistics Management Principles",
      "Logistics Coordination Principles",
      "Warehouse Management Principles",
      "Import and Export Regulations",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF26-011",
    "roleName": "Shipping Coordinator",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Shipping Coordination",
      "Shipping Operations",
      "Bill of Lading Management",
      "Port Operations",
      "Shipping Line Communication"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Notion AI",
      "Power BI Copilot",
      "AI Supply Chain",
      "Zapier"
    ],
    "domainSkills": [
      "Shipping and Ocean Freight Concepts",
      "Multimodal Logistics Concepts",
      "Import and Export Regulations",
      "Freight Forwarding Concepts",
      "Freight Management Principles"
    ]
  },
  {
    "roleId": "JF26-012",
    "roleName": "Cold Chain Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Cold Chain Management",
      "Temperature-Controlled Logistics",
      "Cold Storage Management",
      "Logistics Management",
      "Pharmaceutical Logistics"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Cold Chain Logistics Principles",
      "Temperature-Controlled Storage and Transport",
      "Logistics Management Principles",
      "Warehouse Executive Operations",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF26-013",
    "roleName": "Dispatch Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Dispatch Management",
      "Load Planning",
      "Vehicle Allocation",
      "Dispatch Operations",
      "Dispatch Documentation"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Dispatch Operations Management",
      "Warehouse Management Principles",
      "Delivery Operations Management",
      "Logistics Coordination Principles",
      "Import and Export Regulations"
    ]
  },
  {
    "roleId": "JF26-014",
    "roleName": "Freight Coordinator",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Freight Coordination",
      "Freight Documentation",
      "Freight Rate Comparison",
      "Multimodal Freight",
      "Freight Invoice Verification"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Notion AI",
      "Power BI Copilot",
      "AI Supply Chain",
      "Zapier"
    ],
    "domainSkills": [
      "Freight Management Principles",
      "Freight Forwarding Concepts",
      "Multimodal Logistics Concepts",
      "Import and Export Regulations",
      "Logistics Coordination Principles"
    ]
  },
  {
    "roleId": "JF26-015",
    "roleName": "Reverse Logistics Analyst",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Reverse Logistics Analysis",
      "3PL Returns Management",
      "Returns Data Analysis",
      "Refurbishment Planning",
      "Reverse Supply Chain Optimisation"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "Claude",
      "Notion AI",
      "Zapier",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "E-Commerce Management Principles",
      "Export Documentation and Compliance",
      "Reverse Logistics Concepts",
      "Digital Customer Experience",
      "Inventory Management Principles"
    ]
  },
  {
    "roleId": "JF26-016",
    "roleName": "Last Mile Executive",
    "jobFamily": "Logistics & Warehouse",
    "technicalSkills": [
      "Last Mile Operations",
      "Last Mile Delivery Management",
      "Delivery Scheduling",
      "Customer Delivery Communication",
      "Failed Delivery Management"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Notion AI",
      "Zapier"
    ],
    "domainSkills": [
      "Last Mile Delivery Concepts",
      "Delivery Operations Management",
      "Vehicle Routing and Scheduling",
      "Logistics Management Principles",
      "Digital Customer Experience"
    ]
  },
  {
    "roleId": "JF27-001",
    "roleName": "Operations Manager",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Operations Management",
      "Process Management",
      "Operational KPI Management",
      "Resource Planning",
      "Cost Reduction"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Process Mining AI",
      "Zapier",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Operations Management Principles",
      "Operational Strategy",
      "Lean Management Principles",
      "Operational Metrics and KPI Design",
      "Log Analysis and Correlation"
    ]
  },
  {
    "roleId": "JF27-002",
    "roleName": "Process Excellence Manager",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Process Excellence",
      "Lean Manufacturing",
      "Six Sigma",
      "Continuous Improvement",
      "Value Stream Mapping"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Process Excellence Methodology",
      "Six Sigma Methodology",
      "Lean Management Principles",
      "Root Cause Analysis Methodology",
      "Process Mapping and Analysis"
    ]
  },
  {
    "roleId": "JF27-003",
    "roleName": "Business Analyst - Operations",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Operations Business Analysis",
      "Requirements Gathering - Ops",
      "Process Documentation",
      "Stakeholder Analysis",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Process Mining AI",
      "Zapier",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Business Operations Analysis",
      "Process Mapping and Analysis",
      "Business Process Management",
      "Operational Metrics and KPI Design",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF27-004",
    "roleName": "Six Sigma Black Belt",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Six Sigma Black Belt",
      "DMAIC",
      "Statistical Process Control",
      "Design of Experiments",
      "Minitab"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Six Sigma Methodology",
      "Quality Management Systems",
      "Lean Management Principles",
      "Root Cause Analysis Methodology",
      "Process Excellence Methodology"
    ]
  },
  {
    "roleId": "JF27-005",
    "roleName": "Plant Manager",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Plant Management",
      "Production Management",
      "Plant Safety Management",
      "Capacity Utilisation",
      "Maintenance Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Supply Chain",
      "Power BI Copilot",
      "Zapier",
      "Julius AI"
    ],
    "domainSkills": [
      "Plant and Manufacturing Operations",
      "Production Planning and Control",
      "Lean Management Principles",
      "Log Analysis and Correlation",
      "Operations Management Principles"
    ]
  },
  {
    "roleId": "JF27-006",
    "roleName": "Operations Executive",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Operations Execution",
      "Operations Management",
      "Daily Operations Reporting",
      "SOP Adherence",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Process Mining AI",
      "Zapier",
      "Julius AI"
    ],
    "domainSkills": [
      "Operations Management Principles",
      "Process Mapping and Analysis",
      "Operational Metrics and KPI Design",
      "Lean Management Principles",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF27-007",
    "roleName": "Operations Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Operations Analysis",
      "Operational Data Analysis",
      "Operations Dashboard Reporting",
      "SQL",
      "Trend Analysis - Ops"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Business Operations Analysis",
      "Operational Metrics and KPI Design",
      "Lean Management Principles",
      "Process Mapping and Analysis",
      "Gap Analysis"
    ]
  },
  {
    "roleId": "JF27-008",
    "roleName": "Process Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Process Analysis",
      "As-Is Process Mapping",
      "To-Be Process Design",
      "Process Gap Analysis",
      "Continuous Improvement"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Process Mapping and Analysis",
      "Process Improvement Methodology",
      "Business Process Management",
      "Lean Management Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF27-009",
    "roleName": "Business Process Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Business Process Analysis",
      "BPMN",
      "Business Process Reengineering",
      "Process Documentation",
      "Process Automation Assessment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Process Mining AI",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Business Process Management",
      "Process Mapping and Analysis",
      "Business Operations Analysis",
      "Process Improvement Methodology",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF27-010",
    "roleName": "MIS Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "MIS Reporting",
      "Management Information Systems",
      "Microsoft Excel",
      "Report Automation",
      "Data Consolidation"
    ],
    "aiToolSkills": [
      "Power BI Copilot",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Process Mining AI"
    ],
    "domainSkills": [
      "Management Information Systems (MIS) Concepts",
      "MIS Reporting and Dashboard Design",
      "Operational Metrics and KPI Design",
      "Data-Driven Decision Making",
      "Log Analysis and Correlation"
    ]
  },
  {
    "roleId": "JF27-011",
    "roleName": "Process Improvement Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Process Improvement",
      "Continuous Improvement",
      "Kaizen",
      "Waste Elimination",
      "5S Implementation"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Process Improvement Methodology",
      "Lean Management Principles",
      "Root Cause Analysis Methodology",
      "Process Mapping and Analysis",
      "Quality Management Systems"
    ]
  },
  {
    "roleId": "JF27-012",
    "roleName": "Continuous Improvement Executive",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Process Improvement",
      "CI Execution",
      "Continuous Improvement",
      "Process Observation",
      "Improvement Tracking"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Continuous Improvement Principles",
      "Kaizen and Operational Excellence",
      "Lean Management Principles",
      "Root Cause Analysis Methodology",
      "Quality Management Systems"
    ]
  },
  {
    "roleId": "JF27-013",
    "roleName": "Operations Research Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Operations Research",
      "Linear Programming",
      "Simulation Modelling",
      "Optimisation Techniques",
      "SQL"
    ],
    "aiToolSkills": [
      "Claude",
      "Process Mining AI",
      "Zapier",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Operations Research Principles",
      "Mathematical Optimisation Concepts",
      "Lean Management Principles",
      "Operations Management Principles",
      "Gap Analysis"
    ]
  },
  {
    "roleId": "JF27-014",
    "roleName": "Service Delivery Analyst",
    "jobFamily": "Operations & Process Excellence",
    "technicalSkills": [
      "Service Delivery Analysis",
      "Service Level Management",
      "Incident Analysis",
      "Operations Dashboard Reporting",
      "Service Improvement Planning"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Zapier",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Service Delivery Management",
      "Log Analysis and Correlation",
      "Business Operations Analysis",
      "Operational Metrics and KPI Design",
      "Service Quality and SLA Management"
    ]
  },
  {
    "roleId": "JF28-001",
    "roleName": "Mechanical Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Mechanical Engineering",
      "Engineering Design",
      "Material Selection",
      "GD&T",
      "ANSYS"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Mechanical Engineering Fundamentals",
      "Engineering Mechanics and Statics",
      "Engineering Design Principles",
      "Manufacturing Engineering Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF28-002",
    "roleName": "Design Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Mechanical Design",
      "SolidWorks",
      "CATIA",
      "Design for Manufacturing",
      "GD&T"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "ANSYS AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Engineering Design Principles",
      "Product Design and Development",
      "CAD Modelling and Engineering Drawing",
      "Mechanical Engineering Fundamentals",
      "Manufacturing Engineering Principles"
    ]
  },
  {
    "roleId": "JF28-003",
    "roleName": "Production Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Production Engineering",
      "Process Engineering",
      "Manufacturing Process Design",
      "Jig and Fixture Design",
      "Lean Manufacturing"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Process Mining AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Production Process Engineering",
      "Manufacturing Engineering Principles",
      "Plant and Manufacturing Operations",
      "Root Cause Analysis Methodology",
      "Production Planning and Control"
    ]
  },
  {
    "roleId": "JF28-004",
    "roleName": "Maintenance Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Maintenance Engineering",
      "Preventive Maintenance",
      "Predictive Maintenance",
      "CMMS",
      "Root Cause Failure Analysis"
    ],
    "aiToolSkills": [
      "Microsoft 365 Copilot",
      "ANSYS AI",
      "nTopology (nTop)",
      "Process Mining AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Maintenance Engineering Principles",
      "Reliability Engineering Concepts",
      "Mechanical Engineering Fundamentals",
      "Root Cause Analysis Methodology",
      "Plant and Manufacturing Operations"
    ]
  },
  {
    "roleId": "JF28-005",
    "roleName": "Automobile Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Automobile Engineering",
      "Vehicle Systems Engineering",
      "Powertrain Engineering",
      "ADAS",
      "SolidWorks"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Automobile Engineering Fundamentals",
      "Vehicle Systems and Powertrain",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Reliability Engineering Concepts"
    ]
  },
  {
    "roleId": "JF28-006",
    "roleName": "Thermal Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Thermal Engineering",
      "Heat Transfer Analysis",
      "CFD",
      "Thermodynamics",
      "Thermal Management"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Thermodynamics and Heat Transfer",
      "Thermal System Design",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF28-007",
    "roleName": "HVAC Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "HVAC Engineering",
      "HVAC System Design",
      "Load Calculation",
      "Duct Design",
      "HVAC Commissioning"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "HVAC System Design Principles",
      "Refrigeration and Air Conditioning Concepts",
      "Thermodynamics and Heat Transfer",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF28-008",
    "roleName": "Tooling Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Tooling Engineering",
      "Tool Design",
      "Die Design",
      "SolidWorks",
      "Mould Flow Analysis"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "ANSYS AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Tooling and Jig Design",
      "Manufacturing Tooling Concepts",
      "Manufacturing Engineering Principles",
      "CAD Modelling and Engineering Drawing",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF28-009",
    "roleName": "Robotics Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Robotics Engineering",
      "Robot Programming",
      "Industrial Automation",
      "ROS",
      "PLC Programming"
    ],
    "aiToolSkills": [
      "Autodesk Fusion Generative Design",
      "Microsoft 365 Copilot",
      "nTopology (nTop)",
      "ANSYS AI",
      "Process Mining AI"
    ],
    "domainSkills": [
      "Robotics Engineering Principles",
      "Industrial Automation Concepts",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Product Design and Development"
    ]
  },
  {
    "roleId": "JF28-010",
    "roleName": "CAD Design Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "CAD Design",
      "AutoCAD",
      "SolidWorks",
      "3D CAD Modelling",
      "Drawing Standards"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "ChatGPT",
      "nTopology (nTop)",
      "ANSYS AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "CAD Modelling and Engineering Drawing",
      "Engineering Drawing Standards",
      "Engineering Design Principles",
      "Mechanical Engineering Fundamentals",
      "Manufacturing Engineering Principles"
    ]
  },
  {
    "roleId": "JF28-011",
    "roleName": "Piping Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Piping Engineering",
      "Piping Layout Design",
      "Pipe Stress Analysis",
      "P&ID",
      "CAESAR II"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Piping Engineering Principles",
      "Piping System Design and Layout",
      "Mechanical Engineering Fundamentals",
      "Stress Analysis and Structural Mechanics",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF28-012",
    "roleName": "Stress Analysis Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Stress Analysis",
      "Finite Element Analysis",
      "ANSYS",
      "Structural Analysis",
      "Fatigue Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Stress Analysis and Structural Mechanics",
      "Finite Element Analysis Concepts",
      "Mechanical Engineering Fundamentals",
      "Engineering Mechanics and Statics",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF28-013",
    "roleName": "R&D Mechanical Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "R&D Engineering",
      "Prototype Development",
      "Engineering Testing",
      "Engineering Design",
      "Design for Manufacturing"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Microsoft 365 Copilot",
      "nTopology (nTop)",
      "Process Mining AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Research and Development Methodology",
      "Engineering Experimentation",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Product Design and Development"
    ]
  },
  {
    "roleId": "JF28-014",
    "roleName": "Field Service Engineer",
    "jobFamily": "Mechanical Engineering",
    "technicalSkills": [
      "Field Service Engineering",
      "Equipment Installation",
      "On-site Troubleshooting",
      "Field Commissioning",
      "Maintenance Engineering"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Process Mining AI",
      "ANSYS AI",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Field Service Engineering Principles",
      "Troubleshooting and Fault Diagnosis",
      "Mechanical Engineering Fundamentals",
      "Maintenance Engineering Principles",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF29-001",
    "roleName": "Electrical Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Electrical Engineering",
      "Electrical System Design",
      "Power Distribution",
      "Electrical Protection Systems",
      "ETAP"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Electrical Engineering Fundamentals",
      "Circuit Theory and Analysis",
      "Product Design and Development",
      "Instrumentation Engineering Principles",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF29-002",
    "roleName": "Power Systems Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Power Systems Engineering",
      "Load Flow Analysis",
      "ETAP",
      "Switchgear",
      "Power Quality"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "AutoCAD AI",
      "Perplexity AI",
      "GitHub Copilot"
    ],
    "domainSkills": [
      "Product Design and Development",
      "Electrical Power Distribution",
      "Electrical Engineering Fundamentals",
      "Circuit Theory and Analysis",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF29-003",
    "roleName": "Instrumentation Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Instrumentation Engineering",
      "Control Systems",
      "SCADA",
      "Calibration",
      "DCS"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Perplexity AI",
      "ChatGPT",
      "AutoCAD AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Instrumentation Engineering Principles",
      "Measurement and Control Systems",
      "Electrical Engineering Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF29-004",
    "roleName": "Control Systems Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Control Systems Engineering",
      "MATLAB Simulink",
      "PID Tuning",
      "Control Loop Design",
      "HMI Design"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ANSYS AI",
      "Microsoft 365 Copilot",
      "AutoCAD AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Circuit Theory and Analysis",
      "Classical and Modern Control Theory",
      "Electrical Engineering Fundamentals",
      "Measurement and Control Systems",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF29-005",
    "roleName": "PLC & SCADA Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "PLC & SCADA Engineering",
      "PLC Programming",
      "Industrial Networking",
      "Ladder Logic Programming",
      "SCADA Configuration"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "ANSYS AI",
      "ChatGPT",
      "AutoCAD AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "PLC and SCADA Systems Principles",
      "Industrial Control Systems Design",
      "Industrial Automation Concepts",
      "Electrical Engineering Fundamentals",
      "Measurement and Control Systems"
    ]
  },
  {
    "roleId": "JF29-006",
    "roleName": "Protection Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Protection Engineering",
      "Relay Coordination",
      "Protection Relay Setting",
      "Substation Protection",
      "Arc Flash Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Perplexity AI",
      "ChatGPT",
      "AutoCAD AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Electrical Protection Engineering",
      "Protection Relay Principles",
      "Circuit Theory and Analysis",
      "Electrical Power Distribution",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF29-007",
    "roleName": "Electronics Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Electronics Engineering",
      "Analog Circuit Design",
      "Digital Circuit Design",
      "Circuit Simulation",
      "LTSpice"
    ],
    "aiToolSkills": [
      "Altium AI",
      "ANSYS AI",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Electronics Engineering Fundamentals",
      "Analog and Digital Circuit Design",
      "Circuit Theory and Analysis",
      "Electrical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF29-008",
    "roleName": "VLSI Design Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "VLSI Design",
      "RTL Design",
      "Verilog",
      "VHDL",
      "Synthesis and Place & Route"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "ANSYS AI",
      "Microsoft 365 Copilot",
      "AutoCAD AI",
      "ChatGPT"
    ],
    "domainSkills": [
      "VLSI Design Principles",
      "Digital Logic Design",
      "Semiconductor Device Physics",
      "Electronics Engineering Fundamentals",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF29-009",
    "roleName": "PCB Design Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "PCB Design",
      "Altium Designer",
      "Schematic Capture",
      "PCB Layout",
      "Signal Integrity"
    ],
    "aiToolSkills": [
      "Altium AI",
      "ANSYS AI",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "PCB Design Principles",
      "Electronic Circuit Layout",
      "Electronics Engineering Fundamentals",
      "Analog and Digital Circuit Design",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF29-010",
    "roleName": "Signal Processing Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Signal Processing (Engineering)",
      "DSP Algorithm Development",
      "MATLAB Signal Processing",
      "Filter Design",
      "Python"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT"
    ],
    "domainSkills": [
      "Signal Processing Fundamentals",
      "Digital Signal Processing (DSP) Concepts",
      "Electronics Engineering Fundamentals",
      "Electrical Engineering Fundamentals",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF29-011",
    "roleName": "Electrical Project Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Electrical Project Engineering",
      "Electrical Engineering",
      "Electrical Estimation",
      "Electrical Drawing Review",
      "Site Electrical Supervision"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Circuit Theory and Analysis",
      "Embedded Systems Architecture",
      "Electrical Engineering Fundamentals",
      "Engineering Design Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF29-012",
    "roleName": "Automation & Controls Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Automation Engineering",
      "Industrial Automation",
      "Industrial Control Systems",
      "Motion Control",
      "DCS Configuration"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "ANSYS AI",
      "Microsoft 365 Copilot",
      "AutoCAD AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Industrial Automation Concepts",
      "PLC and SCADA Systems Principles",
      "Circuit Theory and Analysis",
      "Electrical Engineering Fundamentals",
      "Measurement and Control Systems"
    ]
  },
  {
    "roleId": "JF29-013",
    "roleName": "Power Electronics Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Power Electronics",
      "Inverter Design",
      "SMPS Design",
      "Motor Drive Design",
      "MATLAB Simulink"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Perplexity AI",
      "ChatGPT",
      "AutoCAD AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Power Electronics Principles",
      "Converter and Inverter Design Concepts",
      "Electrical Engineering Fundamentals",
      "Electronics Engineering Fundamentals",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF29-014",
    "roleName": "RF & Microwave Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "RF Engineering",
      "Antenna Design",
      "Microwave Circuit Design",
      "RF Simulation",
      "ADS"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Altium AI",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "ChatGPT"
    ],
    "domainSkills": [
      "RF and Microwave Engineering Fundamentals",
      "Antenna Theory and Design",
      "Electronics Engineering Fundamentals",
      "Electrical Engineering Fundamentals",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF29-015",
    "roleName": "Embedded Hardware Engineer",
    "jobFamily": "Electrical & Electronics Engineering",
    "technicalSkills": [
      "Embedded Hardware Design",
      "Microcontroller Design",
      "PCB Design",
      "Hardware Debugging",
      "Board Bring-Up"
    ],
    "aiToolSkills": [
      "Altium AI",
      "GitHub Copilot",
      "ANSYS AI",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Embedded Hardware Design Principles",
      "Hardware Debugging and Testing",
      "Electronics Engineering Fundamentals",
      "Embedded Systems Architecture",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF30-001",
    "roleName": "Civil Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Civil Engineering",
      "Structural Design - Civil",
      "AutoCAD Civil 3D",
      "IS Code Design",
      "Construction Material Testing"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Civil Engineering Fundamentals",
      "Engineering Surveying Concepts",
      "Structural Engineering Principles",
      "Construction Engineering and Management",
      "Geotechnical Engineering Principles"
    ]
  },
  {
    "roleId": "JF30-002",
    "roleName": "Structural Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Structural Engineering",
      "RCC Design",
      "Steel Structure Design",
      "STAAD Pro",
      "ETABS"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Perplexity AI",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Structural Engineering Principles",
      "Structural Analysis Methods",
      "Stress Analysis and Structural Mechanics",
      "Civil Engineering Fundamentals",
      "Finite Element Analysis Concepts"
    ]
  },
  {
    "roleId": "JF30-003",
    "roleName": "Site Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Site Engineering",
      "Construction Supervision",
      "Bar Bending Schedule",
      "Quality Control - Construction",
      "IS Code Design"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Claude",
      "AutoCAD AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Site Engineering Operations",
      "Construction Engineering and Management",
      "Civil Engineering Fundamentals",
      "Engineering Surveying Concepts",
      "Geotechnical Engineering Principles"
    ]
  },
  {
    "roleId": "JF30-004",
    "roleName": "Geotechnical Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Geotechnical Engineering",
      "Soil Investigation",
      "Foundation Design",
      "Ground Improvement",
      "Slope Stability Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk BIM 360 AI",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Geotechnical Engineering Principles",
      "Soil Mechanics and Foundation Design",
      "Civil Engineering Fundamentals",
      "Stress Analysis and Structural Mechanics",
      "Engineering Surveying Concepts"
    ]
  },
  {
    "roleId": "JF30-005",
    "roleName": "Transportation Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Transportation Engineering",
      "Road Design",
      "Traffic Engineering",
      "Highway Design",
      "IRC Standards"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Transportation Engineering Principles",
      "Highway and Pavement Design",
      "Civil Engineering Fundamentals",
      "Soil Mechanics and Foundation Design",
      "Engineering Surveying Concepts"
    ]
  },
  {
    "roleId": "JF30-006",
    "roleName": "Water Resources Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Water Resources Engineering",
      "Hydraulic Design",
      "Hydrology",
      "Irrigation Design",
      "Water Supply Design"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Perplexity AI",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Engineering Surveying Concepts",
      "Hydraulics and Hydrology",
      "Civil Engineering Fundamentals",
      "Soil Mechanics and Foundation Design",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF30-007",
    "roleName": "Surveyor",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Land Surveying",
      "Total Station",
      "GPS Surveying",
      "Levelling",
      "Survey Data Processing"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Surveying Principles and Methodology",
      "Geospatial Measurement Concepts",
      "Civil Engineering Fundamentals",
      "Engineering Surveying Concepts",
      "Site Engineering Operations"
    ]
  },
  {
    "roleId": "JF30-008",
    "roleName": "Project Manager - Construction",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Construction Project Management",
      "Construction Planning",
      "Primavera P6",
      "BOQ and Estimation",
      "Construction Contract Management"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Claude",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Engineering Design Principles",
      "Contract Management in Construction",
      "Construction Engineering and Management",
      "IT Project Management",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF30-009",
    "roleName": "Site Supervisor",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Site Supervision",
      "Construction Supervision",
      "Workforce Supervision",
      "Work Progress Monitoring",
      "Safety Supervision"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Claude",
      "AutoCAD AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Site Supervision Principles",
      "Construction Engineering and Management",
      "Construction Quality Management",
      "Civil Engineering Fundamentals",
      "Engineering Surveying Concepts"
    ]
  },
  {
    "roleId": "JF30-010",
    "roleName": "Quantity Surveyor",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Quantity Surveying",
      "Bill of Quantities",
      "Measurement and Valuation",
      "Cost Planning",
      "Contract Administration"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Quantity Surveying Principles",
      "Bill of Quantities and Cost Estimation",
      "Contract Management in Construction",
      "Construction Cost Control",
      "Tendering and Procurement in Construction"
    ]
  },
  {
    "roleId": "JF30-011",
    "roleName": "Building Inspector",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Building Inspection",
      "Code Compliance Inspection",
      "Defect Identification",
      "Quality Control - Construction",
      "Inspection Reporting"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Claude",
      "AutoCAD AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Building Inspection Methodology",
      "Building Codes and Regulatory Compliance",
      "Civil Engineering Fundamentals",
      "Construction Quality Management",
      "Construction Engineering and Management"
    ]
  },
  {
    "roleId": "JF30-012",
    "roleName": "Construction Manager",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Construction Management",
      "Construction Project Management",
      "Subcontractor Management",
      "Resource Management - Construction",
      "Construction Progress Reporting"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Claude",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Construction Programme Management",
      "Construction Engineering and Management",
      "Construction Cost Control",
      "Contract Management in Construction",
      "Civil Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF30-013",
    "roleName": "Estimation Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Cost Estimation",
      "Quantity Take-Off",
      "Rate Analysis",
      "BOQ and Estimation",
      "Tender Preparation"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Engineering Cost Estimation",
      "Tendering and Procurement in Construction",
      "Bill of Quantities and Cost Estimation",
      "Civil Engineering Fundamentals",
      "Construction Cost Control"
    ]
  },
  {
    "roleId": "JF30-014",
    "roleName": "MEP Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "MEP Engineering",
      "MEP Coordination",
      "MEP Design",
      "HVAC Engineering",
      "BIM for MEP"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Perplexity AI"
    ],
    "domainSkills": [
      "MEP Engineering Principles",
      "Building Services Integration",
      "Mechanical Engineering Fundamentals",
      "Electrical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF30-015",
    "roleName": "Infrastructure Project Manager",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Infrastructure Project Management",
      "Construction Project Management",
      "Government Liaison",
      "Stakeholder Management - Infra",
      "Risk Management - Construction"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Claude",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Engineering Design Principles",
      "Product Design and Development",
      "Contract Management in Construction",
      "Stakeholder and Regulatory Management",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF30-016",
    "roleName": "Highway Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Highway Engineering",
      "Highway Design",
      "Pavement Design",
      "Highway Geometric Design",
      "Road Material Testing"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "AutoCAD AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Highway Engineering and Design",
      "Traffic Engineering Concepts",
      "Civil Engineering Fundamentals",
      "Highway and Pavement Design",
      "Geotechnical Engineering Principles"
    ]
  },
  {
    "roleId": "JF30-017",
    "roleName": "Bridge Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Bridge Engineering",
      "Bridge Design",
      "Structural Engineering",
      "Bridge Inspection",
      "Bridge Load Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Perplexity AI",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Bridge Engineering Principles",
      "Bridge Analysis and Loading",
      "Structural Engineering Principles",
      "Structural Analysis Methods",
      "Geotechnical Engineering Principles"
    ]
  },
  {
    "roleId": "JF30-018",
    "roleName": "Water & Sewage Engineer",
    "jobFamily": "Civil & Structural Engineering",
    "technicalSkills": [
      "Water and Sewage Engineering",
      "Sewage Treatment Design",
      "Water Supply Design",
      "Pipeline Design (Engineering)",
      "Water Treatment Design"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Perplexity AI",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Engineering Surveying Concepts",
      "Wastewater Treatment Concepts",
      "IT Project Management",
      "Hydraulics and Hydrology",
      "Civil Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF31-001",
    "roleName": "Chemical Engineer",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Chemical Engineering",
      "Process Design",
      "Mass and Energy Balance",
      "HYSYS",
      "Reaction Engineering"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Chemical Engineering Fundamentals",
      "Mass and Energy Balance Concepts",
      "Thermodynamics and Heat Transfer",
      "Process Engineering Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-002",
    "roleName": "Process Engineer",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Process Engineering",
      "P&ID",
      "Process Optimisation",
      "Process Safety",
      "HAZOP"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Process Engineering Principles",
      "Process Design and Optimisation",
      "Chemical Engineering Fundamentals",
      "Production Process Engineering",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-003",
    "roleName": "Petroleum Engineer",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Petroleum Engineering",
      "Reservoir Engineering",
      "Well Completion",
      "Production Optimisation",
      "Petrel"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ANSYS AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Petroleum Engineering Fundamentals",
      "Reservoir Engineering Concepts",
      "Chemical Engineering Fundamentals",
      "Thermodynamics and Heat Transfer",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF31-004",
    "roleName": "Polymer Engineer",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Polymer Engineering",
      "Polymer Processing",
      "Material Characterisation",
      "Extrusion and Moulding",
      "Mould Flow Analysis"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Polymer Engineering Principles",
      "Polymer Processing Concepts",
      "Chemical Engineering Fundamentals",
      "Engineering Design Principles",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF31-005",
    "roleName": "Refinery Engineer",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Refinery Engineering",
      "Petroleum Refining",
      "Crude Distillation",
      "Refinery Operations",
      "HAZOP"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ANSYS AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Refinery Engineering Concepts",
      "Petroleum Refining Processes",
      "Petroleum Engineering Fundamentals",
      "Process Engineering Principles",
      "Thermodynamics and Heat Transfer"
    ]
  },
  {
    "roleId": "JF31-006",
    "roleName": "Chemical Engineer - Production",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Chemical Production Management",
      "Chemical Plant Operations",
      "Batch Process Management",
      "Process Safety",
      "GMP Compliance"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Chemical Production Engineering",
      "Chemical Engineering Fundamentals",
      "Plant and Manufacturing Operations",
      "Root Cause Analysis Methodology",
      "Process Engineering Principles"
    ]
  },
  {
    "roleId": "JF31-007",
    "roleName": "Plant Chemist",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Plant Chemistry",
      "In-Process Quality Testing",
      "Chemical Analysis",
      "Titration and Wet Analysis",
      "Process Safety"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aspen AI",
      "Autodesk Fusion Generative Design",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Industrial Chemistry Principles",
      "Analytical Chemistry Principles",
      "Chemical Engineering Fundamentals",
      "Root Cause Analysis Methodology",
      "Laboratory Analysis Techniques"
    ]
  },
  {
    "roleId": "JF31-008",
    "roleName": "R&D Chemist",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Research Chemistry",
      "Synthesis Chemistry",
      "Laboratory Techniques",
      "Spectroscopy",
      "Design of Experiments"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Claude",
      "Perplexity AI",
      "Aspen AI"
    ],
    "domainSkills": [
      "Research and Development Methodology",
      "Analytical Chemistry Principles",
      "Laboratory Analysis Techniques",
      "Engineering Experimentation",
      "Industrial Chemistry Principles"
    ]
  },
  {
    "roleId": "JF31-009",
    "roleName": "Analytical Chemist",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Analytical Chemistry",
      "HPLC",
      "GC-MS",
      "Method Validation",
      "Analytical Instrument Operation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Power BI Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Analytical Chemistry Principles",
      "Laboratory Analysis Techniques",
      "Quality Management Systems",
      "Industrial Chemistry Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-010",
    "roleName": "Plastics Technologist",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Plastics Technology",
      "Injection Moulding",
      "Plastic Material Selection",
      "Extrusion and Moulding",
      "Plastic Part Design"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Plastics Technology Principles",
      "Plastic Processing and Moulding Concepts",
      "Polymer Engineering Principles",
      "Polymer Processing Concepts",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-011",
    "roleName": "Mould Design Engineer",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Mould Design",
      "Injection Mould Design",
      "SolidWorks",
      "Cooling System Design",
      "Mould Base Selection"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "ANSYS AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Aspen AI"
    ],
    "domainSkills": [
      "Mould Design Principles",
      "Injection Mould Engineering",
      "Plastic Processing and Moulding Concepts",
      "Manufacturing Tooling Concepts",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF31-012",
    "roleName": "Paint Technologist",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Paint Technology",
      "Coating Formulation",
      "Paint Testing",
      "Colour Matching - Coatings",
      "Material Characterisation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aspen AI",
      "Autodesk Fusion Generative Design",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Paint and Coatings Technology",
      "Surface Chemistry and Adhesion",
      "Industrial Chemistry Principles",
      "Analytical Chemistry Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-013",
    "roleName": "Coatings Application Specialist",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Coatings Application",
      "Surface Preparation",
      "Spray Painting Techniques",
      "Dry Film Thickness",
      "EHS Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Aspen AI",
      "ANSYS AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Coatings Application Methodology",
      "Paint and Coatings Technology",
      "Surface Chemistry and Adhesion",
      "Environmental Health and Safety (EHS) Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-014",
    "roleName": "QA Manager - Chemicals",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Quality Assurance Management",
      "QMS Implementation",
      "Internal Auditing",
      "CAPA Management",
      "GMP Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Claude",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Plant and Manufacturing Operations",
      "Chemical Quality Systems",
      "Quality Engineering Principles",
      "Governance, Risk, and Compliance (GRC)",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-015",
    "roleName": "EHS Officer - Chemicals",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Environment Health and Safety",
      "Chemical Safety",
      "EHS Compliance",
      "Safety Training Delivery",
      "Process Safety"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Microsoft 365 Copilot",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Environmental Health and Safety (EHS) Principles",
      "Chemical Process Safety",
      "Regulatory Affairs Principles",
      "Workplace Safety Management",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF31-016",
    "roleName": "Regulatory Affairs Officer - Chemicals",
    "jobFamily": "Chemical, Polymer & Process Engineering",
    "technicalSkills": [
      "Regulatory Affairs (Engineering)",
      "Chemical Regulatory Compliance",
      "SDS Management",
      "REACH Compliance",
      "EHS Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Claude",
      "Perplexity AI",
      "Aspen AI"
    ],
    "domainSkills": [
      "Regulatory Affairs Principles",
      "Laboratory Analysis Techniques",
      "Industrial Chemistry Principles",
      "Compliance Frameworks",
      "Analytical Chemistry Principles"
    ]
  },
  {
    "roleId": "JF32-001",
    "roleName": "Manufacturing Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Manufacturing Engineering",
      "Production Engineering",
      "New Product Introduction",
      "Process Validation",
      "Cycle Time Reduction"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Manufacturing Engineering Fundamentals",
      "Manufacturing Engineering Principles",
      "Production Process Engineering",
      "Quality Management Systems",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-002",
    "roleName": "Quality Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Quality Engineering",
      "FMEA",
      "Control Plan",
      "MSA",
      "SPC"
    ],
    "aiToolSkills": [
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "Perplexity AI",
      "Process Mining AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Quality Engineering Principles",
      "Quality Management Systems",
      "Mechanical Engineering Fundamentals",
      "Root Cause Analysis Methodology",
      "Six Sigma Quality Engineering"
    ]
  },
  {
    "roleId": "JF32-003",
    "roleName": "Industrial Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Industrial Engineering",
      "Time and Motion Study",
      "Lean Manufacturing",
      "Work Measurement",
      "Ergonomics"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ANSYS AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Industrial Engineering Principles",
      "Work Study and Methods Engineering",
      "Lean Management Principles",
      "Lean Manufacturing Principles",
      "Six Sigma Quality Engineering"
    ]
  },
  {
    "roleId": "JF32-004",
    "roleName": "Lean Manufacturing Specialist",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Lean Specialist",
      "Lean Manufacturing",
      "TPM",
      "Kanban",
      "Just-in-Time"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Lean Manufacturing Principles",
      "Plant and Manufacturing Operations",
      "Lean Management Principles",
      "Production Planning and Control",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-005",
    "roleName": "Six Sigma Quality Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Six Sigma Quality",
      "DMAIC",
      "Statistical Process Control",
      "Quality Improvement Projects",
      "Measurement System Analysis"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Six Sigma Quality Engineering",
      "Quality Management Systems",
      "Quality Engineering Principles",
      "Root Cause Analysis Methodology",
      "Six Sigma Methodology"
    ]
  },
  {
    "roleId": "JF32-006",
    "roleName": "EHS - Safety Officer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Safety Management",
      "Risk Assessment - Safety",
      "Environment Health and Safety",
      "Permit to Work",
      "Incident Investigation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Power BI Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Workplace Safety Management",
      "Safety Management Systems",
      "Environmental Health and Safety (EHS) Principles",
      "Root Cause Analysis Methodology",
      "Plant and Manufacturing Operations"
    ]
  },
  {
    "roleId": "JF32-007",
    "roleName": "CNC Operator",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "CNC Operation",
      "G-Code Programming",
      "Machine Setup",
      "Dimensional Inspection",
      "GD&T"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Claude",
      "AutoCAD AI",
      "Autodesk Fusion Generative Design",
      "Perplexity AI"
    ],
    "domainSkills": [
      "CNC Machining Concepts",
      "G-Code and Machining Programming Principles",
      "Mechanical Engineering Fundamentals",
      "Manufacturing Tooling Concepts",
      "Engineering Mechanics and Statics"
    ]
  },
  {
    "roleId": "JF32-008",
    "roleName": "Welding Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Welding Engineering",
      "Welding Process Selection",
      "Weld Quality Inspection",
      "WPS and PQR",
      "NDT"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "Claude",
      "Autodesk Fusion Generative Design",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Welding Engineering Principles",
      "Welding Metallurgy and Processes",
      "Mechanical Engineering Fundamentals",
      "Quality Engineering Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-009",
    "roleName": "Metallurgical Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Metallurgical Engineering",
      "Metallography",
      "Heat Treatment",
      "Failure Analysis",
      "Material Characterisation"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Metallurgical Engineering Principles",
      "Physical and Mechanical Metallurgy",
      "Materials Science Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-010",
    "roleName": "Materials Scientist",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Materials Science",
      "Materials Testing",
      "Microstructure Analysis",
      "Advanced Materials Development",
      "Material Characterisation"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Materials Science Fundamentals",
      "Materials Characterisation and Testing",
      "Research and Development Methodology",
      "Engineering Experimentation",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF32-011",
    "roleName": "Ceramic Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Ceramic Engineering",
      "Ceramic Processing",
      "Sintering",
      "Material Characterisation",
      "Refractory Materials"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "Claude",
      "Perplexity AI",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Ceramic Engineering Principles",
      "Ceramic Processing Concepts",
      "Materials Science Fundamentals",
      "Engineering Design Principles",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF32-012",
    "roleName": "Production Supervisor",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Production Supervision",
      "Production Management",
      "Shift Management",
      "Production Target Management",
      "Plant Safety Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Process Mining AI",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Production Supervision Principles",
      "Plant and Manufacturing Operations",
      "Production Planning and Control",
      "Quality Management Systems",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-013",
    "roleName": "Quality Inspector",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Quality Inspection",
      "Incoming Quality Control",
      "Inspection Techniques",
      "Dimensional Inspection",
      "Non-Conformance Reporting"
    ],
    "aiToolSkills": [
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "Perplexity AI",
      "Process Mining AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Quality Inspection Methodology",
      "Quality Engineering Principles",
      "Manufacturing Engineering Principles",
      "Manufacturing Engineering Fundamentals",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-014",
    "roleName": "Maintenance Technician",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Maintenance Technician Skills",
      "Mechanical Maintenance",
      "Electrical Maintenance",
      "Preventive Maintenance",
      "Lubrication Management"
    ],
    "aiToolSkills": [
      "Claude",
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "Perplexity AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Engineering Mechanics and Statics",
      "Preventive and Corrective Maintenance",
      "Maintenance Engineering Principles",
      "Mechanical Engineering Fundamentals",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-015",
    "roleName": "Production Planning Executive",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Production Planning Execution",
      "Master Production Schedule",
      "Production Scheduling",
      "Material Requirement Planning",
      "Bill of Materials Management"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Production Planning Concepts",
      "Production Planning and Control",
      "Plant and Manufacturing Operations",
      "Inventory Optimisation Concepts",
      "Inventory Management Principles"
    ]
  },
  {
    "roleId": "JF32-016",
    "roleName": "Shop Floor Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Shop Floor Engineering",
      "Production Engineering",
      "Work Order Management",
      "Shop Floor Data Collection",
      "Production Bottleneck Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "ANSYS AI",
      "Process Mining AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Shop Floor Operations",
      "Plant and Manufacturing Operations",
      "Production Process Engineering",
      "Root Cause Analysis Methodology",
      "Production Planning and Control"
    ]
  },
  {
    "roleId": "JF32-017",
    "roleName": "Quality Assurance Executive",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Quality Assurance Execution",
      "Quality Inspection",
      "Product Quality Monitoring",
      "Deviation Management",
      "Customer Complaint Handling"
    ],
    "aiToolSkills": [
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "Perplexity AI",
      "Process Mining AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Industrial Engineering Principles",
      "Quality Engineering Principles",
      "Quality Management Systems",
      "Six Sigma Quality Engineering",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF32-018",
    "roleName": "Process Improvement Engineer",
    "jobFamily": "Manufacturing & Quality",
    "technicalSkills": [
      "Process Improvement Engineering",
      "Value Stream Mapping",
      "Bottleneck Elimination",
      "OEE Improvement",
      "Process Re-engineering"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ANSYS AI",
      "ChatGPT",
      "Autodesk Fusion Generative Design",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Process Improvement Methodology",
      "Lean Management Principles",
      "Root Cause Analysis Methodology",
      "Quality Management Systems",
      "Six Sigma Methodology"
    ]
  },
  {
    "roleId": "JF33-001",
    "roleName": "Aerospace Engineer",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Aerospace Engineering",
      "Aerodynamics",
      "Aerospace Materials",
      "Flight Dynamics",
      "DO-178C"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Aerodynamics Principles",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Stress Analysis and Structural Mechanics"
    ]
  },
  {
    "roleId": "JF33-002",
    "roleName": "Avionics Engineer",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Avionics Engineering",
      "Avionics System Design",
      "ARINC 429",
      "MIL-STD-1553",
      "Avionics Testing"
    ],
    "aiToolSkills": [
      "Autodesk Fusion Generative Design",
      "MATLAB AI",
      "ANSYS AI",
      "ChatGPT",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Avionics Systems Principles",
      "Avionics Architecture and Integration",
      "Electrical Engineering Fundamentals",
      "Aerospace Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF33-003",
    "roleName": "Defence Systems Engineer",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Defence Systems Engineering",
      "Systems Engineering",
      "MBSE",
      "Weapons Systems Knowledge",
      "Aerodynamics"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "GitHub Copilot",
      "ChatGPT",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Circuit Theory and Analysis",
      "Systems Engineering Methodology",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF33-004",
    "roleName": "Propulsion Engineer",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Propulsion Engineering",
      "Rocket Propulsion",
      "Combustion Analysis",
      "CFD",
      "Nozzle Design"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Propulsion Engineering Principles",
      "Jet Propulsion and Gas Turbine Theory",
      "Thermodynamics and Heat Transfer",
      "Mechanical Engineering Fundamentals",
      "Aerospace Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF33-005",
    "roleName": "Space Research Scientist",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Space Research",
      "Orbital Mechanics",
      "Remote Sensing",
      "Astrodynamics",
      "Python"
    ],
    "aiToolSkills": [
      "MATLAB AI",
      "Claude",
      "Autodesk Fusion Generative Design",
      "Microsoft 365 Copilot",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Space Science Fundamentals",
      "Orbital Mechanics and Astrodynamics",
      "Research and Development Methodology",
      "Engineering Experimentation",
      "Space Research and Technology Principles"
    ]
  },
  {
    "roleId": "JF33-006",
    "roleName": "Satellite Systems Engineer",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Satellite Systems Engineering",
      "Systems Engineering",
      "Satellite Communication",
      "Link Budget Analysis",
      "Ground Station Operations"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "GitHub Copilot",
      "ChatGPT",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Aerodynamics Principles",
      "Space Mission Design",
      "Systems Engineering Methodology",
      "Aerospace Engineering Fundamentals",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF33-007",
    "roleName": "Propulsion Scientist",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Propulsion Science",
      "Propulsion Engineering",
      "Advanced Propulsion Research",
      "Propellant Chemistry",
      "Hypersonic Propulsion"
    ],
    "aiToolSkills": [
      "MATLAB AI",
      "ChatGPT",
      "ANSYS AI",
      "nTopology (nTop)",
      "Autodesk Fusion Generative Design"
    ],
    "domainSkills": [
      "Rocket Propulsion Science",
      "Combustion Theory",
      "Research and Development Methodology",
      "Thermodynamics and Heat Transfer",
      "Engineering Experimentation"
    ]
  },
  {
    "roleId": "JF33-008",
    "roleName": "Aircraft Maintenance Engineer (AME)",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Aircraft Maintenance",
      "DGCA Regulations",
      "Airframe Maintenance",
      "Engine Maintenance",
      "Maintenance Documentation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ANSYS AI",
      "Autodesk Fusion Generative Design",
      "Claude",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Aircraft Maintenance Engineering",
      "DGCA Regulatory Standards",
      "Mechanical Engineering Fundamentals",
      "Maintenance Engineering Principles",
      "Troubleshooting and Fault Diagnosis"
    ]
  },
  {
    "roleId": "JF33-009",
    "roleName": "Structural Analysis Engineer",
    "jobFamily": "Aerospace & Defence Engineering",
    "technicalSkills": [
      "Structural Analysis Engineering",
      "Finite Element Analysis",
      "Static Structural Analysis",
      "Dynamic Analysis",
      "Composite Structure Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "Autodesk Fusion Generative Design",
      "ChatGPT",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Stress Analysis and Structural Mechanics",
      "Finite Element Analysis Concepts",
      "Structural Engineering Principles",
      "Structural Analysis Methods",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF34-001",
    "roleName": "Architect",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Architecture",
      "Architectural Design",
      "Building Design",
      "Revit",
      "Architectural Drawings"
    ],
    "aiToolSkills": [
      "Rhino AI",
      "Autodesk BIM 360 AI",
      "Midjourney",
      "ChatGPT",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Architectural Design Principles",
      "Architectural Composition and Theory",
      "Building Technology and Construction Systems",
      "Civil Engineering Fundamentals",
      "Construction Engineering and Management"
    ]
  },
  {
    "roleId": "JF34-002",
    "roleName": "Interior Designer",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Interior Design",
      "Space Planning",
      "Material and Finish Selection",
      "3D Interior Visualisation",
      "SketchUp"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Rhino AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Autodesk BIM 360 AI"
    ],
    "domainSkills": [
      "Interior Design Principles",
      "Space Planning and Interior Layouts",
      "Visual Design Principles",
      "Colour Theory",
      "Architectural Design Principles"
    ]
  },
  {
    "roleId": "JF34-003",
    "roleName": "Urban Planner",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Urban Planning",
      "Land Use Planning",
      "Zoning Regulations",
      "GIS for Urban Planning",
      "Master Planning"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk BIM 360 AI",
      "Adobe Firefly",
      "Rhino AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Urban Planning Principles",
      "Land Use Planning and Zoning",
      "Civil Engineering Fundamentals",
      "Transportation Engineering Principles",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF34-004",
    "roleName": "Landscape Architect",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Landscape Architecture",
      "Planting Design",
      "Site Analysis",
      "Landscape Grading",
      "Revit"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Rhino AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Autodesk BIM 360 AI"
    ],
    "domainSkills": [
      "Landscape Architecture Principles",
      "Site Analysis and Landscape Design",
      "Civil Engineering Fundamentals",
      "Architectural Design Principles",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF34-005",
    "roleName": "BIM Modeller",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "BIM Modelling",
      "Revit BIM",
      "Clash Detection",
      "BIM Coordination",
      "BIM for MEP"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "AutoCAD AI",
      "Claude",
      "Canva Magic Studio",
      "Rhino AI"
    ],
    "domainSkills": [
      "BIM Methodology and Standards",
      "Building Information Modelling Concepts",
      "Building Technology and Construction Systems",
      "CAD Modelling and Engineering Drawing",
      "Civil Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF34-006",
    "roleName": "Architectural Draughtsman",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Architectural Draughting",
      "AutoCAD Architecture",
      "Drawing Production",
      "Architectural Drawings",
      "Building Bye-Laws"
    ],
    "aiToolSkills": [
      "AutoCAD AI",
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Rhino AI"
    ],
    "domainSkills": [
      "Architectural Draughting Principles",
      "Architectural Drawing Standards",
      "CAD Modelling and Engineering Drawing",
      "Engineering Drawing Standards",
      "Architectural Design Principles"
    ]
  },
  {
    "roleId": "JF34-007",
    "roleName": "Junior Architect",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Architectural Assistance",
      "Architectural Design",
      "Lumion",
      "Design Development",
      "Presentation Rendering"
    ],
    "aiToolSkills": [
      "Rhino AI",
      "Autodesk BIM 360 AI",
      "Midjourney",
      "ChatGPT",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Architectural Design Principles",
      "Architectural Composition and Theory",
      "Building Technology and Construction Systems",
      "CAD Modelling and Engineering Drawing",
      "Civil Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF34-008",
    "roleName": "Urban Designer",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Urban Design",
      "Public Realm Design",
      "Urban Planning",
      "Streetscape Design",
      "Urban Design Framework"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Autodesk BIM 360 AI",
      "Rhino AI",
      "Canva Magic Studio",
      "Midjourney"
    ],
    "domainSkills": [
      "Urban Design Principles",
      "Public Realm and Streetscape Design",
      "Urban Planning Principles",
      "Architectural Design Principles",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF34-009",
    "roleName": "Sustainability Architect",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Sustainable Architecture",
      "Green Building Design",
      "GRIHA Rating",
      "Building Energy Simulation",
      "Passive Design Strategies"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Rhino AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Autodesk BIM 360 AI"
    ],
    "domainSkills": [
      "Sustainable Architecture Principles",
      "Green Building Rating Systems",
      "Building Energy Analysis Concepts",
      "Architectural Design Principles",
      "Building Technology and Construction Systems"
    ]
  },
  {
    "roleId": "JF34-010",
    "roleName": "Facade Engineer",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Facade Engineering",
      "Curtain Wall Design",
      "Facade Thermal Performance",
      "Cladding Systems",
      "Finite Element Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Rhino AI",
      "AutoCAD AI",
      "Claude",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Facade Engineering Principles",
      "Facade Systems and Cladding",
      "Stress Analysis and Structural Mechanics",
      "Building Technology and Construction Systems",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF34-011",
    "roleName": "Landscape Designer",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Landscape Design",
      "Landscape Architecture",
      "Soft Landscape Design",
      "Hard Landscape Design",
      "Landscape Detailing"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Rhino AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Autodesk BIM 360 AI"
    ],
    "domainSkills": [
      "Landscape Design Principles",
      "Planting Design and Horticulture Concepts",
      "Site Analysis and Landscape Design",
      "Colour Theory",
      "Visual Design Principles"
    ]
  },
  {
    "roleId": "JF34-012",
    "roleName": "Architectural Visualiser",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Architectural Visualisation",
      "3D Rendering",
      "V-Ray",
      "3ds Max",
      "SketchUp"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Firefly",
      "ChatGPT",
      "Canva Magic Studio",
      "Rhino AI"
    ],
    "domainSkills": [
      "Architectural Visualisation Principles",
      "3D Rendering and Presentation Design",
      "Architectural Design Principles",
      "Visual Design Principles",
      "Architectural Composition and Theory"
    ]
  },
  {
    "roleId": "JF34-013",
    "roleName": "Green Building Analyst",
    "jobFamily": "Architecture, Interior & Urban Design",
    "technicalSkills": [
      "Green Building Analysis",
      "LEED Certification",
      "GRIHA Rating",
      "Energy Modelling",
      "Carbon Footprint Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "Adobe Firefly",
      "Autodesk BIM 360 AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Green Building Analysis Principles",
      "Environmental Performance Assessment",
      "Green Building Rating Systems",
      "Building Energy Analysis Concepts",
      "Building Technology and Construction Systems"
    ]
  },
  {
    "roleId": "JF35-001",
    "roleName": "Real Estate Agent",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Real Estate Sales",
      "Property Market Knowledge",
      "Client Acquisition - Real Estate",
      "Property Showing",
      "RERA Compliance"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Midjourney",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Real Estate Sales Principles",
      "Customer Relationship Management Strategy",
      "RERA Compliance and Advisory",
      "Negotiation Principles",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF35-002",
    "roleName": "Property Valuer",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Property Valuation",
      "Comparative Market Analysis",
      "Valuation Report Writing",
      "Income Approach Valuation",
      "Property Market Knowledge"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Property Valuation Principles",
      "Valuation Methodologies",
      "RERA Compliance and Advisory",
      "Real Estate Regulatory Framework",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF35-003",
    "roleName": "Real Estate Developer",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Real Estate Development",
      "Land Acquisition",
      "Project Feasibility Analysis",
      "Construction Liaison",
      "RERA Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "PropTech AI",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Real Estate Development Principles",
      "Development Appraisal and Feasibility",
      "Real Estate Regulatory Framework",
      "RERA Compliance and Advisory",
      "Contract Management in Construction"
    ]
  },
  {
    "roleId": "JF35-004",
    "roleName": "RERA Compliance Officer",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "RERA Compliance Management",
      "Due Diligence - Real Estate",
      "RERA Filing",
      "Buyer Communication - RERA",
      "Statutory Return Submission"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio",
      "PropTech AI"
    ],
    "domainSkills": [
      "RERA Compliance and Advisory",
      "Real Estate Regulatory Framework",
      "Governance, Risk, and Compliance (GRC)",
      "Compliance Frameworks",
      "Information Security Policies and Standards"
    ]
  },
  {
    "roleId": "JF35-005",
    "roleName": "Leasing Manager",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Leasing Management",
      "Lease Negotiation",
      "Tenant Acquisition",
      "Lease Documentation",
      "Property Market Knowledge"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Leasing and Lease Management",
      "Commercial Property Leasing",
      "Real Estate Regulatory Framework",
      "Negotiation Principles",
      "RERA Compliance and Advisory"
    ]
  },
  {
    "roleId": "JF35-006",
    "roleName": "Property Manager",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Property Management",
      "Rent Collection",
      "Property Maintenance Management",
      "Tenant Management",
      "RERA Compliance"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Property Management Principles",
      "Building Operations and Maintenance Management",
      "Tenant Relationship Management",
      "RERA Compliance and Advisory",
      "Contract Management in Construction"
    ]
  },
  {
    "roleId": "JF35-007",
    "roleName": "Real Estate Analyst",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Real Estate Analysis",
      "Market Research - Real Estate",
      "Real Estate Financial Modelling",
      "Investment Analysis - RE",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "Claude",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Real Estate Market Analysis",
      "Investment Property Analysis",
      "Property Valuation Principles",
      "RERA Compliance and Advisory",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF35-008",
    "roleName": "Facilities Manager",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Facilities Management",
      "Hard Services Management",
      "Soft Services Management",
      "FM Contracts Management",
      "Vendor Performance Management"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Facilities Management Principles",
      "Planned Preventive Maintenance for Facilities",
      "Building Operations and Maintenance Management",
      "Environmental Health and Safety (EHS) Principles",
      "Contract Management in Construction"
    ]
  },
  {
    "roleId": "JF35-009",
    "roleName": "Site Acquisition Executive",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Site Acquisition",
      "Land Scouting",
      "Due Diligence - Real Estate",
      "Site Feasibility Assessment",
      "Property Market Knowledge"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "PropTech AI",
      "Perplexity AI",
      "Midjourney",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Site Acquisition and Land Assessment",
      "Real Estate Due Diligence",
      "Real Estate Regulatory Framework",
      "RERA Compliance and Advisory",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF35-010",
    "roleName": "Property Consultant",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Property Consulting",
      "Property Market Knowledge",
      "Investment Property Advisory",
      "Property Valuation",
      "Portfolio Advisory - RE"
    ],
    "aiToolSkills": [
      "PropTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Midjourney",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Valuation Methodologies",
      "Property Valuation Principles",
      "RERA Compliance and Advisory",
      "Real Estate Sales Principles",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF35-011",
    "roleName": "Facilities Coordinator",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Facilities Coordination",
      "Facilities Management",
      "Vendor Coordination - FM",
      "Helpdesk - Facilities",
      "PPM Scheduling"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "PropTech AI",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Facilities Management Principles",
      "Building Operations and Maintenance Management",
      "Property Management Principles",
      "Environmental Health and Safety (EHS) Principles",
      "Contract Management in Construction"
    ]
  },
  {
    "roleId": "JF35-012",
    "roleName": "Real Estate Marketing Executive",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Real Estate Marketing",
      "Property Campaign Management",
      "Real Estate Digital Marketing",
      "Digital Marketing",
      "Property Launch Management"
    ],
    "aiToolSkills": [
      "Midjourney",
      "ChatGPT",
      "Canva Magic Studio",
      "PropTech AI",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Marketing Fundamentals",
      "Real Estate Sales Principles",
      "Brand Identity and Positioning",
      "Digital Marketing Principles",
      "Brand Management Principles"
    ]
  },
  {
    "roleId": "JF35-013",
    "roleName": "Tenant Relations Executive",
    "jobFamily": "Real Estate & Facilities",
    "technicalSkills": [
      "Tenant Relations",
      "Tenant Grievance Management",
      "Tenant Management",
      "Lease Renewal Management",
      "Occupancy Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "PropTech AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Tenant Relationship Management",
      "Property Management Principles",
      "Customer Service Principles",
      "RERA Compliance and Advisory",
      "Building Operations and Maintenance Management"
    ]
  },
  {
    "roleId": "JF36-001",
    "roleName": "General Physician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "General Medicine",
      "Clinical Diagnosis",
      "Patient Management",
      "Pharmacology",
      "Preventive Healthcare"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Pharmacology Principles",
      "Medical Ethics and Professional Standards",
      "Clinical Research Principles"
    ]
  },
  {
    "roleId": "JF36-002",
    "roleName": "Cardiologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Cardiology",
      "Echocardiography",
      "ECG Interpretation",
      "Cardiac Catheterisation",
      "Heart Failure Management"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Cardiology Principles",
      "Cardiac Investigations and Interventions",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Pharmacology Principles"
    ]
  },
  {
    "roleId": "JF36-003",
    "roleName": "Neurologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Neurology",
      "Clinical Diagnosis",
      "Stroke Management",
      "EEG Interpretation",
      "Neurodiagnostics"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Neurology Principles",
      "Neurological Examination and Diagnosis",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Pharmacology Principles"
    ]
  },
  {
    "roleId": "JF36-004",
    "roleName": "Oncologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Oncology",
      "Chemotherapy Protocols",
      "Patient Management",
      "Tumour Board Management",
      "Palliative Care"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Oncology Principles",
      "Cancer Biology and Treatment Modalities",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-005",
    "roleName": "Dermatologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Dermatology",
      "Clinical Diagnosis",
      "Dermatoscopy",
      "Skin Biopsy",
      "Aesthetic Dermatology"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Dermatology Principles",
      "Skin Disease Diagnosis and Management",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-006",
    "roleName": "Psychiatrist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Psychiatry",
      "Psychiatric Assessment",
      "Psychopharmacology",
      "Mental Health Management",
      "Patient Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Psychiatry and Mental Health Principles",
      "Psychopathology and Psychiatric Diagnosis",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-007",
    "roleName": "Paediatrician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Paediatrics",
      "Clinical Diagnosis",
      "Child Development Assessment",
      "Neonatal Care",
      "Paediatric Immunisation"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Paediatric Medicine Principles",
      "Child Development and Paediatric Assessment",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-008",
    "roleName": "Gynaecologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Gynaecology",
      "Obstetrics",
      "Ante-Natal Care",
      "Gynaecological Surgery",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Gynaecology and Obstetrics Principles",
      "Reproductive Health and Obstetric Management",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-009",
    "roleName": "Orthopaedic Surgeon",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Orthopaedic Surgery",
      "Fracture Management",
      "Joint Replacement Surgery",
      "Arthroscopy",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Orthopaedic Surgery Principles",
      "Musculoskeletal Anatomy and Biomechanics",
      "Surgical Techniques and Perioperative Care",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-010",
    "roleName": "Radiologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Radiology",
      "CT Scan Interpretation",
      "MRI Interpretation",
      "X-Ray Interpretation",
      "Interventional Radiology"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "Microsoft 365 Copilot",
      "Perplexity AI",
      "Health Informatics AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Radiology and Medical Imaging Principles",
      "Imaging Modalities and Interpretation",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-011",
    "roleName": "Anaesthesiologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Anaesthesiology",
      "General Anaesthesia",
      "Regional Anaesthesia",
      "Critical Care Medicine",
      "Pain Management"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Anaesthesiology Principles",
      "Perioperative Medicine",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-012",
    "roleName": "Ophthalmologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Ophthalmology",
      "Slit Lamp Examination",
      "Cataract Surgery",
      "Refractive Surgery",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Ophthalmology Principles",
      "Ocular Anatomy and Disease Management",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Pharmacology Principles"
    ]
  },
  {
    "roleId": "JF36-013",
    "roleName": "ENT Specialist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "ENT Medicine",
      "Endoscopic ENT Surgery",
      "Audiometry",
      "Head and Neck Surgery",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Otorhinolaryngology (ENT) Principles",
      "Head and Neck Anatomy and Pathology",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Surgical Techniques and Perioperative Care"
    ]
  },
  {
    "roleId": "JF36-014",
    "roleName": "Endocrinologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Endocrinology",
      "Diabetes Management",
      "Thyroid Disorders",
      "Hormonal Disorder Management",
      "Patient Management"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Endocrinology Principles",
      "Hormonal Disorders and Metabolic Management",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-015",
    "roleName": "Nephrologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Nephrology",
      "Renal Replacement Therapy",
      "Dialysis Management",
      "Patient Management",
      "Kidney Transplant Management"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Nephrology Principles",
      "Renal Disease and Replacement Therapy Concepts",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-016",
    "roleName": "Gastroenterologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Gastroenterology",
      "Endoscopy",
      "Colonoscopy",
      "Liver Disease Management",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Gastroenterology Principles",
      "Gastrointestinal and Hepatic Disease Management",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Pharmacology Principles"
    ]
  },
  {
    "roleId": "JF36-017",
    "roleName": "General Surgeon",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "General Surgery",
      "Laparoscopic Surgery",
      "Surgical Wound Management",
      "Emergency Surgery",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "General Surgery Principles",
      "Surgical Techniques and Perioperative Care",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-018",
    "roleName": "Dentist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Dentistry",
      "Restorative Dentistry",
      "Root Canal Treatment",
      "Tooth Extraction",
      "Dental X-Ray Interpretation"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Dentistry Principles",
      "Oral Diagnosis and Dental Treatment",
      "Pharmacology Principles",
      "Medical Ethics and Professional Standards",
      "Clinical Medicine Fundamentals"
    ]
  },
  {
    "roleId": "JF36-019",
    "roleName": "Orthodontist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Orthodontics",
      "Braces and Aligners",
      "Cephalometric Analysis",
      "Malocclusion Treatment",
      "Dental X-Ray Interpretation"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Orthodontic Principles",
      "Occlusion and Malocclusion Management",
      "Dentistry Principles",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-020",
    "roleName": "Oral Surgeon",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Oral Surgery",
      "Dental Implants",
      "Jaw Surgery",
      "Impacted Tooth Removal",
      "Tooth Extraction"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Oral Surgery Principles",
      "Dentoalveolar and Maxillofacial Surgery",
      "Dentistry Principles",
      "Surgical Techniques and Perioperative Care",
      "Pharmacology Principles"
    ]
  },
  {
    "roleId": "JF36-021",
    "roleName": "Ayurvedic Physician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Ayurveda",
      "Panchakarma",
      "Ayurvedic Diagnosis",
      "Herbal Formulation",
      "Nadi Pariksha"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Ayurvedic Medicine Principles",
      "Panchakarma and Ayurvedic Therapeutics",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-022",
    "roleName": "Homeopathic Doctor",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Homeopathy",
      "Homeopathic Case Taking",
      "Materia Medica",
      "Repertorisation",
      "Constitutional Prescribing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Homeopathic Medicine Principles",
      "Homeopathic Materia Medica and Repertory",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-023",
    "roleName": "Unani Physician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Unani Medicine",
      "Mizaj Evaluation",
      "Unani Pharmacology",
      "Ilaj Bil Tadbeer",
      "Clinical Diagnosis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Unani Medicine Principles",
      "Ilaj-bil-Tadbeer and Unani Therapeutics",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-024",
    "roleName": "Registered Nurse",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Nursing",
      "Patient Care",
      "Medication Administration",
      "Vital Signs Monitoring",
      "Wound Dressing"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Nursing Principles and Practice",
      "Patient Assessment and Care Planning",
      "Clinical Medicine Fundamentals",
      "Pharmacology Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-025",
    "roleName": "Physiotherapist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Physiotherapy",
      "Manual Therapy",
      "Exercise Prescription",
      "Electrotherapy",
      "Functional Assessment"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Physiotherapy Principles",
      "Exercise Therapy and Rehabilitation Concepts",
      "Diagnosis and Treatment Principles",
      "Musculoskeletal Anatomy and Biomechanics",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-026",
    "roleName": "Occupational Therapist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Occupational Therapy",
      "Functional Assessment",
      "Activity of Daily Living Training",
      "Assistive Device Prescription",
      "Patient Management"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Occupational Therapy Principles",
      "Functional Assessment and ADL Rehabilitation",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-027",
    "roleName": "Radiology Technician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Radiography",
      "X-Ray Operation",
      "CT Operation",
      "Radiation Safety (Healthcare)",
      "X-Ray Interpretation"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "Microsoft 365 Copilot",
      "Perplexity AI",
      "Health Informatics AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Radiography and Medical Imaging Technology",
      "Radiation Safety and Patient Protection",
      "Radiology and Medical Imaging Principles",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-028",
    "roleName": "Lab Technician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Medical Laboratory Technology",
      "Haematology Testing",
      "Biochemistry Testing",
      "Microbiology Testing",
      "Sample Collection"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Clinical Laboratory Science Principles",
      "Laboratory Diagnostics Methodology",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF36-029",
    "roleName": "Dietitian & Nutritionist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Dietetics",
      "Clinical Nutrition",
      "Nutritional Assessment",
      "Diet Planning",
      "Patient Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Dietetics and Nutrition Science",
      "Clinical Nutrition and Therapeutic Diets",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-030",
    "roleName": "Speech Therapist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Speech Therapy",
      "Language Disorder Assessment",
      "Articulation Therapy",
      "Dysphagia Management",
      "Patient Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Speech and Language Pathology Principles",
      "Communication Disorders Assessment",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-031",
    "roleName": "Optometrist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Optometry",
      "Refraction Testing",
      "Contact Lens Fitting",
      "Visual Field Testing",
      "Slit Lamp Examination"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Optometry Principles",
      "Vision Assessment and Refraction",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-032",
    "roleName": "Audiologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Audiology",
      "Audiometry",
      "Hearing Aid Fitting",
      "Tympanometry",
      "Cochlear Implant Rehabilitation"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Audiology Principles",
      "Hearing Assessment and Audiological Rehabilitation",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-033",
    "roleName": "Medical Social Worker",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Medical Social Work",
      "Patient Counselling",
      "Discharge Planning",
      "Community Resource Linkage",
      "Patient Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Health Informatics AI",
      "AI Medical Diagnosis",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Medical Social Work Principles",
      "Psychosocial Assessment and Care Coordination",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Psychiatry and Mental Health Principles"
    ]
  },
  {
    "roleId": "JF36-034",
    "roleName": "Operation Theatre Technician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Operation Theatre Technology",
      "Surgical Instrument Sterilisation",
      "OT Setup and Turnover",
      "Anaesthesia Equipment Assistance",
      "Medication Administration"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Operation Theatre Techniques",
      "Surgical Instrumentation and Sterile Field",
      "Clinical Medicine Fundamentals",
      "General Surgery Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-035",
    "roleName": "Dialysis Technician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Dialysis Technology",
      "Haemodialysis Machine Operation",
      "Vascular Access Management",
      "Dialysis Patient Monitoring",
      "Dialysis Management"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Dialysis Technology Principles",
      "Renal Replacement Therapy Operations",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Renal Disease and Replacement Therapy Concepts"
    ]
  },
  {
    "roleId": "JF36-036",
    "roleName": "ECG Technician",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "ECG Technology",
      "ECG Recording",
      "ECG Interpretation",
      "Holter Monitor Operation",
      "Cardiac Stress Test Assistance"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "Microsoft 365 Copilot",
      "Perplexity AI",
      "Health Informatics AI",
      "Abridge"
    ],
    "domainSkills": [
      "ECG Technology and Cardiac Monitoring",
      "Electrocardiogram Interpretation Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Cardiac Investigations and Interventions"
    ]
  },
  {
    "roleId": "JF36-037",
    "roleName": "Clinical Psychologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Clinical Psychology",
      "Psychological Assessment",
      "Cognitive Behavioural Therapy",
      "Psychotherapy",
      "Psychiatric Assessment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Medical Diagnosis",
      "Health Informatics AI",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Clinical Psychology Principles",
      "Psychological Assessment and Psychotherapy",
      "Psychopathology and Psychiatric Diagnosis",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-038",
    "roleName": "Counselling Psychologist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Counselling Psychology",
      "Individual Counselling",
      "Cognitive Behavioural Therapy",
      "Grief and Trauma Counselling",
      "Group Therapy Facilitation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Health Informatics AI",
      "AI Medical Diagnosis",
      "Perplexity AI",
      "Abridge"
    ],
    "domainSkills": [
      "Counselling Psychology Principles",
      "Counselling Theory and Practice",
      "Diagnosis and Treatment Principles",
      "Psychiatry and Mental Health Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF36-039",
    "roleName": "Rehabilitation Specialist",
    "jobFamily": "Healthcare — Clinical",
    "technicalSkills": [
      "Rehabilitation Medicine",
      "Rehabilitation Programme Design",
      "Disability Assessment",
      "Multidisciplinary Rehab Coordination",
      "Physiotherapy"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Microsoft Dragon Copilot"
    ],
    "domainSkills": [
      "Rehabilitation Medicine Principles",
      "Interdisciplinary Rehabilitation Planning",
      "Clinical Medicine Fundamentals",
      "Diagnosis and Treatment Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF37-001",
    "roleName": "Hospital Administrator",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Hospital Administration",
      "Healthcare Operations Management",
      "Hospital Revenue Management",
      "Patient Experience Management",
      "Healthcare Regulatory Compliance"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Perplexity AI",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Hospital Administration Principles",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF37-002",
    "roleName": "Healthcare Quality Manager",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Healthcare Quality Management",
      "NABH Accreditation",
      "Clinical Audit",
      "Patient Safety Management",
      "Healthcare KPI Management"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "Clinical Quality Improvement",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Quality Engineering Principles"
    ]
  },
  {
    "roleId": "JF37-003",
    "roleName": "Health Informatics Manager",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Health Informatics",
      "Healthcare IT Management",
      "EMR Implementation",
      "Health Data Standards",
      "Clinical Decision Support"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "Perplexity AI",
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Health Informatics Principles",
      "Clinical Data Governance",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF37-004",
    "roleName": "Medical Records Manager",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Medical Records Management",
      "ICD Coding",
      "Medical Documentation Standards",
      "Record Retention Compliance",
      "Healthcare Regulatory Compliance"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "Health Information Coding and Classification",
      "Medical Ethics and Professional Standards",
      "Clinical Medicine Fundamentals",
      "Compliance Frameworks"
    ]
  },
  {
    "roleId": "JF37-005",
    "roleName": "Patient Relations Manager",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Patient Relations Management",
      "Complaint Resolution - Healthcare",
      "Patient Feedback Management",
      "Patient Experience Management",
      "Patient Rights Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Health Informatics AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "Patient Experience and Service Recovery",
      "Medical Ethics and Professional Standards",
      "Clinical Medicine Fundamentals",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF37-006",
    "roleName": "Epidemiologist",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Epidemiology",
      "Disease Surveillance",
      "Outbreak Investigation",
      "Epidemiological Study Design",
      "Biostatistics"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "ChatGPT",
      "Google NotebookLM",
      "Health Informatics AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Epidemiology Principles",
      "Disease Surveillance and Outbreak Investigation",
      "Biostatistics Principles",
      "Clinical Medicine Fundamentals",
      "Biostatistical Modelling and Study Design"
    ]
  },
  {
    "roleId": "JF37-007",
    "roleName": "Public Health Officer",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Public Health",
      "Health Programme Implementation",
      "Community Health Assessment",
      "Epidemiology",
      "Vector Control"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Health Informatics AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Public Health Principles",
      "Health Promotion and Disease Prevention",
      "Epidemiology Principles",
      "Medical Ethics and Professional Standards",
      "Clinical Medicine Fundamentals"
    ]
  },
  {
    "roleId": "JF37-008",
    "roleName": "Health Inspector",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Health Inspection",
      "Food Safety Inspection",
      "Sanitation Standards",
      "Health Code Enforcement",
      "Public Health"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Health Informatics AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Environmental and Occupational Health Inspection",
      "Health Regulation and Inspection Methodology",
      "Public Health Principles",
      "Medical Ethics and Professional Standards",
      "Epidemiology Principles"
    ]
  },
  {
    "roleId": "JF37-009",
    "roleName": "Community Health Worker",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Community Health",
      "Health Outreach",
      "Health Education Delivery",
      "Referral Management",
      "Patient Care"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Health Informatics AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Community Health Principles",
      "Community Health Education and Outreach",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Public Health Principles"
    ]
  },
  {
    "roleId": "JF37-010",
    "roleName": "Biostatistician",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Biostatistics",
      "Clinical Trial Statistics",
      "Statistical Software for Health",
      "Survival Analysis",
      "R Programming"
    ],
    "aiToolSkills": [
      "Claude",
      "Perplexity AI",
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Biostatistics Principles",
      "Biostatistical Modelling and Study Design",
      "Diagnosis and Treatment Principles",
      "Clinical Medicine Fundamentals",
      "Epidemiology Principles"
    ]
  },
  {
    "roleId": "JF37-011",
    "roleName": "Medical Coding Analyst",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Medical Coding",
      "ICD Coding",
      "CPT Coding",
      "DRG Coding",
      "Coding Audit"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Medical Coding Principles",
      "ICD and CPT Classification Systems",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Health Information Coding and Classification"
    ]
  },
  {
    "roleId": "JF37-012",
    "roleName": "Healthcare Data Analyst",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Healthcare Data Analysis",
      "Clinical Outcomes Analysis",
      "SQL",
      "Healthcare Dashboard Reporting",
      "Population Health Analytics"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "Perplexity AI",
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "Clinical and Operational Health Analytics",
      "Data Visualization Principles",
      "Clinical Medicine Fundamentals",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF37-013",
    "roleName": "Clinical Coordinator",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Clinical Coordination",
      "Clinical Trial Coordination",
      "Protocol Compliance - Clinical",
      "Study Site Management",
      "Patient Management"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Abridge",
      "Perplexity AI",
      "AI Medical Diagnosis"
    ],
    "domainSkills": [
      "Clinical Coordination Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Diagnosis and Treatment Principles",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF37-014",
    "roleName": "Patient Care Coordinator",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Patient Care Coordination",
      "Care Pathway Management",
      "Patient Management",
      "Appointment Scheduling",
      "Insurance Authorisation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Health Informatics AI",
      "Perplexity AI",
      "Google NotebookLM",
      "AI Medical Diagnosis"
    ],
    "domainSkills": [
      "Patient Care Coordination Concepts",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Customer Service Principles",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF37-015",
    "roleName": "Health Insurance Executive",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Health Insurance",
      "Claims Processing - Health",
      "Pre-Authorisation Management",
      "TPA Coordination",
      "Medical Coding"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Health Informatics AI",
      "Claude",
      "Perplexity AI",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Health Insurance and Third-Party Payer Concepts",
      "Insurance Claims and Pre-Authorisation",
      "Clinical Medicine Fundamentals",
      "Insurance Principles and Concepts",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF37-016",
    "roleName": "Revenue Cycle Analyst",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Revenue Cycle Management",
      "Denial Management",
      "Medical Billing",
      "Revenue Cycle Analytics",
      "Medical Coding"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "Perplexity AI",
      "ChatGPT",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "ICD and CPT Classification Systems",
      "Medical Billing and Coding Compliance",
      "Medical Coding Principles",
      "Clinical and Operational Health Analytics",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF37-017",
    "roleName": "Telemedicine Coordinator",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Telemedicine Coordination",
      "Teleconsultation Platform Management",
      "Remote Patient Monitoring",
      "Appointment Scheduling",
      "Digital Health Compliance"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Perplexity AI",
      "AI Medical Diagnosis",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Telemedicine Principles",
      "Virtual Care Operations",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF37-018",
    "roleName": "Biomedical Equipment Technician",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Biomedical Equipment Technology",
      "Medical Equipment Maintenance",
      "Equipment Calibration",
      "Biomedical Safety Testing",
      "CMMS"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "Medical Device Maintenance and Safety",
      "Electrical Engineering Fundamentals",
      "Clinical Medicine Fundamentals",
      "Troubleshooting and Fault Diagnosis"
    ]
  },
  {
    "roleId": "JF37-019",
    "roleName": "Hospital Quality Executive",
    "jobFamily": "Healthcare — Operations & Administration",
    "technicalSkills": [
      "Hospital Quality Execution",
      "Healthcare Quality Management",
      "NABH Documentation",
      "Quality Incident Reporting",
      "Quality Monitoring"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Google NotebookLM",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "Clinical Quality Improvement",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF38-001",
    "roleName": "Pharmacist",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmacy Practice",
      "Drug Dispensing",
      "Drug Interaction Checking",
      "Pharmaceutical Care",
      "Schedule H Drug Regulations"
    ],
    "aiToolSkills": [
      "Pharma AI",
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Pharmaceutical Sciences Fundamentals",
      "Pharmacology and Therapeutics",
      "Pharmacology Principles",
      "Medical Ethics and Professional Standards",
      "Clinical Medicine Fundamentals"
    ]
  },
  {
    "roleId": "JF38-002",
    "roleName": "Drug Regulatory Affairs Officer",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Drug Regulatory Affairs",
      "CDSCO Submissions",
      "Clinical Trial Regulatory Support",
      "Drug Dossier Preparation",
      "GMP Audit Support"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Perplexity AI",
      "Pharma AI"
    ],
    "domainSkills": [
      "Drug Regulatory Affairs Principles",
      "Drug Approval and Submission Process",
      "Pharmaceutical Sciences Fundamentals",
      "Regulatory Affairs Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-003",
    "roleName": "Medical Representative (MR)",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Medical Sales",
      "Doctor Detailing",
      "Product Knowledge - Pharma",
      "Territory Management - Pharma",
      "Sales"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Microsoft 365 Copilot",
      "Pharma AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Pharmaceutical Sales Principles",
      "Medical Detailing and Product Knowledge",
      "Pharmacology Principles",
      "Clinical Medicine Fundamentals",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF38-004",
    "roleName": "Pharmaceutical Research Scientist",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmaceutical Research",
      "Drug Discovery",
      "In-Vitro Studies",
      "Medicinal Chemistry",
      "Spectroscopy"
    ],
    "aiToolSkills": [
      "Pharma AI",
      "Claude",
      "Microsoft Dragon Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Pharmaceutical Research Methodology",
      "Drug Discovery and Development Concepts",
      "Pharmaceutical Sciences Fundamentals",
      "Research and Development Methodology",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-005",
    "roleName": "Clinical Research Associate (CRA)",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Clinical Research",
      "Site Monitoring",
      "ICH-GCP Compliance",
      "Source Data Verification",
      "Protocol Compliance - Clinical"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Clinical Research Principles",
      "Clinical Trial Monitoring Methodology",
      "GCP and ICH Guidelines",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-006",
    "roleName": "Quality Control Analyst - Pharma",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmaceutical QC",
      "HPLC - Pharma",
      "In-Process Quality Testing - Pharma",
      "Finished Product Testing",
      "Out of Specification Investigation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Pharma AI",
      "Microsoft Dragon Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Pharmaceutical Quality Control Principles",
      "Analytical Method Validation",
      "Analytical Chemistry Principles",
      "Laboratory Analysis Techniques",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-007",
    "roleName": "Pharmacovigilance Analyst",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmacovigilance",
      "Adverse Event Reporting",
      "Signal Detection",
      "PSUR Preparation",
      "MedDRA Coding"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Pharma AI",
      "Claude",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Pharmacovigilance Principles",
      "Adverse Drug Reaction Reporting",
      "Pharmacology Principles",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-008",
    "roleName": "Drug Safety Associate",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Drug Safety",
      "Case Processing",
      "MedDRA Coding",
      "Regulatory Safety Reporting",
      "Adverse Event Reporting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Pharma AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Pharmacovigilance Principles",
      "Adverse Drug Reaction Reporting",
      "Pharmacology Principles",
      "Medical Coding Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-009",
    "roleName": "Medical Writer",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Medical Writing",
      "Clinical Study Report Writing",
      "Regulatory Document Writing",
      "Scientific Literature Review",
      "ICH-GCP Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Perplexity AI",
      "Pharma AI"
    ],
    "domainSkills": [
      "Medical Writing Principles",
      "Regulatory Medical Document Writing",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Clinical Research Principles"
    ]
  },
  {
    "roleId": "JF38-010",
    "roleName": "Biotechnologist",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Biotechnology",
      "Cell Culture",
      "Recombinant DNA Technology",
      "PCR Techniques",
      "Spectroscopy"
    ],
    "aiToolSkills": [
      "Claude",
      "Microsoft Dragon Copilot",
      "ChatGPT",
      "Perplexity AI",
      "Pharma AI"
    ],
    "domainSkills": [
      "Biotechnology Principles",
      "Molecular Biology and Cell Biology Fundamentals",
      "Research and Development Methodology",
      "Engineering Experimentation",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-011",
    "roleName": "Bioinformatics Scientist",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Bioinformatics",
      "Genomic Data Analysis",
      "Python",
      "Sequence Alignment",
      "Protein Structure Prediction"
    ],
    "aiToolSkills": [
      "Microsoft 365 Copilot",
      "Microsoft Dragon Copilot",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Bioinformatics Principles",
      "Genomics and Sequence Analysis Concepts",
      "Molecular Biology and Cell Biology Fundamentals",
      "Engineering Experimentation",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF38-012",
    "roleName": "Genetic Counsellor",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Genetic Counselling",
      "Hereditary Disease Assessment",
      "Pedigree Analysis",
      "Genomic Test Interpretation",
      "Patient Counselling"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Genetic Counselling Principles",
      "Genetics and Heredity Concepts",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF38-013",
    "roleName": "Stem Cell Researcher",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Stem Cell Research",
      "Cell Therapy Development",
      "Stem Cell Culture",
      "Cell Culture",
      "Differentiation Protocols"
    ],
    "aiToolSkills": [
      "Microsoft 365 Copilot",
      "Microsoft Dragon Copilot",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Stem Cell Science and Regenerative Medicine",
      "Cell Culture and Tissue Engineering Concepts",
      "Molecular Biology and Cell Biology Fundamentals",
      "Research and Development Methodology",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-014",
    "roleName": "Regulatory Affairs Executive",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Regulatory Affairs Execution",
      "Drug Regulatory Affairs",
      "Drug Licence Management",
      "Regulatory Submissions Filing",
      "Regulatory Database Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Perplexity AI",
      "Pharma AI"
    ],
    "domainSkills": [
      "Drug Regulatory Affairs Principles",
      "Drug Approval and Submission Process",
      "Regulatory Affairs Principles",
      "Pharmaceutical Sciences Fundamentals",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-015",
    "roleName": "Clinical Data Associate",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Clinical Data Management",
      "EDC System Operation",
      "Data Cleaning",
      "Data Query Management",
      "Source Data Verification"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Clinical Data Management Principles",
      "Clinical Database Design and Entry Concepts",
      "GCP and ICH Guidelines",
      "Medical Ethics and Professional Standards",
      "Clinical Medicine Fundamentals"
    ]
  },
  {
    "roleId": "JF38-016",
    "roleName": "Formulation Scientist",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmaceutical Formulation",
      "Dosage Form Development",
      "Excipient Selection",
      "Stability Studies",
      "GMP Compliance"
    ],
    "aiToolSkills": [
      "Pharma AI",
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Drug Formulation Principles",
      "Dosage Form Design and Development",
      "Pharmaceutical Sciences Fundamentals",
      "Analytical Chemistry Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-017",
    "roleName": "Analytical Chemist - Pharma",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmaceutical Analytical Chemistry",
      "Method Development - Pharma",
      "HPLC - Pharma",
      "Method Validation",
      "Dissolution Testing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Power BI Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Analytical Chemistry Principles",
      "Analytical Method Validation",
      "Laboratory Analysis Techniques",
      "Pharmaceutical Quality Control Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-018",
    "roleName": "Clinical Trials Coordinator",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Clinical Trials Coordination",
      "Patient Enrolment Management",
      "ICH-GCP Compliance",
      "Trial Master File Management",
      "IRB Submission Management"
    ],
    "aiToolSkills": [
      "Health Informatics AI",
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Diagnosis and Treatment Principles",
      "GCP and ICH Guidelines",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Clinical Research Principles"
    ]
  },
  {
    "roleId": "JF38-019",
    "roleName": "Lab Research Associate",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Laboratory Research",
      "Assay Development",
      "Laboratory Techniques",
      "Data Recording and Analysis",
      "Lab Safety Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Power BI Copilot",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Laboratory Research Methodology",
      "Experimental Techniques in Life Sciences",
      "Research and Development Methodology",
      "Medical Ethics and Professional Standards",
      "Laboratory Analysis Techniques"
    ]
  },
  {
    "roleId": "JF38-020",
    "roleName": "Medical Science Liaison (MSL)",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Medical Science Liaison",
      "KOL Engagement",
      "Clinical Evidence Communication",
      "Product Knowledge - Pharma",
      "Scientific Advisory Board Support"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Claude",
      "Pharma AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Medical Science Liaison Principles",
      "Scientific Communication and KOL Engagement",
      "Clinical Medicine Fundamentals",
      "Pharmacology and Therapeutics",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF38-021",
    "roleName": "Validation Engineer",
    "jobFamily": "Pharma, Biotech & Life Sciences",
    "technicalSkills": [
      "Pharmaceutical Validation",
      "Process Validation - Pharma",
      "Equipment Qualification",
      "Validation Protocol Writing",
      "21 CFR Part 11"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Dragon Copilot",
      "Pharma AI",
      "Claude",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Validation Engineering Principles",
      "Process and Equipment Validation",
      "Pharmaceutical Sciences Fundamentals",
      "Engineering Design Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-001",
    "roleName": "Primary School Teacher",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Primary Education",
      "Classroom Management",
      "Child-Centred Teaching",
      "Lesson Planning",
      "Student Assessment"
    ],
    "aiToolSkills": [
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "AI Learning Management System",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Teaching Principles and Pedagogy",
      "Child Development and Learning Theory",
      "Curriculum and Lesson Planning",
      "Inclusive Education and Differentiated Instruction",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-002",
    "roleName": "Secondary School Teacher",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Secondary Education",
      "Subject Matter Expertise",
      "Curriculum Delivery",
      "Lesson Planning",
      "Examination Preparation"
    ],
    "aiToolSkills": [
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "AI Learning Management System",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Teaching Principles and Pedagogy",
      "Secondary Education Pedagogy",
      "Subject Matter Expertise for Secondary Teaching",
      "Curriculum and Lesson Planning",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-003",
    "roleName": "Post Graduate Teacher",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Post Graduate Teaching",
      "Advanced Subject Knowledge",
      "Board Exam Coaching",
      "Lesson Planning",
      "Research-Based Teaching"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI in Education",
      "Khanmigo",
      "MagicSchool AI",
      "AI Learning Management System"
    ],
    "domainSkills": [
      "Post-Graduate Teaching Methodology",
      "Higher-Order Thinking and Academic Skills",
      "Subject Matter Expertise for Secondary Teaching",
      "Curriculum and Lesson Planning",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF39-004",
    "roleName": "Special Educator",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Special Education",
      "Individualised Education Plan",
      "Learning Disability Support",
      "Inclusive Education Practices",
      "Classroom Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI in Education",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Special Education Principles",
      "Inclusive Education and Differentiated Instruction",
      "Child Development and Learning Theory",
      "Teaching Principles and Pedagogy",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-005",
    "roleName": "School Principal",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "School Leadership",
      "Academic Administration",
      "School Governance",
      "Parent and Community Engagement",
      "Team Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "School Leadership and Administration",
      "Educational Policy and Governance",
      "Teaching Principles and Pedagogy",
      "Learning and Development Strategy",
      "Banking Products and Services"
    ]
  },
  {
    "roleId": "JF39-006",
    "roleName": "Academic Coordinator",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Academic Coordination",
      "Timetable Management",
      "Academic Programme Management",
      "Teacher Performance Monitoring",
      "Lesson Planning"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI",
      "AI in Education"
    ],
    "domainSkills": [
      "Academic Coordination Principles",
      "Timetabling and Academic Scheduling",
      "Teaching Principles and Pedagogy",
      "Curriculum and Lesson Planning",
      "Child Development and Learning Theory"
    ]
  },
  {
    "roleId": "JF39-007",
    "roleName": "School Counsellor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "School Counselling",
      "Career Guidance",
      "Student Welfare Management",
      "Behavioural Intervention",
      "Counselling Psychology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI in Education",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "School Counselling Principles",
      "Psychosocial Development in Adolescents",
      "Counselling Psychology Principles",
      "Child Development and Learning Theory",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-008",
    "roleName": "Physical Education Teacher",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Physical Education",
      "Sports Coaching",
      "Fitness Programme Design",
      "Classroom Management",
      "Sports Event Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI in Education",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Physical Education Principles",
      "Sports Science and Exercise Physiology Concepts",
      "Teaching Principles and Pedagogy",
      "Child Development and Learning Theory",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-009",
    "roleName": "Assistant Professor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Higher Education Teaching",
      "University Pedagogy",
      "Research Publication",
      "Academic Research",
      "Lesson Planning"
    ],
    "aiToolSkills": [
      "AI in Education",
      "ChatGPT",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Higher Education Teaching Principles",
      "Academic Research Methodology",
      "Subject Matter Expertise for Secondary Teaching",
      "Adult Learning Theory",
      "Academic Scientific Writing"
    ]
  },
  {
    "roleId": "JF39-010",
    "roleName": "Associate Professor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Associate Professorship",
      "Higher Education Teaching",
      "Research Supervision",
      "Academic Research",
      "Grant Writing"
    ],
    "aiToolSkills": [
      "AI in Education",
      "ChatGPT",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Higher Education Teaching Principles",
      "Scholarly Research Principles",
      "Research Supervision and Mentoring",
      "Academic Research Methodology",
      "Academic Scientific Writing"
    ]
  },
  {
    "roleId": "JF39-011",
    "roleName": "Professor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Professorship",
      "Doctoral Supervision",
      "Academic Leadership",
      "Grant Writing",
      "Research Publication"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "Khanmigo",
      "AI in Education",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Scholarly Research Principles",
      "Research Supervision and Mentoring",
      "Higher Education Teaching Principles",
      "Educational Policy and Governance",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF39-012",
    "roleName": "Registrar",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Academic Registry Management",
      "Student Records Management",
      "Examination Management",
      "Accreditation Support",
      "Compliance Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI in Education",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "University Administration Principles",
      "Academic Records and Examination Management",
      "Educational Policy and Governance",
      "Teaching Principles and Pedagogy",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF39-013",
    "roleName": "Research Scientist",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Scientific Research",
      "Experimental Design",
      "Academic Research",
      "Research Data Analysis",
      "Peer Review"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI in Education",
      "AI Learning Management System",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Scientific Research Principles",
      "Research Design and Experimental Methods",
      "Research and Development Methodology",
      "Engineering Experimentation",
      "Academic Scientific Writing"
    ]
  },
  {
    "roleId": "JF39-014",
    "roleName": "Research Fellow",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Research Fellowship",
      "Independent Research",
      "Academic Research",
      "Literature Synthesis",
      "Research Publication"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Academic Research Methodology",
      "Research Design and Experimental Methods",
      "Research and Development Methodology",
      "Academic Scientific Writing",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF39-015",
    "roleName": "Lab Scientist",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Laboratory Science",
      "Scientific Instrumentation",
      "Laboratory Techniques",
      "Lab Quality Management",
      "Lab Safety Compliance"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "Khanmigo",
      "AI in Education",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Scientific Research Principles",
      "Laboratory Research Methodology",
      "Experimental Techniques in Life Sciences",
      "Engineering Experimentation",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-016",
    "roleName": "Research Associate",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Research Support",
      "Data Collection",
      "Research Data Analysis",
      "Literature Synthesis",
      "Research Report Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Khanmigo",
      "Salesforce Einstein",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Academic Research Methodology",
      "Research Design and Experimental Methods",
      "Research and Development Methodology",
      "Teaching Principles and Pedagogy",
      "Academic Scientific Writing"
    ]
  },
  {
    "roleId": "JF39-017",
    "roleName": "E-Learning Developer",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "E-Learning Development",
      "Instructional Design",
      "Articulate Storyline",
      "Multimedia Learning Design",
      "SCORM Content Development"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Learning Management System",
      "Khanmigo",
      "Power BI Copilot",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "E-Learning Development Principles",
      "Digital Instructional Design",
      "Instructional Design Principles",
      "Adult Learning Theory",
      "Curriculum Development Principles"
    ]
  },
  {
    "roleId": "JF39-018",
    "roleName": "Curriculum Developer",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Curriculum Development",
      "Instructional Design",
      "Curriculum Mapping",
      "Competency Framework Design",
      "Bloom's Taxonomy Application"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Learning Management System",
      "AI in Education",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Curriculum Development Principles",
      "Learning Outcomes Design",
      "Instructional Design Principles",
      "Adult Learning Theory",
      "Learning and Development Strategy"
    ]
  },
  {
    "roleId": "JF39-019",
    "roleName": "Online Tutor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Online Tutoring",
      "Virtual Classroom Facilitation",
      "Lesson Planning",
      "Student Progress Tracking",
      "Adaptive Learning Techniques"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Online Teaching and Facilitation",
      "Teaching Principles and Pedagogy",
      "Adult Learning Theory",
      "Curriculum and Lesson Planning",
      "Educational Technology Concepts"
    ]
  },
  {
    "roleId": "JF39-020",
    "roleName": "Learning Management System (LMS) Admin",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "LMS Administration",
      "Course Management",
      "Moodle",
      "User Enrolment Management",
      "LMS Reporting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Khanmigo",
      "Salesforce Einstein",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Learning Management System (LMS) Administration",
      "Educational Technology Concepts",
      "Learning and Development Strategy",
      "Instructional Design Principles",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF39-021",
    "roleName": "EdTech Product Manager",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "EdTech Product Management",
      "Product Management",
      "Learning Product Design",
      "Ed Tech Market Understanding",
      "Learning Management System"
    ],
    "aiToolSkills": [
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "AI Learning Management System",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Teaching Principles and Pedagogy",
      "Educational Technology Concepts",
      "Product Management Fundamentals",
      "Instructional Design Principles",
      "Adult Learning Theory"
    ]
  },
  {
    "roleId": "JF39-022",
    "roleName": "Corporate Trainer",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Corporate Training",
      "Training Facilitation",
      "Training Needs Analysis",
      "Training Material Development",
      "Training Impact Measurement"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Corporate Training and Development Principles",
      "Teaching Principles and Pedagogy",
      "Training Delivery and Facilitation",
      "Adult Learning Theory",
      "Learning and Development Strategy"
    ]
  },
  {
    "roleId": "JF39-023",
    "roleName": "Soft Skills Trainer",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Soft Skills Training",
      "Training Facilitation",
      "Communication Skills Training",
      "Behavioural Training",
      "Leadership Skills Development"
    ],
    "aiToolSkills": [
      "AI in Education",
      "ChatGPT",
      "Salesforce Einstein",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Soft Skills Training Principles",
      "Interpersonal and Communication Skills Development",
      "Training Delivery and Facilitation",
      "Adult Learning Theory",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF39-024",
    "roleName": "Technical Trainer",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Technical Training",
      "Training Facilitation",
      "Technical Content Delivery",
      "Hands-On Lab Training",
      "Technology Training Design"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "Khanmigo",
      "AI in Education",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Technical Training Methodology",
      "Technical Subject Matter Expertise for Training",
      "Training Delivery and Facilitation",
      "Instructional Design Principles",
      "Adult Learning Theory"
    ]
  },
  {
    "roleId": "JF39-025",
    "roleName": "Training & Development Specialist",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Training and Development",
      "Training Needs Analysis",
      "L&D Programme Management",
      "Learning Management System",
      "Learning Analytics"
    ],
    "aiToolSkills": [
      "AI Learning Management System",
      "ChatGPT",
      "Khanmigo",
      "AI in Education",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Training and Development Management",
      "Learning and Development Strategy",
      "Teaching Principles and Pedagogy",
      "Instructional Design Principles",
      "Training Delivery and Facilitation"
    ]
  },
  {
    "roleId": "JF39-026",
    "roleName": "Examination Coordinator",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Examination Coordination",
      "Examination Management",
      "Exam Paper Management",
      "Hall Ticket and Roll Number Management",
      "Examination Result Processing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Learning Management System",
      "Khanmigo",
      "AI in Education",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Examination Coordination Principles",
      "Assessment Design and Invigilation",
      "University Administration Principles",
      "Medical Ethics and Professional Standards",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF39-027",
    "roleName": "Student Counsellor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Student Counselling",
      "Academic Difficulty Support",
      "Student Motivation Coaching",
      "Behavioural Intervention",
      "Peer Counselling Coordination"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Khanmigo",
      "Salesforce Einstein",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Student Counselling Principles",
      "School Counselling Principles",
      "Counselling Psychology Principles",
      "Child Development and Learning Theory",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF39-028",
    "roleName": "Admissions Counsellor",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Admissions Counselling",
      "Student Recruitment",
      "College Selection Guidance",
      "Admission Process Management",
      "Career Guidance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Khanmigo",
      "MagicSchool AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "Admissions Counselling Principles",
      "Educational Admissions Process",
      "Teaching Principles and Pedagogy",
      "Child Development and Learning Theory",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF39-029",
    "roleName": "Academic Content Developer",
    "jobFamily": "Education & Training",
    "technicalSkills": [
      "Academic Content Development",
      "Study Material Creation",
      "Question Paper Authoring",
      "Curriculum Development",
      "Academic Writing"
    ],
    "aiToolSkills": [
      "Jasper AI",
      "ChatGPT",
      "Khanmigo",
      "AI in Education",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Academic Content Development Principles",
      "Subject Content Design for Curricula",
      "Curriculum Development Principles",
      "Curriculum and Lesson Planning",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF40-001",
    "roleName": "Librarian",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Library Management",
      "Cataloguing",
      "Collection Development",
      "Reference Services",
      "Library Software"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Library Science Principles",
      "Cataloguing and Classification",
      "Collection Development and Management",
      "Library Reference Services",
      "Digital Library Science"
    ]
  },
  {
    "roleId": "JF40-002",
    "roleName": "Assistant Librarian",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Library Operations",
      "Cataloguing",
      "Library Classification",
      "Reference Services",
      "Book Circulation Management"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI",
      "AI Learning Management System"
    ],
    "domainSkills": [
      "Library Science Principles",
      "Cataloguing and Classification",
      "Collection Development and Management",
      "Library Reference Services",
      "Digital Library Science"
    ]
  },
  {
    "roleId": "JF40-003",
    "roleName": "Library Assistant",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Library Assistance",
      "Shelf Management",
      "Book Issue and Return",
      "Library Software",
      "Reference Services"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Power BI Copilot",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Library Reference Services",
      "Library Science Principles",
      "Cataloguing and Classification",
      "Collection Development and Management",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF40-004",
    "roleName": "Knowledge Management Executive",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Knowledge Management",
      "Knowledge Repository Management",
      "Knowledge Capture",
      "Communities of Practice",
      "Process Documentation"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Knowledge Management Principles",
      "Knowledge Capture and Transfer",
      "Data Visualization Principles",
      "Data Storytelling",
      "Dashboard and Report Design Principles"
    ]
  },
  {
    "roleId": "JF40-005",
    "roleName": "Documentation Specialist",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Documentation Management",
      "Document Control",
      "Technical Documentation Management",
      "Version Control - Docs",
      "Technical Writing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Library & Knowledge Management",
      "Power BI Copilot",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Technical Documentation Principles",
      "Learning Experience Design",
      "Information Analysis Principles",
      "Knowledge Management Principles",
      "Instructional Design Principles"
    ]
  },
  {
    "roleId": "JF40-006",
    "roleName": "Information Analyst",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Information Analysis",
      "Competitive Intelligence",
      "Information Synthesis",
      "Research Information Management",
      "Literature Synthesis"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "Microsoft 365 Copilot",
      "Khanmigo",
      "MagicSchool AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Information Analysis Principles",
      "Competitive Intelligence and Information Services",
      "Data Visualization Principles",
      "Data Storytelling",
      "Library Science Principles"
    ]
  },
  {
    "roleId": "JF40-007",
    "roleName": "Archivist",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Archival Management",
      "Archive Preservation",
      "Archival Cataloguing",
      "Digital Preservation",
      "Record Retention Compliance"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Power BI Copilot",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Archival Science Principles",
      "Records Preservation and Conservation",
      "Records Management Principles",
      "Digital Library Science",
      "Library Science Principles"
    ]
  },
  {
    "roleId": "JF40-008",
    "roleName": "Records Manager",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Records Management",
      "Records Retention Policy",
      "Record Classification",
      "Records Compliance",
      "Record Retention Compliance"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Power BI Copilot",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Records Management Principles",
      "Digital Records and Compliance",
      "Compliance Frameworks",
      "Archival Science Principles",
      "Knowledge Management Principles"
    ]
  },
  {
    "roleId": "JF40-009",
    "roleName": "Digital Librarian",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Digital Library Management",
      "Digital Resource Curation",
      "Metadata Management",
      "Institutional Repository",
      "Cataloguing"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Digital Library Science",
      "Digital Preservation Concepts",
      "Library Science Principles",
      "Cataloguing and Classification",
      "Collection Development and Management"
    ]
  },
  {
    "roleId": "JF40-010",
    "roleName": "School Librarian",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "School Library Management",
      "Library Management",
      "Reading Programme Development",
      "Information Literacy Teaching",
      "Library Software"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "AI in Education",
      "ChatGPT",
      "Khanmigo",
      "MagicSchool AI"
    ],
    "domainSkills": [
      "Library Science Principles",
      "Collection Development and Management",
      "Teaching Principles and Pedagogy",
      "Library Reference Services",
      "Child Development and Learning Theory"
    ]
  },
  {
    "roleId": "JF40-011",
    "roleName": "Information Services Analyst",
    "jobFamily": "Library & Information Science",
    "technicalSkills": [
      "Information Services",
      "Database Searching",
      "Research Support Services",
      "Reference Services",
      "Information Needs Assessment"
    ],
    "aiToolSkills": [
      "AI Library & Knowledge Management",
      "Microsoft 365 Copilot",
      "Khanmigo",
      "MagicSchool AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Competitive Intelligence and Information Services",
      "Information Analysis Principles",
      "Library Science Principles",
      "Data Storytelling",
      "Knowledge Management Principles"
    ]
  },
  {
    "roleId": "JF41-001",
    "roleName": "Agronomist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agronomy",
      "Crop Production Management",
      "Soil Fertility Management",
      "Integrated Pest Management",
      "Crop Variety Selection"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Agronomy Principles",
      "Crop Science and Soil Agronomy",
      "Farmer Advisory and Technology Dissemination",
      "Research and Development Methodology",
      "Agricultural Extension Principles"
    ]
  },
  {
    "roleId": "JF41-002",
    "roleName": "Horticulturist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Horticulture",
      "Fruit and Vegetable Cultivation",
      "Integrated Pest Management",
      "Protected Cultivation",
      "Post-Harvest Management"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Horticulture Principles",
      "Horticultural Crop Management",
      "Crop Science and Soil Agronomy",
      "Research and Development Methodology",
      "Agronomy Principles"
    ]
  },
  {
    "roleId": "JF41-003",
    "roleName": "Agricultural Extension Officer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agricultural Extension",
      "Farmer Training",
      "Technology Dissemination",
      "Agronomy",
      "Demonstration Plot Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Precision Agriculture AI",
      "Power BI Copilot",
      "AI in Education",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Agricultural Extension Principles",
      "Farmer Advisory and Technology Dissemination",
      "Agronomy Principles",
      "Design Thinking Methodology",
      "Crop Science and Soil Agronomy"
    ]
  },
  {
    "roleId": "JF41-004",
    "roleName": "Soil Scientist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Soil Science",
      "Soil Sampling and Analysis",
      "Soil Health Assessment",
      "Land Evaluation",
      "Soil Conservation"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Soil Science Principles",
      "Soil Analysis and Management",
      "Crop Science and Soil Agronomy",
      "Research and Development Methodology",
      "Agronomy Principles"
    ]
  },
  {
    "roleId": "JF41-005",
    "roleName": "Plant Pathologist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Plant Pathology",
      "Disease Diagnosis",
      "Disease Management",
      "Integrated Pest Management",
      "Pathogen Identification"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Plant Pathology Principles",
      "Disease Diagnosis and Management in Crops",
      "Agronomy Principles",
      "Research and Development Methodology",
      "Crop Science and Soil Agronomy"
    ]
  },
  {
    "roleId": "JF41-006",
    "roleName": "Entomologist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Entomology",
      "Insect Identification",
      "Pest Surveillance",
      "Integrated Pest Management",
      "Biological Control"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Entomology Principles",
      "Insect Pest Identification and Management",
      "Agronomy Principles",
      "Research and Development Methodology",
      "Crop Science and Soil Agronomy"
    ]
  },
  {
    "roleId": "JF41-007",
    "roleName": "Irrigation Engineer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Irrigation Engineering",
      "Irrigation System Design",
      "Drip and Sprinkler Systems",
      "Water Use Efficiency",
      "Hydraulic Design"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Claude",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Irrigation Engineering Principles",
      "Irrigation System Design and Management",
      "Mechanical Engineering Fundamentals",
      "Hydraulics and Hydrology",
      "Agronomy Principles"
    ]
  },
  {
    "roleId": "JF41-008",
    "roleName": "Animal Husbandry Officer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Animal Husbandry",
      "Livestock Management",
      "Animal Nutrition",
      "Breed Improvement",
      "Animal Vaccination Programme"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Animal Husbandry Principles",
      "Livestock Management and Breeding",
      "Agricultural Extension Principles",
      "Farmer Advisory and Technology Dissemination",
      "Veterinary Science Principles"
    ]
  },
  {
    "roleId": "JF41-009",
    "roleName": "Veterinary Officer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Veterinary Medicine",
      "Animal Disease Diagnosis",
      "Animal Treatment",
      "Veterinary Public Health",
      "Animal Vaccination Programme"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Precision Agriculture AI",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Veterinary Science Principles",
      "Animal Disease Diagnosis and Treatment",
      "Pharmacology Principles",
      "Medical Ethics and Professional Standards",
      "Animal Husbandry Principles"
    ]
  },
  {
    "roleId": "JF41-010",
    "roleName": "Dairy Technologist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Dairy Technology",
      "Milk Processing",
      "Dairy Quality Control",
      "Dairy Plant Operations",
      "GMP Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Precision Agriculture AI",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Dairy Technology Principles",
      "Milk Processing and Quality Management",
      "Industrial Chemistry Principles",
      "Analytical Chemistry Principles",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF41-011",
    "roleName": "Poultry Farm Manager",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Poultry Farm Management",
      "Broiler and Layer Management",
      "Poultry Disease Prevention",
      "Feed and Nutrition Management",
      "Livestock Management"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Poultry Farm Management Principles",
      "Poultry Health and Nutrition",
      "Plant and Manufacturing Operations",
      "Animal Husbandry Principles",
      "Veterinary Science Principles"
    ]
  },
  {
    "roleId": "JF41-012",
    "roleName": "Fisheries Officer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Fisheries Science",
      "Aquaculture",
      "Fish Disease Management",
      "Fisheries Regulatory Compliance",
      "Water Quality Monitoring - Aqua"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Fisheries Science Principles",
      "Aquaculture and Fisheries Management",
      "Research and Development Methodology",
      "Engineering Experimentation",
      "Food Safety Management Systems"
    ]
  },
  {
    "roleId": "JF41-013",
    "roleName": "Agri-Business Manager",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agri-Business Management",
      "Agricultural Value Chain",
      "Agri Market Analysis",
      "Farmer Producer Organisation",
      "Agronomy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Precision Agriculture AI",
      "AI Supply Chain",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Agri-Business Management Principles",
      "Agricultural Market Dynamics",
      "Business Development Principles",
      "Agronomy Principles",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF41-014",
    "roleName": "Agricultural Loan Officer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agricultural Credit",
      "Farm Loan Appraisal",
      "Kisan Credit Card",
      "Agricultural Scheme Knowledge",
      "Credit Assessment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI",
      "Precision Agriculture AI"
    ],
    "domainSkills": [
      "Agricultural Credit and Finance",
      "Agricultural Loan Appraisal",
      "Agronomy Principles",
      "Credit Appraisal and Lending Principles",
      "Agricultural Market Dynamics"
    ]
  },
  {
    "roleId": "JF41-015",
    "roleName": "Commodity Trader",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Commodity Trading",
      "Agricultural Commodity Markets",
      "Futures and Options - Agri",
      "Price Risk Management - Agri",
      "Futures and Options"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Precision Agriculture AI"
    ],
    "domainSkills": [
      "Commodity Trading Principles",
      "Commodity Markets and Price Risk Management",
      "Agricultural Market Dynamics",
      "Corporate Finance Principles",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF41-016",
    "roleName": "Agri Input Sales Manager",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agri Input Sales",
      "Pesticide and Fertiliser Sales",
      "Dealer Network Management",
      "Integrated Pest Management",
      "Agri Season Planning"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Power BI Copilot",
      "Precision Agriculture AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Agricultural Input Sales Principles",
      "Agri-Product Knowledge and Positioning",
      "Agronomy Principles",
      "Sales Fundamentals",
      "Agricultural Extension Principles"
    ]
  },
  {
    "roleId": "JF41-017",
    "roleName": "Agri-Tech Product Manager",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agri-Tech Product Management",
      "Product Management",
      "AgriTech Market Understanding",
      "Digital Agriculture Solutions",
      "Farmer Engagement Strategy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Precision Agriculture AI",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Crop Science and Soil Agronomy",
      "Agricultural Market Dynamics",
      "Product Management Fundamentals",
      "Agronomy Principles",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF41-018",
    "roleName": "Precision Farming Specialist",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Precision Agriculture",
      "GPS and GIS for Agriculture",
      "Variable Rate Technology",
      "Drone-Based Crop Monitoring",
      "Agronomy"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Claude",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Precision Farming Principles",
      "Remote Sensing and Geospatial Analysis for Agriculture",
      "Agronomy Principles",
      "Research and Development Methodology",
      "Crop Science and Soil Agronomy"
    ]
  },
  {
    "roleId": "JF41-019",
    "roleName": "Remote Sensing Analyst - Agri",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Remote Sensing for Agriculture",
      "Satellite Imagery Analysis - Agri",
      "NDVI Analysis",
      "Crop Mapping",
      "Python"
    ],
    "aiToolSkills": [
      "Claude",
      "Precision Agriculture AI",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Remote Sensing and Geospatial Analysis for Agriculture",
      "Crop Science and Soil Agronomy",
      "Precision Farming Principles",
      "Agronomy Principles",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF41-020",
    "roleName": "Farm Manager",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Farm Management",
      "Farm Operations Planning",
      "Crop Production Management",
      "Farm Labour Management",
      "Farm Record Keeping"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Farm Management Principles",
      "Agronomy Principles",
      "Agricultural Market Dynamics",
      "Plant and Manufacturing Operations",
      "Crop Science and Soil Agronomy"
    ]
  },
  {
    "roleId": "JF41-021",
    "roleName": "Agriculture Field Officer",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agriculture Field Operations",
      "Field Crop Monitoring",
      "Farmer Advisory",
      "Agri Scheme Implementation",
      "Agronomy"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Agricultural Extension Principles",
      "Farmer Advisory and Technology Dissemination",
      "Agronomy Principles",
      "Design Thinking Methodology",
      "Crop Science and Soil Agronomy"
    ]
  },
  {
    "roleId": "JF41-022",
    "roleName": "Agri Supply Chain Executive",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Agricultural Supply Chain",
      "Agri Procurement",
      "Warehousing - Agri",
      "Agri Cold Chain",
      "Agricultural Value Chain"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Power BI Copilot",
      "Precision Agriculture AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Agri Supply Chain Concepts",
      "Supply Chain Management Principles",
      "Agricultural Market Dynamics",
      "Inventory Management Principles",
      "Agronomy Principles"
    ]
  },
  {
    "roleId": "JF41-023",
    "roleName": "Aquaculture Technician",
    "jobFamily": "Agriculture & Agri-Tech",
    "technicalSkills": [
      "Aquaculture Technology",
      "Aquaculture",
      "Fish Seed Production",
      "Pond Management",
      "Water Quality Monitoring - Aqua"
    ],
    "aiToolSkills": [
      "Precision Agriculture AI",
      "Power BI Copilot",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Aquaculture Technology Principles",
      "Fish Health and Water Quality Management",
      "Aquaculture and Fisheries Management",
      "Veterinary Science Principles",
      "Food Safety Management Systems"
    ]
  },
  {
    "roleId": "JF42-001",
    "roleName": "Food Technologist",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Technology",
      "Food Product Development",
      "Food Processing",
      "Food Science",
      "Food Safety Standards"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Food Technology Principles",
      "Food Processing Technology",
      "Industrial Chemistry Principles",
      "Food and Beverage Management Principles",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF42-002",
    "roleName": "Food Quality Control Manager",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Quality Management",
      "HACCP",
      "Food Quality Systems",
      "FSSAI Compliance",
      "Non-Conformance Management - Food"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "Claude",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Food and Beverage Management Principles",
      "Food Safety Management Systems",
      "Quality Engineering Principles",
      "Clinical Medicine Fundamentals",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF42-003",
    "roleName": "Food Safety Auditor",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Safety Auditing",
      "FSSAI Compliance",
      "HACCP",
      "Third Party Food Audit",
      "Audit Report Writing - Food"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Food Safety AI",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Food Safety Auditing Methodology",
      "Food Safety Management Systems",
      "Food Regulatory Compliance",
      "Quality Management Systems",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF42-004",
    "roleName": "Food Microbiologist",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Microbiology",
      "Microbial Testing",
      "HACCP",
      "Shelf Life Testing",
      "Contamination Investigation"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "Microsoft 365 Copilot",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Food Microbiology Principles",
      "Microbial Food Safety Concepts",
      "Food Safety Management Systems",
      "Analytical Chemistry Principles",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF42-005",
    "roleName": "Packaging Technologist",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Packaging Technology",
      "Packaging Material Selection",
      "Packaging Design for Food",
      "Food Safety Standards",
      "Packaging Regulatory Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Food Safety AI",
      "Perplexity AI",
      "Julius AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Food Packaging Technology",
      "Packaging Materials Science",
      "Polymer Engineering Principles",
      "Food Regulatory Compliance",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF42-006",
    "roleName": "Food Production Supervisor",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Production Supervision",
      "Production Line Management",
      "HACCP",
      "Food Safety on Floor",
      "GMP Compliance"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Food Production Operations",
      "Food Safety Management Systems",
      "Plant and Manufacturing Operations",
      "Food and Beverage Management Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF42-007",
    "roleName": "Food Quality Analyst",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Quality Analysis",
      "Sensory Evaluation",
      "Food Chemical Testing",
      "Method Validation",
      "Organoleptic Testing"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "Microsoft 365 Copilot",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Food and Beverage Management Principles",
      "Food Sensory Evaluation",
      "Analytical Chemistry Principles",
      "Clinical Medicine Fundamentals",
      "Laboratory Analysis Techniques"
    ]
  },
  {
    "roleId": "JF42-008",
    "roleName": "R&D Food Scientist",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food R&D",
      "Formulation Development - Food",
      "Food Processing",
      "Pilot Scale Trials",
      "Nutritional Profiling"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI",
      "Food Safety AI"
    ],
    "domainSkills": [
      "Food Research and Development Methodology",
      "New Product Development in Food",
      "Food Technology Principles",
      "Research and Development Methodology",
      "Food Safety Management Systems"
    ]
  },
  {
    "roleId": "JF42-009",
    "roleName": "Nutritionist",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Nutrition Science",
      "Clinical Nutrition",
      "Community Nutrition",
      "Nutritional Counselling",
      "Public Health Nutrition"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Food Safety AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Applied Nutrition Principles",
      "Clinical and Community Nutrition",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Diagnosis and Treatment Principles"
    ]
  },
  {
    "roleId": "JF42-010",
    "roleName": "Nutraceutical Executive",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Nutraceuticals",
      "Supplement Formulation",
      "Nutraceutical Regulatory",
      "Food Safety Standards",
      "Health Claims Substantiation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Food Safety AI",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Nutraceuticals and Functional Foods",
      "Bioactive Ingredients and Health Claims",
      "Food and Beverage Management Principles",
      "Marketing Fundamentals",
      "Food Technology Principles"
    ]
  },
  {
    "roleId": "JF42-011",
    "roleName": "Food Regulatory Executive",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Regulatory Affairs",
      "FSSAI Licensing",
      "FSSAI Compliance",
      "Food Label Compliance",
      "Import Export Food Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI",
      "Food Safety AI"
    ],
    "domainSkills": [
      "Food and Beverage Management Principles",
      "FSSAI and Food Law Compliance",
      "Food Regulatory Compliance",
      "Food Technology Principles",
      "Compliance Frameworks"
    ]
  },
  {
    "roleId": "JF42-012",
    "roleName": "Beverage Production Executive",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Beverage Production",
      "Brewing and Blending",
      "Food Processing",
      "CIP Procedures",
      "Beverage Quality Control"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Beverage Production Technology",
      "Food Processing Technology",
      "Food Safety Management Systems",
      "Plant and Manufacturing Operations",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF42-013",
    "roleName": "Food Cold Chain Executive",
    "jobFamily": "Food Processing & Safety",
    "technicalSkills": [
      "Food Cold Chain Management",
      "Chilled and Frozen Logistics",
      "Cold Chain Compliance",
      "HACCP",
      "Cold Store Management"
    ],
    "aiToolSkills": [
      "Food Safety AI",
      "Claude",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Temperature-Controlled Storage and Transport",
      "Cold Chain Logistics Principles",
      "Food Safety Management Systems",
      "Supply Chain Management Principles",
      "Clinical Medicine Fundamentals"
    ]
  },
  {
    "roleId": "JF43-001",
    "roleName": "Oil & Gas Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Oil and Gas Engineering",
      "Upstream Operations",
      "Subsurface Engineering",
      "HSE - Oil and Gas",
      "HAZOP"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "Aspen AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Oil and Gas Engineering Fundamentals",
      "Petroleum Systems and Geoscience Concepts",
      "Petroleum Engineering Fundamentals",
      "Chemical Engineering Fundamentals",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF43-002",
    "roleName": "Drilling Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Drilling Engineering",
      "Well Design",
      "Drilling Fluid Management",
      "Wellbore Stability",
      "Drilling Cost Management"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Drilling Engineering Principles",
      "Well Design and Drilling Operations",
      "Petroleum Engineering Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF43-003",
    "roleName": "Reservoir Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Reservoir Engineering",
      "Reservoir Simulation",
      "Material Balance Analysis",
      "EOR Techniques",
      "Well Test Analysis"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "ChatGPT",
      "Aspen AI",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Reservoir Engineering Concepts",
      "Petroleum Systems and Geoscience Concepts",
      "Petroleum Engineering Fundamentals",
      "Thermodynamics and Heat Transfer",
      "Thermal System Design"
    ]
  },
  {
    "roleId": "JF43-004",
    "roleName": "Production Engineer - O&G",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Oil and Gas Production Engineering",
      "Production Optimisation",
      "Artificial Lift",
      "Production Surveillance",
      "Flow Assurance"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "Aspen AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Process Engineering Principles",
      "Petroleum Engineering Fundamentals",
      "Chemical Engineering Fundamentals",
      "Environmental Health and Safety (EHS) Principles",
      "Process Design and Optimisation"
    ]
  },
  {
    "roleId": "JF43-005",
    "roleName": "Refinery Operation Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Refinery Engineering",
      "Energy Efficiency - Refinery",
      "Process Unit Operations",
      "Refinery Safety Management",
      "Yield Optimisation"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "AI Energy Analytics",
      "ANSYS AI",
      "Perplexity AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Refinery Engineering Concepts",
      "Petroleum Refining Processes",
      "Chemical Engineering Fundamentals",
      "Process Engineering Principles",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF43-006",
    "roleName": "Pipeline Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Pipeline Engineering",
      "Pipeline Design (Energy)",
      "Pipeline Integrity Management",
      "Cathodic Protection",
      "Pipeline SCADA"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AI Energy Analytics",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Pipeline Engineering Principles",
      "Pipeline Design and Integrity Management",
      "Mechanical Engineering Fundamentals",
      "Piping Engineering Principles",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF43-007",
    "roleName": "Power Plant Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Power Plant Engineering",
      "Thermal Power Plant Operations",
      "Boiler Engineering",
      "Turbine Engineering",
      "Power Plant Efficiency"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Power Plant Engineering Principles",
      "Thermal Power Cycle Concepts",
      "Thermodynamics and Heat Transfer",
      "Electrical Engineering Fundamentals",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF43-008",
    "roleName": "Transmission Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Transmission Engineering",
      "HV and EHV Transmission",
      "Transmission Line Design",
      "Power Systems Engineering",
      "FACTS Devices"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Transmission Engineering Principles",
      "High Voltage Transmission Systems",
      "Circuit Theory and Analysis",
      "Electrical Engineering Fundamentals",
      "Electrical Protection Engineering"
    ]
  },
  {
    "roleId": "JF43-009",
    "roleName": "Grid Management Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Grid Management",
      "Load Dispatch",
      "Frequency and Voltage Control",
      "Energy Management System",
      "ETAP"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "Microsoft 365 Copilot",
      "Julius AI",
      "Power BI Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Power Grid Management Principles",
      "Grid Stability and Load Dispatch",
      "Oil and Gas Engineering Fundamentals",
      "Electrical Power Distribution",
      "Commodity Trading Principles"
    ]
  },
  {
    "roleId": "JF43-010",
    "roleName": "Substation Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Substation Engineering",
      "Substation Design",
      "Substation Protection",
      "GIS Switchgear",
      "Substation Automation"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Substation Engineering Principles",
      "Substation Design and Equipment",
      "Circuit Theory and Analysis",
      "Electrical Protection Engineering",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF43-011",
    "roleName": "Oil & Gas Field Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Oil and Gas Field Engineering",
      "Field Operations Management",
      "Production Optimisation",
      "Well Intervention",
      "Surface Facilities Management"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Oil and Gas Field Operations",
      "Production Operations and Optimisation",
      "Oil and Gas Engineering Fundamentals",
      "Petroleum Engineering Fundamentals",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF43-012",
    "roleName": "Energy Trading Analyst",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Energy Trading",
      "Power Market Analysis",
      "Energy Price Forecasting",
      "PPA Structuring",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "AI Energy Analytics",
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Energy Trading Principles",
      "Energy Market Concepts",
      "Commodity Trading Principles",
      "Commodity Markets and Price Risk Management",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF43-013",
    "roleName": "Refinery Process Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Refinery Process Engineering",
      "Process Design",
      "Process Optimisation - Refinery",
      "Crude Evaluation",
      "Blending Optimisation"
    ],
    "aiToolSkills": [
      "Aspen AI",
      "AI Energy Analytics",
      "ANSYS AI",
      "Perplexity AI",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Process Engineering Principles",
      "Refinery Engineering Concepts",
      "Chemical Engineering Fundamentals",
      "Process Design and Optimisation",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF43-014",
    "roleName": "SCADA Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "SCADA Engineering",
      "Modbus Protocol",
      "Industrial Protocol Integration",
      "Telemetry Systems",
      "SCADA Cybersecurity"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "AI Energy Analytics",
      "Microsoft 365 Copilot",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "PLC and SCADA Systems Principles",
      "Industrial Control Systems Design",
      "Circuit Theory and Analysis",
      "Electrical Engineering Fundamentals",
      "Measurement and Control Systems"
    ]
  },
  {
    "roleId": "JF43-015",
    "roleName": "Metering Engineer",
    "jobFamily": "Energy — Oil, Gas & Power",
    "technicalSkills": [
      "Metering Engineering",
      "Smart Meter Technology",
      "AMI Systems",
      "Meter Data Management",
      "ETAP"
    ],
    "aiToolSkills": [
      "AI Energy Analytics",
      "Perplexity AI",
      "ChatGPT",
      "Power BI Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Metering Engineering Principles",
      "Revenue Metering and Smart Grid Concepts",
      "Electrical Engineering Fundamentals",
      "Measurement and Control Systems",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF44-001",
    "roleName": "Solar Energy Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Solar Energy Engineering",
      "PV System Design",
      "Solar Resource Assessment",
      "Solar Plant O&M",
      "PVsyst"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Solar Energy Engineering Principles",
      "Photovoltaic and Solar Thermal Systems",
      "Electrical Engineering Fundamentals",
      "Engineering Design Principles",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF44-002",
    "roleName": "Wind Energy Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Wind Energy Engineering",
      "Wind Turbine Technology",
      "Wind Resource Assessment",
      "Wind Farm O&M",
      "CFD"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Wind Energy Engineering Principles",
      "Wind Turbine Technology and Siting",
      "Electrical Engineering Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF44-003",
    "roleName": "Energy Auditor",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Energy Auditing",
      "Energy Audit Reporting",
      "Energy Conservation Measures",
      "Power Plant Efficiency",
      "BEE Certification"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Energy Auditing Principles",
      "Energy Efficiency Assessment",
      "Thermodynamics and Heat Transfer",
      "Electrical Engineering Fundamentals",
      "Environmental Engineering Principles"
    ]
  },
  {
    "roleId": "JF44-004",
    "roleName": "EV (Electric Vehicle) Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Electric Vehicle Engineering",
      "EV Powertrain Design",
      "BMS Design",
      "EV Charging Infrastructure",
      "Vehicle Electrification"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Clean Energy AI",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Electric Vehicle Technology Principles",
      "EV Powertrain and Charging Systems",
      "Electrical Engineering Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF44-005",
    "roleName": "Battery Technology Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Battery Technology",
      "Lithium-Ion Battery Design",
      "Battery Cell Testing",
      "Battery Pack Engineering",
      "BMS Design"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Clean Energy AI",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Battery Technology Principles",
      "Electrochemical Energy Storage Concepts",
      "Electrical Engineering Fundamentals",
      "Industrial Chemistry Principles",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF44-006",
    "roleName": "Bioenergy Specialist",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Bioenergy",
      "Biomass Energy Systems",
      "Biogas Technology",
      "Biofuel Production",
      "Reaction Engineering"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "Aspen AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Bioenergy Principles",
      "Biomass and Biogas Production Concepts",
      "Chemical Engineering Fundamentals",
      "Thermodynamics and Heat Transfer",
      "Environmental Engineering Principles"
    ]
  },
  {
    "roleId": "JF44-007",
    "roleName": "Environmental Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Environmental Engineering",
      "EIA Preparation",
      "Effluent Treatment",
      "Environmental Compliance",
      "Air Pollution Control"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Perplexity AI",
      "ANSYS AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Environmental Engineering Principles",
      "Pollution Control and Remediation",
      "Environmental Law and Regulations",
      "Chemical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF44-008",
    "roleName": "Environmental Consultant",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Environmental Consulting",
      "Environmental Law",
      "EIA Preparation",
      "Environmental Due Diligence",
      "Environmental Permit Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Clean Energy AI",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Environmental Consulting Methodology",
      "Environmental Impact Assessment",
      "Environmental Law and Regulations",
      "Environmental Engineering Principles",
      "Environmental Performance Assessment"
    ]
  },
  {
    "roleId": "JF44-009",
    "roleName": "EHS Manager",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "EHS Management",
      "Environment Health and Safety",
      "EHS Policy Development",
      "EHS Audit Management",
      "ISO 14001"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Clean Energy AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "EHS Management Principles",
      "HSE Management Systems",
      "Environmental Health and Safety (EHS) Principles",
      "Environmental Law and Regulations",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF44-010",
    "roleName": "Climate Change Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Climate Change Analysis",
      "GHG Inventory",
      "Climate Risk Assessment",
      "Carbon Accounting",
      "Sustainability Reporting"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "Perplexity AI",
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Climate Change Science and Policy",
      "Greenhouse Gas Accounting",
      "Data Visualization Principles",
      "Environmental Engineering Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF44-011",
    "roleName": "Carbon Credit Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Carbon Credits",
      "Carbon Market Analysis",
      "VCS and Gold Standard",
      "MRV - Carbon",
      "Carbon Accounting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Clean Energy AI",
      "Perplexity AI",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Carbon Markets and Carbon Credits",
      "Carbon Finance and Offset Methodology",
      "Greenhouse Gas Accounting",
      "Climate Change Science and Policy",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF44-012",
    "roleName": "Waste Management Specialist",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Waste Management",
      "Solid Waste Management",
      "Hazardous Waste Management",
      "EHS Compliance",
      "Waste-to-Energy"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Waste Management Principles",
      "Solid and Hazardous Waste Management",
      "Environmental Engineering Principles",
      "Pollution Control and Remediation",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF44-013",
    "roleName": "Water Resource Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Water Resource Engineering",
      "Hydrology",
      "Watershed Management",
      "Water Treatment Engineering",
      "Stormwater Management"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Engineering Surveying Concepts",
      "Hydraulics and Hydrology",
      "Civil Engineering Fundamentals",
      "Engineering Design Principles",
      "Environmental Engineering Principles"
    ]
  },
  {
    "roleId": "JF44-014",
    "roleName": "Sustainability Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Sustainability Analysis",
      "ESG Reporting",
      "GHG Inventory",
      "Sustainability Strategy",
      "LCA - Life Cycle Assessment"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Sustainability Analysis Principles",
      "Corporate Sustainability Reporting",
      "Greenhouse Gas Accounting",
      "Data Visualization Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF44-015",
    "roleName": "ESG Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "ESG Analysis",
      "ESG Data Management",
      "ESG Reporting",
      "ESG Rating Assessment",
      "BRSR Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Clean Energy AI",
      "Perplexity AI",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "ESG Analysis Principles",
      "ESG Frameworks and Ratings",
      "Greenhouse Gas Accounting",
      "Data Visualization Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF44-016",
    "roleName": "Green Building Consultant",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Green Building Consulting",
      "LEED Certification",
      "GRIHA Rating",
      "Net Zero Building Design",
      "Building Performance Assessment"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Autodesk BIM 360 AI"
    ],
    "domainSkills": [
      "Green Building Consulting Methodology",
      "Green Building Rating Systems",
      "Building Energy Analysis Concepts",
      "Architectural Design Principles",
      "Environmental Engineering Principles"
    ]
  },
  {
    "roleId": "JF44-017",
    "roleName": "Carbon Accounting Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Carbon Accounting Analysis",
      "CDP Reporting",
      "Science Based Targets",
      "Scope 3 Emissions",
      "Net Zero Planning"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Clean Energy AI",
      "Perplexity AI",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Carbon Accounting Principles",
      "Greenhouse Gas Accounting",
      "Corporate Sustainability Reporting",
      "Financial Accounting Principles",
      "Carbon Markets and Carbon Credits"
    ]
  },
  {
    "roleId": "JF44-018",
    "roleName": "Renewable Energy Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Renewable Energy Analysis",
      "Energy Transition Analysis",
      "Renewable Project Feasibility",
      "Power Sector Modelling",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "Perplexity AI",
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Energy Trading Principles",
      "Clean Energy Market Assessment",
      "Energy Market Concepts",
      "Architectural Design Principles",
      "Climate Change Science and Policy"
    ]
  },
  {
    "roleId": "JF44-019",
    "roleName": "Solar Project Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Solar Project Engineering",
      "PV System Design",
      "EPC Project Management - Solar",
      "Solar Grid Interconnection",
      "Solar SCADA and Monitoring"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Solar Energy Engineering Principles",
      "Photovoltaic and Solar Thermal Systems",
      "Electrical Engineering Fundamentals",
      "Engineering Design Principles",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF44-020",
    "roleName": "Wind Energy Technician",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Wind Turbine Maintenance",
      "Wind Turbine Technology",
      "Turbine Blade Inspection",
      "Electrical Maintenance - Wind",
      "Wind Turbine Troubleshooting"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Wind Energy Engineering Principles",
      "Wind Turbine Technology and Siting",
      "Mechanical Engineering Fundamentals",
      "Electrical Engineering Fundamentals",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF44-021",
    "roleName": "EV Charging Infrastructure Engineer",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "EV Charging Infrastructure Engineering",
      "IEC 61851 Standard",
      "DC Fast Charging Design",
      "Charging Network Management",
      "OCPP Protocol"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Clean Energy AI",
      "Perplexity AI",
      "ChatGPT",
      "Julius AI"
    ],
    "domainSkills": [
      "EV Powertrain and Charging Systems",
      "Electric Vehicle Technology Principles",
      "Electrical Engineering Fundamentals",
      "Engineering Design Principles",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF44-022",
    "roleName": "Clean Energy Analyst",
    "jobFamily": "Energy — Renewable & Sustainability",
    "technicalSkills": [
      "Clean Energy Analysis",
      "Decarbonisation Strategy",
      "Energy Transition Analysis",
      "Clean Technology Assessment",
      "Energy Policy Analysis"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "Perplexity AI",
      "ChatGPT",
      "Julius AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Clean Energy Market Assessment",
      "Green Building Rating Systems",
      "Climate Change Science and Policy",
      "Architectural Design Principles",
      "Corporate Finance Principles"
    ]
  },
  {
    "roleId": "JF45-001",
    "roleName": "Mining Engineer",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mining Engineering",
      "Mine Design",
      "Blasting Operations",
      "Underground Mining",
      "Open Pit Mining"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Mining Engineering Principles",
      "Open Pit and Underground Mining Methods",
      "Civil Engineering Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Mine Safety Principles"
    ]
  },
  {
    "roleId": "JF45-002",
    "roleName": "Geologist",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Geology",
      "Geological Mapping",
      "Mineral Exploration",
      "Drill Core Logging",
      "Resource Estimation"
    ],
    "aiToolSkills": [
      "Microsoft 365 Copilot",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Julius AI"
    ],
    "domainSkills": [
      "Geology Fundamentals",
      "Economic Geology and Mineral Exploration",
      "Research and Development Methodology",
      "Metallurgical Engineering Principles",
      "Physical and Mechanical Metallurgy"
    ]
  },
  {
    "roleId": "JF45-003",
    "roleName": "Mine Safety Officer",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mine Safety Management",
      "Mining Regulations Compliance",
      "Risk Assessment - Safety",
      "Accident Investigation - Mining",
      "Mine Emergency Response"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Mine Safety Principles",
      "Mining Legislation and Safety Standards",
      "EHS Management Principles",
      "Root Cause Analysis Methodology",
      "HSE Management Systems"
    ]
  },
  {
    "roleId": "JF45-004",
    "roleName": "Mine Geotechnical Engineer",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mine Geotechnical Engineering",
      "Slope Stability - Mining",
      "Rock Mechanics",
      "Ground Support Design",
      "Geotechnical Instrumentation"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Economic Geology and Mineral Exploration",
      "Rock Mechanics and Slope Stability",
      "Soil Mechanics and Foundation Design",
      "Stress Analysis and Structural Mechanics",
      "Geology Fundamentals"
    ]
  },
  {
    "roleId": "JF45-005",
    "roleName": "Mineral Processing Engineer",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mineral Processing",
      "Comminution",
      "Flotation",
      "Metallurgical Testing",
      "Failure Analysis"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Mineral Processing Engineering",
      "Comminution and Beneficiation Principles",
      "Chemical Engineering Fundamentals",
      "Metallurgical Engineering Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF45-006",
    "roleName": "Mine Planning Engineer",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mine Planning",
      "Mine Scheduling",
      "Whittle and Surpac",
      "Reserve Estimation (Mining)",
      "Mine Design"
    ],
    "aiToolSkills": [
      "Claude",
      "Perplexity AI",
      "ChatGPT",
      "Julius AI",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Mine Planning and Design",
      "Mine Production Scheduling",
      "Mining Engineering Principles",
      "Economic Geology and Mineral Exploration",
      "Geology Fundamentals"
    ]
  },
  {
    "roleId": "JF45-007",
    "roleName": "Mine Environmental Manager",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mine Environmental Management",
      "EIA Preparation",
      "Mine Rehabilitation",
      "Acid Mine Drainage",
      "Mine Water Management"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Julius AI"
    ],
    "domainSkills": [
      "Mining Environmental Management",
      "Rehabilitation and Environmental Closure",
      "Environmental Impact Assessment",
      "Environmental Law and Regulations",
      "EHS Management Principles"
    ]
  },
  {
    "roleId": "JF45-008",
    "roleName": "Metallurgist",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Metallurgy",
      "Pyrometallurgy",
      "Hydrometallurgy",
      "Failure Analysis",
      "Metal Recovery Optimisation"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "ChatGPT",
      "Julius AI",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Metallurgical Engineering Principles",
      "Physical and Mechanical Metallurgy",
      "Materials Science Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF45-009",
    "roleName": "Mine Drilling Engineer",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Mine Drilling Engineering",
      "Rotary Drilling - Mining",
      "Drill and Blast Design",
      "Blasting Operations",
      "Drilling Contractor Management"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Drilling Engineering Principles",
      "Open Pit and Underground Mining Methods",
      "Mechanical Engineering Fundamentals",
      "Mine Safety Principles",
      "Geology Fundamentals"
    ]
  },
  {
    "roleId": "JF45-010",
    "roleName": "Assay Analyst",
    "jobFamily": "Mining & Geology",
    "technicalSkills": [
      "Assay Analysis",
      "Fire Assay",
      "ICP-MS Analysis",
      "Sample Preparation",
      "Method Validation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Microsoft 365 Copilot",
      "Julius AI"
    ],
    "domainSkills": [
      "Assay Science Principles",
      "Fire Assay and Geochemical Analysis",
      "Analytical Chemistry Principles",
      "Laboratory Analysis Techniques",
      "Geology Fundamentals"
    ]
  },
  {
    "roleId": "JF46-001",
    "roleName": "Front Office Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Front Office Management",
      "Hotel Check-In and Check-Out",
      "Property Management System",
      "Guest Satisfaction Management",
      "Front Desk Operations"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Perplexity AI",
      "Salesforce Einstein",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Hotel Front Office Management",
      "Guest Experience and Check-In Procedures",
      "Hospitality Revenue Management",
      "Customer Service Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF46-002",
    "roleName": "Housekeeping Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Housekeeping Management",
      "Room Cleanliness Standards",
      "Housekeeping Staff Management",
      "Linen and Laundry Management",
      "Food Safety and Hygiene"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Salesforce Einstein",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Housekeeping Management Principles",
      "Room Inventory and Quality Standards",
      "Customer Service Principles",
      "Environmental Health and Safety (EHS) Principles",
      "Workplace Safety Management"
    ]
  },
  {
    "roleId": "JF46-003",
    "roleName": "Food & Beverage Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Food and Beverage Management",
      "Restaurant Operations",
      "F&B Cost Control",
      "Menu Engineering",
      "Food Safety and Hygiene"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Food and Beverage Management Principles",
      "F&B Service and Menu Engineering",
      "Food Safety Management Systems",
      "Customer Service Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF46-004",
    "roleName": "Revenue Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Revenue Management - Hospitality",
      "Yield Management",
      "OTA Channel Management",
      "Occupancy and ADR Optimisation",
      "Property Management System"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "Claude",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Hospitality Revenue Management",
      "Yield Management and Pricing Strategy",
      "Revenue Management Concepts",
      "IT Project Management",
      "Channel Management in Hospitality"
    ]
  },
  {
    "roleId": "JF46-005",
    "roleName": "Concierge",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Concierge Services",
      "Local Area Knowledge",
      "Guest Itinerary Planning",
      "VIP Guest Management",
      "Guest Satisfaction Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Travel & Tourism AI",
      "Salesforce Einstein",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Concierge Principles",
      "Customer Service Principles",
      "Destination Knowledge and Interpretive Skills",
      "Guest Experience and Check-In Procedures",
      "Customer Relationship Management Concepts"
    ]
  },
  {
    "roleId": "JF46-006",
    "roleName": "Reservations Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Reservations Management",
      "Online Booking Systems",
      "Group Booking Management",
      "GDS Systems",
      "Revenue Management - Hospitality"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "Salesforce Einstein",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Medical Ethics and Professional Standards",
      "Channel Management in Hospitality",
      "Hospitality Revenue Management",
      "Customer Service Principles",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF46-007",
    "roleName": "Guest Relations Officer",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Guest Relations",
      "Guest Complaint Resolution",
      "Guest Satisfaction Management",
      "Guest Loyalty Programme Management",
      "Guest Feedback Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Salesforce Einstein",
      "Hospitality AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Guest Relations Principles",
      "Customer Service Principles",
      "Guest Experience and Check-In Procedures",
      "Hotel Front Office Management",
      "Troubleshooting Methodology"
    ]
  },
  {
    "roleId": "JF46-008",
    "roleName": "Chef de Cuisine",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Kitchen Management",
      "Menu Development",
      "Culinary Arts",
      "Food Cost Control",
      "Food Safety and Hygiene"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Jasper AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Culinary Arts Principles",
      "Kitchen Management and Food Production",
      "Food Safety Management Systems",
      "F&B Service and Menu Engineering",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF46-009",
    "roleName": "Executive Chef",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Executive Culinary Leadership",
      "Kitchen Management",
      "Multi-Kitchen Management",
      "Menu Development",
      "Culinary Innovation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Perplexity AI",
      "Jasper AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Kitchen Management and Food Production",
      "Culinary Arts Principles",
      "F&B Service and Menu Engineering",
      "Food and Beverage Management Principles",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF46-010",
    "roleName": "Sous Chef",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Sous Chef Operations",
      "Culinary Arts",
      "Kitchen Production Management",
      "Recipe Standardisation",
      "Food Safety and Hygiene"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Jasper AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Culinary Arts Principles",
      "Kitchen Management and Food Production",
      "Food Safety Management Systems",
      "F&B Service and Menu Engineering",
      "Applied Nutrition Principles"
    ]
  },
  {
    "roleId": "JF46-011",
    "roleName": "Pastry Chef",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Pastry Arts",
      "Dessert Menu Development",
      "Bread and Viennoiserie",
      "Sugar and Chocolate Work",
      "Food Safety and Hygiene"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Midjourney",
      "Canva Magic Studio",
      "Jasper AI"
    ],
    "domainSkills": [
      "Pastry and Confectionery Principles",
      "Culinary Arts Principles",
      "Food Safety Management Systems",
      "Design Thinking Methodology",
      "Applied Nutrition Principles"
    ]
  },
  {
    "roleId": "JF46-012",
    "roleName": "Commis Chef",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Commis Chef Skills",
      "Mise en Place",
      "Basic Cookery Techniques",
      "Kitchen Station Management",
      "Food Safety and Hygiene"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Jasper AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Culinary Arts Principles",
      "Food Safety Management Systems",
      "Kitchen Management and Food Production",
      "Applied Nutrition Principles",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF46-013",
    "roleName": "Restaurant Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Restaurant Management",
      "Restaurant Operations",
      "Table Reservation Management",
      "Floor Service Management",
      "Beverage Service"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Salesforce Einstein",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Restaurant Management Principles",
      "Food Service Operations",
      "Customer Service Principles",
      "Food Safety Management Systems",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF46-014",
    "roleName": "Tour Guide",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Tour Guiding",
      "Heritage and Cultural Knowledge",
      "Group Management - Tourism",
      "Multilingual Communication",
      "Local Area Knowledge"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Travel & Tourism AI",
      "Perplexity AI",
      "Jasper AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Tour Guide Principles",
      "Destination Knowledge and Interpretive Skills",
      "Medical Ethics and Professional Standards",
      "Customer Service Principles",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF46-015",
    "roleName": "Travel Agent",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Travel Agency Operations",
      "Package Tour Design",
      "Airline Ticketing",
      "Amadeus and Galileo",
      "GDS Systems"
    ],
    "aiToolSkills": [
      "Travel & Tourism AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Salesforce Einstein",
      "Jasper AI"
    ],
    "domainSkills": [
      "Marketing Mix (4Ps / 7Ps)",
      "Travel Product Knowledge and Itinerary Design",
      "Sales Fundamentals",
      "Customer Service Principles",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF46-016",
    "roleName": "Tourism Officer",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Tourism Development",
      "Tourism Policy Implementation",
      "Tourism Marketing",
      "Tourist Infrastructure Management",
      "Heritage and Cultural Knowledge"
    ],
    "aiToolSkills": [
      "Travel & Tourism AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Midjourney",
      "Jasper AI"
    ],
    "domainSkills": [
      "Tourism Management Principles",
      "Tourism Marketing and Destination Branding",
      "Destination Knowledge and Interpretive Skills",
      "Marketing Fundamentals",
      "Marketing Mix (4Ps / 7Ps)"
    ]
  },
  {
    "roleId": "JF46-017",
    "roleName": "Destination Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Destination Management",
      "Destination Branding",
      "Tourism Product Development",
      "Stakeholder Management - Tourism",
      "Tourism Marketing"
    ],
    "aiToolSkills": [
      "Travel & Tourism AI",
      "ChatGPT",
      "Perplexity AI",
      "Midjourney",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Destination Management Principles",
      "Troubleshooting Methodology",
      "Tourism Management Principles",
      "Team Leadership and People Management",
      "Sustainable Tourism Practices"
    ]
  },
  {
    "roleId": "JF46-018",
    "roleName": "Eco-Tourism Specialist",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Eco-Tourism",
      "Sustainable Tourism",
      "Nature Interpretation",
      "Community-Based Tourism",
      "Group Management - Tourism"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Travel & Tourism AI",
      "Perplexity AI",
      "Midjourney",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Eco-Tourism Principles",
      "Sustainable Tourism Practices",
      "Destination Knowledge and Interpretive Skills",
      "Environmental Performance Assessment",
      "Environmental Impact Assessment"
    ]
  },
  {
    "roleId": "JF46-019",
    "roleName": "Heritage Site Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Heritage Site Management",
      "Conservation Management",
      "Visitor Experience Management",
      "Heritage Interpretation",
      "Heritage and Cultural Knowledge"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Travel & Tourism AI",
      "Perplexity AI",
      "Canva Magic Studio",
      "Midjourney"
    ],
    "domainSkills": [
      "Heritage Site Management Principles",
      "Cultural Heritage Conservation Concepts",
      "Destination Knowledge and Interpretive Skills",
      "Tour Guide Principles",
      "Sustainable Tourism Practices"
    ]
  },
  {
    "roleId": "JF46-020",
    "roleName": "Event Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Event Management",
      "Event Planning",
      "Event Budget Management",
      "Vendor Management - Events",
      "Venue Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Hospitality AI",
      "Salesforce Einstein",
      "Midjourney"
    ],
    "domainSkills": [
      "Event Management Methodology",
      "Event Production and Logistics",
      "Event Management Principles",
      "Experiential Marketing Concepts",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF46-021",
    "roleName": "Wedding Planner",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Wedding Planning",
      "Wedding Vendor Coordination",
      "Wedding Budget Management",
      "Wedding Décor and Theme Design",
      "Event Planning"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Midjourney",
      "Jasper AI",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Wedding Planning Principles",
      "Event Management Methodology",
      "Event Production and Logistics",
      "Design Thinking Methodology",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF46-022",
    "roleName": "Conference & Exhibition Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Conference Management",
      "Exhibition Management",
      "Delegate Management",
      "Conference AV and Technology",
      "Event Budget Management"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Salesforce Einstein",
      "Midjourney"
    ],
    "domainSkills": [
      "Conference and Exhibition Management",
      "Event Management Methodology",
      "MICE Operations Concepts",
      "Event Production and Logistics",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF46-023",
    "roleName": "MICE Coordinator",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "MICE Coordination",
      "Incentive Travel Planning",
      "MICE Venue Sourcing",
      "Event Logistics Management",
      "Event Planning"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Perplexity AI",
      "Salesforce Einstein",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "MICE Operations Concepts",
      "Event Management Methodology",
      "Conference and Exhibition Management",
      "Customer Service Principles",
      "Event Production and Logistics"
    ]
  },
  {
    "roleId": "JF46-024",
    "roleName": "Spa Manager",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Spa Management",
      "Spa Treatment Menu Design",
      "Spa Revenue Management",
      "Spa Staff Management",
      "Guest Satisfaction Management"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Salesforce Einstein",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Spa Management Principles",
      "Spa Treatment and Service Delivery",
      "Wellness Consulting Principles",
      "Customer Service Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF46-025",
    "roleName": "Wellness Consultant",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Wellness Consulting",
      "Wellness Programme Design",
      "Lifestyle Assessment",
      "Holistic Health Advisory",
      "Nutritional Assessment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Perplexity AI",
      "Jasper AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Wellness Consulting Principles",
      "Holistic Health and Lifestyle Coaching",
      "Applied Nutrition Principles",
      "Medical Ethics and Professional Standards",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF46-026",
    "roleName": "Yoga & Wellness Coach",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Yoga Instruction",
      "Wellness Coaching",
      "Meditation and Mindfulness",
      "Breathwork and Pranayama",
      "Lifestyle Assessment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Jasper AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Yoga and Wellness Coaching Principles",
      "Mind-Body Wellness Concepts",
      "Wellness Consulting Principles",
      "Medical Ethics and Professional Standards",
      "Teaching Principles and Pedagogy"
    ]
  },
  {
    "roleId": "JF46-027",
    "roleName": "Banquet Executive",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Banquet Operations",
      "Banquet Setup and Service",
      "Banquet Coordination",
      "Food Safety and Hygiene",
      "F&B Event Execution"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Banquet Operations Management",
      "Restaurant Management Principles",
      "Food Safety Management Systems",
      "Customer Service Principles",
      "Event Management Methodology"
    ]
  },
  {
    "roleId": "JF46-028",
    "roleName": "Hotel Sales Executive",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Hotel Sales",
      "Corporate Account Management - Hotel",
      "Room Night Sales",
      "Travel Agent Relationship Management",
      "Revenue Management - Hospitality"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Canva Magic Studio",
      "Hospitality AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "Hospitality Sales Principles",
      "Sales Fundamentals",
      "Hospitality Revenue Management",
      "Business Development Principles",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF46-029",
    "roleName": "Housekeeping Supervisor",
    "jobFamily": "Hospitality & Tourism",
    "technicalSkills": [
      "Housekeeping Supervision",
      "Room Inspection",
      "Housekeeping Management",
      "Lost and Found Management",
      "Housekeeping Record Keeping"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Salesforce Einstein",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Room Inventory and Quality Standards",
      "Housekeeping Management Principles",
      "Customer Service Principles",
      "Environmental Health and Safety (EHS) Principles",
      "Workplace Safety Management"
    ]
  },
  {
    "roleId": "JF47-001",
    "roleName": "Commercial Pilot - Captain",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Aircraft Command",
      "ATPL",
      "Multi-Engine IFR Flying",
      "Crew Resource Management",
      "Airline Operations Procedures"
    ],
    "aiToolSkills": [
      "Aviation AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Commercial Pilot Principles",
      "Airline Operations and Regulations",
      "Aerodynamics Principles",
      "Human Factors and Crew Resource Management",
      "Meteorology and Aviation Weather Principles"
    ]
  },
  {
    "roleId": "JF47-002",
    "roleName": "Commercial Pilot - First Officer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "First Officer Duties",
      "CPL",
      "Multi-Engine IFR Flying",
      "Crew Resource Management",
      "Co-Pilot Operations"
    ],
    "aiToolSkills": [
      "Aviation AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Commercial Pilot Principles",
      "Airline Operations and Regulations",
      "Aerodynamics Principles",
      "Human Factors and Crew Resource Management",
      "In-Flight Safety and Emergency Procedures"
    ]
  },
  {
    "roleId": "JF47-003",
    "roleName": "Flight Dispatcher",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Flight Dispatching",
      "Flight Planning",
      "NOTAMs and METARs",
      "Weight and Balance Calculation",
      "Fuel Planning"
    ],
    "aiToolSkills": [
      "Aviation AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Flight Dispatch Principles",
      "Aerospace Engineering Fundamentals",
      "Airline Operations and Regulations",
      "Aerodynamics Principles",
      "Human Factors and Crew Resource Management"
    ]
  },
  {
    "roleId": "JF47-004",
    "roleName": "Flight Operations Officer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Flight Operations Management",
      "Flight Schedule Management",
      "Operational Control",
      "Aviation Regulatory Compliance",
      "Flight Dispatching"
    ],
    "aiToolSkills": [
      "Aviation AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Airline Operations and Regulations",
      "Flight Dispatch Principles",
      "Team Leadership and People Management",
      "Human Factors and Crew Resource Management"
    ]
  },
  {
    "roleId": "JF47-005",
    "roleName": "Senior Cabin Crew",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Cabin Crew Leadership",
      "In-flight Safety Management",
      "Emergency Procedures",
      "Passenger Service Excellence",
      "Crew Resource Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aviation AI",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Cabin Crew Service Principles",
      "In-Flight Safety and Emergency Procedures",
      "Customer Service Principles",
      "Human Factors and Crew Resource Management",
      "Airline Operations and Regulations"
    ]
  },
  {
    "roleId": "JF47-006",
    "roleName": "Cabin Crew - Flight Attendant",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Cabin Crew Service",
      "Safety Demonstration",
      "Emergency Procedures",
      "In-flight Passenger Assistance",
      "First Aid - Aviation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aviation AI",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Cabin Crew Service Principles",
      "In-Flight Safety and Emergency Procedures",
      "Customer Service Principles",
      "Human Factors and Crew Resource Management",
      "Airline Operations and Regulations"
    ]
  },
  {
    "roleId": "JF47-007",
    "roleName": "In-flight Service Manager",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "In-flight Service Management",
      "Cabin Service Standards",
      "Cabin Crew Supervision",
      "In-flight Retail Management",
      "In-flight Safety Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aviation AI",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Cabin Crew Service Principles",
      "In-Flight Safety and Emergency Procedures",
      "Customer Service Principles",
      "Airline Operations and Regulations",
      "Team Leadership and People Management"
    ]
  },
  {
    "roleId": "JF47-008",
    "roleName": "Airport Manager",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Airport Management",
      "Airport Operations",
      "Airport Security Management",
      "Aerodrome Compliance",
      "Aviation Regulatory Compliance"
    ],
    "aiToolSkills": [
      "Aviation AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Airport Management Principles",
      "Airport Terminal Operations",
      "Airline Operations and Regulations",
      "Log Analysis and Correlation",
      "Human Factors and Crew Resource Management"
    ]
  },
  {
    "roleId": "JF47-009",
    "roleName": "Air Traffic Controller",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Air Traffic Control",
      "Radar Control",
      "ATC Phraseology",
      "Airspace Management",
      "ATC Surveillance Systems"
    ],
    "aiToolSkills": [
      "Aviation AI",
      "Perplexity AI",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Air Traffic Control Principles",
      "Airspace Management and Separation Standards",
      "Aerodynamics Principles",
      "Human Factors and Crew Resource Management",
      "Airline Operations and Regulations"
    ]
  },
  {
    "roleId": "JF47-010",
    "roleName": "Ground Handling Staff",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Ground Handling Operations",
      "Aircraft Marshalling",
      "Baggage Handling",
      "Passenger Check-In Operations",
      "Aviation Regulatory Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aviation AI",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Troubleshooting Methodology",
      "Ramp Safety and Aircraft Servicing",
      "Customer Service Principles",
      "Human Factors and Crew Resource Management",
      "Airline Operations and Regulations"
    ]
  },
  {
    "roleId": "JF47-011",
    "roleName": "Airport Security Officer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Airport Security",
      "Passenger Screening",
      "Baggage X-Ray Screening",
      "BCAS Regulations",
      "Aviation Regulatory Compliance"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aviation AI",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Airport Security Principles",
      "Aviation Security Regulations",
      "Human Factors and Crew Resource Management",
      "Airline Operations and Regulations",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF47-012",
    "roleName": "Baggage & Cargo Handler",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Baggage and Cargo Handling",
      "Baggage Handling",
      "Cargo Documentation",
      "Dangerous Goods Handling",
      "ULD Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Aviation AI",
      "Perplexity AI",
      "Zapier",
      "AI Supply Chain"
    ],
    "domainSkills": [
      "Air Cargo and Baggage Handling",
      "Dangerous Goods in Air Transport",
      "Workplace Safety Management",
      "Human Factors and Crew Resource Management",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF47-013",
    "roleName": "Transport Manager",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Transport Management",
      "Fleet Operations",
      "Route Optimisation",
      "Transport Regulatory Compliance",
      "Transport Cost Management"
    ],
    "aiToolSkills": [
      "Transport & Mobility AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Transport Management Principles",
      "Transport Network Operations",
      "Supply Chain Management Principles",
      "Environmental Health and Safety (EHS) Principles",
      "Workplace Safety Management"
    ]
  },
  {
    "roleId": "JF47-014",
    "roleName": "Traffic Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Traffic Engineering",
      "Highway Engineering",
      "Traffic Signal Design",
      "Intersection Design",
      "Traffic Impact Assessment"
    ],
    "aiToolSkills": [
      "Transport & Mobility AI",
      "Perplexity AI",
      "ChatGPT",
      "Zapier",
      "AutoCAD AI"
    ],
    "domainSkills": [
      "Traffic Engineering Principles",
      "Traffic Analysis and Signal Design",
      "Transportation Engineering Principles",
      "Civil Engineering Fundamentals",
      "Highway and Pavement Design"
    ]
  },
  {
    "roleId": "JF47-015",
    "roleName": "Route Planner",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Route Planning",
      "Network Route Analysis",
      "GIS for Transport",
      "Transit Scheduling",
      "Traffic Engineering"
    ],
    "aiToolSkills": [
      "Transport & Mobility AI",
      "Claude",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Transport Route Planning",
      "Fleet Routing and Network Design",
      "Supply Chain Management in Apparel",
      "Supply Chain Management Principles",
      "Transport Management Principles"
    ]
  },
  {
    "roleId": "JF47-016",
    "roleName": "Railway Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Railway Engineering",
      "Track Design",
      "Railway Signalling",
      "Traction and Rolling Stock",
      "Systems Engineering"
    ],
    "aiToolSkills": [
      "Transport & Mobility AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Zapier"
    ],
    "domainSkills": [
      "Railway Engineering Principles",
      "Rail Operations and Track Engineering",
      "Civil Engineering Fundamentals",
      "Engineering Design Principles",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF47-017",
    "roleName": "Metro Rail Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Metro Rail Engineering",
      "Railway Signalling",
      "Metro Systems Integration",
      "Metro Electrification",
      "Automatic Train Control"
    ],
    "aiToolSkills": [
      "Transport & Mobility AI",
      "ANSYS AI",
      "ChatGPT",
      "Perplexity AI",
      "Zapier"
    ],
    "domainSkills": [
      "Urban Rail and Metro Systems Engineering",
      "Metro Rail Operations and Safety",
      "Railway Engineering Principles",
      "Civil Engineering Fundamentals",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF47-018",
    "roleName": "Ship Captain",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Ship Command",
      "Nautical Navigation",
      "Maritime Regulations",
      "GMDSS",
      "Cargo Management at Sea"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Transport & Mobility AI",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Maritime Navigation and Ship Command",
      "International Maritime Regulations",
      "Human Factors and Crew Resource Management",
      "Marine Engineering Principles",
      "Ship Propulsion and Machinery Systems"
    ]
  },
  {
    "roleId": "JF47-019",
    "roleName": "Marine Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Marine Engineering",
      "Ship Machinery Operations",
      "Ship Maintenance",
      "Marine Electrical Systems",
      "Maritime Regulations"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "Claude",
      "Zapier",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Marine Engineering Principles",
      "Ship Propulsion and Machinery Systems",
      "Mechanical Engineering Fundamentals",
      "Electrical Engineering Fundamentals",
      "International Maritime Regulations"
    ]
  },
  {
    "roleId": "JF47-020",
    "roleName": "Port Manager",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Port Management",
      "Port Operations",
      "Container Terminal Management",
      "Port Authority Compliance",
      "Maritime Regulations"
    ],
    "aiToolSkills": [
      "Transport & Mobility AI",
      "AI Supply Chain",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Port Management Principles",
      "Port Operations and Terminal Management",
      "Workplace Safety Management",
      "Supply Chain Management Principles",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF47-021",
    "roleName": "Automotive Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Automotive Engineering",
      "Powertrain Engineering",
      "Vehicle Systems Design",
      "Automotive Testing and Validation",
      "Homologation"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "Zapier"
    ],
    "domainSkills": [
      "Automotive Engineering Principles",
      "Vehicle Systems Integration",
      "Automobile Engineering Fundamentals",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF47-022",
    "roleName": "Vehicle Design Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Vehicle Design Engineering",
      "Exterior Styling Design",
      "Interior Vehicle Design",
      "SolidWorks",
      "Clay Modelling"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "AutoCAD AI",
      "ChatGPT",
      "Perplexity AI",
      "Zapier"
    ],
    "domainSkills": [
      "Vehicle Body and Chassis Design",
      "Engineering Design Principles",
      "Automotive Engineering Principles",
      "CAD Modelling and Engineering Drawing",
      "Stress Analysis and Structural Mechanics"
    ]
  },
  {
    "roleId": "JF47-023",
    "roleName": "EV Design Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "EV System Design",
      "EV Powertrain Design",
      "Electric Drivetrain Design",
      "Thermal Management - EV",
      "EV Software Integration"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Claude",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "EV Design Engineering Principles",
      "Electric Powertrain Architecture",
      "Automotive Engineering Principles",
      "Electrical Engineering Fundamentals",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF47-024",
    "roleName": "Automobile Service Manager",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Automobile Service Management",
      "Workshop Management",
      "Vehicle Diagnostics",
      "Service Advisor Management",
      "Vehicle Maintenance Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ANSYS AI",
      "Perplexity AI",
      "Claude",
      "Zapier"
    ],
    "domainSkills": [
      "Vehicle Systems and Powertrain",
      "Workshop Operations and After-Sales",
      "Automobile Engineering Fundamentals",
      "Customer Service Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF47-025",
    "roleName": "Automotive Quality Engineer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Automotive Quality Engineering",
      "IATF 16949",
      "FMEA",
      "APQP",
      "PPAP"
    ],
    "aiToolSkills": [
      "Claude",
      "ANSYS AI",
      "ChatGPT",
      "Zapier",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Quality Engineering Principles",
      "Root Cause Analysis Methodology",
      "Automobile Engineering Fundamentals",
      "Vehicle Systems and Powertrain"
    ]
  },
  {
    "roleId": "JF47-026",
    "roleName": "Shipping Executive",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Shipping Operations Management",
      "Freight Forwarding",
      "Import-Export Management",
      "Charter Party Management",
      "Liner Agency Operations"
    ],
    "aiToolSkills": [
      "AI Supply Chain",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Zapier"
    ],
    "domainSkills": [
      "Shipping Operations Principles",
      "EXIM Documentation and Procedures",
      "Import and Export Regulations",
      "International Maritime Regulations",
      "Supply Chain Management Principles"
    ]
  },
  {
    "roleId": "JF47-027",
    "roleName": "Maritime Safety Officer",
    "jobFamily": "Aviation & Transportation",
    "technicalSkills": [
      "Maritime Safety Management",
      "ISM Code Compliance",
      "SOLAS Compliance",
      "Maritime Accident Investigation",
      "Maritime Regulations"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Zapier",
      "Transport & Mobility AI"
    ],
    "domainSkills": [
      "Workplace Safety Management",
      "Maritime Safety and ISM Code",
      "Human Factors and Crew Resource Management",
      "Root Cause Analysis Methodology",
      "Environmental Health and Safety (EHS) Principles"
    ]
  },
  {
    "roleId": "JF48-001",
    "roleName": "Telecom Network Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecom Network Engineering",
      "Network Planning and Design",
      "5G Technology",
      "Core Network Engineering",
      "Network Optimisation - Telecom"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Telecommunications Network Engineering",
      "Network Design and Capacity Planning",
      "Electrical Engineering Fundamentals",
      "RF and Microwave Engineering Fundamentals",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF48-002",
    "roleName": "Telecom Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecommunications Engineering",
      "Transmission Engineering - Telecom",
      "Optical Fibre Networks",
      "Microwave Backhaul",
      "Network Planning and Design"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Telecom Engineering Principles",
      "Wireless and Wired Network Concepts",
      "Electrical Engineering Fundamentals",
      "Circuit Theory and Analysis",
      "Telecommunications Network Engineering"
    ]
  },
  {
    "roleId": "JF48-003",
    "roleName": "RF Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "RF Network Engineering",
      "Cell Site Design",
      "RF Engineering",
      "Drive Test Analysis",
      "Network Coverage Optimisation"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "ANSYS AI",
      "Perplexity AI",
      "ChatGPT",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "RF and Microwave Engineering Fundamentals",
      "Antenna Theory and Design",
      "Electrical Engineering Fundamentals",
      "Wireless and Wired Network Concepts",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF48-004",
    "roleName": "Network Architect",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Network Architecture",
      "Enterprise Network Design",
      "Network Planning and Design",
      "SD-WAN",
      "Network Security Architecture"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Network Architecture Principles",
      "Enterprise and Service Provider Network Design",
      "Telecommunications Network Engineering",
      "IP Networking Principles",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF48-005",
    "roleName": "5G Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "5G Network Engineering",
      "5G Technology",
      "5G RAN Deployment",
      "Network Slicing",
      "5G Core Architecture"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "ANSYS AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude"
    ],
    "domainSkills": [
      "Antenna Theory and Design",
      "5G Architecture and Radio Access Technology",
      "Wireless and Wired Network Concepts",
      "RF and Microwave Engineering Fundamentals",
      "Telecommunications Network Engineering"
    ]
  },
  {
    "roleId": "JF48-006",
    "roleName": "Optical Fibre Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Optical Fibre Engineering",
      "Optical Fibre Networks",
      "DWDM Systems",
      "Fibre Splicing and Testing",
      "OTDR Analysis"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Optical Fibre Network Engineering",
      "Fibre Optic Transmission Principles",
      "Electrical Engineering Fundamentals",
      "Telecommunications Network Engineering",
      "Circuit Theory and Analysis"
    ]
  },
  {
    "roleId": "JF48-007",
    "roleName": "Telecom Manager",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecom Operations Management",
      "Network SLA Management",
      "Telecom Vendor Management",
      "Telecom Project Management",
      "Network Optimisation - Telecom"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Claude"
    ],
    "domainSkills": [
      "Gap Analysis",
      "Telecommunications Regulation and Policy",
      "Telecommunications Network Engineering",
      "Budgeting and Resource Management",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF48-008",
    "roleName": "NOC Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "NOC Operations",
      "Network Fault Management",
      "Network Monitoring Tools",
      "Incident Management - Telecom",
      "Network Optimisation - Telecom"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Claude",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "ChatGPT"
    ],
    "domainSkills": [
      "Network Operations Centre Principles",
      "Network Monitoring and Fault Management",
      "Telecommunications Network Engineering",
      "Service Delivery Management",
      "Network Design and Capacity Planning"
    ]
  },
  {
    "roleId": "JF48-009",
    "roleName": "Field Service Engineer - Telecom",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecom Field Engineering",
      "Base Station Installation",
      "Tower Maintenance",
      "Field Network Testing",
      "Drive Test Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Telecom AI",
      "Perplexity AI",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Telecom Field Service Engineering",
      "Telecom Engineering Principles",
      "Electrical Engineering Fundamentals",
      "Field Service Engineering Principles",
      "Troubleshooting and Fault Diagnosis"
    ]
  },
  {
    "roleId": "JF48-010",
    "roleName": "OSS/BSS Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "OSS BSS Engineering",
      "Network Inventory Management",
      "Telecom OSS Architecture",
      "Billing System Integration",
      "Network Planning and Design"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "OSS and BSS Principles",
      "Telecom Support Systems",
      "Telecommunications Network Engineering",
      "Software Development Life Cycle (SDLC)",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF48-011",
    "roleName": "Telecom Sales Manager",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecom Sales Management",
      "Enterprise Telecom Sales",
      "Telecom Solution Selling",
      "Account Management - Telecom",
      "Sales"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Perplexity AI",
      "Telecom AI",
      "Jasper AI"
    ],
    "domainSkills": [
      "Telecom Sales Principles",
      "Sales Fundamentals",
      "Telecommunications Network Engineering",
      "Business Development Principles",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF48-012",
    "roleName": "Telecom Product Manager",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecom Product Management",
      "Product Management",
      "Telecom Product Roadmap",
      "Telecom Market Analysis",
      "5G Technology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Telecom AI",
      "Perplexity AI",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "Product Management Fundamentals",
      "Product Strategy",
      "Telecommunications Regulation and Policy",
      "Telecommunications Network Engineering",
      "Product Roadmap Development"
    ]
  },
  {
    "roleId": "JF48-013",
    "roleName": "Spectrum Planning Analyst",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Spectrum Planning",
      "Frequency Allocation",
      "Spectrum Management Regulations",
      "Interference Analysis",
      "RF Network Engineering"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Claude",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Spectrum Planning and Management",
      "RF and Microwave Engineering Fundamentals",
      "Telecommunications Regulation and Policy",
      "Antenna Theory and Design",
      "Wireless and Wired Network Concepts"
    ]
  },
  {
    "roleId": "JF48-014",
    "roleName": "IP Network Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "IP Network Engineering",
      "BGP and MPLS",
      "IP Routing and Switching",
      "Network QoS",
      "Network Security Architecture"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Perplexity AI",
      "ChatGPT",
      "Claude",
      "Microsoft 365 Copilot"
    ],
    "domainSkills": [
      "IP Networking Principles",
      "Circuit Theory and Analysis",
      "Telecommunications Network Engineering",
      "Electrical Engineering Fundamentals",
      "Security Engineering Principles"
    ]
  },
  {
    "roleId": "JF48-015",
    "roleName": "Telecom Planning Analyst",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Telecom Network Planning",
      "Capacity Planning - Telecom",
      "Telecom Coverage Planning",
      "Network Deployment Planning",
      "Network Planning and Design"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Claude",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Network Design and Capacity Planning",
      "Telecommunications Network Engineering",
      "Data Visualization Principles",
      "Telecommunications Regulation and Policy",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF48-016",
    "roleName": "4G/5G Drive Test Engineer",
    "jobFamily": "Telecom & Networking",
    "technicalSkills": [
      "Drive Test Engineering",
      "Drive Test Analysis",
      "TEMS and NEMO Tools",
      "Network KPI Analysis",
      "Log File Analysis"
    ],
    "aiToolSkills": [
      "Telecom AI",
      "Claude",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "ChatGPT"
    ],
    "domainSkills": [
      "IT Project Management",
      "Network Performance Optimisation",
      "Wireless and Wired Network Concepts",
      "RF and Microwave Engineering Fundamentals",
      "Antenna Theory and Design"
    ]
  },
  {
    "roleId": "JF49-001",
    "roleName": "Satellite Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Satellite Engineering",
      "Satellite Systems Engineering",
      "Satellite Payload Design",
      "Spacecraft Systems Engineering",
      "Satellite Testing"
    ],
    "aiToolSkills": [
      "Space Systems AI",
      "ANSYS AI",
      "MATLAB AI",
      "ChatGPT",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Aerodynamics Principles",
      "Space Mission Design",
      "Aerospace Engineering Fundamentals",
      "Electrical Engineering Fundamentals",
      "Systems Engineering Methodology"
    ]
  },
  {
    "roleId": "JF49-002",
    "roleName": "Space Mission Analyst",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Space Mission Analysis",
      "Mission Design",
      "Orbital Mechanics",
      "Space Systems Modelling",
      "Mission Operations"
    ],
    "aiToolSkills": [
      "Space Systems AI",
      "MATLAB AI",
      "ChatGPT",
      "Claude Code",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Space Science Fundamentals",
      "Orbital Mechanics and Astrodynamics",
      "Space Mission Design",
      "Aerodynamics Principles",
      "Aerospace Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF49-003",
    "roleName": "Ground Station Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Ground Station Engineering",
      "Antenna Systems - Ground",
      "Telemetry and Command",
      "Ground Station Operations",
      "Ground Segment Software"
    ],
    "aiToolSkills": [
      "Space Systems AI",
      "nTopology (nTop)",
      "ChatGPT",
      "Claude",
      "Claude Code"
    ],
    "domainSkills": [
      "Ground Station Engineering Principles",
      "Telemetry, Tracking and Command Systems",
      "RF and Microwave Engineering Fundamentals",
      "Antenna Theory and Design",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF49-004",
    "roleName": "Space Policy Analyst",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Space Policy Analysis",
      "International Space Law",
      "Space Governance",
      "Outer Space Treaty Knowledge",
      "Orbital Mechanics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "nTopology (nTop)",
      "Claude",
      "Claude Code",
      "Space Systems AI"
    ],
    "domainSkills": [
      "Space Policy and Law",
      "International Space Governance",
      "Space Science Fundamentals",
      "Materials Science Fundamentals",
      "Embedded Systems Architecture"
    ]
  },
  {
    "roleId": "JF49-005",
    "roleName": "Space Robotics Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Space Robotics Engineering",
      "Robotics Engineering",
      "Robotic Arm Design - Space",
      "Autonomous Navigation - Space",
      "Space Mechanisms"
    ],
    "aiToolSkills": [
      "nTopology (nTop)",
      "ChatGPT",
      "ANSYS AI",
      "Claude Code",
      "MATLAB AI"
    ],
    "domainSkills": [
      "Aerodynamics Principles",
      "Autonomous Space Systems",
      "Robotics Engineering Principles",
      "Aerospace Engineering Fundamentals",
      "Systems Engineering Methodology"
    ]
  },
  {
    "roleId": "JF49-006",
    "roleName": "Automation Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Automation Systems Engineering",
      "Automation Engineering",
      "Workflow Automation",
      "Process Automation Design",
      "Automation Testing"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Claude",
      "Claude Code",
      "nTopology (nTop)",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Industrial and Process Automation Principles",
      "Automation System Design",
      "Industrial Automation Concepts",
      "Product Design and Development",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF49-007",
    "roleName": "RPA Developer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "RPA Development",
      "UiPath",
      "Automation Anywhere",
      "Process Automation Design",
      "Bot Development"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Microsoft 365 Copilot",
      "Claude Code",
      "Power BI Copilot",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Robotic Process Automation Principles",
      "RPA Workflow Development",
      "Business Process Management",
      "Process Mapping and Analysis",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF49-008",
    "roleName": "AI Robotics Researcher",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "AI Robotics Research",
      "Robotics Engineering",
      "Reinforcement Learning - Robotics",
      "Computer Vision - Robotics",
      "Human-Robot Interaction"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "nTopology (nTop)",
      "MATLAB AI",
      "Claude Code",
      "ANSYS AI"
    ],
    "domainSkills": [
      "AI Robotics Research Principles",
      "Robot Learning and Perception",
      "Machine Learning Fundamentals",
      "Robotics Engineering Principles",
      "Model Selection and Evaluation"
    ]
  },
  {
    "roleId": "JF49-009",
    "roleName": "Nanomaterials Scientist",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Nanomaterials Science",
      "Nanoparticle Synthesis",
      "Nanomaterial Characterisation",
      "Spectroscopy",
      "Nanotoxicology"
    ],
    "aiToolSkills": [
      "Materials Informatics AI",
      "Claude",
      "nTopology (nTop)",
      "Microsoft 365 Copilot",
      "Claude Code"
    ],
    "domainSkills": [
      "Nanomaterials Science Principles",
      "Nanoscale Characterisation and Synthesis",
      "Materials Science Fundamentals",
      "Research and Development Methodology",
      "Analytical Chemistry Principles"
    ]
  },
  {
    "roleId": "JF49-010",
    "roleName": "Nanotechnology Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Nanotechnology Engineering",
      "Nanofabrication",
      "Clean Room Operations",
      "Nanodevice Design",
      "Nanomaterial Characterisation"
    ],
    "aiToolSkills": [
      "Materials Informatics AI",
      "ANSYS AI",
      "ChatGPT",
      "Claude Code",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Nanotechnology Engineering Principles",
      "Nanofabrication Concepts",
      "Nanomaterials Science Principles",
      "Engineering Design Principles",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF49-011",
    "roleName": "Emerging Technology Analyst",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Emerging Technology Analysis",
      "Technology Trend Forecasting",
      "Technology Scouting",
      "Innovation Assessment",
      "Python"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "nTopology (nTop)",
      "Claude",
      "Power BI Copilot",
      "Claude Code"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Technology Horizon Scanning",
      "Design Thinking Methodology",
      "Aerodynamics Principles",
      "Embedded Systems Architecture"
    ]
  },
  {
    "roleId": "JF49-012",
    "roleName": "Simulation & Modelling Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Simulation and Modelling Engineering",
      "Computational Modelling",
      "MATLAB Simulation",
      "Simulation Modelling",
      "Digital Twin Development"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "nTopology (nTop)",
      "ChatGPT",
      "Claude Code"
    ],
    "domainSkills": [
      "Product Design and Development",
      "Computational Modelling Concepts",
      "Embedded Systems Architecture",
      "Engineering Design Principles",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF49-013",
    "roleName": "Industrial IoT Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Industrial IoT Engineering",
      "IoT Architecture Design",
      "Edge Computing",
      "Industrial IoT Protocols",
      "Industrial Networking"
    ],
    "aiToolSkills": [
      "nTopology (nTop)",
      "Claude",
      "ChatGPT",
      "Claude Code",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Circuit Theory and Analysis",
      "Edge Computing and IoT Architecture",
      "Industrial Automation Concepts",
      "Industrial and Process Automation Principles",
      "Electrical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF49-014",
    "roleName": "Embedded AI Engineer",
    "jobFamily": "Space & Emerging Technology",
    "technicalSkills": [
      "Embedded AI Engineering",
      "TinyML",
      "Neural Network Compression",
      "Embedded Hardware-AI Integration",
      "Microcontroller Design"
    ],
    "aiToolSkills": [
      "GitHub Copilot",
      "Claude",
      "ANSYS AI",
      "Claude Code",
      "nTopology (nTop)"
    ],
    "domainSkills": [
      "Embedded AI Engineering Principles",
      "AI Model Deployment on Edge Devices",
      "Machine Learning Fundamentals",
      "Microcontroller Architecture",
      "Embedded Systems Architecture"
    ]
  },
  {
    "roleId": "JF50-001",
    "roleName": "Printing Technician",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Printing Technology",
      "Offset Printing",
      "Digital Printing",
      "Colour Management - Print",
      "Print Quality Control"
    ],
    "aiToolSkills": [
      "Adobe Creative AI",
      "ChatGPT",
      "Midjourney",
      "Canva Magic Studio",
      "Runway"
    ],
    "domainSkills": [
      "Printing Technology Principles",
      "Colour Reproduction in Print",
      "Print Design Principles",
      "Pre-Press and Print Production Concepts",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF50-002",
    "roleName": "Pre-Press Technician",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Pre-Press Technology",
      "Desktop Publishing",
      "PDF Preflight",
      "Colour Separation",
      "Colour Management - Print"
    ],
    "aiToolSkills": [
      "Adobe Creative AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Midjourney",
      "Runway"
    ],
    "domainSkills": [
      "Pre-Press Workflow Principles",
      "Print File Preparation",
      "Pre-Press and Print Production Concepts",
      "Colour Reproduction in Print",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF50-003",
    "roleName": "Print Production Manager",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Print Production Management",
      "Print Vendor Management",
      "Print Quality Control",
      "Print Procurement",
      "Printing Technology"
    ],
    "aiToolSkills": [
      "Adobe Creative AI",
      "ChatGPT",
      "Midjourney",
      "Canva Magic Studio",
      "Runway"
    ],
    "domainSkills": [
      "Production Planning and Control",
      "Printing Technology Principles",
      "Pre-Press Workflow Principles",
      "Plant and Manufacturing Operations",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF50-004",
    "roleName": "Packaging Engineer",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Packaging Engineering",
      "Structural Packaging Design",
      "Packaging Technology",
      "Packaging Testing",
      "Transit Packaging"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "Clean Energy AI"
    ],
    "domainSkills": [
      "Packaging Engineering Principles",
      "Product Design and Development",
      "Food Packaging Technology",
      "Polymer Engineering Principles",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF50-005",
    "roleName": "Packaging Product Designer",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Packaging Product Design",
      "Consumer Packaging Design",
      "Packaging Graphics",
      "Adobe Illustrator - Packaging",
      "Packaging Material Selection"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "ANSYS AI"
    ],
    "domainSkills": [
      "Packaging Product Design Principles",
      "Food and Beverage Management Principles",
      "Visual Design Principles",
      "Colour Theory",
      "Packaging Sustainability Assessment"
    ]
  },
  {
    "roleId": "JF50-006",
    "roleName": "Packaging Buyer",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Packaging Procurement",
      "Packaging Supplier Management",
      "Packaging Cost Management",
      "Packaging Specification Management",
      "Packaging Technology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Adobe Creative AI",
      "Runway",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Packaging Buying Principles",
      "Packaging Engineering Principles",
      "Food and Beverage Management Principles",
      "Food Packaging Technology",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF50-007",
    "roleName": "Packaging Sustainability Analyst",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Packaging Sustainability",
      "Recyclable Packaging Design",
      "Packaging Carbon Footprint",
      "LCA - Life Cycle Assessment",
      "EPR Compliance"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "ChatGPT",
      "Runway",
      "Power BI Copilot",
      "Adobe Creative AI"
    ],
    "domainSkills": [
      "Packaging Sustainability Assessment",
      "Sustainable Packaging Principles",
      "Sustainability Analysis Principles",
      "Greenhouse Gas Accounting",
      "Packaging Materials Science"
    ]
  },
  {
    "roleId": "JF50-008",
    "roleName": "Jewellery Designer",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Jewellery Design",
      "CAD Jewellery Design",
      "Jewellery Sketching",
      "Gemstone Setting Design",
      "Gemology"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Runway"
    ],
    "domainSkills": [
      "Jewellery Design Principles",
      "Gemology Principles",
      "Visual Design Principles",
      "Goldsmithing and Jewellery Crafting",
      "Colour Theory"
    ]
  },
  {
    "roleId": "JF50-009",
    "roleName": "Gemologist",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Gemology",
      "Gem Identification",
      "Gem Grading",
      "Gem Laboratory Equipment",
      "Diamond Grading"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Canva Magic Studio",
      "Runway",
      "Adobe Creative AI"
    ],
    "domainSkills": [
      "Gemology Principles",
      "Gem Identification and Grading",
      "Materials Science Fundamentals",
      "Analytical Chemistry Principles",
      "Diamond Grading Principles"
    ]
  },
  {
    "roleId": "JF50-010",
    "roleName": "Goldsmith",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Goldsmithing",
      "Metal Fabrication - Jewellery",
      "Stone Setting - Craft",
      "Jewellery Finishing",
      "Gemology"
    ],
    "aiToolSkills": [
      "Adobe Creative AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Midjourney",
      "Runway"
    ],
    "domainSkills": [
      "Goldsmithing and Jewellery Crafting",
      "Metal Fabrication and Setting Techniques",
      "Materials Science Fundamentals",
      "Design Thinking Methodology",
      "Gemology Principles"
    ]
  },
  {
    "roleId": "JF50-011",
    "roleName": "Diamond Grader",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Diamond Grading",
      "4Cs of Diamond Grading",
      "GIA Grading Standards",
      "Diamond Measurement",
      "Gemology"
    ],
    "aiToolSkills": [
      "Microsoft 365 Copilot",
      "Canva Magic Studio",
      "Midjourney",
      "Adobe Creative AI",
      "Runway"
    ],
    "domainSkills": [
      "Diamond Grading Principles",
      "Gem Identification and Grading",
      "Gemology Principles",
      "Analytical Chemistry Principles",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF50-012",
    "roleName": "Jewellery Sales Executive",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Jewellery Sales",
      "Jewellery Product Knowledge",
      "Bridal Jewellery Advisory",
      "Gemology",
      "Hallmarking and Certification"
    ],
    "aiToolSkills": [
      "Salesforce Einstein",
      "ChatGPT",
      "Runway",
      "Midjourney",
      "Jasper AI"
    ],
    "domainSkills": [
      "Gems and Jewellery Sales Principles",
      "Gemology Principles",
      "Sales Fundamentals",
      "Jewellery Design Principles",
      "Customer Service Principles"
    ]
  },
  {
    "roleId": "JF50-013",
    "roleName": "Gems & Jewellery Exporter",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Gems and Jewellery Export",
      "Export Documentation",
      "Jewellery Export Documentation",
      "GJEPC Compliance",
      "International Jewellery Trade"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Canva Magic Studio",
      "Runway",
      "Salesforce Einstein",
      "Adobe Creative AI"
    ],
    "domainSkills": [
      "Gems and Jewellery Export Principles",
      "Jewellery Trade and Compliance",
      "EXIM Documentation and Procedures",
      "Gemology Principles",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF50-014",
    "roleName": "Valuer - Jewellery",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Jewellery Valuation",
      "Gemology",
      "Insurance Valuation",
      "Valuation Report Writing - Jewellery",
      "Market Price Assessment"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Canva Magic Studio",
      "Runway",
      "Adobe Creative AI"
    ],
    "domainSkills": [
      "Jewellery Valuation Principles",
      "Precious Metal and Stone Appraisal",
      "Gemology Principles",
      "Gem Identification and Grading",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF50-015",
    "roleName": "Print Production Designer",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Print Design",
      "Adobe InDesign",
      "Layout and Typography",
      "Print-Ready Artwork",
      "Colour Management - Print"
    ],
    "aiToolSkills": [
      "Adobe Creative AI",
      "Midjourney",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Print Design Principles",
      "Pre-Press and Print Production Concepts",
      "Visual Design Principles",
      "Colour Theory",
      "Colour Reproduction in Print"
    ]
  },
  {
    "roleId": "JF50-016",
    "roleName": "Packaging Development Executive",
    "jobFamily": "Printing, Packaging & Gems",
    "technicalSkills": [
      "Packaging Development",
      "New Packaging Introduction",
      "Packaging Technology",
      "Packaging Trial Management",
      "Packaging BOM Management"
    ],
    "aiToolSkills": [
      "Adobe Creative AI",
      "ChatGPT",
      "Canva Magic Studio",
      "Clean Energy AI",
      "Runway"
    ],
    "domainSkills": [
      "Packaging Development Principles",
      "Packaging Specification and Approval",
      "Packaging Engineering Principles",
      "Packaging Materials Science",
      "Food and Beverage Management Principles"
    ]
  },
  {
    "roleId": "JF51-001",
    "roleName": "IAS Officer - District Collector",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "District Administration",
      "Revenue Administration",
      "Law and Order Management",
      "Disaster Management",
      "Development Programme Administration"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Public Administration Principles",
      "District Administration and Governance",
      "Aerospace Engineering Fundamentals",
      "Aerodynamics Principles",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-002",
    "roleName": "IAS Officer - SDM",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Sub-Divisional Administration",
      "Land Record Management",
      "Revenue Court Proceedings",
      "Election Management",
      "Revenue Administration"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Public Administration Principles",
      "Aerodynamics Principles",
      "Materials Science Fundamentals",
      "Materials Characterisation and Testing"
    ]
  },
  {
    "roleId": "JF51-003",
    "roleName": "IAS Officer - Secretary",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Policy Secretariat Work",
      "Policy Formulation",
      "Interdepartmental Coordination",
      "File Noting and Drafting",
      "Statutory Interpretation"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Policy Secretariat and Government Advisory",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals",
      "Aerodynamics Principles",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-004",
    "roleName": "IPS Officer - SP",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Police Administration",
      "Criminal Investigation",
      "Law Enforcement Management",
      "Police District Management",
      "Criminal Law"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Law Enforcement and Police Administration",
      "Criminal Investigation and Public Safety",
      "Aerospace Engineering Fundamentals",
      "Criminal Law and Procedure",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-005",
    "roleName": "IPS Officer - DCP",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Urban Policing",
      "Traffic and Crime Management",
      "Community Policing",
      "Police Station Management",
      "Criminal Law"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Law Enforcement and Police Administration",
      "Criminal Investigation and Public Safety",
      "Aerospace Engineering Fundamentals",
      "Criminal Law and Procedure",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-006",
    "roleName": "IFS Officer - Diplomat",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Diplomatic Service",
      "International Relations",
      "Treaty Negotiation",
      "Foreign Policy Analysis",
      "Protocol Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM",
      "GovTech AI"
    ],
    "domainSkills": [
      "Diplomacy and Foreign Service Principles",
      "Bilateral Relations and Treaty Management",
      "Aerospace Engineering Fundamentals",
      "Aerodynamics Principles",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-007",
    "roleName": "IFS Officer - Consul General",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Consular Operations",
      "Visa and Passport Services",
      "Trade and Investment Promotion",
      "International Relations",
      "Diaspora Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM",
      "GovTech AI"
    ],
    "domainSkills": [
      "Consular Services and Visa Management",
      "Diplomacy and Foreign Service Principles",
      "Bilateral Relations and Treaty Management",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-008",
    "roleName": "IRS Officer - Income Tax",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Income Tax Administration",
      "Tax Assessment",
      "Income Tax Act",
      "Income Tax Investigation",
      "Tax Recovery"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Direct Tax Assessment and Investigation",
      "Direct Taxation Principles",
      "Tax Law Principles",
      "Tax Filing and Compliance Procedures"
    ]
  },
  {
    "roleId": "JF51-009",
    "roleName": "IRS Officer - Customs & GST",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Customs and GST Administration",
      "Customs Valuation",
      "HS Code Classification",
      "Anti-Smuggling Operations",
      "GST Audit and Enforcement"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Customs and Trade Compliance",
      "Indirect Tax Assessment and Enforcement",
      "GST and Indirect Tax Law",
      "Tax Law Principles",
      "Import and Export Regulations"
    ]
  },
  {
    "roleId": "JF51-010",
    "roleName": "IRTS - Railway Traffic Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Railway Traffic Operations",
      "Train Operations Management",
      "Station Management",
      "Railway Commercial Operations",
      "Railway Engineering"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Power BI Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Railway Traffic Management Principles",
      "Train Operations and Scheduling",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-011",
    "roleName": "IRAS - Railway Accounts Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Railway Accounts Management",
      "Government Accounting Standards",
      "Internal Audit - Railway",
      "Railway Finance",
      "Financial Accounting"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Railway Finance and Accounts",
      "Financial Accounting Principles",
      "Government Audit Principles",
      "Public Administration Principles",
      "Law Enforcement and Police Administration"
    ]
  },
  {
    "roleId": "JF51-012",
    "roleName": "IDAS - Defence Accounts Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Defence Accounts Administration",
      "Defence Finance",
      "Military Pay and Allowances",
      "Defence Procurement Finance",
      "Government Accounting Standards"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Defence Finance and Accounts",
      "Financial Accounting Principles",
      "Government Audit Principles",
      "Public Administration Principles",
      "Law Enforcement and Police Administration"
    ]
  },
  {
    "roleId": "JF51-013",
    "roleName": "SSC CGL - Tax Inspector",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Tax Inspection",
      "Income Tax Return Scrutiny",
      "Income Tax Act",
      "TDS Compliance",
      "Tax Survey Operations"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Tax Inspection and Assessment",
      "Direct Taxation Principles",
      "GST and Indirect Tax Law",
      "Public Administration Principles",
      "Tax Filing and Compliance Procedures"
    ]
  },
  {
    "roleId": "JF51-014",
    "roleName": "SSC CGL - Auditor",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Government Audit",
      "CAG Audit Standards",
      "Compliance Audit",
      "Audit Report Preparation",
      "Government Accounting Standards"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Government Audit Principles",
      "Financial Accounting Principles",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-015",
    "roleName": "SSC CGL - Statistical Investigator",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Statistical Investigation",
      "Government Statistical Systems",
      "Field Survey Management",
      "Biostatistics",
      "National Statistical Standards"
    ],
    "aiToolSkills": [
      "Perplexity AI",
      "ChatGPT",
      "Google NotebookLM",
      "GovTech AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Statistical Investigation Methodology",
      "Aerospace Engineering Fundamentals",
      "Public Administration Principles",
      "Data Visualization Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF51-016",
    "roleName": "Postal Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Postal Administration",
      "Postal Operations Management",
      "Post Office Banking",
      "Postal Savings Schemes",
      "Development Programme Administration"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Postal Services Administration",
      "Public Administration Principles",
      "Customer Service Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-017",
    "roleName": "State PCS - Deputy Collector",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "State Administrative Service",
      "Revenue Administration",
      "Sub-Divisional Development",
      "Tehsildar Supervision",
      "State Revenue Code"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "State Revenue and Land Administration",
      "District Administration and Governance",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-018",
    "roleName": "State PCS - DSP",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "State Police Service",
      "Circle Police Management",
      "Crime Prevention",
      "Criminal Law",
      "Subordinate Police Supervision"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "State Police Administration",
      "Law Enforcement and Police Administration",
      "Criminal Investigation and Public Safety",
      "Criminal Law and Procedure",
      "Public Administration Principles"
    ]
  },
  {
    "roleId": "JF51-019",
    "roleName": "Tehsildar",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Tehsil Administration",
      "Mutation and Record Correction",
      "Land Record Management",
      "Revenue Recovery",
      "Tehsil Court Management"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Tehsil Revenue Administration",
      "State Revenue and Land Administration",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-020",
    "roleName": "Block Development Officer (BDO)",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Block Level Administration",
      "Panchayati Raj Management",
      "MGNREGA Implementation",
      "Development Programme Administration",
      "Gram Sabha Facilitation"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Block-Level Rural Development Administration",
      "Public Administration Principles",
      "Public Health Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-021",
    "roleName": "Revenue Inspector",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Revenue Inspection",
      "Khasra and Khatauni Verification",
      "Land Record Management",
      "Demarcation and Survey",
      "Crop Inspection"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Claude",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Revenue Field Inspection",
      "State Revenue and Land Administration",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-022",
    "roleName": "PSU Engineer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "PSU Engineering",
      "Mechanical Engineering",
      "Public Sector Project Execution",
      "Technical Specification Writing",
      "Government Tender Participation"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "ChatGPT",
      "Claude",
      "Google NotebookLM",
      "Perplexity AI"
    ],
    "domainSkills": [
      "PSU Engineering Management",
      "Mechanical Engineering Fundamentals",
      "Engineering Design Principles",
      "Public Administration Principles",
      "Product Design and Development"
    ]
  },
  {
    "roleId": "JF51-023",
    "roleName": "PSU Manager - Finance",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "PSU Finance Management",
      "Government Budget Management",
      "PSU Accounts and Audit",
      "CVC Compliance",
      "Financial Accounting"
    ],
    "aiToolSkills": [
      "Microsoft Copilot for Finance",
      "ChatGPT",
      "Perplexity AI",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Financial Accounting Principles",
      "Public Administration Principles",
      "Direct Taxation Principles",
      "Tax Filing and Compliance Procedures"
    ]
  },
  {
    "roleId": "JF51-024",
    "roleName": "PSU Manager - HR",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "PSU HR Management",
      "Government Service Rules",
      "DPC and Promotion Management",
      "Industrial Relations - PSU",
      "Labour Law"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Recruiting",
      "Perplexity AI",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Human Resource Management Principles",
      "Labour Law and Employment Legislation",
      "Public Administration Principles",
      "Labour Law Advisory and Compliance"
    ]
  },
  {
    "roleId": "JF51-025",
    "roleName": "PSU Manager - Operations",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "PSU Operations Management",
      "Operations Management",
      "Public Sector Production Planning",
      "Government Quality Standards",
      "PSU Safety Management"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "Perplexity AI",
      "Google NotebookLM",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Aerospace Engineering Fundamentals",
      "Operations Management Principles",
      "Public Administration Principles",
      "Aerodynamics Principles",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-026",
    "roleName": "PSU Banking Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "PSU Banking",
      "Priority Sector Lending",
      "NPA Management",
      "Credit Assessment",
      "Government Scheme Banking"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Public Sector Banking Principles",
      "Banking Operations Fundamentals",
      "Credit Appraisal and Lending Principles",
      "Public Administration Principles",
      "Banking Products and Services"
    ]
  },
  {
    "roleId": "JF51-027",
    "roleName": "PSU Insurance Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "PSU Insurance Operations",
      "General Insurance Products",
      "Insurance Claims Settlement",
      "Underwriting",
      "Government Insurance Schemes"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Microsoft Copilot for Finance",
      "Claude",
      "Perplexity AI",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "PSU Insurance Principles",
      "Aerospace Engineering Fundamentals",
      "Public Administration Principles",
      "Underwriting Principles",
      "Insurance Principles and Concepts"
    ]
  },
  {
    "roleId": "JF51-028",
    "roleName": "ISRO Scientist",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Space Science Research",
      "Satellite Mission Development",
      "Launch Vehicle Technology",
      "Aerodynamics",
      "Remote Sensing Applications"
    ],
    "aiToolSkills": [
      "Space Systems AI",
      "MATLAB AI",
      "ChatGPT",
      "Google NotebookLM",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Space Research and Technology Principles",
      "Spacecraft Technology Development",
      "Aerodynamics Principles",
      "Aerospace Engineering Fundamentals",
      "Research and Development Methodology"
    ]
  },
  {
    "roleId": "JF51-029",
    "roleName": "DRDO Scientist",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Defence Research",
      "Defence Technology Development",
      "Military Systems Design",
      "Systems Engineering",
      "Defence Qualification Testing"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "ChatGPT",
      "Google NotebookLM",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Defence Research and Development Principles",
      "Defence Systems Technology",
      "Systems Engineering Methodology",
      "Research and Development Methodology",
      "Research Ethics and Scientific Integrity"
    ]
  },
  {
    "roleId": "JF51-030",
    "roleName": "BARC Scientist",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Nuclear Science Research",
      "Reactor Physics",
      "Radiation Safety (Government & PSU)",
      "Nuclear Fuel Technology",
      "Chemical Engineering"
    ],
    "aiToolSkills": [
      "ANSYS AI",
      "MATLAB AI",
      "ChatGPT",
      "Google NotebookLM",
      "Perplexity AI"
    ],
    "domainSkills": [
      "Nuclear Science and Technology Principles",
      "Reactor Physics and Nuclear Safety",
      "Research and Development Methodology",
      "Radiation Safety and Nuclear Regulations",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-031",
    "roleName": "Indian Army Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Army Command",
      "Military Leadership",
      "Tactics and Field Craft",
      "Military Administration",
      "Counter Insurgency Operations"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "GovTech AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Military Leadership and Command Principles",
      "Army Operations and Tactics",
      "Military Law and Discipline",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-032",
    "roleName": "Indian Navy Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Naval Command",
      "Maritime Warfare",
      "Naval Operations",
      "Nautical Navigation",
      "Naval Engineering Systems"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "GovTech AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Military Leadership and Command Principles",
      "Naval Operations and Strategy",
      "Maritime Navigation and Ship Command",
      "Public Administration Principles",
      "International Maritime Regulations"
    ]
  },
  {
    "roleId": "JF51-033",
    "roleName": "Indian Air Force Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Air Force Command",
      "Fighter Pilot Operations",
      "Air Defence",
      "Multi-Engine IFR Flying",
      "Air Force Administration"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "GovTech AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Military Leadership and Command Principles",
      "Air Force Operations and Strategy",
      "Aerodynamics Principles",
      "Public Administration Principles",
      "Aerospace Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF51-034",
    "roleName": "CRPF Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "CRPF Command",
      "Internal Security Operations",
      "Crowd Control and Riot Management",
      "Para-Military Administration",
      "Military Leadership"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Paramilitary Operations Principles",
      "Border Security and Paramilitary Law",
      "Law Enforcement and Police Administration",
      "Public Administration Principles",
      "Criminal Law and Procedure"
    ]
  },
  {
    "roleId": "JF51-035",
    "roleName": "BSF Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "BSF Command",
      "Border Security Operations",
      "Border Surveillance",
      "Anti-Infiltration Operations",
      "Para-Military Administration"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Border Security and Paramilitary Law",
      "Paramilitary Operations Principles",
      "Law Enforcement and Police Administration",
      "Aerospace Engineering Fundamentals",
      "Materials Science Fundamentals"
    ]
  },
  {
    "roleId": "JF51-036",
    "roleName": "CISF Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "CISF Command",
      "Industrial Security",
      "Critical Infrastructure Protection",
      "Airport Security Management",
      "Para-Military Administration"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Industrial Security Management",
      "Border Security and Paramilitary Law",
      "Paramilitary Operations Principles",
      "Airport Security Principles",
      "Aviation Security Regulations"
    ]
  },
  {
    "roleId": "JF51-037",
    "roleName": "SSB Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "SSB Command",
      "Indo-Nepal and Indo-Bhutan Border Operations",
      "Border Security Operations",
      "Armed Border Patrol",
      "Riverine Operations"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Microsoft 365 Copilot",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Special Security Forces Operations",
      "Border Security and Paramilitary Law",
      "Paramilitary Operations Principles",
      "Public Administration Principles",
      "Law Enforcement and Police Administration"
    ]
  },
  {
    "roleId": "JF51-038",
    "roleName": "Town Planner",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Town Planning",
      "Master Plan Preparation",
      "Land Use Planning",
      "Urban Development Regulations",
      "Building Plan Scrutiny"
    ],
    "aiToolSkills": [
      "Autodesk BIM 360 AI",
      "ChatGPT",
      "Perplexity AI",
      "GovTech AI",
      "Google NotebookLM"
    ],
    "domainSkills": [
      "Town and Country Planning Principles",
      "Urban Development and Infrastructure Planning",
      "Land Use Planning and Zoning",
      "Civil Engineering Fundamentals",
      "State Revenue and Land Administration"
    ]
  },
  {
    "roleId": "JF51-039",
    "roleName": "Panchayat Development Officer",
    "jobFamily": "Government & Public Administration",
    "technicalSkills": [
      "Panchayat Administration",
      "Village Development Planning",
      "Panchayati Raj Management",
      "Panchayat Finance Management",
      "Rural Infrastructure Management"
    ],
    "aiToolSkills": [
      "GovTech AI",
      "ChatGPT",
      "Perplexity AI",
      "Google NotebookLM",
      "Social Impact AI"
    ],
    "domainSkills": [
      "Panchayati Raj Administration",
      "Gram Sabha and Village Development",
      "Block-Level Rural Development Administration",
      "Public Administration Principles",
      "Law Enforcement and Police Administration"
    ]
  },
  {
    "roleId": "JF52-001",
    "roleName": "Social Worker",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Social Work",
      "Case Management - Social",
      "Community Mobilisation",
      "Social Services Navigation",
      "Counselling Psychology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Social Impact AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Social Work Principles",
      "Case Management and Community Intervention",
      "Counselling Psychology Principles",
      "Medical Ethics and Professional Standards",
      "Psychosocial Assessment and Care Coordination"
    ]
  },
  {
    "roleId": "JF52-002",
    "roleName": "Community Development Officer",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Community Development",
      "Participatory Rural Appraisal",
      "Community Mobilisation",
      "Community Need Assessment",
      "Community Resource Mapping"
    ],
    "aiToolSkills": [
      "Social Impact AI",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Community Development Principles",
      "Participatory Development Methodology",
      "Agricultural Extension Principles",
      "Public Health Principles",
      "Farmer Advisory and Technology Dissemination"
    ]
  },
  {
    "roleId": "JF52-003",
    "roleName": "Child Welfare Officer",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Child Welfare",
      "Child Protection",
      "POCSO Knowledge",
      "Child Care Institution Management",
      "Case Management - Social"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Social Impact AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Child Welfare and Protection Principles",
      "Child Rights and Safeguarding",
      "Social Work Principles",
      "Child Development and Learning Theory",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF52-004",
    "roleName": "Women Empowerment Specialist",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Women Empowerment",
      "Gender-Based Violence Response",
      "Women's SHG Development",
      "Gender and Inclusion",
      "Livelihood Programme for Women"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Social Impact AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Women Empowerment and Gender Justice",
      "Gender-Based Violence and Response",
      "Participatory Development Methodology",
      "Public Health Principles",
      "Community Development Principles"
    ]
  },
  {
    "roleId": "JF52-005",
    "roleName": "Program Manager - NGO",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "NGO Programme Management",
      "Development Project Management",
      "Logical Framework Analysis",
      "Donor Reporting",
      "Monitoring and Evaluation"
    ],
    "aiToolSkills": [
      "Social Impact AI",
      "ChatGPT",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Proposal Development Methodology",
      "Project Cycle Management",
      "Monitoring and Evaluation Methodology",
      "Medical Ethics and Professional Standards",
      "Grant Writing Principles"
    ]
  },
  {
    "roleId": "JF52-006",
    "roleName": "CSR Manager",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "CSR Management",
      "CSR Strategy Development",
      "CSR Compliance - Companies Act",
      "Social Impact Measurement",
      "Donor Reporting"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Social Impact AI",
      "Perplexity AI",
      "Canva Magic Studio",
      "Jasper AI"
    ],
    "domainSkills": [
      "Corporate Social Responsibility Management",
      "CSR Strategy and Stakeholder Reporting",
      "Sustainability Analysis Principles",
      "Participatory Development Methodology",
      "Community Development Principles"
    ]
  },
  {
    "roleId": "JF52-007",
    "roleName": "Grant Writer",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Grant Writing",
      "Proposal Development",
      "Donor Research",
      "Grant Reporting",
      "Logical Framework Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Perplexity AI",
      "Jasper AI",
      "Canva Magic Studio",
      "Social Impact AI"
    ],
    "domainSkills": [
      "Grant Writing Principles",
      "Proposal Development Methodology",
      "Project Cycle Management",
      "Monitoring and Evaluation Methodology",
      "Donor Relationship Management"
    ]
  },
  {
    "roleId": "JF52-008",
    "roleName": "Fundraising Manager",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Fundraising Management",
      "Donor Cultivation",
      "Crowdfunding",
      "Donor Reporting",
      "Fundraising Event Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Social Impact AI",
      "Perplexity AI",
      "Jasper AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Fundraising Management Principles",
      "Donor Relationship Management",
      "Marketing Fundamentals",
      "Grant Writing Principles",
      "Proposal Development Methodology"
    ]
  },
  {
    "roleId": "JF52-009",
    "roleName": "Development Consultant",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Development Consulting",
      "Socio-Economic Research",
      "Development Programme Design",
      "International Development Frameworks",
      "Monitoring and Evaluation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Social Impact AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Development Consulting Principles",
      "Policy Analysis Methodology",
      "Project Cycle Management",
      "Monitoring and Evaluation Methodology",
      "IT Project Management"
    ]
  },
  {
    "roleId": "JF52-010",
    "roleName": "Policy Analyst",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Policy Analysis",
      "Policy Research",
      "Stakeholder Consultation",
      "Policy Brief Writing",
      "Social Impact Measurement"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio",
      "Social Impact AI"
    ],
    "domainSkills": [
      "Policy Analysis Methodology",
      "Social Policy Research",
      "Data Visualization Principles",
      "Dashboard and Report Design Principles",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF52-011",
    "roleName": "Gender & Inclusion Specialist",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Gender and Inclusion",
      "Gender Mainstreaming",
      "Disability Inclusion",
      "Gender-Based Violence Response",
      "Social Inclusion Programming"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Social Impact AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Gender and Inclusion Principles",
      "Women Empowerment and Gender Justice",
      "Policy Analysis Methodology",
      "Participatory Development Methodology",
      "Monitoring and Evaluation Methodology"
    ]
  },
  {
    "roleId": "JF52-012",
    "roleName": "WASH Specialist",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "WASH Programming",
      "Water and Sanitation Planning",
      "ODF and Swachh Bharat Implementation",
      "WASH Behaviour Change",
      "Community Mobilisation"
    ],
    "aiToolSkills": [
      "Social Impact AI",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "WASH Programme Principles",
      "Water, Sanitation and Hygiene Behaviour Change",
      "Public Health Principles",
      "Participatory Development Methodology",
      "Civil Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF52-013",
    "roleName": "Livelihoods Specialist",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Livelihoods Development",
      "Market Linkage Development",
      "Skill Development Programming",
      "Value Chain Development",
      "Community Mobilisation"
    ],
    "aiToolSkills": [
      "Social Impact AI",
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Livelihoods Development Principles",
      "Sustainable Livelihoods Framework",
      "Agronomy Principles",
      "Participatory Development Methodology",
      "Microfinance Principles"
    ]
  },
  {
    "roleId": "JF52-014",
    "roleName": "M&E (Monitoring & Evaluation) Officer",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Monitoring and Evaluation",
      "M&E Framework Design",
      "Programme Monitoring",
      "Research Data Analysis",
      "Development Data Management"
    ],
    "aiToolSkills": [
      "Social Impact AI",
      "Claude",
      "Perplexity AI",
      "Canva Magic Studio",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Monitoring and Evaluation Methodology",
      "Data Visualization Principles",
      "Dashboard and Report Design Principles",
      "Project Cycle Management",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF52-015",
    "roleName": "Microfinance Officer",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Microfinance",
      "Microcredit Appraisal",
      "SHG-Bank Linkage",
      "Microfinance Portfolio Management",
      "Community Mobilisation"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Social Impact AI",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Microfinance Principles",
      "Agricultural Credit and Finance",
      "Credit Appraisal and Lending Principles",
      "Self-Help Group Coordination",
      "Negotiation Principles"
    ]
  },
  {
    "roleId": "JF52-016",
    "roleName": "SHG Coordinator",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "SHG Coordination",
      "SHG Formation and Nurturing",
      "SHG Grading",
      "SHG-Bank Linkage",
      "SHG Federations Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Social Impact AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Self-Help Group Coordination",
      "Participatory Development Methodology",
      "Microfinance Principles",
      "Women Empowerment and Gender Justice",
      "Community Development Principles"
    ]
  },
  {
    "roleId": "JF52-017",
    "roleName": "Rural Finance Specialist",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Rural Finance",
      "Financial Inclusion Programming",
      "Rural Credit Planning",
      "SHG-Bank Linkage",
      "NABARD Scheme Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Social Impact AI",
      "Power BI Copilot",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Rural Finance Principles",
      "Agricultural Credit and Finance",
      "Microfinance Principles",
      "Participatory Development Methodology",
      "Agricultural Loan Appraisal"
    ]
  },
  {
    "roleId": "JF52-018",
    "roleName": "Impact Assessment Analyst",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Impact Assessment",
      "Theory of Change",
      "Social Return on Investment",
      "Randomised Control Trial - Development",
      "Social Impact Measurement"
    ],
    "aiToolSkills": [
      "Claude",
      "Perplexity AI",
      "Canva Magic Studio",
      "Social Impact AI",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Impact Assessment Methodology",
      "Social Return on Investment Concepts",
      "Data Visualization Principles",
      "Monitoring and Evaluation Methodology",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF52-019",
    "roleName": "Capacity Building Executive",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Capacity Building",
      "Training of Trainers",
      "Training Facilitation",
      "Organisational Capacity Assessment",
      "Institutional Strengthening"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Social Impact AI",
      "Perplexity AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Capacity Building Methodology",
      "Training Needs Assessment for Development",
      "Participatory Development Methodology",
      "Monitoring and Evaluation Methodology",
      "Community Development Principles"
    ]
  },
  {
    "roleId": "JF52-020",
    "roleName": "Field Research Executive",
    "jobFamily": "Social Sector & Development",
    "technicalSkills": [
      "Field Research",
      "Quantitative Survey Design",
      "Qualitative Research Methods",
      "Data Entry and Cleaning",
      "Development Data Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Power BI Copilot",
      "Perplexity AI",
      "Social Impact AI",
      "Canva Magic Studio"
    ],
    "domainSkills": [
      "Field Research Principles",
      "Qualitative Research Methods in Development",
      "IT Project Management",
      "Project Cycle Management",
      "Research Ethics and Scientific Integrity"
    ]
  },
  {
    "roleId": "JF53-001",
    "roleName": "Fine Artist - Painter",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Fine Art - Painting",
      "Oil and Acrylic Painting",
      "Composition and Colour Theory",
      "Watercolour",
      "Art Portfolio Development"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Fine Art Principles",
      "Painting Techniques and Theory",
      "Colour Theory",
      "Visual Design Principles",
      "Art History and Critical Theory"
    ]
  },
  {
    "roleId": "JF53-002",
    "roleName": "Sculptor",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Sculpture",
      "Clay Modelling - Art",
      "Stone Carving",
      "Metal Sculpture",
      "Art Portfolio Development"
    ],
    "aiToolSkills": [
      "Midjourney",
      "ChatGPT",
      "ElevenLabs",
      "Adobe Creative AI",
      "Runway"
    ],
    "domainSkills": [
      "Sculpture Principles",
      "Three-Dimensional Form and Materials",
      "Colour Theory",
      "Visual Design Principles",
      "Fine Art Principles"
    ]
  },
  {
    "roleId": "JF53-003",
    "roleName": "Ceramic Artist",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Ceramic Art",
      "Wheel Throwing",
      "Ceramic Glazing",
      "Kiln Operations",
      "Art Portfolio Development"
    ],
    "aiToolSkills": [
      "Midjourney",
      "ChatGPT",
      "ElevenLabs",
      "Adobe Creative AI",
      "Runway"
    ],
    "domainSkills": [
      "Ceramic Art Principles",
      "Three-Dimensional Form and Materials",
      "Colour Theory",
      "Fine Art Principles",
      "Art History and Critical Theory"
    ]
  },
  {
    "roleId": "JF53-004",
    "roleName": "Muralist",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Mural Art",
      "Large Format Painting",
      "Composition and Colour Theory",
      "Site-Specific Art",
      "Wall Surface Preparation"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Mural Art Principles",
      "Large-Scale Painting and Wall Art Techniques",
      "Painting Techniques and Theory",
      "Colour Theory",
      "Visual Design Principles"
    ]
  },
  {
    "roleId": "JF53-005",
    "roleName": "Product Designer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Product Design",
      "Design Thinking",
      "Prototyping",
      "User Research - Design",
      "SolidWorks"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Product Design Principles",
      "User-Centred Design Methodology",
      "Design Thinking Methodology",
      "Visual Design Principles",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF53-006",
    "roleName": "Industrial Designer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Industrial Design",
      "Design Thinking",
      "Ergonomics",
      "Manufacturing Process Knowledge",
      "Design for Manufacture"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "MATLAB AI"
    ],
    "domainSkills": [
      "Industrial Design Principles",
      "Design for Manufacturing Concepts",
      "Product Design Principles",
      "Design Thinking Methodology",
      "Mechanical Engineering Fundamentals"
    ]
  },
  {
    "roleId": "JF53-007",
    "roleName": "Furniture Designer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Furniture Design",
      "Wood Joinery and Techniques",
      "Design Thinking",
      "Material Selection - Furniture",
      "Furniture Technical Drawing"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Furniture Design Principles",
      "Visual Design Principles",
      "Design Thinking Methodology",
      "Materials Science Fundamentals",
      "Engineering Design Principles"
    ]
  },
  {
    "roleId": "JF53-008",
    "roleName": "Art Teacher",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Art Education",
      "Visual Arts Teaching",
      "Composition and Colour Theory",
      "Art Criticism and Appreciation",
      "Classroom Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Art Education Principles",
      "Fine Art Principles",
      "Teaching Principles and Pedagogy",
      "Colour Theory",
      "Visual Design Principles"
    ]
  },
  {
    "roleId": "JF53-009",
    "roleName": "Craft Designer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Craft Design",
      "Traditional Craft Techniques",
      "Craft Collection Development",
      "Design Thinking",
      "Material Craftsmanship"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Craft Design Principles",
      "Traditional and Contemporary Craft Techniques",
      "Visual Design Principles",
      "Colour Theory",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF53-010",
    "roleName": "Set Designer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Set Design",
      "Scenic Design",
      "Prop Design",
      "AutoCAD Architecture",
      "Production Design Coordination"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Set Design Principles",
      "Spatial and Production Design for Theatre",
      "Visual Design Principles",
      "Colour Theory",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF53-011",
    "roleName": "Assistant Theatre Director",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Theatre Direction",
      "Script Analysis",
      "Rehearsal Management",
      "Stage Management",
      "Character Development"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Theatre Direction Principles",
      "Dramatic Theory and Performance",
      "Dance and Choreography Principles",
      "Theatre Acting Principles",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF53-012",
    "roleName": "Dancer / Choreographer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Dance and Choreography",
      "Classical Indian Dance",
      "Choreographic Composition",
      "Contemporary Dance",
      "Rehearsal Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Adobe Firefly",
      "Midjourney",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Dance and Choreography Principles",
      "Movement and Performance Theory",
      "Sports Science and Exercise Physiology Concepts",
      "Teaching Principles and Pedagogy",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF53-013",
    "roleName": "Theatre Actor",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Theatre Acting",
      "Voice and Diction",
      "Movement and Physical Theatre",
      "Character Development",
      "Script Analysis"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Adobe Firefly",
      "ElevenLabs",
      "Midjourney",
      "Runway"
    ],
    "domainSkills": [
      "Theatre Acting Principles",
      "Dramatic Theory and Performance",
      "Theatre Direction Principles",
      "Dance and Choreography Principles",
      "Voice and Speech Production"
    ]
  },
  {
    "roleId": "JF53-014",
    "roleName": "Music Composer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Music Composition",
      "Music Theory",
      "Orchestration",
      "DAW Production",
      "Content Licensing"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ElevenLabs",
      "Midjourney",
      "Adobe Firefly",
      "Runway"
    ],
    "domainSkills": [
      "Music Composition Principles",
      "Harmony, Counterpoint and Arrangement",
      "Music Theory Fundamentals",
      "Design Thinking Methodology",
      "Song Structure and Composition"
    ]
  },
  {
    "roleId": "JF53-015",
    "roleName": "Textile Print Designer",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Textile Print Design",
      "Repeat Pattern Design",
      "Textile Colour Ways",
      "Adobe Photoshop",
      "Screen and Digital Print Techniques"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "Runway",
      "Adobe Firefly"
    ],
    "domainSkills": [
      "Textile Print Design Principles",
      "Surface Pattern and Repeat Design",
      "Colour Theory",
      "Visual Design Principles",
      "Print Design Principles"
    ]
  },
  {
    "roleId": "JF53-016",
    "roleName": "Jewellery Production Artist",
    "jobFamily": "Fine Arts, Craft & Performing Arts",
    "technicalSkills": [
      "Jewellery Production Art",
      "Goldsmithing",
      "Hand Engraving - Jewellery",
      "Filigree and Granulation",
      "Enamelling"
    ],
    "aiToolSkills": [
      "Midjourney",
      "Adobe Creative AI",
      "ChatGPT",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Jewellery Production and Artisan Skills",
      "Jewellery Design Principles",
      "Gem Identification and Grading",
      "Colour Theory",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF54-001",
    "roleName": "Professional Athlete - Cricket",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Cricket",
      "Batting Technique",
      "Bowling Technique",
      "Fielding",
      "Cricket Match Strategy"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Cricket Performance Principles",
      "Cricket Technical Skills and Match Craft",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards",
      "Sports Analytics Principles"
    ]
  },
  {
    "roleId": "JF54-002",
    "roleName": "Professional Athlete - Football",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Football",
      "Ball Control and Dribbling",
      "Tactical Football Play",
      "Fitness Programme Design",
      "Set Piece Execution"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Football Performance Principles",
      "Football Technical Skills and Tactics",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards",
      "Sports Analytics Principles"
    ]
  },
  {
    "roleId": "JF54-003",
    "roleName": "Professional Athlete - Badminton",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Badminton",
      "Badminton Stroke Techniques",
      "Badminton Footwork",
      "Badminton Match Strategy",
      "Fitness Programme Design"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Badminton Performance Principles",
      "Badminton Technical Skills and Strategy",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards",
      "Sports Analytics Principles"
    ]
  },
  {
    "roleId": "JF54-004",
    "roleName": "Professional Athlete - Hockey",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Hockey",
      "Stick Skills",
      "Hockey Positioning and Tactics",
      "Set Play Execution - Hockey",
      "Fitness Programme Design"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Field Hockey Performance Principles",
      "Hockey Technical Skills and Tactics",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards",
      "Sports Analytics Principles"
    ]
  },
  {
    "roleId": "JF54-005",
    "roleName": "Professional Athlete - Kabaddi",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Kabaddi",
      "Raiding Techniques",
      "Defensive Tactics - Kabaddi",
      "Kabaddi Match Strategy",
      "Fitness Programme Design"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Adobe Firefly",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Kabaddi Performance Principles",
      "Kabaddi Techniques and Tactical Systems",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards",
      "Sports Analytics Principles"
    ]
  },
  {
    "roleId": "JF54-006",
    "roleName": "Sports Coach",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Coaching",
      "Coaching Methodology",
      "Athlete Performance Management",
      "Training Programme Design",
      "Sports Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "ElevenLabs",
      "Adobe Firefly",
      "Runway"
    ],
    "domainSkills": [
      "Sports Coaching Principles",
      "Coaching Methodology and Periodisation",
      "Sports Science and Exercise Physiology Concepts",
      "Adult Learning Theory",
      "Sports Psychology Principles"
    ]
  },
  {
    "roleId": "JF54-007",
    "roleName": "Sports Physiotherapist",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Physiotherapy",
      "Sports Injury Assessment",
      "Rehabilitation - Sports",
      "Manual Therapy",
      "Fitness Programme Design"
    ],
    "aiToolSkills": [
      "AI Medical Diagnosis",
      "ChatGPT",
      "Midjourney",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Sports Physiotherapy Principles",
      "Athletic Injury Assessment and Rehabilitation",
      "Clinical Medicine Fundamentals",
      "Medical Ethics and Professional Standards",
      "Sports Science and Exercise Physiology Concepts"
    ]
  },
  {
    "roleId": "JF54-008",
    "roleName": "Sports Psychologist",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Psychology",
      "Mental Performance Coaching",
      "Concentration and Focus Training",
      "Pre-Competition Psychology",
      "Counselling Psychology"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "ElevenLabs",
      "Power BI Copilot",
      "Runway"
    ],
    "domainSkills": [
      "Sports Psychology Principles",
      "Mental Performance and Psychological Intervention",
      "Counselling Psychology Principles",
      "Medical Ethics and Professional Standards",
      "Sports Science and Exercise Physiology Concepts"
    ]
  },
  {
    "roleId": "JF54-009",
    "roleName": "Sports Analyst",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Analytics",
      "Performance Data Analysis",
      "Video Analysis - Sports",
      "Statistical Modelling - Sports",
      "Python"
    ],
    "aiToolSkills": [
      "Claude",
      "Runway",
      "ChatGPT",
      "ElevenLabs",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Sports Analytics Principles",
      "Athletic Performance Data Analysis",
      "Data Visualization Principles",
      "Sports Science and Exercise Physiology Concepts",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF54-010",
    "roleName": "Sports Scout",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Scouting",
      "Talent Identification",
      "Player Assessment",
      "Video Analysis - Sports",
      "Scouting Network Management"
    ],
    "aiToolSkills": [
      "Claude",
      "ChatGPT",
      "ElevenLabs",
      "Runway",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Talent Identification and Scouting",
      "Sports Coaching Principles",
      "Coaching Methodology and Periodisation",
      "Sports Analytics Principles",
      "Athletic Performance Data Analysis"
    ]
  },
  {
    "roleId": "JF54-011",
    "roleName": "Personal Trainer",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Personal Training",
      "Fitness Assessment",
      "Resistance Training",
      "Client Fitness Programming",
      "Nutrition Science"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ElevenLabs",
      "Midjourney",
      "Jasper AI",
      "Runway"
    ],
    "domainSkills": [
      "Personal Training Principles",
      "Exercise Programme Design",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards",
      "Applied Nutrition Principles"
    ]
  },
  {
    "roleId": "JF54-012",
    "roleName": "Yoga Instructor",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Yoga Teaching",
      "Yoga Instruction",
      "Yoga Sequencing",
      "Yoga Anatomy",
      "Pranayama Teaching"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Midjourney",
      "Jasper AI",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Yoga Instruction Principles",
      "Movement and Performance Theory",
      "Sports Science and Exercise Physiology Concepts",
      "Teaching Principles and Pedagogy",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF54-013",
    "roleName": "Sports Nutritionist",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Nutrition",
      "Athletic Diet Planning",
      "Nutrition Science",
      "Supplement Protocol",
      "Body Composition Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Jasper AI",
      "Midjourney",
      "ElevenLabs",
      "Runway"
    ],
    "domainSkills": [
      "Sports Nutrition Principles",
      "Athlete Dietary Planning",
      "Applied Nutrition Principles",
      "Sports Science and Exercise Physiology Concepts",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF54-014",
    "roleName": "Gym Manager",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Gym Management",
      "Gym Equipment Management",
      "Member Retention",
      "Client Fitness Programming",
      "Fitness Business Management"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Midjourney",
      "Runway",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Fitness Facility Management",
      "Personal Training Principles",
      "Customer Service Principles",
      "Environmental Health and Safety (EHS) Principles",
      "Revenue Management Concepts"
    ]
  },
  {
    "roleId": "JF54-015",
    "roleName": "Crossfit Coach",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "CrossFit Coaching",
      "WOD Programming",
      "Olympic Weightlifting Coaching",
      "Metabolic Conditioning",
      "Resistance Training"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ElevenLabs",
      "Midjourney",
      "Jasper AI",
      "Runway"
    ],
    "domainSkills": [
      "CrossFit Coaching Methodology",
      "Strength and Conditioning Principles",
      "Sports Science and Exercise Physiology Concepts",
      "Sports Coaching Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF54-016",
    "roleName": "Sports Manager",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Management",
      "Athlete Contract Management",
      "Sports Facility Management",
      "Team Operations Management",
      "Sports Coaching"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Salesforce Einstein",
      "Midjourney",
      "Runway",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Sports Management Principles",
      "Athlete and Club Management",
      "Business Development Principles",
      "Marketing Mix (4Ps / 7Ps)",
      "Marketing Fundamentals"
    ]
  },
  {
    "roleId": "JF54-017",
    "roleName": "Sports Marketing Manager",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Marketing",
      "Sponsorship Management",
      "Athlete Branding",
      "Sports Fan Engagement",
      "Digital Marketing"
    ],
    "aiToolSkills": [
      "Midjourney",
      "ChatGPT",
      "Adobe Firefly",
      "Jasper AI",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Sports Marketing Principles",
      "Sports Sponsorship and Brand Partnership",
      "Marketing Fundamentals",
      "Digital Marketing Principles",
      "Business Development Principles"
    ]
  },
  {
    "roleId": "JF54-018",
    "roleName": "Sports Event Manager",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Event Management",
      "Tournament Operations",
      "Sports Venue Management",
      "Event Budget Management",
      "Sports Event Safety"
    ],
    "aiToolSkills": [
      "Hospitality AI",
      "ChatGPT",
      "Adobe Firefly",
      "Salesforce Einstein",
      "Midjourney"
    ],
    "domainSkills": [
      "Clinical Medicine Fundamentals",
      "Event Management Methodology",
      "Event Management Principles",
      "Teaching Principles and Pedagogy",
      "Sports Marketing Principles"
    ]
  },
  {
    "roleId": "JF54-019",
    "roleName": "Sports & Media Journalist",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Sports Journalism",
      "Sports Writing",
      "Sports Broadcasting",
      "Sports Media Production",
      "Sports Analytics"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "Adobe Firefly",
      "Jasper AI",
      "Midjourney",
      "Runway"
    ],
    "domainSkills": [
      "Sports Media and Journalism Principles",
      "Sports Journalism Principles",
      "Sports Coaching Principles",
      "Digital Marketing Principles",
      "Journalism Principles and Ethics"
    ]
  },
  {
    "roleId": "JF54-020",
    "roleName": "Esports Manager",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Esports Management",
      "Esports Team Operations",
      "Gaming Performance Analytics",
      "Esports Tournament Management",
      "Sports Management"
    ],
    "aiToolSkills": [
      "Claude",
      "Runway",
      "ChatGPT",
      "ElevenLabs",
      "Salesforce Einstein"
    ],
    "domainSkills": [
      "Esports Management Principles",
      "Esports Ecosystem and Competition Management",
      "Sports Management Principles",
      "Marketing Fundamentals",
      "Marketing Mix (4Ps / 7Ps)"
    ]
  },
  {
    "roleId": "JF54-021",
    "roleName": "Strength Coach",
    "jobFamily": "Sports, Fitness & Wellness",
    "technicalSkills": [
      "Strength and Conditioning",
      "Periodisation Planning",
      "Power Development Training",
      "Resistance Training",
      "Recovery and Regeneration"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "ElevenLabs",
      "Midjourney",
      "Jasper AI",
      "Runway"
    ],
    "domainSkills": [
      "Strength and Conditioning Principles",
      "Resistance Training and Athletic Development",
      "Sports Science and Exercise Physiology Concepts",
      "Sports Coaching Principles",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF55-001",
    "roleName": "Management Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Management Consulting",
      "Business Problem Solving",
      "Client Engagement Management",
      "Consulting Delivery",
      "Hypothesis-Driven Analysis"
    ],
    "aiToolSkills": [
      "Claude",
      "ChatGPT",
      "AlphaSense",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Management Consulting Principles",
      "Business Problem-Solving Methodology",
      "Design Thinking Methodology",
      "IT Consulting Methodology",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF55-002",
    "roleName": "Strategy Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Strategy Analysis",
      "Strategic Planning Support",
      "Hypothesis-Driven Analysis",
      "Competitive Analysis",
      "Market Sizing"
    ],
    "aiToolSkills": [
      "AlphaSense",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Strategy Analysis Principles",
      "Competitive and Market Analysis",
      "Capital Markets Knowledge",
      "Business Problem-Solving Methodology",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF55-003",
    "roleName": "Business Transformation Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Business Transformation",
      "Operating Model Design",
      "Transformation Roadmap",
      "Change Enablement",
      "Consulting Delivery"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "Claude",
      "Gamma",
      "AlphaSense",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Business Transformation Consulting",
      "Organisational Change Architecture",
      "Management Consulting Principles",
      "Change Management Methodology",
      "Change Management for Digital Initiatives"
    ]
  },
  {
    "roleId": "JF55-004",
    "roleName": "MBB Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "MBB-Level Analysis",
      "Business Problem Solving",
      "Slide Deck Storytelling",
      "Qualitative Research - Consulting",
      "Benchmarking Analysis"
    ],
    "aiToolSkills": [
      "Claude",
      "ChatGPT",
      "AlphaSense",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Management Consulting Principles",
      "Business Problem-Solving Methodology",
      "Strategy Analysis Principles",
      "IT Consulting Methodology",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF55-005",
    "roleName": "HR Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "HR Consulting",
      "Organisation Design",
      "HR Diagnostic",
      "Talent Strategy",
      "Client Engagement Management"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AI Recruiting",
      "AlphaSense",
      "Claude",
      "Gamma"
    ],
    "domainSkills": [
      "Human Capital Consulting Principles",
      "Human Resource Management Principles",
      "Organisation Design and Effectiveness",
      "Management Consulting Principles",
      "IT Consulting Methodology"
    ]
  },
  {
    "roleId": "JF55-006",
    "roleName": "OD Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Organisation Development Consulting",
      "Culture Transformation",
      "Leadership Development Consulting",
      "Team Effectiveness",
      "Organisation Design"
    ],
    "aiToolSkills": [
      "Claude",
      "ChatGPT",
      "AlphaSense",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Organisation Design and Effectiveness",
      "Organisational Change Architecture",
      "Human Resource Management Principles",
      "Design Thinking Methodology",
      "Business Transformation Consulting"
    ]
  },
  {
    "roleId": "JF55-007",
    "roleName": "Financial Advisor",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Financial Advisory",
      "Personal Financial Planning",
      "Investment Advisory",
      "Retirement Planning",
      "Portfolio Management"
    ],
    "aiToolSkills": [
      "Microsoft Copilot for Finance",
      "ChatGPT",
      "AlphaSense",
      "Claude",
      "Gamma"
    ],
    "domainSkills": [
      "Financial Planning for Clients",
      "IT Consulting Methodology",
      "Gap Analysis",
      "Taxation Concepts",
      "Medical Ethics and Professional Standards"
    ]
  },
  {
    "roleId": "JF55-008",
    "roleName": "M&A Advisor",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "M&A Advisory",
      "Transaction Advisory",
      "Deal Structuring",
      "M&A Valuation",
      "Financial Modeling"
    ],
    "aiToolSkills": [
      "Microsoft Copilot for Finance",
      "Claude",
      "Gamma",
      "AlphaSense",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Mergers and Acquisitions Advisory",
      "Deal Structuring and Negotiation",
      "Corporate Finance Principles",
      "Capital Markets Knowledge",
      "Due Diligence Methodology"
    ]
  },
  {
    "roleId": "JF55-009",
    "roleName": "Restructuring Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Restructuring Advisory",
      "Turnaround Management",
      "Debt Restructuring",
      "Insolvency and IBC",
      "M&A Valuation"
    ],
    "aiToolSkills": [
      "Microsoft Copilot for Finance",
      "Claude",
      "Gamma",
      "AlphaSense",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Corporate Restructuring Principles",
      "Financial Restructuring and Turnaround",
      "Corporate Finance Principles",
      "Gap Analysis",
      "IT Consulting Methodology"
    ]
  },
  {
    "roleId": "JF55-010",
    "roleName": "ESG Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "ESG Consulting",
      "ESG Framework Implementation",
      "ESG Analysis",
      "ESG Due Diligence",
      "Sustainable Finance Advisory"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "Claude",
      "Gamma",
      "AlphaSense",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "ESG Consulting Principles",
      "Sustainability Strategy and Reporting Advisory",
      "ESG Analysis Principles",
      "Greenhouse Gas Accounting",
      "IT Consulting Methodology"
    ]
  },
  {
    "roleId": "JF55-011",
    "roleName": "Sustainability Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Sustainability Consulting",
      "Corporate Sustainability Strategy",
      "Net Zero Advisory",
      "Sustainability Reporting Advisory",
      "Sustainability Analysis"
    ],
    "aiToolSkills": [
      "Clean Energy AI",
      "Claude",
      "Gamma",
      "AlphaSense",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Sustainability Analysis Principles",
      "Sustainability Strategy and Reporting Advisory",
      "Greenhouse Gas Accounting",
      "Management Consulting Principles",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF55-012",
    "roleName": "Business Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Business Analysis",
      "Requirements Elicitation",
      "Process Mapping",
      "Functional Specification Writing",
      "Project Management"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "AlphaSense",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Business Analysis Principles",
      "Requirements Elicitation and Process Mapping",
      "Business Analysis Methodology",
      "Design Thinking Methodology",
      "Gap Analysis"
    ]
  },
  {
    "roleId": "JF55-013",
    "roleName": "Change Management Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Change Management",
      "Stakeholder Impact Analysis",
      "Communications Planning",
      "Change Readiness Assessment",
      "Change Enablement"
    ],
    "aiToolSkills": [
      "Claude",
      "ChatGPT",
      "AlphaSense",
      "Gamma",
      "Process Mining AI"
    ],
    "domainSkills": [
      "Change Management Methodology",
      "Stakeholder Engagement and Adoption",
      "Management Consulting Principles",
      "Change Management for Digital Initiatives",
      "Design Thinking Methodology"
    ]
  },
  {
    "roleId": "JF55-014",
    "roleName": "Project Manager",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Project Management",
      "PMP Methodology",
      "Project Risk Management",
      "Project Stakeholder Management",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AlphaSense",
      "Microsoft 365 Copilot",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Project Management Methodology",
      "Process Improvement Methodology",
      "Gap Analysis",
      "Root Cause Analysis Methodology",
      "Business Analysis Methodology"
    ]
  },
  {
    "roleId": "JF55-015",
    "roleName": "Program Coordinator",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Programme Coordination",
      "Programme Tracking",
      "Action Item Management",
      "Project Management",
      "Microsoft Excel"
    ],
    "aiToolSkills": [
      "ChatGPT",
      "AlphaSense",
      "Microsoft 365 Copilot",
      "Gamma",
      "Process Mining AI"
    ],
    "domainSkills": [
      "Programme Coordination Principles",
      "Project Delivery and Administrative Coordination",
      "Gap Analysis",
      "IT Consulting Methodology",
      "Project Management Methodology"
    ]
  },
  {
    "roleId": "JF55-016",
    "roleName": "PMO Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "PMO Operations",
      "Portfolio Reporting",
      "Project Governance",
      "PMO Dashboard Management",
      "Project Management"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "AlphaSense",
      "Power BI Copilot",
      "Gamma"
    ],
    "domainSkills": [
      "PMO Governance and Standards",
      "PMO Portfolio Reporting",
      "Project Management Methodology",
      "Gap Analysis",
      "IT Consulting Methodology"
    ]
  },
  {
    "roleId": "JF55-017",
    "roleName": "Risk Advisory Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Risk Advisory",
      "Enterprise Risk Assessment",
      "Risk Framework Design",
      "Internal Controls Advisory",
      "Credit Risk Management"
    ],
    "aiToolSkills": [
      "AlphaSense",
      "Claude",
      "ChatGPT",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Risk Advisory Principles",
      "Enterprise Risk Assessment and Reporting",
      "Governance, Risk, and Compliance (GRC)",
      "Management Consulting Principles",
      "Root Cause Analysis Methodology"
    ]
  },
  {
    "roleId": "JF55-018",
    "roleName": "Implementation Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Implementation Consulting",
      "Solution Deployment Management",
      "User Adoption Management",
      "Change Enablement",
      "Implementation Quality Assurance"
    ],
    "aiToolSkills": [
      "Process Mining AI",
      "ChatGPT",
      "AlphaSense",
      "Claude",
      "Gamma"
    ],
    "domainSkills": [
      "Implementation Consulting Principles",
      "Solution Deployment and Change Readiness",
      "Change Management Methodology",
      "Project Management Methodology",
      "Change Management for Digital Initiatives"
    ]
  },
  {
    "roleId": "JF55-019",
    "roleName": "Due Diligence Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Due Diligence",
      "Commercial Due Diligence",
      "Operational Due Diligence",
      "Transaction Advisory",
      "Due Diligence Report Writing"
    ],
    "aiToolSkills": [
      "Microsoft Copilot for Finance",
      "Claude",
      "ChatGPT",
      "AlphaSense",
      "Gamma"
    ],
    "domainSkills": [
      "Due Diligence Methodology",
      "Commercial and Financial Due Diligence",
      "Gap Analysis",
      "Capital Markets Knowledge",
      "Management Consulting Principles"
    ]
  },
  {
    "roleId": "JF55-020",
    "roleName": "Market Intelligence Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Market Intelligence",
      "Primary Market Research",
      "Industry Analysis",
      "Syndicated Research Analysis",
      "Competitive Analysis"
    ],
    "aiToolSkills": [
      "AlphaSense",
      "ChatGPT",
      "Microsoft 365 Copilot",
      "Gamma",
      "Power BI Copilot"
    ],
    "domainSkills": [
      "Market Intelligence Principles",
      "Competitive Intelligence Analysis",
      "Capital Markets Knowledge",
      "Competitive and Market Analysis",
      "Data Storytelling"
    ]
  },
  {
    "roleId": "JF55-021",
    "roleName": "Digital Strategy Consultant",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Digital Strategy Consulting",
      "Digital Maturity Assessment",
      "Digital Transformation Roadmap",
      "Technology Vendor Assessment",
      "Business Problem Solving"
    ],
    "aiToolSkills": [
      "Claude",
      "ChatGPT",
      "AlphaSense",
      "Power BI Copilot",
      "Gamma"
    ],
    "domainSkills": [
      "Digital Strategy Consulting Principles",
      "Digital Transformation Frameworks",
      "Management Consulting Principles",
      "Design Thinking Methodology",
      "IT Consulting Methodology"
    ]
  },
  {
    "roleId": "JF55-022",
    "roleName": "Technology Risk Analyst",
    "jobFamily": "Consulting & Strategy",
    "technicalSkills": [
      "Technology Risk",
      "IT Risk Assessment",
      "Technology Control Framework",
      "Cybersecurity",
      "Third Party Risk - Technology"
    ],
    "aiToolSkills": [
      "Microsoft 365 Copilot",
      "AlphaSense",
      "Claude",
      "Power BI Copilot",
      "Gamma"
    ],
    "domainSkills": [
      "Technology Risk Advisory Principles",
      "IT and Cyber Risk Assessment",
      "Governance, Risk, and Compliance (GRC)",
      "Information Security Policies and Standards",
      "Management Consulting Principles , I HAVE PASTED 55 FAMILY ONLY"
    ]
  }
];

// Helper: get all unique job families
export const JOB_FAMILIES = [...new Set(SMAART_ROLE_LIBRARY.map(r => r.jobFamily))].sort();

// Helper: fuzzy match a job title to roles
export function matchRoleByTitle(query) {
    if (!query || query.length < 2) return [];
    const q = query.toLowerCase();
    return SMAART_ROLE_LIBRARY
        .filter(r => r.roleName.toLowerCase().includes(q) || r.jobFamily.toLowerCase().includes(q))
        .slice(0, 8);
}

// Helper: get role by exact roleId
export function getRoleById(roleId) {
    return SMAART_ROLE_LIBRARY.find(r => r.roleId === roleId) || null;
}

/**
 * Exact (case/spacing-insensitive) role lookup by title.
 *
 * matchRoleByTitle is a fuzzy search for the suggestion dropdown. This one is
 * for "the typed title IS this role" — so a job form can load the full skill
 * set without the user having to click a suggestion.
 */
export function findRoleByExactTitle(title) {
    if (!title) return null;
    const norm = (s) => String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
    const target = norm(title);
    if (!target) return null;
    return SMAART_ROLE_LIBRARY.find(r => norm(r.roleName) === target) || null;
}

// Helper: convert role to structuredSkills format used by JobManagement
export function roleToStructuredSkills(role) {
    const skills = [];
    (role.technicalSkills || []).forEach(s => {
        skills.push({ skill_name: s, requiredLevel: 3, isEssential: true, category: 'Technical' });
    });
    (role.domainSkills || []).forEach(s => {
        skills.push({ skill_name: s, requiredLevel: 2, isEssential: true, category: 'Domain' });
    });
    (role.aiToolSkills || []).forEach(s => {
        skills.push({ skill_name: s, requiredLevel: 2, isEssential: false, category: 'AI Tool' });
    });
    return skills;
}
